import {
  coroutineScope39ukucf23mhsm as coroutineScope,
  launch1c91vkjzdi9sd as launch,
  Key_instancebefxze3q9f64 as Key_instance,
  cancelChildrennwartoz0yn6c as cancelChildren,
  delayvyed5wvki0ic as delay,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancelChildren10wlln0b749a7 as cancelChildren_0,
  supervisorScope3mi0bhexh7bxt as supervisorScope,
  CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1 as CoroutineStart_UNDISPATCHED_getInstance,
  asyncz02dsa2nb2zt as async,
  cancelAndJoin21f2rd386nyt8 as cancelAndJoin,
  awaitCancellation3exsywb4az079 as awaitCancellation,
  combinemp03aok49jmu as combine,
  CoroutineStart_LAZY_getInstanceyyljs516jwiz as CoroutineStart_LAZY_getInstance,
  Channel3r72atmcithql as Channel,
  NonCancellable_getInstance245ec57g3sl0k as NonCancellable_getInstance,
  withContextqz5k6d9p9xx5 as withContext,
  Mutex16li1l0asjv17 as Mutex,
} from './kotlinx-coroutines-core.mjs';
import {
  boundAwait1gsd6dbqqqgm5 as boundAwait,
  AnotherAnswerReaction_AllowOtherAnswers_getInstance1axe0kb0br3tx as AnotherAnswerReaction_AllowOtherAnswers_getInstance,
  reportWarning2za12zxcfzdkq as reportWarning,
  AnimationInsertionType_JustBeforeAnswer_getInstancestoighh2durw as AnimationInsertionType_JustBeforeAnswer_getInstance,
  StartResolveCardEvent204obdiuwrl30 as StartResolveCardEvent,
  GameScopesChangeEvent3ju8pn6l9637u as GameScopesChangeEvent,
  PlayerTurnPhase3jebsnvqgqk4f as PlayerTurnPhase,
  get_mesmerizedHuntervr8fdrybqjgt as get_mesmerizedHunter,
  defaultAnswer34nzhbo7sipew as defaultAnswer,
  AdjustedSavedAnswer1193xhmb1myfp as AdjustedSavedAnswer,
  MapUiScalingAndPosition2k3s7s83zg6ay as MapUiScalingAndPosition,
  AnotherAnswerReaction_ReshowVariants_getInstance2p4pnhj458ex as AnotherAnswerReaction_ReshowVariants_getInstance,
  get_clientSetupOrNull24ih5m60r311v as get_clientSetupOrNull,
  Duel1tcmns9b4sqco as Duel,
  BeastGameExpansions_ShatteredIsles_getInstance33verx6u4dl6s as BeastGameExpansions_ShatteredIsles_getInstance,
  BeastGameExpansions_TheGreatHunt_getInstance1uqkzoanwkf2v as BeastGameExpansions_TheGreatHunt_getInstance,
  BeastGameExpansions_Ashfall_getInstance1yhnjjgaypnsy as BeastGameExpansions_Ashfall_getInstance,
  GameContentVersion2in87ovmr1f1t as GameContentVersion,
  RevealedArsenalPlace_getInstance3ex2xtf4e2o0l as RevealedArsenalPlace_getInstance,
  GeneralCardMoveEventp0piwr0iypgm as GeneralCardMoveEvent,
  BeastlyTalentCard2sm6mvj831dxe as BeastlyTalentCard,
  HunterItemCard2be7jfoohe5k1 as HunterItemCard,
  RestoreArsenalEvent5a9kgyvy1983 as RestoreArsenalEvent,
  withStateRuntime2d9i5e0jyf3jd as withStateRuntime,
  GainUnknownArsenalCardEvent16knnvhqpv4q6 as GainUnknownArsenalCardEvent,
  GainOpenArsenalCardEvent1wkypt3doegkq as GainOpenArsenalCardEvent,
  HandPlace2nuj4crujja2o as HandPlace,
  get_phase19xfr6wqyjp6q as get_phase,
  ContractInitPhasebbm6nkk1m701 as ContractInitPhase,
  GainGrudgesEvent2f9md6n75zqvn as GainGrudgesEvent,
  get_objectType3emg51nk00g59 as get_objectType,
  Bolgin2aemms6gmbcjq as Bolgin,
  InitialPhase39dki7vc6ulgd as InitialPhase,
  MovementEvent2k96wxlpbvifd as MovementEvent,
  get_currentDayNumber3ti9bsc9tdlne as get_currentDayNumber,
  SpendGrudgesEvent1jh4fpetxg74v as SpendGrudgesEvent,
  get_currentTurnNumberh1xt6wcogwmf as get_currentTurnNumber,
  get_playedCardsNumber1epqlr3nueavd as get_playedCardsNumber,
  get_bolginBeast1wicfe2k50uar as get_bolginBeast,
  NightPhase_getInstance7ju3w96rz5 as NightPhase_getInstance,
  get_charactersInOrder24hmg1035jqha as get_charactersInOrder,
  RestoreStuffEventgfbvhbkq5mvx as RestoreStuffEvent,
  NonePhase_getInstance4bkyqrl7u9r4 as NonePhase_getInstance,
  InitGameStateEvent3t2iihh898bro as InitGameStateEvent,
  ApplyDamageEvent1ksol0gohmdlc as ApplyDamageEvent,
  NewSimpleObjectEvent2xofhungb2zip as NewSimpleObjectEvent,
  StartPhaseEvent16kv7wan6gsti as StartPhaseEvent,
  EngorgeCard1kl6oz4cn8a4g as EngorgeCard,
  SmokeBombCard3qyzfh70i7qlq as SmokeBombCard,
  RevealLastMovementsEvent30p82wxlim6r6 as RevealLastMovementsEvent,
  TrailsRevealedEvent119ggsxe5h312 as TrailsRevealedEvent,
  FlareCard36tx25o1tara1 as FlareCard,
  BladeOfValhCard_getInstance31t71anst074h as BladeOfValhCard_getInstance,
  OutpostCard1ffzsar9gm9bf as OutpostCard,
  DamageResolvedEvent2i6m6cxbjj8ye as DamageResolvedEvent,
  get_helgaHunter3o73ghj9up41g as get_helgaHunter,
  NightPhase3kd1qmzjhtveh as NightPhase,
  CheckForDestroyEvent3d9009ucbvqzf as CheckForDestroyEvent,
  TransformSimpleObjectChangeEvent14cfif3i7bfn5 as TransformSimpleObjectChangeEvent,
  DawnPhase1gkmlp1a4ffp0 as DawnPhase,
  Helga_getInstance3a4t2szsrwroo as Helga_getInstance,
  ChooseCharacterQuestion15prhcvmg0xx6 as ChooseCharacterQuestion,
  Varja_getInstanceczhyz7rvxazb as Varja_getInstance,
  Iona_getInstance1jzicrvxoqh2j as Iona_getInstance,
  DestinationQuestion3h9r448czxeoe as DestinationQuestion,
  BeastCharacter1uqk4ouyve4z0 as BeastCharacter,
  PlayCardInTurnQuestion1hww2zcmfisni as PlayCardInTurnQuestion,
  EnsnareCard_getInstance37eqqzyvf3yl7 as EnsnareCard_getInstance,
  PlayCardVariant161wiv7hcla9a as PlayCardVariant,
  ObjectsGameQuestion2boxyklmnsg55 as ObjectsGameQuestion,
  UpgradeQuestion1yilwq9twob5k as UpgradeQuestion,
  HeroicSpeechUpgrade_getInstancemgl1ytakjrzy as HeroicSpeechUpgrade_getInstance,
  ChooseCardOnDraftQuestion3dw7wif1c6a1e as ChooseCardOnDraftQuestion,
  Helgapgiytndle9pb as Helga,
  Varja3v3kktzudcxc9 as Varja,
  Ionapl84deju72tb as Iona,
  EngorgeCard_getInstance13d2ezow3zuya as EngorgeCard_getInstance,
  SummonPolypCard_getInstance1h86vkh8ulqlg as SummonPolypCard_getInstance,
  StatementQuestion1lxt2f1cnz3ov as StatementQuestion,
  SummonSignStatement1zd9rsibb55e3 as SummonSignStatement,
  PlaceNewObjectQuestion2hcww1pm3bmd7 as PlaceNewObjectQuestion,
  ChooseCardsQuestion236iunubwe5yh as ChooseCardsQuestion,
  BeastlyTongueCard_getInstancet114a32976bo as BeastlyTongueCard_getInstance,
  SeerCard_getInstance7zjuuadxukfm as SeerCard_getInstance,
  InciteCard_getInstance1kcstun54fx9h as InciteCard_getInstance,
  get_varjaHunterobdiv7ofixj0 as get_varjaHunter,
  BolsterCard_getInstance2ki3w8dsghywt as BolsterCard_getInstance,
  get_ionaHunter1aexy6rx5u8b0 as get_ionaHunter,
  LeapCard_getInstanceznp92u5id8gd as LeapCard_getInstance,
  get_hand3l0uqiz1oyo3x as get_hand,
  AttackStatement2n5hixt2vwt0t as AttackStatement,
  _BoardPosition___init__impl__1nizgq3b7o6zwawcqwa as _BoardPosition___init__impl__1nizgq,
  AncientPowerNumberQuestion3cdrapqw1ph4u as AncientPowerNumberQuestion,
  TriggersQuestionesdw70q2hiv1 as TriggersQuestion,
  SettlerType3458v8k9hj1ql as SettlerType,
  FarmerType33h0bg4h185y3 as FarmerType,
  AbilityCardhe2jylhd819j as AbilityCard,
  ArsenalCardToGainQuestionContext_getInstance1cinbinh20wv6 as ArsenalCardToGainQuestionContext_getInstance,
  get_isRevealed1yvfqt0zljrxx as get_isRevealed,
  get_isHidden25d33ee7ol8iu as get_isHidden,
  HunterCharacter38ygd0hbflv64 as HunterCharacter,
  ZoneQuestion1169zovvoqch5 as ZoneQuestion,
  LocationTypeQuestion1z8yhezyamvr0 as LocationTypeQuestion,
  SimpleBeastMovementStatement3aqths0sbkqim as SimpleBeastMovementStatement,
  GainBeastlyTalentStatement3j7e8qwncf3jm as GainBeastlyTalentStatement,
  summonsOnMap2jrlywmkxceyb as summonsOnMap,
  ActivateSummonsStatement2coksmlkd9lq4 as ActivateSummonsStatement,
  BurstStatement3hv5c5jnu34bn as BurstStatement,
  PolypType33r525labzybw as PolypType,
  AncientCallingUpgrade_getInstance1pft1zar3r8ic as AncientCallingUpgrade_getInstance,
  SheepType_getInstanceosw2mgv1ahze as SheepType_getInstance,
  BeastMovementInfoChange24yaol0g17fut as BeastMovementInfoChange,
  AnimationInsertionlscydg2wjcsr as AnimationInsertion,
  get_fullObserverGameTeamMarker14m9rs3amysry as get_fullObserverGameTeamMarker,
  get_huntersGameTeamiqiqxeugntgm as get_huntersGameTeam,
  get_beastsGameTeam1y1bdmzuny63m as get_beastsGameTeam,
  WhatWillBeReapply_InitialStateNotification_getInstance3h7h3bfq48y51 as WhatWillBeReapply_InitialStateNotification_getInstance,
  WhatWillBeReapply_GameNotification_getInstancegdd46s353szd as WhatWillBeReapply_GameNotification_getInstance,
  WhatWillBeReapply_GameQuestion_getInstance3bzstdqe7zbi6 as WhatWillBeReapply_GameQuestion_getInstance,
  GameTeamukq9bbth76rc as GameTeam,
  GameNotification1mpvi762l5m54 as GameNotification,
  get_revision1galai6fn5pio as get_revision,
  installAnswer1autkomcz1d8r as installAnswer,
  CurrentAndOldStateHolderSimple1681ghu28vpum as CurrentAndOldStateHolderSimple,
  MasterFixingSupportingAgent3u14yuiuqy94 as MasterFixingSupportingAgent,
  RevertSupportingAgent2za8f9p9lpp6u as RevertSupportingAgent,
  PingingSupportni7c00aatics as PingingSupport,
  SandboxInitApplyEventSuccessResult2qcp21d5sdzi as SandboxInitApplyEventSuccessResult,
  RestoreArsenalEvent_getInstance1ivhs49gu01tz as RestoreArsenalEvent_getInstance,
  calculateCheckCode2pl8736fah0hq as calculateCheckCode,
  applyAllChanges38fbuwnf838ci as applyAllChanges,
  approveMasterFixing3bcyvp6ou6qqf as approveMasterFixing,
  PrintingGameRuntimeDiagnostics_instanceknsic9pmcauw as PrintingGameRuntimeDiagnostics_instance,
} from './beast-beast-common.mjs';
import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  constructCallableReference23y65rf941mch as constructCallableReference,
  VOID3gxj6tk5isa35 as VOID,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  ArrayList3it5z8td81qkl as ArrayList,
  emptyList1g2z5xcrvp2zy as emptyList,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  firstOrNull1982767dljvdy as firstOrNull_0,
  Collection1k04j3hzsbod0 as Collection,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString_0,
  createThis2j2avj17cvnv2 as createThis,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  listOfvhqybd2zx248 as listOf,
  joinToString1cxrrlmo0chqs as joinToString,
  captureStack1fzi4aczwc4hg as captureStack,
  Enum3alwj03lh1n41 as Enum,
  to2cs3ny02qtbcb as to,
  StringBuildermazzzhj6kkai as StringBuilder,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  println2shhhgwwt4c61 as println,
  throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException,
  protoOf180f3jzyo7rfj as protoOf,
  listOf1jh22dvmctj1r as listOf_0,
  emptySetcxexqki71qfa as emptySet,
  setOf1u3mizs95ngxo as setOf,
  toSet2orjxp16sotqu as toSet,
  sorted354mfsiv4s7x5 as sorted,
  getOrNull1go7ef9ldk0df as getOrNull,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  singleOrNull21olsob387p54 as singleOrNull,
  last1vo29oleiqj36 as last,
  enumEntries20mr21zbe3az4 as enumEntries,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  CancellationException3b36o9qz53rgr as CancellationException,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class ChoiceFlow {
  constructor(agent, presentation, anotherAnswerState, listener, configuration) {
    var tmp;
    if (configuration === VOID) {
      tmp = ChoiceFlow$_init_$lambda_cpbfms;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    this.pdv_1 = agent;
    this.qdv_1 = presentation;
    this.rdv_1 = anotherAnswerState;
    this.sdv_1 = listener;
    this.tdv_1 = configuration;
    this.udv_1 = false;
    this.vdv_1 = null;
    this.wdv_1 = emptyList();
    this.xdv_1 = null;
    this.ydv_1 = false;
    this.zdv_1 = null;
  }
  udw() {
    // Inline function 'kotlin.let' call
    var it = this.pdv_1.o6t();
    return !(it == null) && this.rdv_1.vdw() === -1 && it.b6y();
  }
  wdw() {
    var tmp = this;
    var tmp0_safe_receiver = this.pdv_1.o6t();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6y();
    tmp.wdv_1 = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  xdw() {
    this.udv_1 = false;
  }
  ydw() {
    this.ydv_1 = false;
  }
  zdw() {
    this.xdv_1 = null;
    this.ydv_1 = false;
    this.vdv_1 = null;
    this.wdv_1 = emptyList();
  }
  adx(event) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (!(this.xdv_1 == null)) {
      tmp_1 = !(event instanceof StartResolveCardEvent);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = !(event instanceof GameScopesChangeEvent);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = this.pdv_1.t6h().l38_1;
      // Inline function 'kotlin.collections.containsKey' call
      var key = this.xdv_1;
      tmp = !(isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).u4(key);
    } else {
      tmp = false;
    }
    if (tmp)
      this.xdv_1 = null;
  }
  bdx() {
    this.xdv_1 = firstOrNull(this.pdv_1.t6h().l38_1.x4());
  }
  cdx() {
    var tmp0_safe_receiver = this.zdv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancelChildren_0(tmp0_safe_receiver);
    }
    this.zdv_1 = null;
    this.qdv_1.cdw();
  }
  *ddw($context_GameStateRuntime_604ce3, question, mayNothing, scope, $completion) {
    yield* this.qdv_1.ddx($completion);
    var result = CompletableDeferred();
    var install = ChoiceFlow$installQuestion$slambda(this, $context_GameStateRuntime_604ce3, question, mayNothing, scope, result);
    this.qdv_1.edx(install);
    yield* install($completion);
    return result;
  }
  *fdx($context_GameStateRuntime_604ce3, question, mayNothing, forcePrecise, onInstalled, $completion) {
    var config = this.tdv_1();
    var tmp = firstOrNull_0(this.pdv_1.t6h().c38_1);
    var tmp0_safe_receiver = tmp instanceof PlayerTurnPhase ? tmp : null;
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4g_1;
    var tmp_0;
    if (!(it == null)) {
      // Inline function 'kotlin.with' call
      var $this$with = this.pdv_1.t6h();
      var tmp$ret$2 = get_mesmerizedHunter($this$with);
      tmp_0 = equals(it, tmp$ret$2);
    } else {
      tmp_0 = false;
    }
    var mesmerizedTurn = tmp_0;
    var precise = !config.odw_1 && (config.idw_1 || forcePrecise || !(this.xdv_1 == null) || this.ydv_1 || mesmerizedTurn);
    var automatic = precise ? null : defaultAnswer($context_GameStateRuntime_604ce3, question, mayNothing);
    var predefined = this.udw() ? (yield* peekAnswerAndAnimations($context_GameStateRuntime_604ce3, ensureNotNull(this.pdv_1.o6t()), question, mayNothing, $completion)) : null;
    if (predefined == null) {
      if (config.mdw_1) {
        this.sdv_1().gdx();
      }
      if (!(automatic == null))
        return automatic.j71_1;
      return yield* /*#__NOINLINE__*/inQuestionScope(this, ChoiceFlow$chooseImpl$slambda(this, $context_GameStateRuntime_604ce3, question, mayNothing, onInstalled), $completion);
    }
    this.udv_1 = true;
    var savedAnswer = predefined.jm();
    var animations = predefined.km();
    this.vdv_1 = savedAnswer;
    if (savedAnswer == null) {
      // Inline function 'kotlin.require' call
      if (!mayNothing) {
        var message = 'Answer null cannot be when nothing impossible';
        throw IllegalArgumentException.h2(toString(message));
      }
    } else {
      if (isInterface(savedAnswer, AdjustedSavedAnswer)) {
        return savedAnswer.h6y();
      } else {
        var tmp0 = question.s3o();
        var tmp$ret$6;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp0, Collection)) {
            tmp_1 = tmp0.n1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$6 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (equals(element, savedAnswer)) {
              tmp$ret$6 = true;
              break $l$block_0;
            }
          }
          tmp$ret$6 = false;
        }
        // Inline function 'kotlin.require' call
        if (!tmp$ret$6) {
          var message_0 = 'Answer was ' + toString(savedAnswer) + ' but variants were ' + question.s3o().toString();
          throw IllegalArgumentException.h2(toString(message_0));
        }
      }
    }
    if (!(automatic == null) && equals(savedAnswer, automatic.j71_1))
      return automatic.j71_1;
    if (!config.jdw_1 || config.kdw_1) {
      var tmp_2;
      if (config.jdw_1) {
        tmp_2 = animations;
      } else {
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList.p2();
        var _iterator__ex2g4s_0 = animations.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (element_0 instanceof MapUiScalingAndPosition) {
            destination.d2(element_0);
          }
        }
        tmp_2 = destination;
      }
      var instructions = tmp_2;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = instructions.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        yield* this.qdv_1.hdx(element_1, $completion);
      }
      if (config.kdw_1) {
        // Inline function 'kotlin.with' call
        var $this$with_0 = this.pdv_1;
        yield* this.sdv_1().edw($this$with_0, question, mayNothing, $completion);
      }
      return savedAnswer;
    }
    yield* this.qdv_1.idx(animations, $completion);
    if (this.sdv_1().jdx(this.pdv_1)) {
      // Inline function 'kotlin.with' call
      var $this$with_1 = this.pdv_1;
      yield* this.sdv_1().edw($this$with_1, question, mayNothing, $completion);
      return savedAnswer;
    }
    return yield* coroutineScope(ChoiceFlow$chooseImpl$slambda_0(this, savedAnswer, $context_GameStateRuntime_604ce3, question, mayNothing, onInstalled, animations), $completion);
  }
  kdx($context_GameStateRuntime_604ce3, question, mayNothing, forcePrecise, onInstalled, $completion, $super) {
    forcePrecise = forcePrecise === VOID ? false : forcePrecise;
    var tmp;
    if (onInstalled === VOID) {
      tmp = ChoiceFlow$chooseImpl$lambda;
    } else {
      tmp = onInstalled;
    }
    onInstalled = tmp;
    return $super === VOID ? this.fdx($context_GameStateRuntime_604ce3, question, mayNothing, forcePrecise, onInstalled, $completion) : $super.fdx.call(this, $context_GameStateRuntime_604ce3, question, mayNothing, forcePrecise, onInstalled, $completion);
  }
}
class ChoicePresentation {}
function *prepareQuestion($completion) {
  return Unit_instance;
}
function setRestoreQuestion(restore) {
}
function *afterInstallation(choice, scope, $completion) {
  return Unit_instance;
}
function questionClosed() {
}
function *beforeReplay(animations, $completion) {
  return Unit_instance;
}
function *animateBeforeAnswer(animation, $completion) {
  return Unit_instance;
}
function *highlightReplayAnswer(answer, $completion) {
  return Unit_instance;
}
function *animateReplayAnswer(answer, animations, $completion) {
  return Unit_instance;
}
function *replayAnswerAccepted($completion) {
  return Unit_instance;
}
function *wrongReplayAnswer($completion) {
  return Unit_instance;
}
class InstalledChoice {
  constructor(answer, canReopenQuestion) {
    canReopenQuestion = canReopenQuestion === VOID ? false : canReopenQuestion;
    this.ndv_1 = answer;
    this.odv_1 = canReopenQuestion;
  }
  toString() {
    return 'InstalledChoice(answer=' + toString(this.ndv_1) + ', canReopenQuestion=' + this.odv_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ndv_1);
    result = imul(result, 31) + getBooleanHashCode(this.odv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InstalledChoice))
      return false;
    if (!equals(this.ndv_1, other.ndv_1))
      return false;
    if (!(this.odv_1 === other.odv_1))
      return false;
    return true;
  }
}
class ChoiceFlowConfiguration {
  constructor(alwaysPlayPrecisely, showReplayControls, automaticReplay, disableAnimations, printOnboardingTexts, anotherAnswerReaction, isOnboardingMode) {
    alwaysPlayPrecisely = alwaysPlayPrecisely === VOID ? false : alwaysPlayPrecisely;
    showReplayControls = showReplayControls === VOID ? true : showReplayControls;
    automaticReplay = automaticReplay === VOID ? false : automaticReplay;
    disableAnimations = disableAnimations === VOID ? false : disableAnimations;
    printOnboardingTexts = printOnboardingTexts === VOID ? false : printOnboardingTexts;
    anotherAnswerReaction = anotherAnswerReaction === VOID ? AnotherAnswerReaction_ReshowVariants_getInstance() : anotherAnswerReaction;
    isOnboardingMode = isOnboardingMode === VOID ? false : isOnboardingMode;
    this.idw_1 = alwaysPlayPrecisely;
    this.jdw_1 = showReplayControls;
    this.kdw_1 = automaticReplay;
    this.ldw_1 = disableAnimations;
    this.mdw_1 = printOnboardingTexts;
    this.ndw_1 = anotherAnswerReaction;
    this.odw_1 = isOnboardingMode;
  }
  toString() {
    return 'ChoiceFlowConfiguration(alwaysPlayPrecisely=' + this.idw_1 + ', showReplayControls=' + this.jdw_1 + ', automaticReplay=' + this.kdw_1 + ', disableAnimations=' + this.ldw_1 + ', printOnboardingTexts=' + this.mdw_1 + ', anotherAnswerReaction=' + this.ndw_1.toString() + ', isOnboardingMode=' + this.odw_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.idw_1);
    result = imul(result, 31) + getBooleanHashCode(this.jdw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kdw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ldw_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mdw_1) | 0;
    result = imul(result, 31) + this.ndw_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.odw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChoiceFlowConfiguration))
      return false;
    if (!(this.idw_1 === other.idw_1))
      return false;
    if (!(this.jdw_1 === other.jdw_1))
      return false;
    if (!(this.kdw_1 === other.kdw_1))
      return false;
    if (!(this.ldw_1 === other.ldw_1))
      return false;
    if (!(this.mdw_1 === other.mdw_1))
      return false;
    if (!this.ndw_1.equals(other.ndw_1))
      return false;
    if (!(this.odw_1 === other.odw_1))
      return false;
    return true;
  }
}
class UiSessionState {
  constructor() {
    this.ldx_1 = null;
    this.mdx_1 = null;
    this.ndx_1 = false;
  }
  odx() {
    var tmp0_safe_receiver = this.mdx_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o1n();
    }
    this.mdx_1 = null;
  }
  ra8() {
    this.ldx_1 = null;
  }
}
class OfflineRecordedGameSetup {
  constructor(playFromStart, finishReplayOnAnswerNumber) {
    finishReplayOnAnswerNumber = finishReplayOnAnswerNumber === VOID ? null : finishReplayOnAnswerNumber;
    this.pdx_1 = playFromStart;
    this.qdx_1 = finishReplayOnAnswerNumber;
  }
  toString() {
    return 'OfflineRecordedGameSetup(playFromStart=' + this.pdx_1 + ', finishReplayOnAnswerNumber=' + this.qdx_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.pdx_1);
    result = imul(result, 31) + (this.qdx_1 == null ? 0 : this.qdx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OfflineRecordedGameSetup))
      return false;
    if (!(this.pdx_1 === other.pdx_1))
      return false;
    if (!(this.qdx_1 == other.qdx_1))
      return false;
    return true;
  }
}
class MenuManagement {}
function get_replayTimeline() {
  return null;
}
function get_isNetworkGame() {
  return false;
}
function get_canShareReplay() {
  return false;
}
function *shareReplay($completion) {
  return Unit_instance;
}
function reloadGameCallback() {
  return Unit_instance;
}
class ServerDuelSetup {
  constructor(setup) {
    this.xdx_1 = setup;
  }
  toString() {
    return 'ServerDuelSetup(setup=' + this.xdx_1.toString() + ')';
  }
  hashCode() {
    return this.xdx_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ServerDuelSetup))
      return false;
    if (!this.xdx_1.equals(other.xdx_1))
      return false;
    return true;
  }
}
class NewGameSetup {
  toString() {
    return 'NewGameSetup';
  }
  hashCode() {
    return -204712992;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NewGameSetup))
      return false;
    return true;
  }
}
class SandboxSetup {
  constructor(reconnectData) {
    this.ydx_1 = reconnectData;
  }
  toString() {
    return 'SandboxSetup(reconnectData=' + toString_0(this.ydx_1) + ')';
  }
  hashCode() {
    return this.ydx_1 == null ? 0 : this.ydx_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxSetup))
      return false;
    if (!equals(this.ydx_1, other.ydx_1))
      return false;
    return true;
  }
}
class ReconnectSandboxSetup {
  constructor(gameRules, sandboxCode) {
    this.zdx_1 = gameRules;
    this.ady_1 = sandboxCode;
  }
  toString() {
    return 'ReconnectSandboxSetup(gameRules=' + toString(this.zdx_1) + ', sandboxCode=' + this.ady_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.zdx_1);
    result = imul(result, 31) + this.ady_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReconnectSandboxSetup))
      return false;
    if (!equals(this.zdx_1, other.zdx_1))
      return false;
    if (!this.ady_1.equals(other.ady_1))
      return false;
    return true;
  }
}
class LoadGameSetup {
  toString() {
    return 'LoadGameSetup';
  }
  hashCode() {
    return -1380565488;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadGameSetup))
      return false;
    return true;
  }
}
class ContentVersionSelectionState {
  constructor(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled) {
    return new.target.edy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled);
  }
  static edy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled) {
    var $this = createThis(this);
    $this.bdy_1 = isShatteredIslesEnabled;
    $this.cdy_1 = isTheGreatHuntEnabled;
    $this.ddy_1 = isAshfallEnabled;
    return $this;
  }
  static fdy(gameContentVersion) {
    return this.edy(gameContentVersion.q3d_1.w2(BeastGameExpansions_ShatteredIsles_getInstance()), gameContentVersion.q3d_1.w2(BeastGameExpansions_TheGreatHunt_getInstance()), gameContentVersion.q3d_1.w2(BeastGameExpansions_Ashfall_getInstance()));
  }
  gdy() {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet.v2();
    if (this.bdy_1) {
      this_0.d2(BeastGameExpansions_ShatteredIsles_getInstance());
    }
    if (this.cdy_1) {
      this_0.d2(BeastGameExpansions_TheGreatHunt_getInstance());
    }
    if (this.ddy_1) {
      this_0.d2(BeastGameExpansions_Ashfall_getInstance());
    }
    var tmp$ret$0 = this_0.g9();
    return GameContentVersion.v3d(tmp$ret$0);
  }
  hdy() {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList.p2();
    if (this.bdy_1) {
      this_0.d2('SI');
    }
    if (this.cdy_1) {
      this_0.d2('TGH');
    }
    if (this.ddy_1) {
      this_0.d2('Ashfall');
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    var this_1 = this_0.g9();
    var tmp;
    if (this_1.n1()) {
      tmp = listOf('Base');
    } else {
      tmp = this_1;
    }
    var tmp$ret$4 = tmp;
    return joinToString(tmp$ret$4, ', ');
  }
  idy(allowedExpansions) {
    return this.jdy(this.bdy_1 && allowedExpansions.w2(BeastGameExpansions_ShatteredIsles_getInstance()), this.cdy_1 && allowedExpansions.w2(BeastGameExpansions_TheGreatHunt_getInstance()), this.ddy_1 && allowedExpansions.w2(BeastGameExpansions_Ashfall_getInstance()));
  }
  jdy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled) {
    return ContentVersionSelectionState.edy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled);
  }
  kdy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled, $super) {
    isShatteredIslesEnabled = isShatteredIslesEnabled === VOID ? this.bdy_1 : isShatteredIslesEnabled;
    isTheGreatHuntEnabled = isTheGreatHuntEnabled === VOID ? this.cdy_1 : isTheGreatHuntEnabled;
    isAshfallEnabled = isAshfallEnabled === VOID ? this.ddy_1 : isAshfallEnabled;
    return $super === VOID ? this.jdy(isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled) : $super.jdy.call(this, isShatteredIslesEnabled, isTheGreatHuntEnabled, isAshfallEnabled);
  }
  toString() {
    return 'ContentVersionSelectionState(isShatteredIslesEnabled=' + this.bdy_1 + ', isTheGreatHuntEnabled=' + this.cdy_1 + ', isAshfallEnabled=' + this.ddy_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.bdy_1);
    result = imul(result, 31) + getBooleanHashCode(this.cdy_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ddy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ContentVersionSelectionState))
      return false;
    if (!(this.bdy_1 === other.bdy_1))
      return false;
    if (!(this.cdy_1 === other.cdy_1))
      return false;
    if (!(this.ddy_1 === other.ddy_1))
      return false;
    return true;
  }
}
class PressedBackException extends IllegalStateException {
  constructor() {
    return new.target.pdy();
  }
  static pdy() {
    var $this = this.o('Pressed Back Onboarding button');
    captureStack($this, $this.ody_1);
    return $this;
  }
}
class GameFlowNotificationType extends Enum {}
class GameFlowListener {}
function flushPendingTexts() {
}
function skipReplayQuestionPresentation(holder) {
  return false;
}
function *prepareReplayBoundary(holder, question, mayNothing, $completion) {
  return Unit_instance;
}
function *beforeNotificationApplied($context_CurrentAndOldStateHolder_1ksmhi, event, $completion) {
  return Unit_instance;
}
function *afterNotificationApplied($context_CurrentAndOldStateHolder_1ksmhi, event, $completion) {
  return Unit_instance;
}
function *beforeAnswer($context_CurrentAndOldStateHolder_1ksmhi, gameQuestion, mayNothing, $completion) {
  return Unit_instance;
}
function *whenChoiceUiWasInstalled($context_CurrentAndOldStateHolder_1ksmhi, gameQuestion, mayNothing, $completion) {
  return Unit_instance;
}
function *answerWasGiven($context_CurrentAndOldStateHolder_1ksmhi, gameQuestion, mayNothing, answer, $completion) {
  return Unit_instance;
}
class OnboardingGameFlowListener {
  constructor() {
    this.qdy_1 = StringBuilder.l1();
    this.rdy_1 = 0;
    this.sdy_1 = 0;
    this.tdy_1 = 0;
    this.udy_1 = -1;
    this.vdy_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.wdy_1 = LinkedHashMap.m7();
    this.xdy_1 = null;
    this.ydy_1 = null;
  }
  gdx() {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.qdy_1;
    if (charSequenceLength(this_0) > 0) {
      println(this.qdy_1.toString());
      this.qdy_1.sh();
    }
  }
  jdx(holder) {
    var tmp0_safe_receiver = this.wdy_1.w4(to(this.tdy_1, holder.t6h().g38_1));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(GameFlowNotificationType_WhenChoiceUiWasInstalled_getInstance());
    var lastStep = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.qm_1;
    return !(lastStep == null) && lastStep < this.rdy_1;
  }
  zdy(startFromInfoStep, startFromAnswer) {
    this.qdy_1.sh();
    this.rdy_1 = startFromInfoStep;
    this.udy_1 = startFromAnswer;
    this.sdy_1 = 0;
    this.tdy_1 = 0;
    this.vdy_1 = null;
    this.wdy_1.a5();
    this.xdy_1 = null;
    this.ydy_1 = null;
  }
  adz(revision) {
    this.sdy_1 = this.sdy_1 + 1 | 0;
    // Inline function 'kotlin.requireNotNull' call
    var tmp0 = this.vdy_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalArgumentException.h2(toString(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var type = tmp$ret$1;
    var tmp0_0 = this.wdy_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = to(this.tdy_1, revision);
    var value = tmp0_0.w4(key);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      var answer = LinkedHashMap.m7();
      tmp0_0.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var steps = tmp;
    var tmp0_safe_receiver = steps.w4(type);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pm_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = to(tmp1_elvis_lhs == null ? this.sdy_1 - 1 | 0 : tmp1_elvis_lhs, this.sdy_1 - 1 | 0);
    steps.b5(type, value_0);
  }
  bdz() {
    this.sdy_1 = 0;
    this.tdy_1 = this.tdy_1 + 1 | 0;
    if (this.tdy_1 > this.udy_1)
      this.rdy_1 = 0;
    if (this.tdy_1 === this.udy_1)
      this.udy_1 = -1;
  }
  *cdz($context_CurrentAndOldStateHolder_1ksmhi, gameQuestion, mayNothing, $completion) {
    this.bdz();
    return Unit_instance;
  }
  *ddz(holder, notificationType, action, $completion) {
    this.vdy_1 = notificationType;
    var stepAtStart = this.sdy_1;
    while (true) {
      try {
        yield* action($completion);
        return Unit_instance;
      } catch ($p) {
        if ($p instanceof PressedBackException) {
          var e = $p;
          this.rdy_1 = this.sdy_1 - 2 | 0;
          this.sdy_1 = stepAtStart;
          if (this.rdy_1 < stepAtStart) {
            var steps = this.wdy_1.w4(to(this.tdy_1, holder.t6h().g38_1));
            var tmp = this;
            var tmp1_safe_receiver = steps == null ? null : steps.w4(GameFlowNotificationType_BeforeNotificationApplied_getInstance());
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pm_1;
            tmp.sdy_1 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
            yield* this.edz(holder, notificationType, $completion);
            yield* awaitCancellation($completion);
            throwKotlinNothingValueException();
          }
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }
  *edz(holder, notificationType, $completion) {
    throw PressedBackException.pdy();
  }
  fdz(holder, notificationType) {
    var tmp;
    switch (notificationType.w1_1) {
      case 3:
        tmp = rewindModeAcrossNotification$checkpoint(this, holder, GameFlowNotificationType_BeforeAnswer_getInstance());
        break;
      case 4:
        var before = rewindModeAcrossNotification$checkpoint(this, holder, GameFlowNotificationType_BeforeAnswer_getInstance());
        var installed = rewindModeAcrossNotification$checkpoint(this, holder, GameFlowNotificationType_WhenChoiceUiWasInstalled_getInstance());
        var tmp_0;
        if (!(before == null)) {
          var tmp2_elvis_lhs = installed == null ? null : installed.qm_1;
          tmp_0 = to(before.pm_1, tmp2_elvis_lhs == null ? before.qm_1 : tmp2_elvis_lhs);
        } else {
          tmp_0 = installed;
        }

        tmp = tmp_0;
        break;
      default:
        tmp = null;
        break;
    }
    var withinCurrentEvent = tmp;
    if (!(withinCurrentEvent == null)) {
      this.sdy_1 = withinCurrentEvent.pm_1;
      this.rdy_1 = withinCurrentEvent.qm_1;
      this.udy_1 = this.tdy_1;
    }
    return notificationType.equals(GameFlowNotificationType_AfterNotificationApplied_getInstance()) ? RevertMode_DefaultRevert_getInstance() : !(withinCurrentEvent == null) ? RevertMode_ReapplyJustCurrent_getInstance() : RevertMode_RevertFirstForSure_getInstance();
  }
  *gdz(holder, question, mayNothing, $completion) {
    var answer = this.tdy_1;
    var startingAnswer = this.udy_1;
    var startingStep = this.rdy_1;
    var step = this.sdy_1;
    var beforeMap = this.xdy_1;
    var map = this.ydy_1;
    try {
      this.udy_1 = 2147483647;
      // Inline function 'kotlin.with' call
      yield* this.cdz(holder, question, mayNothing, $completion);
      yield* this.edw(holder, question, mayNothing, $completion);
    }finally {
      this.tdy_1 = answer;
      this.udy_1 = startingAnswer;
      this.rdy_1 = startingStep;
      this.sdy_1 = step;
      this.xdy_1 = beforeMap;
      this.ydy_1 = map;
    }
    return Unit_instance;
  }
}
class OnboardingHint extends Enum {
  constructor(name, ordinal, needNextButton, text) {
    super(name, ordinal);
    this.mdz_1 = needNextButton;
    this.ndz_1 = text;
  }
}
class OnboardingSequence extends Enum {
  constructor(name, ordinal, hints) {
    super(name, ordinal);
    this.qdz_1 = hints;
  }
}
class OnboardingScript extends OnboardingGameFlowListener {
  constructor(onHint) {
    var tmp;
    if (onHint === VOID) {
      tmp = OnboardingScript$_init_$slambda_qyeczq();
    } else {
      tmp = onHint;
    }
    onHint = tmp;
    super();
    this.ae0_1 = onHint;
  }
  he0() {
    return false;
  }
  ie0(holder) {
    return true;
  }
  *je0(holder, hint, $completion) {
    yield* this.ae0_1(hint, $completion);
    return Unit_instance;
  }
  *ge0(holder, closeHint, $completion) {
    return Unit_instance;
  }
  de0(holder, closeHint, $completion, $super) {
    closeHint = closeHint === VOID ? true : closeHint;
    return $super === VOID ? this.ge0(holder, closeHint, $completion) : $super.ge0.call(this, holder, closeHint, $completion);
  }
  ke0(holder) {
  }
  *ce0(holder, hint, $completion) {
    if (this.he0()) {
      this.qdy_1.m1(hint.ndz_1).m1('\n\n');
      return Unit_instance;
    }
    this.adz(holder.t6h().g38_1);
    if (!this.ie0(holder) || this.sdy_1 <= this.rdy_1 || this.tdy_1 < this.udy_1) {
      this.xdy_1 = this.ydy_1;
      return Unit_instance;
    }
    yield* this.je0(holder, hint, $completion);
    this.xdy_1 = this.ydy_1;
    return Unit_instance;
  }
  *be0(holder, sequence, $completion) {
    var _iterator__ex2g4s = sequence.qdz_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var hint = _iterator__ex2g4s.r1();
      yield* this.ce0(holder, hint, $completion);
    }
    return Unit_instance;
  }
  ee0(x, y, scale) {
    this.xdy_1 = this.ydy_1;
    this.ydy_1 = new MapUiScalingAndPosition(x, y, scale);
  }
  fe0() {
    this.xdy_1 = this.ydy_1;
    this.ee0(0, 0, 0.166728);
  }
  *hdz(stateHolder, event, $completion) {
    if (!stateHolder.y6h()) {
      return Unit_instance;
    }
    var tmp = GameFlowNotificationType_BeforeNotificationApplied_getInstance();
    yield* this.ddz(stateHolder, tmp, OnboardingScript$beforeNotificationApplied$slambda(stateHolder, this, event), $completion);
    return Unit_instance;
  }
  *idz(stateHolder, event, $completion) {
    var tmp = GameFlowNotificationType_AfterNotificationApplied_getInstance();
    yield* this.ddz(stateHolder, tmp, OnboardingScript$afterNotificationApplied$slambda(stateHolder, this, event), $completion);
    return Unit_instance;
  }
  *cdz(stateHolder, gameQuestion, mayNothing, $completion) {
    yield* protoOf(OnboardingGameFlowListener).cdz.call(this, stateHolder, gameQuestion, mayNothing, $completion);
    var tmp = GameFlowNotificationType_BeforeAnswer_getInstance();
    yield* this.ddz(stateHolder, tmp, OnboardingScript$beforeAnswer$slambda(stateHolder, this, gameQuestion), $completion);
    return Unit_instance;
  }
  *edw(stateHolder, gameQuestion, mayNothing, $completion) {
    var tmp = GameFlowNotificationType_WhenChoiceUiWasInstalled_getInstance();
    yield* this.ddz(stateHolder, tmp, OnboardingScript$whenChoiceUiWasInstalled$slambda(this, stateHolder, gameQuestion), $completion);
    return Unit_instance;
  }
  *jdz(stateHolder, gameQuestion, mayNothing, answer, $completion) {
    this.ke0(stateHolder);
    var tmp = GameFlowNotificationType_AnswerWasGiven_getInstance();
    yield* this.ddz(stateHolder, tmp, OnboardingScript$answerWasGiven$slambda(this, stateHolder, gameQuestion, mayNothing, answer), $completion);
    return Unit_instance;
  }
}
class GameTeamProvider {}
function get_hasFullVisibility() {
  return this.k3q() === get_fullObserverGameTeamMarker();
}
function canSeePrivateInfoOf(team) {
  return this.me0() || this.k3q() === team;
}
class JustGameTeamProvider {
  constructor(gameTeam) {
    this.le0_1 = gameTeam;
  }
  k3q() {
    return this.le0_1;
  }
}
class ReplayVisibility extends Enum {
  constructor(name, ordinal, label) {
    super(name, ordinal);
    this.pe0_1 = label;
  }
}
class SwitchingGameTeamProvider {
  constructor(gameTeam, startShowAnswerFrom, loadingProgressUpdater, loadingFinishedUpdater, replayAdvanceUpdater, allowReplayVisibilitySwitching) {
    startShowAnswerFrom = startShowAnswerFrom === VOID ? 0 : startShowAnswerFrom;
    var tmp;
    if (loadingProgressUpdater === VOID) {
      tmp = SwitchingGameTeamProvider$_init_$slambda_1fvhxe();
    } else {
      tmp = loadingProgressUpdater;
    }
    loadingProgressUpdater = tmp;
    var tmp_0;
    if (loadingFinishedUpdater === VOID) {
      tmp_0 = SwitchingGameTeamProvider$_init_$slambda_1fvhxe_0();
    } else {
      tmp_0 = loadingFinishedUpdater;
    }
    loadingFinishedUpdater = tmp_0;
    var tmp_1;
    if (replayAdvanceUpdater === VOID) {
      tmp_1 = SwitchingGameTeamProvider$_init_$lambda_o57uil;
    } else {
      tmp_1 = replayAdvanceUpdater;
    }
    replayAdvanceUpdater = tmp_1;
    allowReplayVisibilitySwitching = allowReplayVisibilitySwitching === VOID ? true : allowReplayVisibilitySwitching;
    this.qe0_1 = gameTeam;
    this.re0_1 = startShowAnswerFrom;
    this.se0_1 = loadingProgressUpdater;
    this.te0_1 = loadingFinishedUpdater;
    this.ue0_1 = replayAdvanceUpdater;
    this.ve0_1 = allowReplayVisibilitySwitching;
    this.we0_1 = null;
    this.xe0_1 = null;
    this.ye0_1 = null;
    this.ze0_1 = ReplayVisibility_CurrentTeam_getInstance();
  }
  k3q() {
    return this.qe0_1;
  }
  me0() {
    return get_hasFullVisibility.call(this) || this.ze0_1.equals(ReplayVisibility_FullVisibility_getInstance());
  }
  ae1() {
    return get_fixedVisibilityTeam(this.ze0_1);
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.ce1_1 = function_0;
  }
  pj(a, b) {
    return this.ce1_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.ce1_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class RevertMode extends Enum {}
class ReplayRevertFlow {
  constructor(agent, choice, clearQuestion, listener, configuration) {
    var tmp;
    if (clearQuestion === VOID) {
      tmp = ReplayRevertFlow$_init_$slambda_mc16wj(agent);
    } else {
      tmp = clearQuestion;
    }
    clearQuestion = tmp;
    var tmp_0;
    if (listener === VOID) {
      tmp_0 = ReplayRevertFlow$_init_$lambda_tblrhq;
    } else {
      tmp_0 = listener;
    }
    listener = tmp_0;
    var tmp_1;
    if (configuration === VOID) {
      tmp_1 = ReplayRevertFlow$_init_$lambda_tblrhq_0;
    } else {
      tmp_1 = configuration;
    }
    configuration = tmp_1;
    this.de1_1 = agent;
    this.ee1_1 = choice;
    this.fe1_1 = clearQuestion;
    this.ge1_1 = listener;
    this.he1_1 = configuration;
    this.ie1_1 = true;
    this.je1_1 = false;
    this.ke1_1 = null;
  }
  *pe1(revertMode, $completion) {
    var tmp0_elvis_lhs = this.ke1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var revert = tmp;
    this.je1_1 = true;
    try {
      var tmp_0 = this.ge1_1();
      var onboarding = tmp_0 instanceof OnboardingGameFlowListener ? tmp_0 : null;
      yield* /*#__NOINLINE__*/performRewind(this, revertMode, revert, onboarding, $completion);
    }finally {
      this.je1_1 = false;
    }
    return Unit_instance;
  }
}
class ReplayRevertConfiguration {
  constructor(isOnboardingMode, alwaysPlayPrecisely) {
    isOnboardingMode = isOnboardingMode === VOID ? false : isOnboardingMode;
    alwaysPlayPrecisely = alwaysPlayPrecisely === VOID ? false : alwaysPlayPrecisely;
    this.me1_1 = isOnboardingMode;
    this.ne1_1 = alwaysPlayPrecisely;
  }
  toString() {
    return 'ReplayRevertConfiguration(isOnboardingMode=' + this.me1_1 + ', alwaysPlayPrecisely=' + this.ne1_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.me1_1);
    result = imul(result, 31) + getBooleanHashCode(this.ne1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplayRevertConfiguration))
      return false;
    if (!(this.me1_1 === other.me1_1))
      return false;
    if (!(this.ne1_1 === other.ne1_1))
      return false;
    return true;
  }
}
class SameScreenFlowAgent {
  constructor(gameTeam, switchingGameTeamProvider, presentation, configuration, requireHotSeatHandover) {
    var tmp;
    if (configuration === VOID) {
      tmp = SameScreenFlowAgent$_init_$lambda_hk2r4q;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    requireHotSeatHandover = requireHotSeatHandover === VOID ? false : requireHotSeatHandover;
    this.qe1_1 = gameTeam;
    this.re1_1 = switchingGameTeamProvider;
    this.se1_1 = presentation;
    this.te1_1 = configuration;
    this.ue1_1 = requireHotSeatHandover;
    this.we1_1 = false;
    this.xe1_1 = null;
    this.ye1_1 = true;
  }
  se2(_set____db54di) {
    this.ve1_1 = _set____db54di;
  }
  o6t() {
    var tmp = this.ve1_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('savedAnswers');
    }
  }
  *p6t($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion) {
    var tmp = this.se1_1.te2();
    return yield* installAnswer(tmp, SameScreenFlowAgent$chooseDeferred$slambda(this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing), $completion);
  }
  *r6t(notification, $completion) {
    if (!(this.ve1_1 == null) && shouldBufferReplayNotification(this.o6t().z6x(), this.re1_1.re0_1)) {
      if (this.re1_1.we0_1 == null)
        this.re1_1.we0_1 = new CurrentAndOldStateHolderSimple(this.te1_1().ae2_1);
      var currentAndOldStateHolder = ensureNotNull(this.re1_1.we0_1);
      var tmp;
      if (!currentAndOldStateHolder.y6h()) {
        tmp = true;
      } else {
        var tmp_0 = currentAndOldStateHolder.t6h().g38_1;
        var tmp0_safe_receiver = notification.y3p_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e3q_1;
        tmp = tmp_0 < (tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs);
      }
      if (tmp) {
        // Inline function 'kotlin.with' call
        yield* this.te1_1().be2_1.hdz(currentAndOldStateHolder, notification.x3p_1, $completion);
        yield* currentAndOldStateHolder.z6h(notification, $completion);
        // Inline function 'kotlin.with' call
        yield* this.te1_1().be2_1.idz(currentAndOldStateHolder, notification.x3p_1, $completion);
      }
      return Unit_instance;
    }
    yield* this.re1_1.te0_1($completion);
    yield* /*#__NOINLINE__*/notifyAboutGameEventImpl(this, notification, VOID, $completion);
    return Unit_instance;
  }
  *v6q(requestingTeam, $completion) {
    return yield* this.se1_1.fe2(SameScreenFlowAgent$approveMasterFixing$slambda(this, requestingTeam), $completion);
  }
  *t6q(requestingTeam, $completion) {
    return yield* this.se1_1.fe2(SameScreenFlowAgent$approveRevert$slambda(this, requestingTeam), $completion);
  }
  *u6q(event, revertingChanges, checkInfo, $completion) {
    yield* this.se1_1.fe2(SameScreenFlowAgent$revertEvent$slambda(this, checkInfo, event, revertingChanges), $completion);
    return Unit_instance;
  }
  *w6q(masterFixingEventsConsumer, $completion) {
    yield* this.se1_1.fe2(SameScreenFlowAgent$useMasterFixingEvents$slambda(masterFixingEventsConsumer, this), $completion);
    return Unit_instance;
  }
  *s6t($completion) {
    var tmp0_safe_receiver = this.re1_1.we0_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6h();
    return tmp1_elvis_lhs == null ? (yield* /*#__NOINLINE__*/showAndGetControlAgent(this, $completion)).t6h() : tmp1_elvis_lhs;
  }
  *s6q(element, $completion) {
    yield* (yield* /*#__NOINLINE__*/showAndGetControlAgent(this, $completion)).s6q(element, $completion);
    return Unit_instance;
  }
}
class ReplayQuestionReinstallException extends CancellationException {
  constructor() {
    return new.target.qe2();
  }
  static qe2() {
    var $this = this.n('Replay question reinstall requested');
    captureStack($this, $this.pe2_1);
    return $this;
  }
}
class PreparedSandbox {
  constructor(gameState, startParams, gameCode, numberOfAppliedEvents) {
    this.ue2_1 = gameState;
    this.ve2_1 = startParams;
    this.we2_1 = gameCode;
    this.xe2_1 = numberOfAppliedEvents;
  }
  toString() {
    return 'PreparedSandbox(gameState=' + this.ue2_1.toString() + ', startParams=' + this.ve2_1.toString() + ', gameCode=' + toString_0(this.we2_1) + ', numberOfAppliedEvents=' + this.xe2_1 + ')';
  }
  hashCode() {
    var result = this.ue2_1.hashCode();
    result = imul(result, 31) + this.ve2_1.hashCode() | 0;
    result = imul(result, 31) + (this.we2_1 == null ? 0 : this.we2_1.hashCode()) | 0;
    result = imul(result, 31) + this.xe2_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreparedSandbox))
      return false;
    if (!this.ue2_1.equals(other.ue2_1))
      return false;
    if (!this.ve2_1.equals(other.ve2_1))
      return false;
    if (!equals(this.we2_1, other.we2_1))
      return false;
    if (!(this.xe2_1 === other.xe2_1))
      return false;
    return true;
  }
}
class Submission {
  constructor(number, before, after, event) {
    this.ye2_1 = number;
    this.ze2_1 = before;
    this.ae3_1 = after;
    this.be3_1 = event;
  }
  toString() {
    return 'Submission(number=' + this.ye2_1 + ', before=' + this.ze2_1.toString() + ', after=' + this.ae3_1.toString() + ', event=' + toString(this.be3_1) + ')';
  }
  hashCode() {
    var result = this.ye2_1;
    result = imul(result, 31) + this.ze2_1.hashCode() | 0;
    result = imul(result, 31) + this.ae3_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.be3_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Submission))
      return false;
    if (!(this.ye2_1 === other.ye2_1))
      return false;
    if (!this.ze2_1.equals(other.ze2_1))
      return false;
    if (!this.ae3_1.equals(other.ae3_1))
      return false;
    if (!equals(this.be3_1, other.be3_1))
      return false;
    return true;
  }
}
class SandboxSetupFlow {
  constructor(agent, specialSetup, submitRemoteEvent, notify) {
    var tmp;
    if (notify === VOID) {
      tmp = SandboxSetupFlow$_init_$slambda_5c7gnc(agent);
    } else {
      tmp = notify;
    }
    notify = tmp;
    this.ce3_1 = agent;
    this.de3_1 = specialSetup;
    this.ee3_1 = submitRemoteEvent;
    this.fe3_1 = notify;
    this.ge3_1 = Mutex();
    this.he3_1 = CompletableDeferred();
    this.ie3_1 = null;
    this.je3_1 = null;
    this.ke3_1 = false;
    this.le3_1 = false;
    this.me3_1 = 0;
  }
  *we3(initialState, gameCode, numberOfAppliedEvents, restoreArsenal, $completion) {
    return yield* coroutineScope(SandboxSetupFlow$prepare$slambda(this, numberOfAppliedEvents, gameCode, initialState, restoreArsenal), $completion);
  }
  *ue3(event, $completion) {
    var tmp0 = this.je3_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Sandbox setup is not active';
        throw IllegalStateException.o(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var scope = tmp$ret$0;
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    var operation = async(scope, VOID, tmp, SandboxSetupFlow$submitEvent$slambda(this, event));
    try {
      // Inline function 'kotlin.getOrThrow' call
      var this_0 = (yield* operation.m1q($completion)).zw_1;
      throwOnFailure(this_0);
      _Result___get_value__impl__bjfvqg(this_0);
    }finally {
      operation.o1n();
    }
    return Unit_instance;
  }
  *xe3(params, $completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.ge3_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      var tmp$ret$1;
      $l$block: {
        if (!this.ke3_1 || !this.le3_1) {
          tmp$ret$1 = false;
          break $l$block;
        }
        // Inline function 'kotlin.require' call
        if (!!equals(params.h6x_1, NonePhase_getInstance())) {
          var message = 'Game phase should be initialized for sandbox play';
          throw IllegalArgumentException.h2(toString(message));
        }
        this.le3_1 = false;
        tmp$ret$1 = this.he3_1.l1t(params);
      }
      tmp = tmp$ret$1;
    }finally {
      this_0.k2a(null);
    }
    return tmp;
  }
}
class SpecialSetupFlow {
  constructor(state, cleanup, refresh) {
    var tmp;
    if (cleanup === VOID) {
      tmp = SpecialSetupFlow$_init_$slambda_lybk6();
    } else {
      tmp = cleanup;
    }
    cleanup = tmp;
    var tmp_0;
    if (refresh === VOID) {
      tmp_0 = SpecialSetupFlow$_init_$slambda_lybk6_0();
    } else {
      tmp_0 = refresh;
    }
    refresh = tmp_0;
    this.ne3_1 = state;
    this.oe3_1 = cleanup;
    this.pe3_1 = refresh;
    this.qe3_1 = null;
  }
  se3() {
    var tmp = this.qe3_1;
    return tmp instanceof SandboxInit;
  }
  e1m() {
    return !(this.qe3_1 == null);
  }
  te3(gameState) {
    return activate(this, gameState, SandboxInit_instance);
  }
  re3() {
    this.qe3_1 = null;
  }
  *ve3($completion) {
    // Inline function 'kotlin.check' call
    if (!this.se3()) {
      var message = 'Sandbox setup is not active';
      throw IllegalStateException.o(toString(message));
    }
    yield* this.oe3_1($completion);
    this.re3();
    return Unit_instance;
  }
  *w6q(masterFixingEventsConsumer, $completion) {
    if (!(masterFixingEventsConsumer == null)) {
      var tmp = this.qe3_1;
      if (tmp instanceof MasterFixing)
        return Unit_instance;
      activate(this, this.ne3_1.t6h().y4l(), new MasterFixing(masterFixingEventsConsumer));
    } else {
      var tmp_0 = this.qe3_1;
      if (!(tmp_0 instanceof MasterFixing))
        return Unit_instance;
      yield* this.oe3_1($completion);
      this.re3();
    }
    yield* this.pe3_1($completion);
    return Unit_instance;
  }
  *ye3(event, submitSandboxEvent, $completion) {
    var active = this.qe3_1;
    var tmp;
    if (equals(active, SandboxInit_instance)) {
      yield* submitSandboxEvent(event, $completion);
      tmp = true;
    } else {
      if (active instanceof MasterFixing) {
        tmp = yield* active.ze3_1.l95(event, $completion);
      } else {
        if (active == null) {
          // Inline function 'kotlin.error' call
          var message = 'Special setup mode is not active';
          throw IllegalStateException.o(toString(message));
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  *ae4($completion) {
    var tmp = this.qe3_1;
    var tmp0_elvis_lhs = tmp instanceof MasterFixing ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var active = tmp_0;
    if (!(yield* active.ze3_1.l95(null, $completion)))
      return false;
    if (this.qe3_1 === active)
      yield* this.w6q(null, $completion);
    return true;
  }
}
class SandboxInit {
  toString() {
    return 'SandboxInit';
  }
  hashCode() {
    return -1103117339;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxInit))
      return false;
    return true;
  }
}
class MasterFixing {
  constructor(eventsConsumer) {
    this.ze3_1 = eventsConsumer;
  }
}
class EmptyListener {}
class UiFlowConfiguration {
  constructor(diagnostics, globalGameFlowListener, isOfflineReplay, isWaitingForStartReplayMode, logGivenAnswer) {
    diagnostics = diagnostics === VOID ? PrintingGameRuntimeDiagnostics_instance : diagnostics;
    globalGameFlowListener = globalGameFlowListener === VOID ? EmptyListener_instance : globalGameFlowListener;
    isOfflineReplay = isOfflineReplay === VOID ? false : isOfflineReplay;
    isWaitingForStartReplayMode = isWaitingForStartReplayMode === VOID ? false : isWaitingForStartReplayMode;
    var tmp;
    if (logGivenAnswer === VOID) {
      tmp = UiFlowConfiguration$_init_$lambda_zls2f;
    } else {
      tmp = logGivenAnswer;
    }
    logGivenAnswer = tmp;
    this.ae2_1 = diagnostics;
    this.be2_1 = globalGameFlowListener;
    this.ce2_1 = isOfflineReplay;
    this.de2_1 = isWaitingForStartReplayMode;
    this.ee2_1 = logGivenAnswer;
  }
  toString() {
    return 'UiFlowConfiguration(diagnostics=' + toString(this.ae2_1) + ', globalGameFlowListener=' + toString(this.be2_1) + ', isOfflineReplay=' + this.ce2_1 + ', isWaitingForStartReplayMode=' + this.de2_1 + ', logGivenAnswer=' + toString(this.ee2_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.ae2_1);
    result = imul(result, 31) + hashCode(this.be2_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ce2_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.de2_1) | 0;
    result = imul(result, 31) + hashCode(this.ee2_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UiFlowConfiguration))
      return false;
    if (!equals(this.ae2_1, other.ae2_1))
      return false;
    if (!equals(this.be2_1, other.be2_1))
      return false;
    if (!(this.ce2_1 === other.ce2_1))
      return false;
    if (!(this.de2_1 === other.de2_1))
      return false;
    if (!equals(this.ee2_1, other.ee2_1))
      return false;
    return true;
  }
}
//endregion
function *inQuestionScope($this, block, $completion) {
  return yield* coroutineScope(ChoiceFlow$inQuestionScope$slambda($this, block), $completion);
}
function ChoiceFlow$_init_$lambda_cpbfms() {
  return new ChoiceFlowConfiguration();
}
function ChoiceFlow$installQuestion$slambda$slambda($result, $choice) {
  return constructCallableReference(function *($this$launch, $completion) {
    $result.l1t(yield* boundAwait($choice.ndv_1, $completion));
    return Unit_instance;
  }, 1);
}
function ChoiceFlow$installQuestion$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $scope, $result) {
  return constructCallableReference(function *($completion) {
    var choice = yield* this$0.qdv_1.adw($$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $scope, $completion);
    yield* this$0.qdv_1.bdw(choice, $scope, $completion);
    launch($scope, VOID, VOID, ChoiceFlow$installQuestion$slambda$slambda($result, choice));
    return Unit_instance;
  }, 0);
}
function ChoiceFlow$inQuestionScope$slambda(this$0, $block) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var job = $this$coroutineScope.d1m().ae(Key_instance);
    this$0.zdv_1 = job;
    var tmp;
    try {
      tmp = yield* $block($this$coroutineScope, $completion);
    }finally {
      if (this$0.zdv_1 === job) {
        this$0.zdv_1 = null;
        this$0.qdv_1.cdw();
      }
    }
    return tmp;
  }, 1);
}
function ChoiceFlow$chooseImpl$lambda() {
  return Unit_instance;
}
function ChoiceFlow$chooseImpl$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $onInstalled) {
  return constructCallableReference(function *($this$inQuestionScope, $completion) {
    var answer = yield* this$0.ddw($$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $this$inQuestionScope, $completion);
    $onInstalled();
    // Inline function 'kotlin.with' call
    var $this$with = this$0.pdv_1;
    yield* this$0.sdv_1().edw($this$with, $question, $mayNothing, $completion);
    var result = yield* boundAwait(answer, $completion);
    cancelChildren($this$inQuestionScope.d1m());
    return result;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda$slambda$slambda$slambda(this$0, $savedAnswer) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* this$0.qdv_1.fdw($savedAnswer, $completion);
    return Unit_instance;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda$slambda$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $onInstalled, $installed, $savedAnswer) {
  return constructCallableReference(function *($this$inQuestionScope, $completion) {
    var answer = yield* this$0.ddw($$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $this$inQuestionScope, $completion);
    $onInstalled();
    $installed.l1t(Unit_instance);
    var tmp;
    if (!this$0.pdv_1.gdw()) {
      launch($this$inQuestionScope, VOID, VOID, ChoiceFlow$chooseImpl$slambda$slambda$slambda$slambda(this$0, $savedAnswer));
      tmp = Unit_instance;
    }
    var value = yield* boundAwait(answer, $completion);
    cancelChildren($this$inQuestionScope.d1m());
    return value;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda$slambda(this$0, $savedAnswer, $$context_GameStateRuntime_ogzdp3, $result, $question, $mayNothing, $onInstalled, $installed) {
  return constructCallableReference(function *($this$launch, $completion) {
    $l$loop: while (true) {
      var liveAnswer = yield* /*#__NOINLINE__*/inQuestionScope(this$0, ChoiceFlow$chooseImpl$slambda$slambda$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $onInstalled, $installed, $savedAnswer), $completion);
      if (!equals(liveAnswer, $savedAnswer)) {
        if (!this$0.tdv_1().ndw_1.equals(AnotherAnswerReaction_AllowOtherAnswers_getInstance())) {
          yield* this$0.qdv_1.hdw($completion);
          continue $l$loop;
        }
        reportWarning($$context_GameStateRuntime_ogzdp3, 'Non-predefined answer was chosen');
        this$0.rdv_1.pdw(ensureNotNull(this$0.pdv_1.o6t()).z6x());
        this$0.pdv_1.qdw(null);
      }
      $result.l1t(liveAnswer);
      break $l$loop;
    }
    return Unit_instance;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda$slambda_0($installed, this$0, $question, $mayNothing) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $installed.m1q($completion);
    // Inline function 'kotlin.with' call
    var $this$with = this$0.pdv_1;
    yield* this$0.sdv_1().edw($this$with, $question, $mayNothing, $completion);
    return Unit_instance;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda$slambda_1($installed, this$0, $savedAnswer, $animations, $result) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $installed.m1q($completion);
    var tmp;
    if (this$0.pdv_1.gdw()) {
      var tmp_0;
      if (!this$0.tdv_1().ldw_1) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        tmp_0 = yield* delay(tmp$ret$0, $completion);
      }
      tmp = tmp_0;
    } else {
      tmp = yield* this$0.pdv_1.rdw().n22($completion);
    }
    var tmp_1;
    if (!this$0.tdv_1().ldw_1) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $animations;
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element.u6x().equals(AnimationInsertionType_JustBeforeAnswer_getInstance())) {
          destination.d2(element);
        }
      }
      tmp_1 = yield* this$0.qdv_1.sdw($savedAnswer, destination, $completion);
    }
    yield* this$0.qdv_1.tdw($completion);
    $result.l1t($savedAnswer);
    return Unit_instance;
  }, 1);
}
function ChoiceFlow$chooseImpl$slambda_0(this$0, $savedAnswer, $$context_GameStateRuntime_ogzdp3, $question, $mayNothing, $onInstalled, $animations) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var result = CompletableDeferred();
    var installed = CompletableDeferred();
    launch($this$coroutineScope, VOID, VOID, ChoiceFlow$chooseImpl$slambda$slambda(this$0, $savedAnswer, $$context_GameStateRuntime_ogzdp3, result, $question, $mayNothing, $onInstalled, installed));
    launch($this$coroutineScope, VOID, VOID, ChoiceFlow$chooseImpl$slambda$slambda_0(installed, this$0, $question, $mayNothing));
    launch($this$coroutineScope, VOID, VOID, ChoiceFlow$chooseImpl$slambda$slambda_1(installed, this$0, $savedAnswer, $animations, result));
    var answer = yield* boundAwait(result, $completion);
    cancelChildren($this$coroutineScope.d1m());
    return answer;
  }, 1);
}
function *reconnectClientAfterReload(oldSession, requestReload, showWaiting, reconnect, startGame, $completion) {
  return yield* supervisorScope(reconnectClientAfterReload$slambda(requestReload, showWaiting, oldSession, reconnect, startGame), $completion);
}
function *processDuelSession(_this__u8e3s4, setup, reconnectSession, onReloadRequired, onReconnectUnavailable, $completion) {
  reconnectSession = reconnectSession === VOID ? true : reconnectSession;
  onReloadRequired = onReloadRequired === VOID ? null : onReloadRequired;
  var tmp;
  if (onReconnectUnavailable === VOID) {
    tmp = processDuelSession$slambda(setup);
  } else {
    tmp = onReconnectUnavailable;
  }
  onReconnectUnavailable = tmp;
  if (reconnectSession && get_clientSetupOrNull(yield* _this__u8e3s4.g6l(setup.o6q_1, setup.p6q_1, VOID, $completion)) == null) {
    yield* onReconnectUnavailable($completion);
    return Unit_instance;
  }
  yield* _this__u8e3s4.u6l(new Duel(setup.o6q_1, setup.p6q_1), onReloadRequired, $completion);
  return Unit_instance;
}
function reconnectClientAfterReload$slambda$slambda($it) {
  return constructCallableReference(function *($this$async, $completion) {
    yield* $it($completion);
    return Unit_instance;
  }, 1);
}
function reconnectClientAfterReload$slambda($requestReload, $showWaiting, $oldSession, $reconnect, $startGame) {
  return constructCallableReference(function *($this$supervisorScope, $completion) {
    var tmp0_safe_receiver = $requestReload;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp = async($this$supervisorScope, VOID, tmp_0, reconnectClientAfterReload$slambda$slambda(tmp0_safe_receiver));
    }
    var reloadRequest = tmp;
    var tmp_1;
    try {
      yield* $showWaiting($completion);
      yield* cancelAndJoin($oldSession, $completion);
      if (reloadRequest == null)
        null;
      else
        yield* reloadRequest.m1q($completion);
      yield* $reconnect($completion);
      tmp_1 = yield* $startGame($completion);
    }finally {
      $oldSession.o1n();
    }
    return Unit_instance;
  }, 1);
}
function processDuelSession$slambda($setup) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.error' call
    var message = 'Cannot reconnect to game ' + $setup.o6q_1.o6k_1;
    throw IllegalStateException.o(toString(message));
  }, 0);
}
var NewGameSetup_instance;
function NewGameSetup_getInstance() {
  return NewGameSetup_instance;
}
var LoadGameSetup_instance;
function LoadGameSetup_getInstance() {
  return LoadGameSetup_instance;
}
var GameFlowNotificationType_BeforeNotificationApplied_instance;
var GameFlowNotificationType_AfterNotificationApplied_instance;
var GameFlowNotificationType_BeforeAnswer_instance;
var GameFlowNotificationType_WhenChoiceUiWasInstalled_instance;
var GameFlowNotificationType_AnswerWasGiven_instance;
var GameFlowNotificationType_entriesInitialized;
function GameFlowNotificationType_initEntries() {
  if (GameFlowNotificationType_entriesInitialized)
    return Unit_instance;
  GameFlowNotificationType_entriesInitialized = true;
  GameFlowNotificationType_BeforeNotificationApplied_instance = new GameFlowNotificationType('BeforeNotificationApplied', 0);
  GameFlowNotificationType_AfterNotificationApplied_instance = new GameFlowNotificationType('AfterNotificationApplied', 1);
  GameFlowNotificationType_BeforeAnswer_instance = new GameFlowNotificationType('BeforeAnswer', 2);
  GameFlowNotificationType_WhenChoiceUiWasInstalled_instance = new GameFlowNotificationType('WhenChoiceUiWasInstalled', 3);
  GameFlowNotificationType_AnswerWasGiven_instance = new GameFlowNotificationType('AnswerWasGiven', 4);
}
function rewindModeAcrossNotification$checkpoint(this$0, $holder, type) {
  var tmp0_safe_receiver = this$0.wdy_1.w4(to(this$0.tdy_1, $holder.t6h().g38_1));
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(type);
}
function GameFlowNotificationType_BeforeNotificationApplied_getInstance() {
  GameFlowNotificationType_initEntries();
  return GameFlowNotificationType_BeforeNotificationApplied_instance;
}
function GameFlowNotificationType_AfterNotificationApplied_getInstance() {
  GameFlowNotificationType_initEntries();
  return GameFlowNotificationType_AfterNotificationApplied_instance;
}
function GameFlowNotificationType_BeforeAnswer_getInstance() {
  GameFlowNotificationType_initEntries();
  return GameFlowNotificationType_BeforeAnswer_instance;
}
function GameFlowNotificationType_WhenChoiceUiWasInstalled_getInstance() {
  GameFlowNotificationType_initEntries();
  return GameFlowNotificationType_WhenChoiceUiWasInstalled_instance;
}
function GameFlowNotificationType_AnswerWasGiven_getInstance() {
  GameFlowNotificationType_initEntries();
  return GameFlowNotificationType_AnswerWasGiven_instance;
}
var OnboardingHint_WelcomeToTheInteractiveOnboardingForThe_instance;
var OnboardingHint_WhenYouBeginANewGameYou_instance;
var OnboardingHint_FirstOfAllTheContractSpecifiesThe_instance;
var OnboardingHint_NextTheContractDefinesTheWinningConditions_instance;
var OnboardingHint_SettlersAreRepresentedByNobleTypeBlueNoble_instance;
var OnboardingHint_TheFarmerTypeYellowMeeplesAreTheFarmers_instance;
var OnboardingHint_TheNobleTypeBlueMeeplesAreTheNobles_instance;
var OnboardingHint_BesidesSettlersTheMapContainsALot_instance;
var OnboardingHint_BothTheBeastAndTheHuntersTeams_instance;
var OnboardingHint_YouCanFindHPValuesAndOneGrudge_instance;
var OnboardingHint_UsuallyContractsIncludeSeveralDaysThisContract_instance;
var OnboardingHint_YouWillSpendMostOfTheGame_instance;
var OnboardingHint_CardsAreEssentiallyTheMainResourceIn_instance;
var OnboardingHint_LetSTalkALittleMoreAbout_instance;
var OnboardingHint_EveryCharacterHasItsOwnSetOf_instance;
var OnboardingHint_DiscardPilesAreOpenInformationInThe_instance;
var OnboardingHint_ActionCardsAreTheCoreDriverOf_instance;
var OnboardingHint_ThereAre16ActionCardsThatAre_instance;
var OnboardingHint_ButYouCanKeepArsenalCardsBeastly_instance;
var OnboardingHint_HoweverArsenalCardsAreNotEasyTo_instance;
var OnboardingHint_AlsoEveryCardHasASpecialKind_instance;
var OnboardingHint_RedSignRedAndBlueSignBlueCardsAre_instance;
var OnboardingHint_ReactionSignReactionCardsArePlayedWhenTheir_instance;
var OnboardingHint_TrapSignTrapCardsArePlayedLikeBlueSign_instance;
var OnboardingHint_SomeArsenalCardsHaveTheOneGrudgeGrudge_instance;
var OnboardingHint_LetSReturnToTheGameFlow_instance;
var OnboardingHint_InMostContractsTheNightPhaseHas_instance;
var OnboardingHint_TheseRewardsAreSpecifiedByTheContract_instance;
var OnboardingHint_TheRewardWillBeGivenToYou_instance;
var OnboardingHint_AtTheBeginningOfTheGameReveal_instance;
var OnboardingHint_ThenPlayersChooseTheirCharactersTheBeast_instance;
var OnboardingHint_EveryBeastHasACharacterBoardWith_instance;
var OnboardingHint_EveryBeastHasAPreferredLocationType_instance;
var OnboardingHint_BolginHas5HP_instance;
var OnboardingHint_AlsoEveryBeastHas4AbilityCards_instance;
var OnboardingHint_LetSLookAgainAtBolginS_instance;
var OnboardingHint_EveryBeastHasItsOwnSummonsSo_instance;
var OnboardingHint_EachSummonHas3ActionsMoveOne_instance;
var OnboardingHint_SoBolginSPolypsCanBurstA_instance;
var OnboardingHint_TheBeastHasBeenChosenSoThe_instance;
var OnboardingHint_EveryHunterHasASetOfThree_instance;
var OnboardingHint_TheThirdAbilityCardIsAUnique_instance;
var OnboardingHint_EveryHunterAlsoHasACharacterBoard_instance;
var OnboardingHint_LetSPickVarjaAsTheSecond_instance;
var OnboardingHint_VarjaHasTheSameTrackAndHunt_instance;
var OnboardingHint_ForTheLastPositionLetSPick_instance;
var OnboardingHint_IonaIsVeryNiceForTheLast_instance;
var OnboardingHint_ContractsAlsoSpecifyAdditionalRulesAndStarting_instance;
var OnboardingHint_TheBeastStartsTheGameInThe_instance;
var OnboardingHint_YouMayAlsoNoticeWhiteLinesSplitting_instance;
var OnboardingHint_AtTheBeginningOfTheGameThe_instance;
var OnboardingHint_ToReceiveTheFirstNightRewardBolgin_instance;
var OnboardingHint_TheMapHas3ConvenientSwampLocations_instance;
var OnboardingHint_AndTheNextStepToTheLeft_instance;
var OnboardingHint_WhenTheBeastMovesItMustPut_instance;
var OnboardingHint_ForThisMovementBolginHasToPut_instance;
var OnboardingHint_ThereAreFiveTypesOfMovementCards_instance;
var OnboardingHint_ItIsImportantThatBeastCannotPlay_instance;
var OnboardingHint_ToSimplifyTheTrackingOfBeastThis_instance;
var OnboardingHint_TrailsTrailIsAnImportantConceptIn_instance;
var OnboardingHint_LetSSwitchToTheHuntersPerspective_instance;
var OnboardingHint_HuntersDonTSeeTheBeastS_instance;
var OnboardingHint_ActuallyTheBeastCanBeInTwo_instance;
var OnboardingHint_NowItIsTheHunterSPart_instance;
var OnboardingHint_HuntersGainManyBonusesWhenTheyStay_instance;
var OnboardingHint_SoLetSPlaceHelgaInTiveden_instance;
var OnboardingHint_NowLetSPlaceVarjaInGhastvik_instance;
var OnboardingHint_AndLetSPlaceIonaInGhastvik_instance;
var OnboardingHint_BeforeTheDraftBeginsTheBeastReceives_instance;
var OnboardingHint_LetSPlayALittleBitGreedy_instance;
var OnboardingHint_TheBeastGameIsDesignedSoThat_instance;
var OnboardingHint_LetSPickEnsnareActionCardFor_instance;
var OnboardingHint_ForVarjaLetSPickTheCharge_instance;
var OnboardingHint_AndAtLastLetSChooseHidden_instance;
var OnboardingHint_WhenAllPlayersHavePickedACard_instance;
var OnboardingHint_LetSPickTheAnimateCard_instance;
var OnboardingHint_LetSPickTheAdaptCardFor_instance;
var OnboardingHint_ForVarijaLetSPickTheDark_instance;
var OnboardingHint_AndForIonaLetSPickThe_instance;
var OnboardingHint_DuringTheDayPhaseAllPlayersTake_instance;
var OnboardingHint_PassingIsNotFinalAPlayerMay_instance;
var OnboardingHint_APlayerMayPassOnlyIfNo_instance;
var OnboardingHint_RightNowBolginHas4AbilityCards_instance;
var OnboardingHint_DuringATurnAPlayerCanEither_instance;
var OnboardingHint_SometimesYouMayWantToMoveBut_instance;
var OnboardingHint_NowLetSPlayTheEngorgeCard_instance;
var OnboardingHint_JustClickOnTheEngorgeCard_instance;
var OnboardingHint_WhenYouPlayACardYouShould_instance;
var OnboardingHint_TechnicallyYouCanSkipAllStatementsOn_instance;
var OnboardingHint_SoInThisCaseBolginPerformsAn_instance;
var OnboardingHint_WhenTheBeastRevealsHuntersCanPlay_instance;
var OnboardingHint_WhenAttackingTheBeastMustDeclareA_instance;
var OnboardingHint_ByDefaultEveryBeastDealsOneDamage_instance;
var OnboardingHint_SheepTypeHasJust1HPSoBolgin_instance;
var OnboardingHint_BolginPlayedTheFirstCardAndIt_instance;
var OnboardingHint_LetSPlayTheSummonPolypCard_instance;
var OnboardingHint_ThisCardContainsTwoStatementsThatCan_instance;
var OnboardingHint_LetSStartWithTheSummonActivationAction_instance;
var OnboardingHint_WhenYouPlayASummonActivationActionYou_instance;
var OnboardingHint_SinceThereIsNoPolypOnThe_instance;
var OnboardingHint_EveryBeastHasItsOwnSummonLimit_instance;
var OnboardingHint_EveryBeastCanPlaceASummonOnly_instance;
var OnboardingHint_LetSPlaceAPolypJustAbove_instance;
var OnboardingHint_WhenASummonIsActivatedItPerforms_instance;
var OnboardingHint_LikeHuntersAndBeastsSummonsHave1_instance;
var OnboardingHint_WhileSummonsAreQuiteDeadlyTheyHave_instance;
var OnboardingHint_AndNowLetSMoveBolginOne_instance;
var OnboardingHint_BolginHasPlayedTwoCardsAndIt_instance;
var OnboardingHint_NoteThatHelgaCanPassNowIt_instance;
var OnboardingHint_LetSPlayTheEnsnareCard_instance;
var OnboardingHint_TheEnsnareCardAllowsYouToSee_instance;
var OnboardingHint_LetSDiscardTheBeastlyTongueCard_instance;
var OnboardingHint_LetSKeepTheCardsAndEnd_instance;
var OnboardingHint_LetSMoveCloseToBeastPlay_instance;
var OnboardingHint_TheInciteCardAllowsYouToMove_instance;
var OnboardingHint_HuntersPerformMovementStepByStepAnd_instance;
var OnboardingHint_MoveVarjaOneStepLower_instance;
var OnboardingHint_NoteThatAllHunterMovementsAsWell_instance;
var OnboardingHint_NowLetSMoveIonaOneStep_instance;
var OnboardingHint_LetSNowFinishVarjsSTurn_instance;
var OnboardingHint_WhileTheTwoHuntersAreTogetherLet_instance;
var OnboardingHint_SoNowBothVarjaAndIonaCan_instance;
var OnboardingHint_ThereAre3OpenHunterItemsAnd_instance;
var OnboardingHint_IonaReceivedTheSmokebombCardThisCard_instance;
var OnboardingHint_NowItIsTimeToPickAn_instance;
var OnboardingHint_NowLetSKillThatPolypPlay_instance;
var OnboardingHint_TheAttackInTheSilverArrowCard_instance;
var OnboardingHint_NearbyLocationsAreLocationsThatAre1_instance;
var OnboardingHint_SoLetSPlayTheAttackAnd_instance;
var OnboardingHint_ThisIsWhyTheSilverArrowIs_instance;
var OnboardingHint_NoteThatBolginIsNowInA_instance;
var OnboardingHint_LetSPlayTheUnearthCardTo_instance;
var OnboardingHint_LetSPickTheBrutalityCard_instance;
var OnboardingHint_AndLetSJustFinishTheTurn_instance;
var OnboardingHint_BolginPlayedQuiteGreedilyLetSPunish_instance;
var OnboardingHint_NowTheHuntersKnowForSureWhere_instance;
var OnboardingHint_LetSFinishHelgaSTurnNow_instance;
var OnboardingHint_NowLetSMoveVarjaOntoBolgin_instance;
var OnboardingHint_LetSMoveVarjaOneStepTo_instance;
var OnboardingHint_AndNowLetSPlayTheTrack_instance;
var OnboardingHint_LetSMoveOneMoreStepRight_instance;
var OnboardingHint_WhenTheBeastIsHiddenTheStandee_instance;
var OnboardingHint_EvenThoughTheHuntersAlreadyKnowWhere_instance;
var OnboardingHint_NowItSTimeToRelocateIona_instance;
var OnboardingHint_LetSChooseIona_instance;
var OnboardingHint_AsTheDestinationLetSChooseVarja_instance;
var OnboardingHint_AtLastPlayTheHuntCard_instance;
var OnboardingHint_SoBolginPaidForTheirGreedyPlay_instance;
var OnboardingHint_NoteThatBolginMustPayOneOneGrudge_instance;
var OnboardingHint_LetSChooseTheSheepType_instance;
var OnboardingHint_PlayersCanIncreaseTheDamageByUsing_instance;
var OnboardingHint_WhenYouSpendAnAncientPowerReturnIt_instance;
var OnboardingHint_LetSSaveAncientPowerForNowJust_instance;
var OnboardingHint_NowIonaCanPlayHerSmokebombCard_instance;
var OnboardingHint_BolginNeedsToMoveAwayFromThe_instance;
var OnboardingHint_NowItIsConvenientTimeToPlay_instance;
var OnboardingHint_NoteThatMovingBolginToTheRight_instance;
var OnboardingHint_LetSMoveBolginOneMoreStep_instance;
var OnboardingHint_AndNowLetSTrickTheHunters_instance;
var OnboardingHint_LetSPlayTheDarkDealingsCard_instance;
var OnboardingHint_TheDarkDealingsCardAllowsToReturn_instance;
var OnboardingHint_LetSEndHelgaSTurn_instance;
var OnboardingHint_TheHuntersCanTryToCheckBolgin_instance;
var OnboardingHint_HuntersDonTKnowWhereBolginMoved_instance;
var OnboardingHint_MoveTheFarmerTypeOneStepUp_instance;
var OnboardingHint_TheTrailIsFoundSoLetS_instance;
var OnboardingHint_MoveIonaOneStepRight_instance;
var OnboardingHint_NowItIsAGoodTimeTo_instance;
var OnboardingHint_NoteThatDarkRitualsCardAlsoDeals_instance;
var OnboardingHint_TheSaferPlayWouldBeToReturn_instance;
var OnboardingHint_AndLetSReturnTheCommandCard_instance;
var OnboardingHint_NowTheHuntersNeedToProtectBoth_instance;
var OnboardingHint_MoveIonaOneStepLeft_instance;
var OnboardingHint_AndOneMoreStepLeft_instance;
var OnboardingHint_OkTheHuntersDiscoverThatBolginDid_instance;
var OnboardingHint_OkLetSTryToKillThe_instance;
var OnboardingHint_LetSPerformTheAttackFirst_instance;
var OnboardingHint_AttackFarmerType_instance;
var OnboardingHint_LetSKillTheFarmerTypeInOne_instance;
var OnboardingHint_AndNowItIsAGoodTime_instance;
var OnboardingHint_SoTheHuntersSavedTheSettlerThe_instance;
var OnboardingHint_OkBolginFailedToKillTheFarmerType_instance;
var OnboardingHint_LetSPlayTheEvolveCardTo_instance;
var OnboardingHint_LetSMoveFirst_instance;
var OnboardingHint_LetSMoveOneStepToThe_instance;
var OnboardingHint_AndNowLetSUpgradeBolgin_instance;
var OnboardingHint_SoLetSIncreaseBolginSMobility_instance;
var OnboardingHint_FinallyLetSRelocateHelgaCloserTo_instance;
var OnboardingHint_LetSRelocateHelgaFirstAndCheck_instance;
var OnboardingHint_ChooseNewArksteadAsTheDestination_instance;
var OnboardingHint_LetSPickAnUnknownCard_instance;
var OnboardingHint_HelgaReceivedTheFlareCardThisIs_instance;
var OnboardingHint_TheHuntersKnowWhereBolginIsRight_instance;
var OnboardingHint_LetSStartByMovingIona_instance;
var OnboardingHint_MoveIonaOneStepSouth_instance;
var OnboardingHint_ThenLetSMoveTheWoundedFarmerType_instance;
var OnboardingHint_MoveTheFarmerTypeToTheRight_instance;
var OnboardingHint_LetSTalkNowAboutTrapSignTraps_instance;
var OnboardingHint_SoLetSPlayTheFireTrap_instance;
var OnboardingHint_LetSPlaceItInTheNew_instance;
var OnboardingHint_TheHuntersHaveNowPreparedIonaTo_instance;
var OnboardingHint_LetSPlayTheAvariceCardTo_instance;
var OnboardingHint_TheAvariceCardGivesAnActionTo_instance;
var OnboardingHint_MoveIonaToTheRight_instance;
var OnboardingHint_TheAvariceCardAllowsAttacksOnlyAgainst_instance;
var OnboardingHint_AndNowLetSPlayTheHunt_instance;
var OnboardingHint_SoBeforeTheAttackIonaSearchedAnd_instance;
var OnboardingHint_LetSPlayTheHasteCard_instance;
var OnboardingHint_LetSMoveBolginFirst_instance;
var OnboardingHint_LetSMoveBolginOneMoreStep2_instance;
var OnboardingHint_AndNowLetSMoveBolginInto_instance;
var OnboardingHint_BolginDecidesToFinishTheWoundedFarmerType_instance;
var OnboardingHint_InMostCasesYouWantToMove_instance;
var OnboardingHint_LetSMoveTheFarmerTypeOneStep_instance;
var OnboardingHint_MovementAndReactionsHaveFinishedSoBolgin_instance;
var OnboardingHint_AsTheSecondCardLetSPlay_instance;
var OnboardingHint_TheAnimateCardHasTheThenKeyword_instance;
var OnboardingHint_SoFirstYouMustPerformSummonActivationBecause_instance;
var OnboardingHint_LetSPlaceItNearFarmerTypeFrom_instance;
var OnboardingHint_ThirteenActionCardsWereDealtDuringThe_instance;
var OnboardingHint_HelgaAndIonaInTheSameLocation_instance;
var OnboardingHint_LetSStartWithHelga_instance;
var OnboardingHint_LetSPickTheUnknownHunterItem_instance;
var OnboardingHint_TheOutpostCardIsQuiteSituationalIt_instance;
var OnboardingHint_LetSAlsoPickTheUnknownHunter_instance;
var OnboardingHint_TheBladeOfValhCardIsThe_instance;
var OnboardingHint_LetSFinishHelgaSTurnFor_instance;
var OnboardingHint_LetSPassForVarja_instance;
var OnboardingHint_AndLetSPassForIonaAs_instance;
var OnboardingHint_TheHuntersHaveMostlyRunOutOf_instance;
var OnboardingHint_LetSFirstPickABeastlyTalent_instance;
var OnboardingHint_LetSPickTheUnbendingWill_instance;
var OnboardingHint_AndLetSMoveBolginOneStep_instance;
var OnboardingHint_LetSPassForHelga_instance;
var OnboardingHint_AndLetSPassForVarjaAs_instance;
var OnboardingHint_LetSActuallyPlayTheBladeOf_instance;
var OnboardingHint_SometimesYouMayWantToPlayThe_instance;
var OnboardingHint_LetSPickTheMostPracticalUpgrade_instance;
var OnboardingHint_LetSPlayTheUnbendingWillCard_instance;
var OnboardingHint_AndLetSReturnTheSummonPolyp_instance;
var OnboardingHint_AndLetSFinishTheTurn_instance;
var OnboardingHint_LetSPlayTheTrackCard_instance;
var OnboardingHint_LetSSupposeTheHuntersGuessBolgin_instance;
var OnboardingHint_ThereIsATrailSoTrackNow_instance;
var OnboardingHint_HelgaFinishesTrackInTheSameZone_instance;
var OnboardingHint_LetSFinishHelgaSTurn_instance;
var OnboardingHint_VarjaCannotDoMuchEitherLetS_instance;
var OnboardingHint_IonaHasNoCardsSoSheWill_instance;
var OnboardingHint_LetSPlayTheSummonPolypCard2_instance;
var OnboardingHint_LetSStartWithMovement_instance;
var OnboardingHint_LetSMoveBolginWest_instance;
var OnboardingHint_AndNowLetSPlaySummonActivation_instance;
var OnboardingHint_LetSActivateAllSummonsOnThe_instance;
var OnboardingHint_AndLetSUsePolypSUnique_instance;
var OnboardingHint_SoBurstThePolypInGhastvikFjord_instance;
var OnboardingHint_ThePolypBurstsDestroyingItselfWoundingThe_instance;
var OnboardingHint_AndNowLetSPlayTheRage_instance;
var OnboardingHint_NowItIsUnlikelyThatHelgaCan_instance;
var OnboardingHint_LetSMoveHelgaNorth_instance;
var OnboardingHint_LetSPassForVarja2_instance;
var OnboardingHint_AndNowBolginHasOneGrudgeToPlay_instance;
var OnboardingHint_LetSStartWithMovement2_instance;
var OnboardingHint_LetSMoveBolginEast_instance;
var OnboardingHint_AndNowLetSPlaySummonActivation2_instance;
var OnboardingHint_LetSPlaceTheNewPolypIn_instance;
var OnboardingHint_LetSPlayTheOutpostCard_instance;
var OnboardingHint_WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile_instance;
var OnboardingHint_ThatPolypCanBurstHittingBothVarja_instance;
var OnboardingHint_LetSMoveVarjaWestCloseTo_instance;
var OnboardingHint_TheDayIsOverSinceAllCharacters_instance;
var OnboardingHint_BolginReceivesAncientPowerAndMayNowPerform_instance;
var OnboardingHint_LetSUseTheBurstAgain_instance;
var OnboardingHint_LetSBurstTheWoundedFarmerTypeBelow_instance;
var OnboardingHint_NoteThatTheFarmerTypeWasKilledBy_instance;
var OnboardingHint_TheCascadeUpgradeAllowsBolginToMove_instance;
var OnboardingHint_NowItIsTimeForTheHunters_instance;
var OnboardingHint_NoteThatTheHuntersKnowBolginS_instance;
var OnboardingHint_AllHuntersGainOneGrudgeAsAReward_instance;
var OnboardingHint_LetSMoveHelgaOneStepRight_instance;
var OnboardingHint_NextLetSMoveVarja_instance;
var OnboardingHint_LetSMoveVarjaNorth_instance;
var OnboardingHint_AndLetSMoveIonaEastClose_instance;
var OnboardingHint_AfterTheRewardsHunterItemsAndBeastly_instance;
var OnboardingHint_NextAllActionCardsFromHandsUnused_instance;
var OnboardingHint_FinallyRemoveAllOneDamageFromSettlersFarmerType_instance;
var OnboardingHint_InMostContractsTheDeathOfThe_instance;
var OnboardingHint_TheRewardSubphaseIsResolvedBeforeThe_instance;
var OnboardingHint_IfAHunterDiesByABeast_instance;
var OnboardingHint_AfterTheRefreshPlayersMayUpgradeAs_instance;
var OnboardingHint_TheHuntersNowKnowThatBolginIs_instance;
var OnboardingHint_LetSStartWithVarjaAndUpgrade_instance;
var OnboardingHint_LetSChooseTheFarmerTypeInVintervik_instance;
var OnboardingHint_NowTheHuntersWillHaveSomeTime_instance;
var OnboardingHint_BolginNowNeedsOnlyOneDamageOneDamageTo_instance;
var OnboardingHint_AndLetSSaveOneGrudgeForHelga_instance;
var OnboardingHint_TheNextDayNowBeginsWithThe_instance;
var OnboardingHint_entriesInitialized;
function OnboardingHint_initEntries() {
  if (OnboardingHint_entriesInitialized)
    return Unit_instance;
  OnboardingHint_entriesInitialized = true;
  OnboardingHint_WelcomeToTheInteractiveOnboardingForThe_instance = new OnboardingHint('WelcomeToTheInteractiveOnboardingForThe', 0, true, 'Welcome to the interactive onboarding\nfor the Beast board game!\nPress the Next button to continue.');
  OnboardingHint_WhenYouBeginANewGameYou_instance = new OnboardingHint('WhenYouBeginANewGameYou', 1, true, "When you begin a new game,\nyou first choose a contract.\nThis onboarding uses the\nAttack on the Northern Settlements\ncontract. Let's look at it.");
  OnboardingHint_FirstOfAllTheContractSpecifiesThe_instance = new OnboardingHint('FirstOfAllTheContractSpecifiesThe', 2, true, 'First of all, the contract specifies\nthe number of players and the map.');
  OnboardingHint_NextTheContractDefinesTheWinningConditions_instance = new OnboardingHint('NextTheContractDefinesTheWinningConditions', 3, true, 'Next, the contract defines\nthe winning conditions for both sides.\nSo in this contract, the Beast must\nkill 3 settlers during 4 days.');
  OnboardingHint_SettlersAreRepresentedByNobleTypeBlueNoble_instance = new OnboardingHint('SettlersAreRepresentedByNobleTypeBlueNoble', 4, true, 'Settlers are represented by <NobleType> blue Noble meeples and <FarmerType> yellow Farmer meeples.');
  OnboardingHint_TheFarmerTypeYellowMeeplesAreTheFarmers_instance = new OnboardingHint('TheFarmerTypeYellowMeeplesAreTheFarmers', 5, true, 'The <FarmerType> yellow meeples are the Farmers.\nThey have 2 HP.');
  OnboardingHint_TheNobleTypeBlueMeeplesAreTheNobles_instance = new OnboardingHint('TheNobleTypeBlueMeeplesAreTheNobles', 6, true, 'The <NobleType> blue meeples are the Nobles.\nAnd they have 3 HP.');
  OnboardingHint_BesidesSettlersTheMapContainsALot_instance = new OnboardingHint('BesidesSettlersTheMapContainsALot', 7, true, 'Besides settlers, the map contains a lot of animals: <SheepType> Sheep\n<BoarType> Boars, and <BearType> Bears. Usually, only the Beast interacts with animals\nby moving and killing them to gain the <OneGrudge> (Grudges),\nand to fulfill the contract rewards.');
  OnboardingHint_BothTheBeastAndTheHuntersTeams_instance = new OnboardingHint('BothTheBeastAndTheHuntersTeams', 8, true, 'Both the Beast and the Hunters teams can gain and spend <OneGrudge> Grudges.\nThe Grudges can be spent on character upgrades\nand as payment for some powerful cards.');
  OnboardingHint_YouCanFindHPValuesAndOneGrudge_instance = new OnboardingHint('YouCanFindHPValuesAndOneGrudge', 9, true, 'You can find HP values and <OneGrudge> rewards at the bottom of the map.\nNote, that only the Beast can attack the animals in the Base game.\nFor example, a <BearType> Bear has 2 HP, and killing it rewards 4 <OneGrudge> Grudges.');
  OnboardingHint_UsuallyContractsIncludeSeveralDaysThisContract_instance = new OnboardingHint('UsuallyContractsIncludeSeveralDaysThisContract', 10, true, 'Usually, contracts include several days.\nThis contract has 4 days. Each day has\nthree global phases: Dawn, Day, and Night.');
  OnboardingHint_YouWillSpendMostOfTheGame_instance = new OnboardingHint('YouWillSpendMostOfTheGame', 11, true, 'You will spend most of the game in the Day phase.\nDuring the Day, players perform their turns one by one.\nIn the Beast game, most actions are performed\nby playing cards during your turn.');
  OnboardingHint_CardsAreEssentiallyTheMainResourceIn_instance = new OnboardingHint('CardsAreEssentiallyTheMainResourceIn', 12, true, 'Cards are essentially the main resource\nin the game. To attack, you need a card\nwith the word "Attack" on it.\nIf you want to move, it\'s best to have\na card with the word "Move" on it.\nThe game includes other ways to gain actions,\nbut cards are the main source.');
  OnboardingHint_LetSTalkALittleMoreAbout_instance = new OnboardingHint('LetSTalkALittleMoreAbout', 13, true, "Let's talk a little more\nabout cards in the game.\nThere are three types of cards.");
  OnboardingHint_EveryCharacterHasItsOwnSetOf_instance = new OnboardingHint('EveryCharacterHasItsOwnSetOf', 14, true, 'Every character has its own set of ability cards.\nAbility cards refresh every Night.\nYou can almost always rely on this type of card.');
  OnboardingHint_DiscardPilesAreOpenInformationInThe_instance = new OnboardingHint('DiscardPilesAreOpenInformationInThe', 15, true, 'Discard piles are open information\nin the game. This means that\nevery player knows which Ability cards\nother players have discarded.');
  OnboardingHint_ActionCardsAreTheCoreDriverOf_instance = new OnboardingHint('ActionCardsAreTheCoreDriverOf', 16, true, 'Action cards are the core driver of the game.\nEach Action card has two parts:\nthe upper part is for the Hunters and\nthe bottom part is for the Beast.');
  OnboardingHint_ThereAre16ActionCardsThatAre_instance = new OnboardingHint('ThereAre16ActionCardsThatAre', 17, true, 'There are 16 Action cards that are dealt\nevery Dawn phase through a draft. Note that\nsome Action cards remain unused after the draft.\nYou cannot keep Action cards between days.');
  OnboardingHint_ButYouCanKeepArsenalCardsBeastly_instance = new OnboardingHint('ButYouCanKeepArsenalCardsBeastly', 18, true, 'But you can keep Arsenal cards:\nBeastly Talents and Hunter Items.\nThey remain in your hand until you play them,\nor until an effect forces you to discard them.');
  OnboardingHint_HoweverArsenalCardsAreNotEasyTo_instance = new OnboardingHint('HoweverArsenalCardsAreNotEasyTo', 19, true, 'However, Arsenal cards are not easy to gain.\nYou can gain them through other cards,\nrewards, or upgrades.');
  OnboardingHint_AlsoEveryCardHasASpecialKind_instance = new OnboardingHint('AlsoEveryCardHasASpecialKind', 20, true, 'Also, every card has a special Kind: it can be\n<RedSign> Red card, <BlueSign> Blue card,\n<TrapSign> Trap card, or <ReactionSign> Reaction card.');
  OnboardingHint_RedSignRedAndBlueSignBlueCardsAre_instance = new OnboardingHint('RedSignRedAndBlueSignBlueCardsAre', 21, true, "<RedSign> Red and <BlueSign> Blue cards are played\nduring a character's turn in the Day phase.");
  OnboardingHint_ReactionSignReactionCardsArePlayedWhenTheir_instance = new OnboardingHint('ReactionSignReactionCardsArePlayedWhenTheir', 22, true, '<ReactionSign> Reaction cards are played\nwhen their trigger condition is met.\nIn most cases, this happens outside your turn.');
  OnboardingHint_TrapSignTrapCardsArePlayedLikeBlueSign_instance = new OnboardingHint('TrapSignTrapCardsArePlayedLikeBlueSign', 23, true, '<TrapSign> Trap cards are played like <BlueSign> Blue cards to be set.\nThey are later activated as a reaction.\nWe will talk more about all these kinds later.');
  OnboardingHint_SomeArsenalCardsHaveTheOneGrudgeGrudge_instance = new OnboardingHint('SomeArsenalCardsHaveTheOneGrudgeGrudge', 24, true, 'Some Arsenal cards have the <OneGrudge> Grudge\nicon near the Kind. This means that you must\npay <OneGrudge> when you play such a card.');
  OnboardingHint_LetSReturnToTheGameFlow_instance = new OnboardingHint('LetSReturnToTheGameFlow', 25, true, "Let's return to the game flow. When all players\npassed in a row, the Night phase begins.\nThe Night phase has several subphases.");
  OnboardingHint_InMostContractsTheNightPhaseHas_instance = new OnboardingHint('InMostContractsTheNightPhaseHas', 26, true, 'In most contracts the Night\nphase has a reward subphase.');
  OnboardingHint_TheseRewardsAreSpecifiedByTheContract_instance = new OnboardingHint('TheseRewardsAreSpecifiedByTheContract', 27, true, "These rewards are specified by the contract.\nFor example, in this contract, if Beast kills\ntwo <SheepType> sheep or one <BoarType> boar during the first day,\nBeast will receive the <AncientPower> Ancient Power and\nwill perform the <SummonActivation> Summon Activation.\nDon't worry \u2014 we will explain this later.");
  OnboardingHint_TheRewardWillBeGivenToYou_instance = new OnboardingHint('TheRewardWillBeGivenToYou', 28, true, 'The reward will be given to you\nif you meet its condition by the start of the Night.\nYou might notice that a <BoarType> boar is a condition\nfor the second night reward in this contract, also.\nThus, by killing a <BoarType> boar on the first day,\nBeast will secure the rewards for both days!');
  OnboardingHint_AtTheBeginningOfTheGameReveal_instance = new OnboardingHint('AtTheBeginningOfTheGameReveal', 29, true, 'At the beginning of the game,\nreveal 6 open Arsenal cards:\n3 Hunter Items and 3 Beastly Talents.\nThey may affect your character choice.');
  OnboardingHint_ThenPlayersChooseTheirCharactersTheBeast_instance = new OnboardingHint('ThenPlayersChooseTheirCharactersTheBeast', 30, false, "Then players choose their characters.\nThe Beast should pick a character first.\nLet's go with Bolgin as it is recommended in the rulebook.");
  OnboardingHint_EveryBeastHasACharacterBoardWith_instance = new OnboardingHint('EveryBeastHasACharacterBoardWith', 31, true, "Every Beast has a character board with information.\nLet's look at Bolgin's board closely.");
  OnboardingHint_EveryBeastHasAPreferredLocationType_instance = new OnboardingHint('EveryBeastHasAPreferredLocationType', 32, true, "Every Beast has a preferred location type.\nBolgin's preferred location is <Swamp> Swamp.");
  OnboardingHint_BolginHas5HP_instance = new OnboardingHint('BolginHas5HP', 33, true, 'Bolgin has 5 HP');
  OnboardingHint_AlsoEveryBeastHas4AbilityCards_instance = new OnboardingHint('AlsoEveryBeastHas4AbilityCards', 34, true, "Also, every beast has 4 Ability cards. Let's look at\nBolgin's cards. Two of these cards have the <Swamp> sign\nnext to their color Kind. It means that the Engorge\nand Leap cards can be played only from <Swamp> locations.");
  OnboardingHint_LetSLookAgainAtBolginS_instance = new OnboardingHint('LetSLookAgainAtBolginS', 35, true, "Let's look again at Bolgin's board. She has 7 upgrades.\nYou cannot unlock an upgrade at any point during the game.\nInstead, you must wait for the upgrade phase of the Night.\nSome cards and scenarios also allow you to upgrade.");
  OnboardingHint_EveryBeastHasItsOwnSummonsSo_instance = new OnboardingHint('EveryBeastHasItsOwnSummonsSo', 36, true, 'Every Beast has its own summons.\nSo Bolgin has up to 3 Polyps.');
  OnboardingHint_EachSummonHas3ActionsMoveOne_instance = new OnboardingHint('EachSummonHas3ActionsMoveOne', 37, true, "Each summon has 3 actions:\n* Move one step\n* Attack in the current location\n* Perform the unique ability specified on the Beast's board.");
  OnboardingHint_SoBolginSPolypsCanBurstA_instance = new OnboardingHint('SoBolginSPolypsCanBurstA', 38, true, "So Bolgin's Polyps can Burst:\nA Polyp moves one step, then deals damage\nto all units around it by bursting,\nand transforms the location into <Swamp>.");
  OnboardingHint_TheBeastHasBeenChosenSoThe_instance = new OnboardingHint('TheBeastHasBeenChosenSoThe', 39, false, "The Beast has been chosen, so the Hunters now choose their characters.\nLet's follow the rulebook's first-game recommendation\nand pick Helga as the first Hunter.");
  OnboardingHint_EveryHunterHasASetOfThree_instance = new OnboardingHint('EveryHunterHasASetOfThree', 40, true, 'Every Hunter has a set of three Ability cards.\nTwo of these cards are usually the standard\nhunting cards: the Track card to chase the Beast,\nand the Hunt card to reveal and attack the Beast.');
  OnboardingHint_TheThirdAbilityCardIsAUnique_instance = new OnboardingHint('TheThirdAbilityCardIsAUnique', 41, true, 'The third ability card is a unique hunter ability.\nHelga is a powerful supporting hunter. The Seer card\nhelps a lot to track the Beast during the game.');
  OnboardingHint_EveryHunterAlsoHasACharacterBoard_instance = new OnboardingHint('EveryHunterAlsoHasACharacterBoard', 42, true, "Every Hunter also has a character board.\nThe board has information about the\nHunter's maximum HP, and available upgrades.");
  OnboardingHint_LetSPickVarjaAsTheSecond_instance = new OnboardingHint('LetSPickVarjaAsTheSecond', 43, false, "Let's pick Varja as the second Hunter");
  OnboardingHint_VarjaHasTheSameTrackAndHunt_instance = new OnboardingHint('VarjaHasTheSameTrackAndHunt', 44, true, 'Varja has the same Track and Hunt cards.\nShe also has a very powerful Command card.\nIt can be used for both defense and attack.');
  OnboardingHint_ForTheLastPositionLetSPick_instance = new OnboardingHint('ForTheLastPositionLetSPick', 45, false, "For the last position, let's pick Iona");
  OnboardingHint_IonaIsVeryNiceForTheLast_instance = new OnboardingHint('IonaIsVeryNiceForTheLast', 46, true, 'Iona is very nice for the last position.\nHer Silver Arrow card allows to eliminate summons\nquite effectively and without losing position.');
  OnboardingHint_ContractsAlsoSpecifyAdditionalRulesAndStarting_instance = new OnboardingHint('ContractsAlsoSpecifyAdditionalRulesAndStarting', 47, true, 'Contracts also specify additional rules and\nstarting conditions. In this contract, the\nBeast starts with 2 <OneGrudge> and 2 random\nBeastly Talent cards. Hunters will start with one <OneGrudge>.');
  OnboardingHint_TheBeastStartsTheGameInThe_instance = new OnboardingHint('TheBeastStartsTheGameInThe', 48, true, 'The Beast starts the game in the Lair of the Beast.\nOn this map it is just the center of the map.\nThis location is a <Swamp>, a <Forest> and a <Cave> at the same time.');
  OnboardingHint_YouMayAlsoNoticeWhiteLinesSplitting_instance = new OnboardingHint('YouMayAlsoNoticeWhiteLinesSplitting', 49, true, 'You may also notice white lines splitting the map for 4 zones.\nMany game conditions and effects are bound to a zone.\nEach location belongs to only one zone except the center:\nit belongs to all zones at the same time.');
  OnboardingHint_AtTheBeginningOfTheGameThe_instance = new OnboardingHint('AtTheBeginningOfTheGameThe', 50, true, 'At the beginning of the game, the Beast has 2 bonus movements.\nBolgin is a <Swamp> Beast, so it is more convenient to start in <Swamp> locations.');
  OnboardingHint_ToReceiveTheFirstNightRewardBolgin_instance = new OnboardingHint('ToReceiveTheFirstNightRewardBolgin', 51, true, 'To receive the first night reward Bolgin has to kill\n2 <SheepType> or 1 <BoarType>. Killing 2 <SheepType> is usually easier.');
  OnboardingHint_TheMapHas3ConvenientSwampLocations_instance = new OnboardingHint('TheMapHas3ConvenientSwampLocations', 52, false, "The map has 3 convenient <Swamp> locations with a <SheepType>, each 2 steps\nfrom the center. Let's choose the location not far from the New Arkstead.\nSo let's make the first step to the South.");
  OnboardingHint_AndTheNextStepToTheLeft_instance = new OnboardingHint('AndTheNextStepToTheLeft', 53, false, 'And the next step to the left location');
  OnboardingHint_WhenTheBeastMovesItMustPut_instance = new OnboardingHint('WhenTheBeastMovesItMustPut', 54, true, 'When the Beast moves, it must put\nthe corresponding movement cards.\nIn the physical game you should\nmark your path on the minimap\nwithout moving the standee anywhere.');
  OnboardingHint_ForThisMovementBolginHasToPut_instance = new OnboardingHint('ForThisMovementBolginHasToPut', 55, true, "For this movement Bolgin has to put\nSouth and West cards in the right order.\nHunters don't see the Beast's actual\nposition after the movement.\nBut they know how many movement cards the\nBeast has played since it was last revealed.");
  OnboardingHint_ThereAreFiveTypesOfMovementCards_instance = new OnboardingHint('ThereAreFiveTypesOfMovementCards', 56, true, 'There are five types of movement cards:\nthe directional movements and No Movement cards.\nThe Beast can place No Movement cards to\nconfuse Hunters or when fewer steps are needed.');
  OnboardingHint_ItIsImportantThatBeastCannotPlay_instance = new OnboardingHint('ItIsImportantThatBeastCannotPlay', 57, true, 'It is important that Beast cannot play a No Movement\ncard while in a location with a Hunter or a Settler.\nIf an effect forces you to move from that location,\nyou have to play the directional movement card.');
  OnboardingHint_ToSimplifyTheTrackingOfBeastThis_instance = new OnboardingHint('ToSimplifyTheTrackingOfBeastThis', 58, true, 'To simplify the tracking of Beast, this interface\nwill show the actual Beast location from Beast perspective.\nThe last revealed Beast location is marked with big <Trail> sign.\nAnd the Beast path is marked with semitransparent trails.');
  OnboardingHint_TrailsTrailIsAnImportantConceptIn_instance = new OnboardingHint('TrailsTrailIsAnImportantConceptIn', 59, true, 'Trails <Trail> is an important concept in the game.\nHunters and settlers reveal a <Trail> on their locations.\nSo in physical game, the Beast needs to track their entire path\nand put <Trail> on his path when it should be revealed.\nA good practice is to ask whether a new <Trail> should be revealed\nafter each movement, just to be sure no mistakes were done.');
  OnboardingHint_LetSSwitchToTheHuntersPerspective_instance = new OnboardingHint('LetSSwitchToTheHuntersPerspective', 60, true, "Let's switch to the Hunters' perspective.\nThis interface will highlight the player who\nshould make a decision with Light Green color.");
  OnboardingHint_HuntersDonTSeeTheBeastS_instance = new OnboardingHint('HuntersDonTSeeTheBeastS', 61, true, "Hunters don't see the Beast's current location.\nBut they see the last revealed Beast's location,\nnumber of played movement cards and revealed <Trail> trails.");
  OnboardingHint_ActuallyTheBeastCanBeInTwo_instance = new OnboardingHint('ActuallyTheBeastCanBeInTwo', 62, true, 'Actually, the Beast can be in two states: revealed and hidden.\nThe Beast is considered as revealed if no movement cards are laying on the map.');
  OnboardingHint_NowItIsTheHunterSPart_instance = new OnboardingHint('NowItIsTheHunterSPart', 63, true, "Now it is the hunter's part of the game setup.\nEach hunter can start from any Town.");
  OnboardingHint_HuntersGainManyBonusesWhenTheyStay_instance = new OnboardingHint('HuntersGainManyBonusesWhenTheyStay', 64, true, 'Hunters gain many bonuses when they stay together.\nYou can place all three of them into one town.\nBut if the Hunters are misplaced on the map,\nthe Beast will have too much freedom.');
  OnboardingHint_SoLetSPlaceHelgaInTiveden_instance = new OnboardingHint('SoLetSPlaceHelgaInTiveden', 65, false, "So let's place Helga in Tiveden for the case Bolgin went West");
  OnboardingHint_NowLetSPlaceVarjaInGhastvik_instance = new OnboardingHint('NowLetSPlaceVarjaInGhastvik', 66, false, "Now let's place Varja in Ghastvik Fjord");
  OnboardingHint_AndLetSPlaceIonaInGhastvik_instance = new OnboardingHint('AndLetSPlaceIonaInGhastvik', 67, false, "And let's place Iona in Ghastvik Fjord as well");
  OnboardingHint_BeforeTheDraftBeginsTheBeastReceives_instance = new OnboardingHint('BeforeTheDraftBeginsTheBeastReceives', 68, true, 'Before the draft begins, the Beast receives one random Action card.\nThen every player receives 3 Action cards and chooses one of them.\nAfter every player picks an Action card,\nthe remaining cards are passed to the next player.');
  OnboardingHint_LetSPlayALittleBitGreedy_instance = new OnboardingHint('LetSPlayALittleBitGreedy', 69, false, "Let's play a little bit greedy and pick the Unearth Action card.");
  OnboardingHint_TheBeastGameIsDesignedSoThat_instance = new OnboardingHint('TheBeastGameIsDesignedSoThat', 70, true, "The Beast game is designed so that\nHunters can look at each other's hands at any time.\nDuring the draft, it is important to coordinate your picks.");
  OnboardingHint_LetSPickEnsnareActionCardFor_instance = new OnboardingHint('LetSPickEnsnareActionCardFor', 71, false, "Let's pick Ensnare Action card for Helga");
  OnboardingHint_ForVarjaLetSPickTheCharge_instance = new OnboardingHint('ForVarjaLetSPickTheCharge', 72, false, "For Varja, let's pick the Charge Action card");
  OnboardingHint_AndAtLastLetSChooseHidden_instance = new OnboardingHint('AndAtLastLetSChooseHidden', 73, false, "And at last, let's choose Hidden Passage Action card for Iona");
  OnboardingHint_WhenAllPlayersHavePickedACard_instance = new OnboardingHint('WhenAllPlayersHavePickedACard', 74, true, 'When all players have picked a card, the remaining two cards are passed to the\nnext player. Now Bolgin should pick one of the two cards she received from Iona.');
  OnboardingHint_LetSPickTheAnimateCard_instance = new OnboardingHint('LetSPickTheAnimateCard', 75, false, "Let's pick the Animate card");
  OnboardingHint_LetSPickTheAdaptCardFor_instance = new OnboardingHint('LetSPickTheAdaptCardFor', 76, false, "Let's pick the Adapt card for Helga");
  OnboardingHint_ForVarijaLetSPickTheDark_instance = new OnboardingHint('ForVarijaLetSPickTheDark', 77, false, "For Varija let's pick the Dark Rituals Action card");
  OnboardingHint_AndForIonaLetSPickThe_instance = new OnboardingHint('AndForIonaLetSPickThe', 78, false, "And for Iona, let's pick the Bolster card");
  OnboardingHint_DuringTheDayPhaseAllPlayersTake_instance = new OnboardingHint('DuringTheDayPhaseAllPlayersTake', 79, true, 'During the Day phase, all players take turns\none by one, starting with the Beast.\nThis phase continues until all players pass in a row.');
  OnboardingHint_PassingIsNotFinalAPlayerMay_instance = new OnboardingHint('PassingIsNotFinalAPlayerMay', 80, true, 'Passing is not final. A player may continue\nplaying cards if another player plays a card,\nuntil the full turn cycle is completed.');
  OnboardingHint_APlayerMayPassOnlyIfNo_instance = new OnboardingHint('APlayerMayPassOnlyIfNo', 81, true, 'A player may pass only if no other player has fewer Action cards.\nRemember that Action cards are the cards used in the draft.');
  OnboardingHint_RightNowBolginHas4AbilityCards_instance = new OnboardingHint('RightNowBolginHas4AbilityCards', 82, true, 'Right now Bolgin has 4 Ability cards, 4 Action cards, and 2 Beastly Talents from the\ncontract setup. All Hunters have 3 Action cards, so Bolgin cannot Pass this turn.');
  OnboardingHint_DuringATurnAPlayerCanEither_instance = new OnboardingHint('DuringATurnAPlayerCanEither', 83, true, 'During a turn a player can either 1) perform the Flee action, or 2) play one or two <RedSign> <BlueSign> cards.\nBut it is forbidden to play two <RedSign> cards or two <BlueSign> cards in one turn.');
  OnboardingHint_SometimesYouMayWantToMoveBut_instance = new OnboardingHint('SometimesYouMayWantToMoveBut', 84, true, 'Sometimes you may want to move but do not have,\nor do not want to spend, a card with a movement effect.\nIn that case you can Flee as we mentioned before.\nIt means you can discard any card you have to move just one step.\nThis is the only action you can take in that turn.\nYou cannot play a card and Flee after that or Flee and play a card.');
  OnboardingHint_NowLetSPlayTheEngorgeCard_instance = new OnboardingHint('NowLetSPlayTheEngorgeCard', 85, true, "Now let's play the Engorge card. This card can be played only\nwhen Bolgin's current location is a <Swamp> Swamp. So now it is possible.");
  OnboardingHint_JustClickOnTheEngorgeCard_instance = new OnboardingHint('JustClickOnTheEngorgeCard', 86, false, 'Just click on the Engorge card');
  OnboardingHint_WhenYouPlayACardYouShould_instance = new OnboardingHint('WhenYouPlayACardYouShould', 87, true, 'When you play a card, you should show it to all players and\nannounce which statement you will play first, if you have a choice.');
  OnboardingHint_TechnicallyYouCanSkipAllStatementsOn_instance = new OnboardingHint('TechnicallyYouCanSkipAllStatementsOn', 88, true, 'Technically, you can skip all statements on a card to trigger\ncertain effects or effectively discard the card. But in most cases,\nyou will simply perform the statements on the card, especially\nif there is only one statement on the card.');
  OnboardingHint_SoInThisCaseBolginPerformsAn_instance = new OnboardingHint('SoInThisCaseBolginPerformsAn', 89, true, "So in this case, Bolgin performs an attack statement.\nThe attack is performed in several steps. First,\nthe Beast reveals themselves. This means showing the\nmovement path and revealing and returning all movement\ncards to confirm it. Then remove all <Trail> trails from the map\nand move the Beast's standee to the actual location.");
  OnboardingHint_WhenTheBeastRevealsHuntersCanPlay_instance = new OnboardingHint('WhenTheBeastRevealsHuntersCanPlay', 90, true, "When the Beast reveals, Hunters can play <ReactionSign> Reactions cards and/or\nactivate <TrapSign> traps. But it is the start of the game and the Hunters do not\nhave any such cards yet. So let's continue resolve the attack statement.");
  OnboardingHint_WhenAttackingTheBeastMustDeclareA_instance = new OnboardingHint('WhenAttackingTheBeastMustDeclareA', 91, true, 'When attacking, the Beast must declare a target.\nIn this case it is pretty obvious, just the <SheepType>.\nBut actually you may choose to attack the "air" just\nto reveal the Beast, even if valid targets are present.');
  OnboardingHint_ByDefaultEveryBeastDealsOneDamage_instance = new OnboardingHint('ByDefaultEveryBeastDealsOneDamage', 92, true, 'By default, every Beast deals one damage per attack.\nBut Beast can improve the damage by upgrading it.\nHunters also have one damage per attack.\nAlso, players can increase the damage by using <AncientPower> Ancient Powers.\nWe will talk about <AncientPower> Ancient Powers later.');
  OnboardingHint_SheepTypeHasJust1HPSoBolgin_instance = new OnboardingHint('SheepTypeHasJust1HPSoBolgin', 93, true, '<SheepType> has just 1 HP, so Bolgin kills it and receives <OneGrudge> as a reward');
  OnboardingHint_BolginPlayedTheFirstCardAndIt_instance = new OnboardingHint('BolginPlayedTheFirstCardAndIt', 94, true, 'Bolgin played the first card, and it was <RedSign>.\nSo now Bolgin can play a <BlueSign> card, or end her turn.\nNote that now it is impossible to play the Flee action.');
  OnboardingHint_LetSPlayTheSummonPolypCard_instance = new OnboardingHint('LetSPlayTheSummonPolypCard', 95, false, "Let's play the Summon Polyp card");
  OnboardingHint_ThisCardContainsTwoStatementsThatCan_instance = new OnboardingHint('ThisCardContainsTwoStatementsThatCan', 96, true, 'This card contains two statements that can be played in any order.\nYou have to declare what statement you are playing first.\nBut the decision whether to play the second statement you can postpone\nuntil the first statement is fully completed.');
  OnboardingHint_LetSStartWithTheSummonActivationAction_instance = new OnboardingHint('LetSStartWithTheSummonActivationAction', 97, false, "Let's start with the <SummonActivation> action");
  OnboardingHint_WhenYouPlayASummonActivationActionYou_instance = new OnboardingHint('WhenYouPlayASummonActivationActionYou', 98, true, 'When you play a <SummonActivation> action, you have to do either:\n1) Place a new summon to the board (Polyps for Bolgin) or\n2) Activate all summons you have on the map.');
  OnboardingHint_SinceThereIsNoPolypOnThe_instance = new OnboardingHint('SinceThereIsNoPolypOnThe', 99, true, 'Since there is no Polyp on the board yet,\nyou have to choose the first variant and place a Polyp.');
  OnboardingHint_EveryBeastHasItsOwnSummonLimit_instance = new OnboardingHint('EveryBeastHasItsOwnSummonLimit', 100, true, 'Every Beast has its own summon limit, so Bolgin\ncannot have more than 3 Polyps on the board.\nIf you exceed this limit, you must replace\nan existing summon with the new one.');
  OnboardingHint_EveryBeastCanPlaceASummonOnly_instance = new OnboardingHint('EveryBeastCanPlaceASummonOnly', 101, true, "Every Beast can place a summon only on their preferred location type\n(<Swamp> for Bolgin), and no more than 2 steps away from Beast's current location.\nSo placing a Summon may give a hint for the Hunters where to look for Beast itself.");
  OnboardingHint_LetSPlaceAPolypJustAbove_instance = new OnboardingHint('LetSPlaceAPolypJustAbove', 102, false, "Let's place a Polyp just above New Arkstead.\nThis way it can threaten the farmer there.");
  OnboardingHint_WhenASummonIsActivatedItPerforms_instance = new OnboardingHint('WhenASummonIsActivatedItPerforms', 103, true, 'When a summon is activated, it performs one of three actions:\n1) Move one step; 2) Attack on the current location;\n3) and perform the unique ability. For Polyps it is Burst.');
  OnboardingHint_LikeHuntersAndBeastsSummonsHave1_instance = new OnboardingHint('LikeHuntersAndBeastsSummonsHave1', 104, true, 'Like Hunters and Beasts, summons have 1 base damage.\nNote, the Beast does not gain any <OneGrudge> from kills made by summons.\nBut the kills still count to the Night rewards and the victory.');
  OnboardingHint_WhileSummonsAreQuiteDeadlyTheyHave_instance = new OnboardingHint('WhileSummonsAreQuiteDeadlyTheyHave', 105, true, 'While summons are quite deadly they have only 1 HP.\nAnd their movements are not hidden from Hunters.');
  OnboardingHint_AndNowLetSMoveBolginOne_instance = new OnboardingHint('AndNowLetSMoveBolginOne', 106, false, "And now let's move Bolgin one step to the right");
  OnboardingHint_BolginHasPlayedTwoCardsAndIt_instance = new OnboardingHint('BolginHasPlayedTwoCardsAndIt', 107, true, "Bolgin has played two cards, and it is now Helga's turn.\nOnce again, Hunters don't know Bolgin's current location.\nInstead, Hunters know her last revealed location\nand the number of movement cards she have played.");
  OnboardingHint_NoteThatHelgaCanPassNowIt_instance = new OnboardingHint('NoteThatHelgaCanPassNowIt', 108, true, 'Note that Helga can Pass now. It is possible because Bolgin\nstill has 4 Action cards, while all Hunters have 3 Action cards.');
  OnboardingHint_LetSPlayTheEnsnareCard_instance = new OnboardingHint('LetSPlayTheEnsnareCard', 109, false, "Let's play the Ensnare card");
  OnboardingHint_TheEnsnareCardAllowsYouToSee_instance = new OnboardingHint('TheEnsnareCardAllowsYouToSee', 110, true, "The Ensnare card allows you to see full Beast's full hand.\nHowever, you may discard only an Ability card.\nNote that this effect is different for the Beast.\nWhen the Beast plays the Ensnare card, they may\ndiscard any card from a Hunter's hand.");
  OnboardingHint_LetSDiscardTheBeastlyTongueCard_instance = new OnboardingHint('LetSDiscardTheBeastlyTongueCard', 111, false, "Let's discard the Beastly Tongue card");
  OnboardingHint_LetSKeepTheCardsAndEnd_instance = new OnboardingHint('LetSKeepTheCardsAndEnd', 112, false, "Let's keep the cards and end the turn");
  OnboardingHint_LetSMoveCloseToBeastPlay_instance = new OnboardingHint('LetSMoveCloseToBeastPlay', 113, false, "Let's move close to Beast.\nPlay the Incite card to move both Hunters downward.");
  OnboardingHint_TheInciteCardAllowsYouToMove_instance = new OnboardingHint('TheInciteCardAllowsYouToMove', 114, true, 'The Incite card allows you to move all Hunters\nin the same zone as the Hunter who played the card.\nNow Varja and Iona are in the Barum zone,\nwhile Helga is in the Vildmark zone.');
  OnboardingHint_HuntersPerformMovementStepByStepAnd_instance = new OnboardingHint('HuntersPerformMovementStepByStepAnd', 115, false, "Hunters perform movement step by step,\nand can choose the order of Hunters.\nIt is not very important in this particular case,\nbut let's start with Varja");
  OnboardingHint_MoveVarjaOneStepLower_instance = new OnboardingHint('MoveVarjaOneStepLower', 116, false, 'Move Varja one step lower');
  OnboardingHint_NoteThatAllHunterMovementsAsWell_instance = new OnboardingHint('NoteThatAllHunterMovementsAsWell', 117, true, 'Note that all Hunter movements, as well as those of settlers,\nsummons and other non-Beast creatures should be read as UP-TO.\nThis means you may skip these movements entirely.\nHowever, the Beast must always put the required number of\nmovement cards, unless skipping the whole movement statement.');
  OnboardingHint_NowLetSMoveIonaOneStep_instance = new OnboardingHint('NowLetSMoveIonaOneStep', 118, false, "Now let's move Iona one step lower as well");
  OnboardingHint_LetSNowFinishVarjsSTurn_instance = new OnboardingHint('LetSNowFinishVarjsSTurn', 119, false, "Let's now finish Varjs's turn");
  OnboardingHint_WhileTheTwoHuntersAreTogetherLet_instance = new OnboardingHint('WhileTheTwoHuntersAreTogetherLet', 120, false, "While the two Hunters are together,\nlet's play the Bolster card");
  OnboardingHint_SoNowBothVarjaAndIonaCan_instance = new OnboardingHint('SoNowBothVarjaAndIonaCan', 121, false, "So now both Varja and Iona can gain a Hunter Item.\nHunters can decide the order in which they pick items.\nSo let's start with Iona.");
  OnboardingHint_ThereAre3OpenHunterItemsAnd_instance = new OnboardingHint('ThereAre3OpenHunterItemsAnd', 122, false, "There are 3 open Hunter Items and many unknown items remaining.\nLet's pick an unknown card.");
  OnboardingHint_IonaReceivedTheSmokebombCardThisCard_instance = new OnboardingHint('IonaReceivedTheSmokebombCardThisCard', 123, true, "Iona received the Smokebomb card.\nThis card might be a game changer,\nespecially if Beast doesn't know about it.");
  OnboardingHint_NowItIsTimeToPickAn_instance = new OnboardingHint('NowItIsTimeToPickAn', 124, false, "Now it is time to pick an Item for Varja.\nLet's pick the Fire Trap.");
  OnboardingHint_NowLetSKillThatPolypPlay_instance = new OnboardingHint('NowLetSKillThatPolypPlay', 125, false, "Now let's kill that Polyp.\nPlay the Silver Arrow card.");
  OnboardingHint_TheAttackInTheSilverArrowCard_instance = new OnboardingHint('TheAttackInTheSilverArrowCard', 126, true, 'The attack in the Silver Arrow card has a couple of modifiers:\nIt can target only summons, but it may target them in nearby locations.');
  OnboardingHint_NearbyLocationsAreLocationsThatAre1_instance = new OnboardingHint('NearbyLocationsAreLocationsThatAre1', 127, true, 'Nearby locations are locations that are\n1 step away or the current location itself.');
  OnboardingHint_SoLetSPlayTheAttackAnd_instance = new OnboardingHint('SoLetSPlayTheAttackAnd', 128, false, "So let's play the Attack and kill the nearby summon");
  OnboardingHint_ThisIsWhyTheSilverArrowIs_instance = new OnboardingHint('ThisIsWhyTheSilverArrowIs', 129, false, "This is why the Silver Arrow is so efficient: after\nkilling a summon, you may move even in the opposite direction.\nBut now let's move toward Bolgin, one step right.");
  OnboardingHint_NoteThatBolginIsNowInA_instance = new OnboardingHint('NoteThatBolginIsNowInA', 130, true, 'Note that Bolgin is now in a <Forest>,\nso she cannot play the Leap card');
  OnboardingHint_LetSPlayTheUnearthCardTo_instance = new OnboardingHint('LetSPlayTheUnearthCardTo', 131, false, "Let's play the Unearth card to gain <AncientPower> Ancient Power and a Beastly Talent");
  OnboardingHint_LetSPickTheBrutalityCard_instance = new OnboardingHint('LetSPickTheBrutalityCard', 132, false, "Let's pick the Brutality card");
  OnboardingHint_AndLetSJustFinishTheTurn_instance = new OnboardingHint('AndLetSJustFinishTheTurn', 133, false, "And let's just finish the turn");
  OnboardingHint_BolginPlayedQuiteGreedilyLetSPunish_instance = new OnboardingHint('BolginPlayedQuiteGreedilyLetSPunish', 134, false, "Bolgin played quite greedily, let's punish her for that.\nTo attack the Beast, you must first find them.\nSo let's play the Seer card to reveal Bolgin's last step.");
  OnboardingHint_NowTheHuntersKnowForSureWhere_instance = new OnboardingHint('NowTheHuntersKnowForSureWhere', 135, true, 'Now the Hunters know for sure where Bolgin is');
  OnboardingHint_LetSFinishHelgaSTurnNow_instance = new OnboardingHint('LetSFinishHelgaSTurnNow', 136, false, "Let's finish Helga's turn now");
  OnboardingHint_NowLetSMoveVarjaOntoBolgin_instance = new OnboardingHint('NowLetSMoveVarjaOntoBolgin', 137, false, "Now let's move Varja onto Bolgin's location.\nPlay the Charge card just to move.");
  OnboardingHint_LetSMoveVarjaOneStepTo_instance = new OnboardingHint('LetSMoveVarjaOneStepTo', 138, false, "Let's move Varja one step to the right and skip the attack, as\nno target is available. Hunters can attack only the Beast and its summons.");
  OnboardingHint_AndNowLetSPlayTheTrack_instance = new OnboardingHint('AndNowLetSPlayTheTrack', 139, false, "And now let's play the Track card");
  OnboardingHint_LetSMoveOneMoreStepRight_instance = new OnboardingHint('LetSMoveOneMoreStepRight', 140, false, "Let's move one more step right");
  OnboardingHint_WhenTheBeastIsHiddenTheStandee_instance = new OnboardingHint('WhenTheBeastIsHiddenTheStandee', 141, false, "When the Beast is hidden, the standee is treated as a revealed <Trail>.\nSo Varja stepped into a location with a <Trail>, one additional\nmove with the Track card. Let's move one more step to the right.");
  OnboardingHint_EvenThoughTheHuntersAlreadyKnowWhere_instance = new OnboardingHint('EvenThoughTheHuntersAlreadyKnowWhere', 142, true, 'Even though the Hunters already know where\nBolgin is, the new <Trail> is placed only now.\nNote that a location can have more than one <Trail>\nif the Beast has entered it several times.');
  OnboardingHint_NowItSTimeToRelocateIona_instance = new OnboardingHint('NowItSTimeToRelocateIona', 143, false, "Now it's time to relocate Iona. Play the Hidden Passage card.");
  OnboardingHint_LetSChooseIona_instance = new OnboardingHint('LetSChooseIona', 144, false, "Let's choose Iona");
  OnboardingHint_AsTheDestinationLetSChooseVarja_instance = new OnboardingHint('AsTheDestinationLetSChooseVarja', 145, false, "As the destination, let's choose Varja's location");
  OnboardingHint_AtLastPlayTheHuntCard_instance = new OnboardingHint('AtLastPlayTheHuntCard', 146, false, 'At last, play the Hunt card!');
  OnboardingHint_SoBolginPaidForTheirGreedyPlay_instance = new OnboardingHint('SoBolginPaidForTheirGreedyPlay', 147, false, "So Bolgin paid for their greedy play. Or maybe it was just a gambit?\nLet's play the Brutality card to kill a <SheepType> and fulfill the first-day reward.");
  OnboardingHint_NoteThatBolginMustPayOneOneGrudge_instance = new OnboardingHint('NoteThatBolginMustPayOneOneGrudge', 148, true, 'Note that Bolgin must pay one <OneGrudge> to play the Brutality card');
  OnboardingHint_LetSChooseTheSheepType_instance = new OnboardingHint('LetSChooseTheSheepType', 149, false, "Let's choose the <SheepType>");
  OnboardingHint_PlayersCanIncreaseTheDamageByUsing_instance = new OnboardingHint('PlayersCanIncreaseTheDamageByUsing', 150, true, 'Players can increase the damage by using <AncientPower> Ancient Powers:\none additional damage for each <AncientPower> spent. It is important,\nthat you must declare how many <AncientPower> you will spend\nwhen you name your target, before any attack triggers resolve.');
  OnboardingHint_WhenYouSpendAnAncientPowerReturnIt_instance = new OnboardingHint('WhenYouSpendAnAncientPowerReturnIt', 151, true, "When you spend an <AncientPower>, return it to the supply.\nAncient Powers are limited. No more than 3 <AncientPower> can be in players' hands.");
  OnboardingHint_LetSSaveAncientPowerForNowJust_instance = new OnboardingHint('LetSSaveAncientPowerForNowJust', 152, false, "Let's save <AncientPower> for now. Just choose None.");
  OnboardingHint_NowIonaCanPlayHerSmokebombCard_instance = new OnboardingHint('NowIonaCanPlayHerSmokebombCard', 153, false, "Now Iona can play her Smokebomb card.\nWhile this might be an appropriate play\n(to deny the animal kill and prevent the Beast's reward),\nlet's save the Smokebomb card for later.\nJust choose Do Nothing");
  OnboardingHint_BolginNeedsToMoveAwayFromThe_instance = new OnboardingHint('BolginNeedsToMoveAwayFromThe', 154, false, "Bolgin needs to move away from the Hunters. Let's move Bolgin left.");
  OnboardingHint_NowItIsConvenientTimeToPlay_instance = new OnboardingHint('NowItIsConvenientTimeToPlay', 155, false, 'Now it is convenient time to play the Leap card.\nNote that the Leap can played only from a <Swamp>.');
  OnboardingHint_NoteThatMovingBolginToTheRight_instance = new OnboardingHint('NoteThatMovingBolginToTheRight', 156, true, 'Note that moving Bolgin to the right would result in another <Trail>\n(the first one is the standee itself), so Bolgin cannot trick Hunters that way.');
  OnboardingHint_LetSMoveBolginOneMoreStep_instance = new OnboardingHint('LetSMoveBolginOneMoreStep', 157, false, "Let's move Bolgin one more step left");
  OnboardingHint_AndNowLetSTrickTheHunters_instance = new OnboardingHint('AndNowLetSTrickTheHunters', 158, false, "And now let's trick the Hunters and play the No Movement card.\nClick on Bolgin's current location.");
  OnboardingHint_LetSPlayTheDarkDealingsCard_instance = new OnboardingHint('LetSPlayTheDarkDealingsCard', 159, false, "Let's play the Dark Dealings card. Note, that this card\ncannot be played when it is the last Action card in the hand.");
  OnboardingHint_TheDarkDealingsCardAllowsToReturn_instance = new OnboardingHint('TheDarkDealingsCardAllowsToReturn', 160, false, "The Dark Dealings card allows to return an Action card from the discard pile.\nLet's take back the Bolster card to boost hunter's team even more!\nNote, that Dark Dealings play is costly for the Hunters:\nthe card dealt a <OneDamage> to Helga.");
  OnboardingHint_LetSEndHelgaSTurn_instance = new OnboardingHint('LetSEndHelgaSTurn', 161, false, "Let's end Helga's turn");
  OnboardingHint_TheHuntersCanTryToCheckBolgin_instance = new OnboardingHint('TheHuntersCanTryToCheckBolgin', 162, false, "The Hunters can try to check Bolgin's path.\nLet's play the Command card.");
  OnboardingHint_HuntersDonTKnowWhereBolginMoved_instance = new OnboardingHint('HuntersDonTKnowWhereBolginMoved', 163, false, "Hunters don't know where Bolgin moved.\nThere are three variants actually.\nBut let's try a trick and reveal a <Trail> using the Settler!\nLet's move the <FarmerType> from New Arkstead one step to the North.");
  OnboardingHint_MoveTheFarmerTypeOneStepUp_instance = new OnboardingHint('MoveTheFarmerTypeOneStepUp', 164, false, 'Move the <FarmerType> one step up');
  OnboardingHint_TheTrailIsFoundSoLetS_instance = new OnboardingHint('TheTrailIsFoundSoLetS', 165, false, "The <Trail> is found, so let's move Iona\ncloser to Bolgin. Pick Iona to move.");
  OnboardingHint_MoveIonaOneStepRight_instance = new OnboardingHint('MoveIonaOneStepRight', 166, false, 'Move Iona one step right');
  OnboardingHint_NowItIsAGoodTimeTo_instance = new OnboardingHint('NowItIsAGoodTimeTo', 167, false, "Now it is a good time to restore hunter's resources.\nLet's play the Dark Rituals card to return Hunters' abilities.");
  OnboardingHint_NoteThatDarkRitualsCardAlsoDeals_instance = new OnboardingHint('NoteThatDarkRitualsCardAlsoDeals', 168, false, "Note, that Dark Rituals card also deals a <OneDamage> to a hunter.\nBut it allows to return an ability to several Hunters.\nLet's start with Iona.");
  OnboardingHint_TheSaferPlayWouldBeToReturn_instance = new OnboardingHint('TheSaferPlayWouldBeToReturn', 169, false, "The safer play would be to return the Silver Arrow.\nBut let's try more aggressive tactics and pick the Hunt card back.");
  OnboardingHint_AndLetSReturnTheCommandCard_instance = new OnboardingHint('AndLetSReturnTheCommandCard', 170, false, "And let's return the Command card back for Varja");
  OnboardingHint_NowTheHuntersNeedToProtectBoth_instance = new OnboardingHint('NowTheHuntersNeedToProtectBoth', 171, false, "Now the Hunters need to protect both <FarmerType>.\nBolgin is two steps away (right?..), so let's play the Track card.");
  OnboardingHint_MoveIonaOneStepLeft_instance = new OnboardingHint('MoveIonaOneStepLeft', 172, false, 'Move Iona one step left');
  OnboardingHint_AndOneMoreStepLeft_instance = new OnboardingHint('AndOneMoreStepLeft', 173, false, 'And one more step left');
  OnboardingHint_OkTheHuntersDiscoverThatBolginDid_instance = new OnboardingHint('OkTheHuntersDiscoverThatBolginDid', 174, false, "Ok, the Hunters discover that Bolgin did not move\nfarther and is now on the <FarmerType>'s location.\nSo let's just finish the turn in this protective position.");
  OnboardingHint_OkLetSTryToKillThe_instance = new OnboardingHint('OkLetSTryToKillThe', 175, false, "Ok, let's try to kill the <FarmerType>. Play the Prowl card.");
  OnboardingHint_LetSPerformTheAttackFirst_instance = new OnboardingHint('LetSPerformTheAttackFirst', 176, false, "Let's perform the attack first");
  OnboardingHint_AttackFarmerType_instance = new OnboardingHint('AttackFarmerType', 177, false, 'Attack <FarmerType>');
  OnboardingHint_LetSKillTheFarmerTypeInOne_instance = new OnboardingHint('LetSKillTheFarmerTypeInOne', 178, false, "Let's kill the <FarmerType> in one strike and spend <AncientPower>");
  OnboardingHint_AndNowItIsAGoodTime_instance = new OnboardingHint('AndNowItIsAGoodTime', 179, false, 'And now it is a good time for the Hunters to play the Smokebomb card.\nNote that this reaction is played AFTER Beast names\nthe target declares the <AncientPower> to spend.');
  OnboardingHint_SoTheHuntersSavedTheSettlerThe_instance = new OnboardingHint('SoTheHuntersSavedTheSettlerThe', 180, true, 'So the Hunters saved the settler.\nThe Smokebomb card reduced the damage to just one.');
  OnboardingHint_OkBolginFailedToKillTheFarmerType_instance = new OnboardingHint('OkBolginFailedToKillTheFarmerType', 181, false, "Ok, Bolgin failed to kill the <FarmerType> in one strike.\nHowever, the Avarice card is still resolving, so it is time\nto pick a Beastly Talent. Let's pick the Strange Summons card.");
  OnboardingHint_LetSPlayTheEvolveCardTo_instance = new OnboardingHint('LetSPlayTheEvolveCardTo', 182, false, "Let's play the Evolve card to move away");
  OnboardingHint_LetSMoveFirst_instance = new OnboardingHint('LetSMoveFirst', 183, false, "Let's move first");
  OnboardingHint_LetSMoveOneStepToThe_instance = new OnboardingHint('LetSMoveOneStepToThe', 184, false, "Let's move one step to the South");
  OnboardingHint_AndNowLetSUpgradeBolgin_instance = new OnboardingHint('AndNowLetSUpgradeBolgin', 185, false, "And now let's upgrade Bolgin!");
  OnboardingHint_SoLetSIncreaseBolginSMobility_instance = new OnboardingHint('SoLetSIncreaseBolginSMobility', 186, false, "So let''s increase Bolgin's mobility by unlocking the Cascade upgrade.\nFrom now on, you may move 1 step after a Polyp dies.");
  OnboardingHint_FinallyLetSRelocateHelgaCloserTo_instance = new OnboardingHint('FinallyLetSRelocateHelgaCloserTo', 187, false, "Finally, let's relocate Helga closer to the other Hunters.\nPlay the Adapt card.");
  OnboardingHint_LetSRelocateHelgaFirstAndCheck_instance = new OnboardingHint('LetSRelocateHelgaFirstAndCheck', 188, false, "Let's relocate Helga first and check Bolgin's possible location");
  OnboardingHint_ChooseNewArksteadAsTheDestination_instance = new OnboardingHint('ChooseNewArksteadAsTheDestination', 189, false, 'Choose New Arkstead as the destination');
  OnboardingHint_LetSPickAnUnknownCard_instance = new OnboardingHint('LetSPickAnUnknownCard', 190, false, "Let's pick an unknown card");
  OnboardingHint_HelgaReceivedTheFlareCardThisIs_instance = new OnboardingHint('HelgaReceivedTheFlareCardThisIs', 191, true, 'Helga received the Flare card.\nThis is also a game-changing card!');
  OnboardingHint_TheHuntersKnowWhereBolginIsRight_instance = new OnboardingHint('TheHuntersKnowWhereBolginIsRight', 192, false, "The Hunters know where Bolgin is right now,\nso let's move Iona to prepare the next hit.\nPlay the Command card.");
  OnboardingHint_LetSStartByMovingIona_instance = new OnboardingHint('LetSStartByMovingIona', 193, false, "Let's start by moving Iona");
  OnboardingHint_MoveIonaOneStepSouth_instance = new OnboardingHint('MoveIonaOneStepSouth', 194, false, 'Move Iona one step south');
  OnboardingHint_ThenLetSMoveTheWoundedFarmerType_instance = new OnboardingHint('ThenLetSMoveTheWoundedFarmerType', 195, false, "Then let's move the wounded <FarmerType> one step east");
  OnboardingHint_MoveTheFarmerTypeToTheRight_instance = new OnboardingHint('MoveTheFarmerTypeToTheRight', 196, false, 'Move the <FarmerType> to the right');
  OnboardingHint_LetSTalkNowAboutTrapSignTraps_instance = new OnboardingHint('LetSTalkNowAboutTrapSignTraps', 197, true, "Let's talk now about <TrapSign> Traps.\nHunters can play a <TrapSign> as a <BlueSign> card,\nname the zone where the trap will trigger and\nsecretly choose the location type it will trigger on.");
  OnboardingHint_SoLetSPlayTheFireTrap_instance = new OnboardingHint('SoLetSPlayTheFireTrap', 198, false, "So let's play the Fire Trap card");
  OnboardingHint_LetSPlaceItInTheNew_instance = new OnboardingHint('LetSPlaceItInTheNew', 199, false, "Let's place it in the New Elda zone");
  OnboardingHint_TheHuntersHaveNowPreparedIonaTo_instance = new OnboardingHint('TheHuntersHaveNowPreparedIonaTo', 200, false, "The Hunters have now prepared Iona to strike Bolgin.\nSo let's place the trap so it triggers during the attack.\nChoose <Settlement> as the Trap target.");
  OnboardingHint_LetSPlayTheAvariceCardTo_instance = new OnboardingHint('LetSPlayTheAvariceCardTo', 201, false, "Let's play the Avarice card to move Iona onto Bolgin's location");
  OnboardingHint_TheAvariceCardGivesAnActionTo_instance = new OnboardingHint('TheAvariceCardGivesAnActionTo', 202, false, "The Avarice card gives an action to both Iona and Helga in this case.\nLet's start with Iona.");
  OnboardingHint_MoveIonaToTheRight_instance = new OnboardingHint('MoveIonaToTheRight', 203, false, 'Move Iona to the right');
  OnboardingHint_TheAvariceCardAllowsAttacksOnlyAgainst_instance = new OnboardingHint('TheAvariceCardAllowsAttacksOnlyAgainst', 204, false, "The Avarice card allows attacks only against a revealed Beast,\nso Helga cannot do it now. Helga can move now, but let's leave her here.");
  OnboardingHint_AndNowLetSPlayTheHunt_instance = new OnboardingHint('AndNowLetSPlayTheHunt', 205, false, "And now let's play the Hunt card!");
  OnboardingHint_SoBeforeTheAttackIonaSearchedAnd_instance = new OnboardingHint('SoBeforeTheAttackIonaSearchedAnd', 206, false, "So before the attack Iona searched and revealed Bolgin.\nAt this moment, the Hunters can activate the Fire trap.\nLet's do it!");
  OnboardingHint_LetSPlayTheHasteCard_instance = new OnboardingHint('LetSPlayTheHasteCard', 207, false, "Let's play the Haste card");
  OnboardingHint_LetSMoveBolginFirst_instance = new OnboardingHint('LetSMoveBolginFirst', 208, false, "Let's move Bolgin first");
  OnboardingHint_LetSMoveBolginOneMoreStep2_instance = new OnboardingHint('LetSMoveBolginOneMoreStep2', 209, false, "Let's move Bolgin one more step right");
  OnboardingHint_AndNowLetSMoveBolginInto_instance = new OnboardingHint('AndNowLetSMoveBolginInto', 210, false, "And now let's move Bolgin into the location with the <FarmerType>. Move North.");
  OnboardingHint_BolginDecidesToFinishTheWoundedFarmerType_instance = new OnboardingHint('BolginDecidesToFinishTheWoundedFarmerType', 211, false, "Bolgin decides to finish the wounded <FarmerType>.\nLet's move the <FarmerType> out of the attack.\nPlay the Flare reaction.");
  OnboardingHint_InMostCasesYouWantToMove_instance = new OnboardingHint('InMostCasesYouWantToMove', 212, false, "In most cases you want to move a settler from the coming attack.\nBut actually, the Flare card allows you to move any Settler at the moment\na new <Trail> appears. Here, let's play it the standard way and move the wounded <FarmerType>.");
  OnboardingHint_LetSMoveTheFarmerTypeOneStep_instance = new OnboardingHint('LetSMoveTheFarmerTypeOneStep', 213, false, "Let's move the <FarmerType> one step East, to Varja's location");
  OnboardingHint_MovementAndReactionsHaveFinishedSoBolgin_instance = new OnboardingHint('MovementAndReactionsHaveFinishedSoBolgin', 214, false, "Movement and reactions have finished, so Bolgin can now play the second statement\nNote that this statement can be skipped. Let's transform all nearby locations into <Swamp>.\nBeasts can transform locations only into their preferred location type.");
  OnboardingHint_AsTheSecondCardLetSPlay_instance = new OnboardingHint('AsTheSecondCardLetSPlay', 215, false, "As the second card, let's play the Animate card.\nNote, that the Strange Summons card cannot be played,\nbecause it requires <OneGrudge>, and Bolgin has none.");
  OnboardingHint_TheAnimateCardHasTheThenKeyword_instance = new OnboardingHint('TheAnimateCardHasTheThenKeyword', 216, true, 'The Animate card has the "then" keyword.\nThis means that you must play the entire statement,\nand you cannot skip either part.');
  OnboardingHint_SoFirstYouMustPerformSummonActivationBecause_instance = new OnboardingHint('SoFirstYouMustPerformSummonActivationBecause', 217, true, 'So, First, you must perform <SummonActivation>.\nBecause there are no Polyps on the board, you have to place a new one.');
  OnboardingHint_LetSPlaceItNearFarmerTypeFrom_instance = new OnboardingHint('LetSPlaceItNearFarmerTypeFrom', 218, false, "Let's place it near <FarmerType> from Ghastvik Fjord");
  OnboardingHint_ThirteenActionCardsWereDealtDuringThe_instance = new OnboardingHint('ThirteenActionCardsWereDealtDuringThe', 219, false, "13 Action cards were dealt during the draft, and 3 cards were left unused.\nThe Animate card allows you to look at the unused cards and pick one.\nLet's pick the Pursuit card.");
  OnboardingHint_HelgaAndIonaInTheSameLocation_instance = new OnboardingHint('HelgaAndIonaInTheSameLocation', 220, false, "Helga and Iona in the same location, let's play the Bolster card!");
  OnboardingHint_LetSStartWithHelga_instance = new OnboardingHint('LetSStartWithHelga', 221, false, "Let's start with Helga");
  OnboardingHint_LetSPickTheUnknownHunterItem_instance = new OnboardingHint('LetSPickTheUnknownHunterItem', 222, false, "Let's pick the unknown hunter item for Helga");
  OnboardingHint_TheOutpostCardIsQuiteSituationalIt_instance = new OnboardingHint('TheOutpostCardIsQuiteSituationalIt', 223, true, 'The Outpost card is quite situational.\nIt allows to place a Watchtower:\nWhen a Hunter stands on a Watchtower,\nall <Trail> on nearby locations are revealed.');
  OnboardingHint_LetSAlsoPickTheUnknownHunter_instance = new OnboardingHint('LetSAlsoPickTheUnknownHunter', 224, false, "Let's also pick the unknown hunter item for Iona");
  OnboardingHint_TheBladeOfValhCardIsThe_instance = new OnboardingHint('TheBladeOfValhCardIsThe', 225, true, 'The Blade of Valh card is the only card that\nallows Hunters to upgrade something during the Day phase');
  OnboardingHint_LetSFinishHelgaSTurnFor_instance = new OnboardingHint('LetSFinishHelgaSTurnFor', 226, false, "Let's finish Helga's turn for now");
  OnboardingHint_LetSPassForVarja_instance = new OnboardingHint('LetSPassForVarja', 227, false, "Let's Pass for Varja");
  OnboardingHint_AndLetSPassForIonaAs_instance = new OnboardingHint('AndLetSPassForIonaAs', 228, false, "And let's Pass for Iona as well");
  OnboardingHint_TheHuntersHaveMostlyRunOutOf_instance = new OnboardingHint('TheHuntersHaveMostlyRunOutOf', 229, false, "The Hunters have mostly run out of cards, so this is a good opportunity to attack Settlers.\nIt is quite dangerous to attack the wounded <FarmerType> right now.\nSo let's attack another one. Play the Pursuit card first.");
  OnboardingHint_LetSFirstPickABeastlyTalent_instance = new OnboardingHint('LetSFirstPickABeastlyTalent', 230, false, "Let's first pick a Beastly Talent");
  OnboardingHint_LetSPickTheUnbendingWill_instance = new OnboardingHint('LetSPickTheUnbendingWill', 231, false, "Let's pick the Unbending Will");
  OnboardingHint_AndLetSMoveBolginOneStep_instance = new OnboardingHint('AndLetSMoveBolginOneStep', 232, false, "And let's move Bolgin one step North");
  OnboardingHint_LetSPassForHelga_instance = new OnboardingHint('LetSPassForHelga', 233, false, "Let's Pass for Helga");
  OnboardingHint_AndLetSPassForVarjaAs_instance = new OnboardingHint('AndLetSPassForVarjaAs', 234, false, "And let's Pass for Varja as well");
  OnboardingHint_LetSActuallyPlayTheBladeOf_instance = new OnboardingHint('LetSActuallyPlayTheBladeOf', 235, false, "Let's actually play the Blade of Valh card");
  OnboardingHint_SometimesYouMayWantToPlayThe_instance = new OnboardingHint('SometimesYouMayWantToPlayThe', 236, false, "Sometimes you may want to play the Blade of Valh just to gain a <OneGrudge>.\nBut let's actually upgrade Iona.");
  OnboardingHint_LetSPickTheMostPracticalUpgrade_instance = new OnboardingHint('LetSPickTheMostPracticalUpgrade', 237, false, "Let's pick the most practical upgrade: Joint Effort.\nIt is very cheap and gives Iona many bonus movement opportunities.");
  OnboardingHint_LetSPlayTheUnbendingWillCard_instance = new OnboardingHint('LetSPlayTheUnbendingWillCard', 238, false, "Let's play the Unbending Will card");
  OnboardingHint_AndLetSReturnTheSummonPolyp_instance = new OnboardingHint('AndLetSReturnTheSummonPolyp', 239, false, "And let's return the Summon Polyp card to hand");
  OnboardingHint_AndLetSFinishTheTurn_instance = new OnboardingHint('AndLetSFinishTheTurn', 240, false, "And let's finish the turn");
  OnboardingHint_LetSPlayTheTrackCard_instance = new OnboardingHint('LetSPlayTheTrackCard', 241, false, "Let's play the Track card");
  OnboardingHint_LetSSupposeTheHuntersGuessBolgin_instance = new OnboardingHint('LetSSupposeTheHuntersGuessBolgin', 242, false, "Let's suppose the Hunters guess Bolgin's path correctly and move to the right");
  OnboardingHint_ThereIsATrailSoTrackNow_instance = new OnboardingHint('ThereIsATrailSoTrackNow', 243, false, "There is a <Trail>, so Track now allows one\nadditional move. Let's move North.");
  OnboardingHint_HelgaFinishesTrackInTheSameZone_instance = new OnboardingHint('HelgaFinishesTrackInTheSameZone', 244, false, "Helga finishes Track in the same zone as Iona, and Iona\nhas the Joint Effort upgrade. So Iona can also move now.\nLet's move Iona North.");
  OnboardingHint_LetSFinishHelgaSTurn_instance = new OnboardingHint('LetSFinishHelgaSTurn', 245, false, "Let's finish Helga's turn");
  OnboardingHint_VarjaCannotDoMuchEitherLetS_instance = new OnboardingHint('VarjaCannotDoMuchEitherLetS', 246, false, "Varja cannot do much either. Let's Pass.");
  OnboardingHint_IonaHasNoCardsSoSheWill_instance = new OnboardingHint('IonaHasNoCardsSoSheWill', 247, true, 'Iona has no cards, so she will effectively Pass from now on');
  OnboardingHint_LetSPlayTheSummonPolypCard2_instance = new OnboardingHint('LetSPlayTheSummonPolypCard2', 248, false, "Let's play the Summon Polyp card");
  OnboardingHint_LetSStartWithMovement_instance = new OnboardingHint('LetSStartWithMovement', 249, false, "Let's start with movement");
  OnboardingHint_LetSMoveBolginWest_instance = new OnboardingHint('LetSMoveBolginWest', 250, false, "Let's move Bolgin West");
  OnboardingHint_AndNowLetSPlaySummonActivation_instance = new OnboardingHint('AndNowLetSPlaySummonActivation', 251, false, "And now let's play <SummonActivation>");
  OnboardingHint_LetSActivateAllSummonsOnThe_instance = new OnboardingHint('LetSActivateAllSummonsOnThe', 252, false, "Let's activate all summons on the board (actually, only one in this case)");
  OnboardingHint_AndLetSUsePolypSUnique_instance = new OnboardingHint('AndLetSUsePolypSUnique', 253, false, "And let's use Polyp's unique ability: Burst");
  OnboardingHint_SoBurstThePolypInGhastvikFjord_instance = new OnboardingHint('SoBurstThePolypInGhastvikFjord', 254, false, 'So Burst the Polyp in Ghastvik Fjord to target the <FarmerType>');
  OnboardingHint_ThePolypBurstsDestroyingItselfWoundingThe_instance = new OnboardingHint('ThePolypBurstsDestroyingItselfWoundingThe', 255, false, "The Polyp bursts, destroying itself, wounding the <FarmerType>, and transforming Ghastvik Fjord into <Swamp>.\nBecause Bolgin has upgraded Cascade, they may now move 1 step after the Polyp dies.\nLet's move Bolgin to the <FarmerType>.");
  OnboardingHint_AndNowLetSPlayTheRage_instance = new OnboardingHint('AndNowLetSPlayTheRage', 256, false, "And now let's play the Rage card to finish the <FarmerType>");
  OnboardingHint_NowItIsUnlikelyThatHelgaCan_instance = new OnboardingHint('NowItIsUnlikelyThatHelgaCan', 257, false, "Now it is unlikely that Helga can use the Hunt card to Attack.\nSo let's use the Hunt card to Flee: it allows you to discard a card to move 1 step.");
  OnboardingHint_LetSMoveHelgaNorth_instance = new OnboardingHint('LetSMoveHelgaNorth', 258, false, "Let's move Helga North");
  OnboardingHint_LetSPassForVarja2_instance = new OnboardingHint('LetSPassForVarja2', 259, false, "Let's Pass for Varja");
  OnboardingHint_AndNowBolginHasOneGrudgeToPlay_instance = new OnboardingHint('AndNowBolginHasOneGrudgeToPlay', 260, false, "And now Bolgin has <OneGrudge> to play the Strange Summons card! Let's do it.");
  OnboardingHint_LetSStartWithMovement2_instance = new OnboardingHint('LetSStartWithMovement2', 261, false, "Let's start with movement");
  OnboardingHint_LetSMoveBolginEast_instance = new OnboardingHint('LetSMoveBolginEast', 262, false, "Let's move Bolgin East");
  OnboardingHint_AndNowLetSPlaySummonActivation2_instance = new OnboardingHint('AndNowLetSPlaySummonActivation2', 263, false, "And now let's play <SummonActivation>");
  OnboardingHint_LetSPlaceTheNewPolypIn_instance = new OnboardingHint('LetSPlaceTheNewPolypIn', 264, false, "Let's place the new Polyp in the center of the map");
  OnboardingHint_LetSPlayTheOutpostCard_instance = new OnboardingHint('LetSPlayTheOutpostCard', 265, false, "Let's play the Outpost card");
  OnboardingHint_WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile_instance = new OnboardingHint('WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile', 266, true, '<WatchtowerType> reveals nearby <Trail> only only while a Hunter is in its location');
  OnboardingHint_ThatPolypCanBurstHittingBothVarja_instance = new OnboardingHint('ThatPolypCanBurstHittingBothVarja', 267, false, "That Polyp can Burst, hitting both Varja and the <FarmerType>.\nIt is impossible to save the <FarmerType>, so so let's at least Flee with Varja.");
  OnboardingHint_LetSMoveVarjaWestCloseTo_instance = new OnboardingHint('LetSMoveVarjaWestCloseTo', 268, false, "Let's move Varja West, close to the other Hunters");
  OnboardingHint_TheDayIsOverSinceAllCharacters_instance = new OnboardingHint('TheDayIsOverSinceAllCharacters', 269, true, 'The Day is over, since all characters have Passed. Now the Night begins.\nThe Night phase starts with the Reward subphase. As always,\nBeasts receive rewards before Hunters.');
  OnboardingHint_BolginReceivesAncientPowerAndMayNowPerform_instance = new OnboardingHint('BolginReceivesAncientPowerAndMayNowPerform', 270, false, "Bolgin receives <AncientPower>, and may now perform <SummonActivation>. Let's activate the Polyp!");
  OnboardingHint_LetSUseTheBurstAgain_instance = new OnboardingHint('LetSUseTheBurstAgain', 271, false, "Let's use the Burst again");
  OnboardingHint_LetSBurstTheWoundedFarmerTypeBelow_instance = new OnboardingHint('LetSBurstTheWoundedFarmerTypeBelow', 272, false, "Let's Burst the wounded <FarmerType> below");
  OnboardingHint_NoteThatTheFarmerTypeWasKilledBy_instance = new OnboardingHint('NoteThatTheFarmerTypeWasKilledBy', 273, true, "Note that the <FarmerType> was killed by a Polyp,\nso Bolgin doesn't receive any <OneGrudge> reward");
  OnboardingHint_TheCascadeUpgradeAllowsBolginToMove_instance = new OnboardingHint('TheCascadeUpgradeAllowsBolginToMove', 274, false, "The Cascade upgrade allows Bolgin to move. Let's move Bolgin East.");
  OnboardingHint_NowItIsTimeForTheHunters_instance = new OnboardingHint('NowItIsTimeForTheHunters', 275, true, "Now it is time for the Hunters' reward, since they managed to deal <OneDamage> (actually, even <ThreeDamages>)");
  OnboardingHint_NoteThatTheHuntersKnowBolginS_instance = new OnboardingHint('NoteThatTheHuntersKnowBolginS', 276, true, "Note that the Hunters know Bolgin's location, since <WatchtowerType> has revealed the new <Trail>");
  OnboardingHint_AllHuntersGainOneGrudgeAsAReward_instance = new OnboardingHint('AllHuntersGainOneGrudgeAsAReward', 277, false, "All Hunters gain <OneGrudge> as a reward, and each\nHunter may also move 1 step. Let's start with Helga.");
  OnboardingHint_LetSMoveHelgaOneStepRight_instance = new OnboardingHint('LetSMoveHelgaOneStepRight', 278, false, "Let's move Helga one step right");
  OnboardingHint_NextLetSMoveVarja_instance = new OnboardingHint('NextLetSMoveVarja', 279, false, "Next, let's move Varja");
  OnboardingHint_LetSMoveVarjaNorth_instance = new OnboardingHint('LetSMoveVarjaNorth', 280, false, "Let's move Varja North");
  OnboardingHint_AndLetSMoveIonaEastClose_instance = new OnboardingHint('AndLetSMoveIonaEastClose', 281, false, "And let's move Iona East, close to the other Hunters");
  OnboardingHint_AfterTheRewardsHunterItemsAndBeastly_instance = new OnboardingHint('AfterTheRewardsHunterItemsAndBeastly', 282, true, 'After the Rewards, Hunter Items and Beastly Talents are refreshed:\nremaining open cards are discarded, and new ones are revealed.');
  OnboardingHint_NextAllActionCardsFromHandsUnused_instance = new OnboardingHint('NextAllActionCardsFromHandsUnused', 283, true, "Next, all Action cards (from hands, unused cards, and the discard pile) are combined into\na single deck for the next draft. All Ability cards return to their owners' hands.");
  OnboardingHint_FinallyRemoveAllOneDamageFromSettlersFarmerType_instance = new OnboardingHint('FinallyRemoveAllOneDamageFromSettlersFarmerType', 284, true, 'Finally, remove all <OneDamage> from Settlers <FarmerType> <NobleType> and Animals <SheepType> <BoarType> <BearType>.\nThey have again full HP! But Beasts and Hunters keep their wounds.');
  OnboardingHint_InMostContractsTheDeathOfThe_instance = new OnboardingHint('InMostContractsTheDeathOfThe', 285, true, 'In most contracts, the death of the Beast results in a Hunter team victory.\nHowever, the death of a Hunter is not permanent. All dead Hunters may be placed\nin any <Settlement> during this Night subphase. There is a funny corner case:\nthis is impossible if there are no <Settlement> locations on the map (if all have been transformed).');
  OnboardingHint_TheRewardSubphaseIsResolvedBeforeThe_instance = new OnboardingHint('TheRewardSubphaseIsResolvedBeforeThe', 286, true, "The Reward subphase is resolved before the Refresh,\nso dead Hunters don't receive Rewards.\nIn addition, when a Hunter dies, they lose all <OneGrudge> and discard all cards.\nOnly upgrades are preserved.");
  OnboardingHint_IfAHunterDiesByABeast_instance = new OnboardingHint('IfAHunterDiesByABeast', 287, true, "If a Hunter dies by a Beast attack, then the Beast\ngains one random Action card from that Hunter's hand (if the Hunter had any).\nAll remaining Action cards and other cards are discarded.");
  OnboardingHint_AfterTheRefreshPlayersMayUpgradeAs_instance = new OnboardingHint('AfterTheRefreshPlayersMayUpgradeAs', 288, true, "After the Refresh, players may upgrade.\nAs always, Beasts upgrade first, then Hunters upgrade.\nPlayers may buy as many upgrades as they want, as long as they have enough <OneGrudge>.\nBut now Bolgin has no <OneGrudge>, so let's proceed to the Hunters' upgrades.\nHunters may upgrade in any order and can even combine upgrades into powerful combos.");
  OnboardingHint_TheHuntersNowKnowThatBolginIs_instance = new OnboardingHint('TheHuntersNowKnowThatBolginIs', 289, true, 'The Hunters now know that Bolgin is 3 steps away from a <FarmerType>.\n<FarmerType> could be killed in one turn if Bolgin receives the right cards in the Draft.');
  OnboardingHint_LetSStartWithVarjaAndUpgrade_instance = new OnboardingHint('LetSStartWithVarjaAndUpgrade', 290, false, "Let's start with Varja and upgrade\nthe Heroic Speech. It is the Yellow upgrade,\nso it has a one-time effect\nand may be used only once per game.");
  OnboardingHint_LetSChooseTheFarmerTypeInVintervik_instance = new OnboardingHint('LetSChooseTheFarmerTypeInVintervik', 291, false, "Let's choose the <FarmerType> in Vintervik, so they will be relatively safe");
  OnboardingHint_NowTheHuntersWillHaveSomeTime_instance = new OnboardingHint('NowTheHuntersWillHaveSomeTime', 292, true, 'Now the Hunters will have some time for sure');
  OnboardingHint_BolginNowNeedsOnlyOneDamageOneDamageTo_instance = new OnboardingHint('BolginNowNeedsOnlyOneDamageOneDamageTo', 293, false, "Bolgin now needs only <OneDamage> <OneDamage> to kill.\nLet's upgrade the Ancient Calling for Iona.");
  OnboardingHint_AndLetSSaveOneGrudgeForHelga_instance = new OnboardingHint('AndLetSSaveOneGrudgeForHelga', 294, false, "And let's save <OneGrudge> for Helga.\nJust press Done.");
  OnboardingHint_TheNextDayNowBeginsWithThe_instance = new OnboardingHint('TheNextDayNowBeginsWithThe', 295, false, "The next day now begins with the Dawn phase (the Draft).\nFrom this position, it is hard to tell who will win.\nBut let's finish the Onboarding Script. Now you are\nfully prepared for your own Beast games. Good luck!");
}
var OnboardingSequence_Introduction_instance;
var OnboardingSequence_BolginBoard_instance;
var OnboardingSequence_HelgaBoard_instance;
var OnboardingSequence_VarjaCards_instance;
var OnboardingSequence_IonaCards_instance;
var OnboardingSequence_ContractStartingConditions_instance;
var OnboardingSequence_MovementCards_instance;
var OnboardingSequence_SmokeBomb_instance;
var OnboardingSequence_Flare_instance;
var OnboardingSequence_Outpost_instance;
var OnboardingSequence_BladeOfValh_instance;
var OnboardingSequence_entriesInitialized;
function OnboardingSequence_initEntries() {
  if (OnboardingSequence_entriesInitialized)
    return Unit_instance;
  OnboardingSequence_entriesInitialized = true;
  OnboardingSequence_Introduction_instance = new OnboardingSequence('Introduction', 0, listOf_0([OnboardingHint_WelcomeToTheInteractiveOnboardingForThe_getInstance(), OnboardingHint_WhenYouBeginANewGameYou_getInstance(), OnboardingHint_FirstOfAllTheContractSpecifiesThe_getInstance(), OnboardingHint_NextTheContractDefinesTheWinningConditions_getInstance(), OnboardingHint_SettlersAreRepresentedByNobleTypeBlueNoble_getInstance(), OnboardingHint_TheFarmerTypeYellowMeeplesAreTheFarmers_getInstance(), OnboardingHint_TheNobleTypeBlueMeeplesAreTheNobles_getInstance(), OnboardingHint_BesidesSettlersTheMapContainsALot_getInstance(), OnboardingHint_BothTheBeastAndTheHuntersTeams_getInstance(), OnboardingHint_YouCanFindHPValuesAndOneGrudge_getInstance(), OnboardingHint_UsuallyContractsIncludeSeveralDaysThisContract_getInstance(), OnboardingHint_YouWillSpendMostOfTheGame_getInstance(), OnboardingHint_CardsAreEssentiallyTheMainResourceIn_getInstance(), OnboardingHint_LetSTalkALittleMoreAbout_getInstance(), OnboardingHint_EveryCharacterHasItsOwnSetOf_getInstance(), OnboardingHint_DiscardPilesAreOpenInformationInThe_getInstance(), OnboardingHint_ActionCardsAreTheCoreDriverOf_getInstance(), OnboardingHint_ThereAre16ActionCardsThatAre_getInstance(), OnboardingHint_ButYouCanKeepArsenalCardsBeastly_getInstance(), OnboardingHint_HoweverArsenalCardsAreNotEasyTo_getInstance(), OnboardingHint_AlsoEveryCardHasASpecialKind_getInstance(), OnboardingHint_RedSignRedAndBlueSignBlueCardsAre_getInstance(), OnboardingHint_ReactionSignReactionCardsArePlayedWhenTheir_getInstance(), OnboardingHint_TrapSignTrapCardsArePlayedLikeBlueSign_getInstance(), OnboardingHint_SomeArsenalCardsHaveTheOneGrudgeGrudge_getInstance(), OnboardingHint_LetSReturnToTheGameFlow_getInstance(), OnboardingHint_InMostContractsTheNightPhaseHas_getInstance(), OnboardingHint_TheseRewardsAreSpecifiedByTheContract_getInstance(), OnboardingHint_TheRewardWillBeGivenToYou_getInstance()]));
  OnboardingSequence_BolginBoard_instance = new OnboardingSequence('BolginBoard', 1, listOf_0([OnboardingHint_EveryBeastHasACharacterBoardWith_getInstance(), OnboardingHint_EveryBeastHasAPreferredLocationType_getInstance(), OnboardingHint_BolginHas5HP_getInstance(), OnboardingHint_AlsoEveryBeastHas4AbilityCards_getInstance(), OnboardingHint_LetSLookAgainAtBolginS_getInstance(), OnboardingHint_EveryBeastHasItsOwnSummonsSo_getInstance(), OnboardingHint_EachSummonHas3ActionsMoveOne_getInstance(), OnboardingHint_SoBolginSPolypsCanBurstA_getInstance()]));
  OnboardingSequence_HelgaBoard_instance = new OnboardingSequence('HelgaBoard', 2, listOf_0([OnboardingHint_EveryHunterHasASetOfThree_getInstance(), OnboardingHint_TheThirdAbilityCardIsAUnique_getInstance(), OnboardingHint_EveryHunterAlsoHasACharacterBoard_getInstance()]));
  OnboardingSequence_VarjaCards_instance = new OnboardingSequence('VarjaCards', 3, listOf(OnboardingHint_VarjaHasTheSameTrackAndHunt_getInstance()));
  OnboardingSequence_IonaCards_instance = new OnboardingSequence('IonaCards', 4, listOf(OnboardingHint_IonaIsVeryNiceForTheLast_getInstance()));
  OnboardingSequence_ContractStartingConditions_instance = new OnboardingSequence('ContractStartingConditions', 5, listOf(OnboardingHint_ContractsAlsoSpecifyAdditionalRulesAndStarting_getInstance()));
  OnboardingSequence_MovementCards_instance = new OnboardingSequence('MovementCards', 6, listOf_0([OnboardingHint_WhenTheBeastMovesItMustPut_getInstance(), OnboardingHint_ForThisMovementBolginHasToPut_getInstance(), OnboardingHint_ThereAreFiveTypesOfMovementCards_getInstance(), OnboardingHint_ItIsImportantThatBeastCannotPlay_getInstance()]));
  OnboardingSequence_SmokeBomb_instance = new OnboardingSequence('SmokeBomb', 7, listOf(OnboardingHint_IonaReceivedTheSmokebombCardThisCard_getInstance()));
  OnboardingSequence_Flare_instance = new OnboardingSequence('Flare', 8, listOf(OnboardingHint_HelgaReceivedTheFlareCardThisIs_getInstance()));
  OnboardingSequence_Outpost_instance = new OnboardingSequence('Outpost', 9, listOf(OnboardingHint_TheOutpostCardIsQuiteSituationalIt_getInstance()));
  OnboardingSequence_BladeOfValh_instance = new OnboardingSequence('BladeOfValh', 10, listOf(OnboardingHint_TheBladeOfValhCardIsThe_getInstance()));
}
function OnboardingHint_WelcomeToTheInteractiveOnboardingForThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WelcomeToTheInteractiveOnboardingForThe_instance;
}
function OnboardingHint_WhenYouBeginANewGameYou_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenYouBeginANewGameYou_instance;
}
function OnboardingHint_FirstOfAllTheContractSpecifiesThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_FirstOfAllTheContractSpecifiesThe_instance;
}
function OnboardingHint_NextTheContractDefinesTheWinningConditions_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NextTheContractDefinesTheWinningConditions_instance;
}
function OnboardingHint_SettlersAreRepresentedByNobleTypeBlueNoble_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SettlersAreRepresentedByNobleTypeBlueNoble_instance;
}
function OnboardingHint_TheFarmerTypeYellowMeeplesAreTheFarmers_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheFarmerTypeYellowMeeplesAreTheFarmers_instance;
}
function OnboardingHint_TheNobleTypeBlueMeeplesAreTheNobles_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheNobleTypeBlueMeeplesAreTheNobles_instance;
}
function OnboardingHint_BesidesSettlersTheMapContainsALot_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BesidesSettlersTheMapContainsALot_instance;
}
function OnboardingHint_BothTheBeastAndTheHuntersTeams_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BothTheBeastAndTheHuntersTeams_instance;
}
function OnboardingHint_YouCanFindHPValuesAndOneGrudge_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_YouCanFindHPValuesAndOneGrudge_instance;
}
function OnboardingHint_UsuallyContractsIncludeSeveralDaysThisContract_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_UsuallyContractsIncludeSeveralDaysThisContract_instance;
}
function OnboardingHint_YouWillSpendMostOfTheGame_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_YouWillSpendMostOfTheGame_instance;
}
function OnboardingHint_CardsAreEssentiallyTheMainResourceIn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_CardsAreEssentiallyTheMainResourceIn_instance;
}
function OnboardingHint_LetSTalkALittleMoreAbout_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSTalkALittleMoreAbout_instance;
}
function OnboardingHint_EveryCharacterHasItsOwnSetOf_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryCharacterHasItsOwnSetOf_instance;
}
function OnboardingHint_DiscardPilesAreOpenInformationInThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_DiscardPilesAreOpenInformationInThe_instance;
}
function OnboardingHint_ActionCardsAreTheCoreDriverOf_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ActionCardsAreTheCoreDriverOf_instance;
}
function OnboardingHint_ThereAre16ActionCardsThatAre_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThereAre16ActionCardsThatAre_instance;
}
function OnboardingHint_ButYouCanKeepArsenalCardsBeastly_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ButYouCanKeepArsenalCardsBeastly_instance;
}
function OnboardingHint_HoweverArsenalCardsAreNotEasyTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HoweverArsenalCardsAreNotEasyTo_instance;
}
function OnboardingHint_AlsoEveryCardHasASpecialKind_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AlsoEveryCardHasASpecialKind_instance;
}
function OnboardingHint_RedSignRedAndBlueSignBlueCardsAre_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_RedSignRedAndBlueSignBlueCardsAre_instance;
}
function OnboardingHint_ReactionSignReactionCardsArePlayedWhenTheir_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ReactionSignReactionCardsArePlayedWhenTheir_instance;
}
function OnboardingHint_TrapSignTrapCardsArePlayedLikeBlueSign_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TrapSignTrapCardsArePlayedLikeBlueSign_instance;
}
function OnboardingHint_SomeArsenalCardsHaveTheOneGrudgeGrudge_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SomeArsenalCardsHaveTheOneGrudgeGrudge_instance;
}
function OnboardingHint_LetSReturnToTheGameFlow_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSReturnToTheGameFlow_instance;
}
function OnboardingHint_InMostContractsTheNightPhaseHas_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_InMostContractsTheNightPhaseHas_instance;
}
function OnboardingHint_TheseRewardsAreSpecifiedByTheContract_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheseRewardsAreSpecifiedByTheContract_instance;
}
function OnboardingHint_TheRewardWillBeGivenToYou_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheRewardWillBeGivenToYou_instance;
}
function OnboardingHint_AtTheBeginningOfTheGameReveal_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AtTheBeginningOfTheGameReveal_instance;
}
function OnboardingHint_ThenPlayersChooseTheirCharactersTheBeast_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThenPlayersChooseTheirCharactersTheBeast_instance;
}
function OnboardingHint_EveryBeastHasACharacterBoardWith_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryBeastHasACharacterBoardWith_instance;
}
function OnboardingHint_EveryBeastHasAPreferredLocationType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryBeastHasAPreferredLocationType_instance;
}
function OnboardingHint_BolginHas5HP_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginHas5HP_instance;
}
function OnboardingHint_AlsoEveryBeastHas4AbilityCards_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AlsoEveryBeastHas4AbilityCards_instance;
}
function OnboardingHint_LetSLookAgainAtBolginS_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSLookAgainAtBolginS_instance;
}
function OnboardingHint_EveryBeastHasItsOwnSummonsSo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryBeastHasItsOwnSummonsSo_instance;
}
function OnboardingHint_EachSummonHas3ActionsMoveOne_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EachSummonHas3ActionsMoveOne_instance;
}
function OnboardingHint_SoBolginSPolypsCanBurstA_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoBolginSPolypsCanBurstA_instance;
}
function OnboardingHint_TheBeastHasBeenChosenSoThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheBeastHasBeenChosenSoThe_instance;
}
function OnboardingHint_EveryHunterHasASetOfThree_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryHunterHasASetOfThree_instance;
}
function OnboardingHint_TheThirdAbilityCardIsAUnique_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheThirdAbilityCardIsAUnique_instance;
}
function OnboardingHint_EveryHunterAlsoHasACharacterBoard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryHunterAlsoHasACharacterBoard_instance;
}
function OnboardingHint_LetSPickVarjaAsTheSecond_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickVarjaAsTheSecond_instance;
}
function OnboardingHint_VarjaHasTheSameTrackAndHunt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_VarjaHasTheSameTrackAndHunt_instance;
}
function OnboardingHint_ForTheLastPositionLetSPick_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ForTheLastPositionLetSPick_instance;
}
function OnboardingHint_IonaIsVeryNiceForTheLast_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_IonaIsVeryNiceForTheLast_instance;
}
function OnboardingHint_ContractsAlsoSpecifyAdditionalRulesAndStarting_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ContractsAlsoSpecifyAdditionalRulesAndStarting_instance;
}
function OnboardingHint_TheBeastStartsTheGameInThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheBeastStartsTheGameInThe_instance;
}
function OnboardingHint_YouMayAlsoNoticeWhiteLinesSplitting_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_YouMayAlsoNoticeWhiteLinesSplitting_instance;
}
function OnboardingHint_AtTheBeginningOfTheGameThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AtTheBeginningOfTheGameThe_instance;
}
function OnboardingHint_ToReceiveTheFirstNightRewardBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ToReceiveTheFirstNightRewardBolgin_instance;
}
function OnboardingHint_TheMapHas3ConvenientSwampLocations_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheMapHas3ConvenientSwampLocations_instance;
}
function OnboardingHint_AndTheNextStepToTheLeft_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndTheNextStepToTheLeft_instance;
}
function OnboardingHint_WhenTheBeastMovesItMustPut_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenTheBeastMovesItMustPut_instance;
}
function OnboardingHint_ForThisMovementBolginHasToPut_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ForThisMovementBolginHasToPut_instance;
}
function OnboardingHint_ThereAreFiveTypesOfMovementCards_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThereAreFiveTypesOfMovementCards_instance;
}
function OnboardingHint_ItIsImportantThatBeastCannotPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ItIsImportantThatBeastCannotPlay_instance;
}
function OnboardingHint_ToSimplifyTheTrackingOfBeastThis_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ToSimplifyTheTrackingOfBeastThis_instance;
}
function OnboardingHint_TrailsTrailIsAnImportantConceptIn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TrailsTrailIsAnImportantConceptIn_instance;
}
function OnboardingHint_LetSSwitchToTheHuntersPerspective_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSSwitchToTheHuntersPerspective_instance;
}
function OnboardingHint_HuntersDonTSeeTheBeastS_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HuntersDonTSeeTheBeastS_instance;
}
function OnboardingHint_ActuallyTheBeastCanBeInTwo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ActuallyTheBeastCanBeInTwo_instance;
}
function OnboardingHint_NowItIsTheHunterSPart_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsTheHunterSPart_instance;
}
function OnboardingHint_HuntersGainManyBonusesWhenTheyStay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HuntersGainManyBonusesWhenTheyStay_instance;
}
function OnboardingHint_SoLetSPlaceHelgaInTiveden_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoLetSPlaceHelgaInTiveden_instance;
}
function OnboardingHint_NowLetSPlaceVarjaInGhastvik_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowLetSPlaceVarjaInGhastvik_instance;
}
function OnboardingHint_AndLetSPlaceIonaInGhastvik_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSPlaceIonaInGhastvik_instance;
}
function OnboardingHint_BeforeTheDraftBeginsTheBeastReceives_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BeforeTheDraftBeginsTheBeastReceives_instance;
}
function OnboardingHint_LetSPlayALittleBitGreedy_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayALittleBitGreedy_instance;
}
function OnboardingHint_TheBeastGameIsDesignedSoThat_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheBeastGameIsDesignedSoThat_instance;
}
function OnboardingHint_LetSPickEnsnareActionCardFor_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickEnsnareActionCardFor_instance;
}
function OnboardingHint_ForVarjaLetSPickTheCharge_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ForVarjaLetSPickTheCharge_instance;
}
function OnboardingHint_AndAtLastLetSChooseHidden_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndAtLastLetSChooseHidden_instance;
}
function OnboardingHint_WhenAllPlayersHavePickedACard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenAllPlayersHavePickedACard_instance;
}
function OnboardingHint_LetSPickTheAnimateCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheAnimateCard_instance;
}
function OnboardingHint_LetSPickTheAdaptCardFor_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheAdaptCardFor_instance;
}
function OnboardingHint_ForVarijaLetSPickTheDark_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ForVarijaLetSPickTheDark_instance;
}
function OnboardingHint_AndForIonaLetSPickThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndForIonaLetSPickThe_instance;
}
function OnboardingHint_DuringTheDayPhaseAllPlayersTake_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_DuringTheDayPhaseAllPlayersTake_instance;
}
function OnboardingHint_PassingIsNotFinalAPlayerMay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_PassingIsNotFinalAPlayerMay_instance;
}
function OnboardingHint_APlayerMayPassOnlyIfNo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_APlayerMayPassOnlyIfNo_instance;
}
function OnboardingHint_RightNowBolginHas4AbilityCards_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_RightNowBolginHas4AbilityCards_instance;
}
function OnboardingHint_DuringATurnAPlayerCanEither_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_DuringATurnAPlayerCanEither_instance;
}
function OnboardingHint_SometimesYouMayWantToMoveBut_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SometimesYouMayWantToMoveBut_instance;
}
function OnboardingHint_NowLetSPlayTheEngorgeCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowLetSPlayTheEngorgeCard_instance;
}
function OnboardingHint_JustClickOnTheEngorgeCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_JustClickOnTheEngorgeCard_instance;
}
function OnboardingHint_WhenYouPlayACardYouShould_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenYouPlayACardYouShould_instance;
}
function OnboardingHint_TechnicallyYouCanSkipAllStatementsOn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TechnicallyYouCanSkipAllStatementsOn_instance;
}
function OnboardingHint_SoInThisCaseBolginPerformsAn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoInThisCaseBolginPerformsAn_instance;
}
function OnboardingHint_WhenTheBeastRevealsHuntersCanPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenTheBeastRevealsHuntersCanPlay_instance;
}
function OnboardingHint_WhenAttackingTheBeastMustDeclareA_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenAttackingTheBeastMustDeclareA_instance;
}
function OnboardingHint_ByDefaultEveryBeastDealsOneDamage_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ByDefaultEveryBeastDealsOneDamage_instance;
}
function OnboardingHint_SheepTypeHasJust1HPSoBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SheepTypeHasJust1HPSoBolgin_instance;
}
function OnboardingHint_BolginPlayedTheFirstCardAndIt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginPlayedTheFirstCardAndIt_instance;
}
function OnboardingHint_LetSPlayTheSummonPolypCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheSummonPolypCard_instance;
}
function OnboardingHint_ThisCardContainsTwoStatementsThatCan_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThisCardContainsTwoStatementsThatCan_instance;
}
function OnboardingHint_LetSStartWithTheSummonActivationAction_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartWithTheSummonActivationAction_instance;
}
function OnboardingHint_WhenYouPlayASummonActivationActionYou_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenYouPlayASummonActivationActionYou_instance;
}
function OnboardingHint_SinceThereIsNoPolypOnThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SinceThereIsNoPolypOnThe_instance;
}
function OnboardingHint_EveryBeastHasItsOwnSummonLimit_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryBeastHasItsOwnSummonLimit_instance;
}
function OnboardingHint_EveryBeastCanPlaceASummonOnly_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EveryBeastCanPlaceASummonOnly_instance;
}
function OnboardingHint_LetSPlaceAPolypJustAbove_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlaceAPolypJustAbove_instance;
}
function OnboardingHint_WhenASummonIsActivatedItPerforms_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenASummonIsActivatedItPerforms_instance;
}
function OnboardingHint_LikeHuntersAndBeastsSummonsHave1_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LikeHuntersAndBeastsSummonsHave1_instance;
}
function OnboardingHint_WhileSummonsAreQuiteDeadlyTheyHave_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhileSummonsAreQuiteDeadlyTheyHave_instance;
}
function OnboardingHint_AndNowLetSMoveBolginOne_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSMoveBolginOne_instance;
}
function OnboardingHint_BolginHasPlayedTwoCardsAndIt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginHasPlayedTwoCardsAndIt_instance;
}
function OnboardingHint_NoteThatHelgaCanPassNowIt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatHelgaCanPassNowIt_instance;
}
function OnboardingHint_LetSPlayTheEnsnareCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheEnsnareCard_instance;
}
function OnboardingHint_TheEnsnareCardAllowsYouToSee_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheEnsnareCardAllowsYouToSee_instance;
}
function OnboardingHint_LetSDiscardTheBeastlyTongueCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSDiscardTheBeastlyTongueCard_instance;
}
function OnboardingHint_LetSKeepTheCardsAndEnd_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSKeepTheCardsAndEnd_instance;
}
function OnboardingHint_LetSMoveCloseToBeastPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveCloseToBeastPlay_instance;
}
function OnboardingHint_TheInciteCardAllowsYouToMove_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheInciteCardAllowsYouToMove_instance;
}
function OnboardingHint_HuntersPerformMovementStepByStepAnd_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HuntersPerformMovementStepByStepAnd_instance;
}
function OnboardingHint_MoveVarjaOneStepLower_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveVarjaOneStepLower_instance;
}
function OnboardingHint_NoteThatAllHunterMovementsAsWell_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatAllHunterMovementsAsWell_instance;
}
function OnboardingHint_NowLetSMoveIonaOneStep_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowLetSMoveIonaOneStep_instance;
}
function OnboardingHint_LetSNowFinishVarjsSTurn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSNowFinishVarjsSTurn_instance;
}
function OnboardingHint_WhileTheTwoHuntersAreTogetherLet_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhileTheTwoHuntersAreTogetherLet_instance;
}
function OnboardingHint_SoNowBothVarjaAndIonaCan_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoNowBothVarjaAndIonaCan_instance;
}
function OnboardingHint_ThereAre3OpenHunterItemsAnd_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThereAre3OpenHunterItemsAnd_instance;
}
function OnboardingHint_IonaReceivedTheSmokebombCardThisCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_IonaReceivedTheSmokebombCardThisCard_instance;
}
function OnboardingHint_NowItIsTimeToPickAn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsTimeToPickAn_instance;
}
function OnboardingHint_NowLetSKillThatPolypPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowLetSKillThatPolypPlay_instance;
}
function OnboardingHint_TheAttackInTheSilverArrowCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheAttackInTheSilverArrowCard_instance;
}
function OnboardingHint_NearbyLocationsAreLocationsThatAre1_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NearbyLocationsAreLocationsThatAre1_instance;
}
function OnboardingHint_SoLetSPlayTheAttackAnd_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoLetSPlayTheAttackAnd_instance;
}
function OnboardingHint_ThisIsWhyTheSilverArrowIs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThisIsWhyTheSilverArrowIs_instance;
}
function OnboardingHint_NoteThatBolginIsNowInA_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatBolginIsNowInA_instance;
}
function OnboardingHint_LetSPlayTheUnearthCardTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheUnearthCardTo_instance;
}
function OnboardingHint_LetSPickTheBrutalityCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheBrutalityCard_instance;
}
function OnboardingHint_AndLetSJustFinishTheTurn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSJustFinishTheTurn_instance;
}
function OnboardingHint_BolginPlayedQuiteGreedilyLetSPunish_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginPlayedQuiteGreedilyLetSPunish_instance;
}
function OnboardingHint_NowTheHuntersKnowForSureWhere_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowTheHuntersKnowForSureWhere_instance;
}
function OnboardingHint_LetSFinishHelgaSTurnNow_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSFinishHelgaSTurnNow_instance;
}
function OnboardingHint_NowLetSMoveVarjaOntoBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowLetSMoveVarjaOntoBolgin_instance;
}
function OnboardingHint_LetSMoveVarjaOneStepTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveVarjaOneStepTo_instance;
}
function OnboardingHint_AndNowLetSPlayTheTrack_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSPlayTheTrack_instance;
}
function OnboardingHint_LetSMoveOneMoreStepRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveOneMoreStepRight_instance;
}
function OnboardingHint_WhenTheBeastIsHiddenTheStandee_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenTheBeastIsHiddenTheStandee_instance;
}
function OnboardingHint_EvenThoughTheHuntersAlreadyKnowWhere_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_EvenThoughTheHuntersAlreadyKnowWhere_instance;
}
function OnboardingHint_NowItSTimeToRelocateIona_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItSTimeToRelocateIona_instance;
}
function OnboardingHint_LetSChooseIona_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSChooseIona_instance;
}
function OnboardingHint_AsTheDestinationLetSChooseVarja_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AsTheDestinationLetSChooseVarja_instance;
}
function OnboardingHint_AtLastPlayTheHuntCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AtLastPlayTheHuntCard_instance;
}
function OnboardingHint_SoBolginPaidForTheirGreedyPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoBolginPaidForTheirGreedyPlay_instance;
}
function OnboardingHint_NoteThatBolginMustPayOneOneGrudge_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatBolginMustPayOneOneGrudge_instance;
}
function OnboardingHint_LetSChooseTheSheepType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSChooseTheSheepType_instance;
}
function OnboardingHint_PlayersCanIncreaseTheDamageByUsing_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_PlayersCanIncreaseTheDamageByUsing_instance;
}
function OnboardingHint_WhenYouSpendAnAncientPowerReturnIt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WhenYouSpendAnAncientPowerReturnIt_instance;
}
function OnboardingHint_LetSSaveAncientPowerForNowJust_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSSaveAncientPowerForNowJust_instance;
}
function OnboardingHint_NowIonaCanPlayHerSmokebombCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowIonaCanPlayHerSmokebombCard_instance;
}
function OnboardingHint_BolginNeedsToMoveAwayFromThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginNeedsToMoveAwayFromThe_instance;
}
function OnboardingHint_NowItIsConvenientTimeToPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsConvenientTimeToPlay_instance;
}
function OnboardingHint_NoteThatMovingBolginToTheRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatMovingBolginToTheRight_instance;
}
function OnboardingHint_LetSMoveBolginOneMoreStep_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveBolginOneMoreStep_instance;
}
function OnboardingHint_AndNowLetSTrickTheHunters_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSTrickTheHunters_instance;
}
function OnboardingHint_LetSPlayTheDarkDealingsCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheDarkDealingsCard_instance;
}
function OnboardingHint_TheDarkDealingsCardAllowsToReturn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheDarkDealingsCardAllowsToReturn_instance;
}
function OnboardingHint_LetSEndHelgaSTurn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSEndHelgaSTurn_instance;
}
function OnboardingHint_TheHuntersCanTryToCheckBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheHuntersCanTryToCheckBolgin_instance;
}
function OnboardingHint_HuntersDonTKnowWhereBolginMoved_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HuntersDonTKnowWhereBolginMoved_instance;
}
function OnboardingHint_MoveTheFarmerTypeOneStepUp_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveTheFarmerTypeOneStepUp_instance;
}
function OnboardingHint_TheTrailIsFoundSoLetS_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheTrailIsFoundSoLetS_instance;
}
function OnboardingHint_MoveIonaOneStepRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveIonaOneStepRight_instance;
}
function OnboardingHint_NowItIsAGoodTimeTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsAGoodTimeTo_instance;
}
function OnboardingHint_NoteThatDarkRitualsCardAlsoDeals_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatDarkRitualsCardAlsoDeals_instance;
}
function OnboardingHint_TheSaferPlayWouldBeToReturn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheSaferPlayWouldBeToReturn_instance;
}
function OnboardingHint_AndLetSReturnTheCommandCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSReturnTheCommandCard_instance;
}
function OnboardingHint_NowTheHuntersNeedToProtectBoth_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowTheHuntersNeedToProtectBoth_instance;
}
function OnboardingHint_MoveIonaOneStepLeft_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveIonaOneStepLeft_instance;
}
function OnboardingHint_AndOneMoreStepLeft_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndOneMoreStepLeft_instance;
}
function OnboardingHint_OkTheHuntersDiscoverThatBolginDid_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_OkTheHuntersDiscoverThatBolginDid_instance;
}
function OnboardingHint_OkLetSTryToKillThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_OkLetSTryToKillThe_instance;
}
function OnboardingHint_LetSPerformTheAttackFirst_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPerformTheAttackFirst_instance;
}
function OnboardingHint_AttackFarmerType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AttackFarmerType_instance;
}
function OnboardingHint_LetSKillTheFarmerTypeInOne_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSKillTheFarmerTypeInOne_instance;
}
function OnboardingHint_AndNowItIsAGoodTime_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowItIsAGoodTime_instance;
}
function OnboardingHint_SoTheHuntersSavedTheSettlerThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoTheHuntersSavedTheSettlerThe_instance;
}
function OnboardingHint_OkBolginFailedToKillTheFarmerType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_OkBolginFailedToKillTheFarmerType_instance;
}
function OnboardingHint_LetSPlayTheEvolveCardTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheEvolveCardTo_instance;
}
function OnboardingHint_LetSMoveFirst_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveFirst_instance;
}
function OnboardingHint_LetSMoveOneStepToThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveOneStepToThe_instance;
}
function OnboardingHint_AndNowLetSUpgradeBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSUpgradeBolgin_instance;
}
function OnboardingHint_SoLetSIncreaseBolginSMobility_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoLetSIncreaseBolginSMobility_instance;
}
function OnboardingHint_FinallyLetSRelocateHelgaCloserTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_FinallyLetSRelocateHelgaCloserTo_instance;
}
function OnboardingHint_LetSRelocateHelgaFirstAndCheck_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSRelocateHelgaFirstAndCheck_instance;
}
function OnboardingHint_ChooseNewArksteadAsTheDestination_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ChooseNewArksteadAsTheDestination_instance;
}
function OnboardingHint_LetSPickAnUnknownCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickAnUnknownCard_instance;
}
function OnboardingHint_HelgaReceivedTheFlareCardThisIs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HelgaReceivedTheFlareCardThisIs_instance;
}
function OnboardingHint_TheHuntersKnowWhereBolginIsRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheHuntersKnowWhereBolginIsRight_instance;
}
function OnboardingHint_LetSStartByMovingIona_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartByMovingIona_instance;
}
function OnboardingHint_MoveIonaOneStepSouth_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveIonaOneStepSouth_instance;
}
function OnboardingHint_ThenLetSMoveTheWoundedFarmerType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThenLetSMoveTheWoundedFarmerType_instance;
}
function OnboardingHint_MoveTheFarmerTypeToTheRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveTheFarmerTypeToTheRight_instance;
}
function OnboardingHint_LetSTalkNowAboutTrapSignTraps_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSTalkNowAboutTrapSignTraps_instance;
}
function OnboardingHint_SoLetSPlayTheFireTrap_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoLetSPlayTheFireTrap_instance;
}
function OnboardingHint_LetSPlaceItInTheNew_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlaceItInTheNew_instance;
}
function OnboardingHint_TheHuntersHaveNowPreparedIonaTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheHuntersHaveNowPreparedIonaTo_instance;
}
function OnboardingHint_LetSPlayTheAvariceCardTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheAvariceCardTo_instance;
}
function OnboardingHint_TheAvariceCardGivesAnActionTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheAvariceCardGivesAnActionTo_instance;
}
function OnboardingHint_MoveIonaToTheRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MoveIonaToTheRight_instance;
}
function OnboardingHint_TheAvariceCardAllowsAttacksOnlyAgainst_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheAvariceCardAllowsAttacksOnlyAgainst_instance;
}
function OnboardingHint_AndNowLetSPlayTheHunt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSPlayTheHunt_instance;
}
function OnboardingHint_SoBeforeTheAttackIonaSearchedAnd_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoBeforeTheAttackIonaSearchedAnd_instance;
}
function OnboardingHint_LetSPlayTheHasteCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheHasteCard_instance;
}
function OnboardingHint_LetSMoveBolginFirst_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveBolginFirst_instance;
}
function OnboardingHint_LetSMoveBolginOneMoreStep2_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveBolginOneMoreStep2_instance;
}
function OnboardingHint_AndNowLetSMoveBolginInto_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSMoveBolginInto_instance;
}
function OnboardingHint_BolginDecidesToFinishTheWoundedFarmerType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginDecidesToFinishTheWoundedFarmerType_instance;
}
function OnboardingHint_InMostCasesYouWantToMove_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_InMostCasesYouWantToMove_instance;
}
function OnboardingHint_LetSMoveTheFarmerTypeOneStep_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveTheFarmerTypeOneStep_instance;
}
function OnboardingHint_MovementAndReactionsHaveFinishedSoBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_MovementAndReactionsHaveFinishedSoBolgin_instance;
}
function OnboardingHint_AsTheSecondCardLetSPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AsTheSecondCardLetSPlay_instance;
}
function OnboardingHint_TheAnimateCardHasTheThenKeyword_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheAnimateCardHasTheThenKeyword_instance;
}
function OnboardingHint_SoFirstYouMustPerformSummonActivationBecause_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoFirstYouMustPerformSummonActivationBecause_instance;
}
function OnboardingHint_LetSPlaceItNearFarmerTypeFrom_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlaceItNearFarmerTypeFrom_instance;
}
function OnboardingHint_ThirteenActionCardsWereDealtDuringThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThirteenActionCardsWereDealtDuringThe_instance;
}
function OnboardingHint_HelgaAndIonaInTheSameLocation_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HelgaAndIonaInTheSameLocation_instance;
}
function OnboardingHint_LetSStartWithHelga_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartWithHelga_instance;
}
function OnboardingHint_LetSPickTheUnknownHunterItem_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheUnknownHunterItem_instance;
}
function OnboardingHint_TheOutpostCardIsQuiteSituationalIt_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheOutpostCardIsQuiteSituationalIt_instance;
}
function OnboardingHint_LetSAlsoPickTheUnknownHunter_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSAlsoPickTheUnknownHunter_instance;
}
function OnboardingHint_TheBladeOfValhCardIsThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheBladeOfValhCardIsThe_instance;
}
function OnboardingHint_LetSFinishHelgaSTurnFor_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSFinishHelgaSTurnFor_instance;
}
function OnboardingHint_LetSPassForVarja_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPassForVarja_instance;
}
function OnboardingHint_AndLetSPassForIonaAs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSPassForIonaAs_instance;
}
function OnboardingHint_TheHuntersHaveMostlyRunOutOf_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheHuntersHaveMostlyRunOutOf_instance;
}
function OnboardingHint_LetSFirstPickABeastlyTalent_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSFirstPickABeastlyTalent_instance;
}
function OnboardingHint_LetSPickTheUnbendingWill_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheUnbendingWill_instance;
}
function OnboardingHint_AndLetSMoveBolginOneStep_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSMoveBolginOneStep_instance;
}
function OnboardingHint_LetSPassForHelga_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPassForHelga_instance;
}
function OnboardingHint_AndLetSPassForVarjaAs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSPassForVarjaAs_instance;
}
function OnboardingHint_LetSActuallyPlayTheBladeOf_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSActuallyPlayTheBladeOf_instance;
}
function OnboardingHint_SometimesYouMayWantToPlayThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SometimesYouMayWantToPlayThe_instance;
}
function OnboardingHint_LetSPickTheMostPracticalUpgrade_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPickTheMostPracticalUpgrade_instance;
}
function OnboardingHint_LetSPlayTheUnbendingWillCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheUnbendingWillCard_instance;
}
function OnboardingHint_AndLetSReturnTheSummonPolyp_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSReturnTheSummonPolyp_instance;
}
function OnboardingHint_AndLetSFinishTheTurn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSFinishTheTurn_instance;
}
function OnboardingHint_LetSPlayTheTrackCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheTrackCard_instance;
}
function OnboardingHint_LetSSupposeTheHuntersGuessBolgin_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSSupposeTheHuntersGuessBolgin_instance;
}
function OnboardingHint_ThereIsATrailSoTrackNow_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThereIsATrailSoTrackNow_instance;
}
function OnboardingHint_HelgaFinishesTrackInTheSameZone_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_HelgaFinishesTrackInTheSameZone_instance;
}
function OnboardingHint_LetSFinishHelgaSTurn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSFinishHelgaSTurn_instance;
}
function OnboardingHint_VarjaCannotDoMuchEitherLetS_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_VarjaCannotDoMuchEitherLetS_instance;
}
function OnboardingHint_IonaHasNoCardsSoSheWill_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_IonaHasNoCardsSoSheWill_instance;
}
function OnboardingHint_LetSPlayTheSummonPolypCard2_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheSummonPolypCard2_instance;
}
function OnboardingHint_LetSStartWithMovement_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartWithMovement_instance;
}
function OnboardingHint_LetSMoveBolginWest_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveBolginWest_instance;
}
function OnboardingHint_AndNowLetSPlaySummonActivation_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSPlaySummonActivation_instance;
}
function OnboardingHint_LetSActivateAllSummonsOnThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSActivateAllSummonsOnThe_instance;
}
function OnboardingHint_AndLetSUsePolypSUnique_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSUsePolypSUnique_instance;
}
function OnboardingHint_SoBurstThePolypInGhastvikFjord_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_SoBurstThePolypInGhastvikFjord_instance;
}
function OnboardingHint_ThePolypBurstsDestroyingItselfWoundingThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThePolypBurstsDestroyingItselfWoundingThe_instance;
}
function OnboardingHint_AndNowLetSPlayTheRage_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSPlayTheRage_instance;
}
function OnboardingHint_NowItIsUnlikelyThatHelgaCan_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsUnlikelyThatHelgaCan_instance;
}
function OnboardingHint_LetSMoveHelgaNorth_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveHelgaNorth_instance;
}
function OnboardingHint_LetSPassForVarja2_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPassForVarja2_instance;
}
function OnboardingHint_AndNowBolginHasOneGrudgeToPlay_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowBolginHasOneGrudgeToPlay_instance;
}
function OnboardingHint_LetSStartWithMovement2_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartWithMovement2_instance;
}
function OnboardingHint_LetSMoveBolginEast_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveBolginEast_instance;
}
function OnboardingHint_AndNowLetSPlaySummonActivation2_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndNowLetSPlaySummonActivation2_instance;
}
function OnboardingHint_LetSPlaceTheNewPolypIn_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlaceTheNewPolypIn_instance;
}
function OnboardingHint_LetSPlayTheOutpostCard_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSPlayTheOutpostCard_instance;
}
function OnboardingHint_WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile_instance;
}
function OnboardingHint_ThatPolypCanBurstHittingBothVarja_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_ThatPolypCanBurstHittingBothVarja_instance;
}
function OnboardingHint_LetSMoveVarjaWestCloseTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveVarjaWestCloseTo_instance;
}
function OnboardingHint_TheDayIsOverSinceAllCharacters_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheDayIsOverSinceAllCharacters_instance;
}
function OnboardingHint_BolginReceivesAncientPowerAndMayNowPerform_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginReceivesAncientPowerAndMayNowPerform_instance;
}
function OnboardingHint_LetSUseTheBurstAgain_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSUseTheBurstAgain_instance;
}
function OnboardingHint_LetSBurstTheWoundedFarmerTypeBelow_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSBurstTheWoundedFarmerTypeBelow_instance;
}
function OnboardingHint_NoteThatTheFarmerTypeWasKilledBy_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatTheFarmerTypeWasKilledBy_instance;
}
function OnboardingHint_TheCascadeUpgradeAllowsBolginToMove_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheCascadeUpgradeAllowsBolginToMove_instance;
}
function OnboardingHint_NowItIsTimeForTheHunters_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowItIsTimeForTheHunters_instance;
}
function OnboardingHint_NoteThatTheHuntersKnowBolginS_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NoteThatTheHuntersKnowBolginS_instance;
}
function OnboardingHint_AllHuntersGainOneGrudgeAsAReward_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AllHuntersGainOneGrudgeAsAReward_instance;
}
function OnboardingHint_LetSMoveHelgaOneStepRight_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveHelgaOneStepRight_instance;
}
function OnboardingHint_NextLetSMoveVarja_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NextLetSMoveVarja_instance;
}
function OnboardingHint_LetSMoveVarjaNorth_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSMoveVarjaNorth_instance;
}
function OnboardingHint_AndLetSMoveIonaEastClose_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSMoveIonaEastClose_instance;
}
function OnboardingHint_AfterTheRewardsHunterItemsAndBeastly_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AfterTheRewardsHunterItemsAndBeastly_instance;
}
function OnboardingHint_NextAllActionCardsFromHandsUnused_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NextAllActionCardsFromHandsUnused_instance;
}
function OnboardingHint_FinallyRemoveAllOneDamageFromSettlersFarmerType_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_FinallyRemoveAllOneDamageFromSettlersFarmerType_instance;
}
function OnboardingHint_InMostContractsTheDeathOfThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_InMostContractsTheDeathOfThe_instance;
}
function OnboardingHint_TheRewardSubphaseIsResolvedBeforeThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheRewardSubphaseIsResolvedBeforeThe_instance;
}
function OnboardingHint_IfAHunterDiesByABeast_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_IfAHunterDiesByABeast_instance;
}
function OnboardingHint_AfterTheRefreshPlayersMayUpgradeAs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AfterTheRefreshPlayersMayUpgradeAs_instance;
}
function OnboardingHint_TheHuntersNowKnowThatBolginIs_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheHuntersNowKnowThatBolginIs_instance;
}
function OnboardingHint_LetSStartWithVarjaAndUpgrade_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSStartWithVarjaAndUpgrade_instance;
}
function OnboardingHint_LetSChooseTheFarmerTypeInVintervik_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_LetSChooseTheFarmerTypeInVintervik_instance;
}
function OnboardingHint_NowTheHuntersWillHaveSomeTime_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_NowTheHuntersWillHaveSomeTime_instance;
}
function OnboardingHint_BolginNowNeedsOnlyOneDamageOneDamageTo_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_BolginNowNeedsOnlyOneDamageOneDamageTo_instance;
}
function OnboardingHint_AndLetSSaveOneGrudgeForHelga_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_AndLetSSaveOneGrudgeForHelga_instance;
}
function OnboardingHint_TheNextDayNowBeginsWithThe_getInstance() {
  OnboardingHint_initEntries();
  return OnboardingHint_TheNextDayNowBeginsWithThe_instance;
}
function OnboardingSequence_Introduction_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_Introduction_instance;
}
function OnboardingSequence_BolginBoard_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_BolginBoard_instance;
}
function OnboardingSequence_HelgaBoard_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_HelgaBoard_instance;
}
function OnboardingSequence_VarjaCards_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_VarjaCards_instance;
}
function OnboardingSequence_IonaCards_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_IonaCards_instance;
}
function OnboardingSequence_ContractStartingConditions_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_ContractStartingConditions_instance;
}
function OnboardingSequence_MovementCards_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_MovementCards_instance;
}
function OnboardingSequence_SmokeBomb_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_SmokeBomb_instance;
}
function OnboardingSequence_Flare_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_Flare_instance;
}
function OnboardingSequence_Outpost_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_Outpost_instance;
}
function OnboardingSequence_BladeOfValh_getInstance() {
  OnboardingSequence_initEntries();
  return OnboardingSequence_BladeOfValh_instance;
}
function refreshesArsenal($this, $receiver) {
  var tmp;
  if ($receiver instanceof RestoreArsenalEvent) {
    tmp = true;
  } else {
    var tmp_0;
    var tmp_1;
    if ($receiver instanceof GeneralCardMoveEvent) {
      tmp_1 = equals($receiver.p53_1, RevealedArsenalPlace_getInstance());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0 = $receiver.o53_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_2;
        if (isInterface(tmp0, Collection)) {
          tmp_2 = tmp0.n1();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp_3;
          if (isInterface(element, HunterItemCard)) {
            tmp_3 = true;
          } else {
            tmp_3 = isInterface(element, BeastlyTalentCard);
          }
          if (tmp_3) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp_0 = tmp$ret$0;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function gainedCards($this, $receiver, event) {
  var tmp;
  if (event instanceof GeneralCardMoveEvent) {
    var tmp_0;
    var tmp_1 = event.p53_1;
    if (tmp_1 instanceof HandPlace) {
      tmp_0 = toSet(event.o53_1);
    } else {
      tmp_0 = emptySet();
    }
    tmp = tmp_0;
  } else {
    if (event instanceof GainOpenArsenalCardEvent) {
      tmp = setOf(event.i51_1);
    } else {
      if (event instanceof GainUnknownArsenalCardEvent) {
        var tmp_2 = $receiver.w6h();
        tmp = withStateRuntime($receiver, tmp_2, OnboardingScript$gainedCards$lambda(event));
      } else {
        tmp = emptySet();
      }
    }
  }
  return tmp;
}
function *beforeNotificationAppliedInt($this, $context_GameState_t6qee5, $receiver, event, $completion) {
  var tmp;
  var tmp_0;
  if (event instanceof GainGrudgesEvent) {
    var tmp_1 = get_phase($context_GameState_t6qee5);
    tmp_0 = isInterface(tmp_1, ContractInitPhase);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp0 = event.t51_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(tmp0, Collection)) {
        tmp_2 = tmp0.n1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_3 = get_objectType($context_GameState_t6qee5, element);
        if (tmp_3 instanceof Bolgin) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* $this.be0($receiver, OnboardingSequence_ContractStartingConditions_getInstance(), $completion);
  }
  var tmp_4;
  var tmp_5;
  if (event instanceof MovementEvent) {
    var tmp_6 = get_phase($context_GameState_t6qee5);
    tmp_5 = tmp_6 instanceof InitialPhase;
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    var tmp_7 = $receiver.t6h();
    tmp_4 = withStateRuntime($receiver, tmp_7, OnboardingScript$beforeNotificationAppliedInt$lambda(event));
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    yield* $this.be0($receiver, OnboardingSequence_MovementCards_getInstance(), $completion);
  }
  var tmp_8;
  var tmp_9;
  var tmp_10;
  var tmp_11;
  if (event instanceof SpendGrudgesEvent) {
    tmp_11 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_11 = false;
  }
  if (tmp_11) {
    tmp_10 = get_currentTurnNumber($context_GameState_t6qee5) === 3;
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    tmp_9 = get_playedCardsNumber($context_GameState_t6qee5) === 0;
  } else {
    tmp_9 = false;
  }
  if (tmp_9) {
    tmp_8 = equals(get_phase($context_GameState_t6qee5), new PlayerTurnPhase(get_bolginBeast($context_GameState_t6qee5)));
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatBolginMustPayOneOneGrudge_getInstance(), $completion);
  }
  var tmp_12;
  var tmp_13;
  if (event instanceof GainGrudgesEvent) {
    tmp_13 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_13 = false;
  }
  if (tmp_13) {
    tmp_12 = equals(get_phase($context_GameState_t6qee5), NightPhase_getInstance());
  } else {
    tmp_12 = false;
  }
  if (tmp_12) {
    yield* $this.ce0($receiver, OnboardingHint_NowItIsTimeForTheHunters_getInstance(), $completion);
  }
  var tmp_14;
  var tmp_15;
  var tmp_16;
  if (refreshesArsenal($this, event)) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_16 = !get_charactersInOrder($context_GameState_t6qee5).n1();
  } else {
    tmp_16 = false;
  }
  if (tmp_16) {
    tmp_15 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_15 = false;
  }
  if (tmp_15) {
    tmp_14 = equals(get_phase($context_GameState_t6qee5), NightPhase_getInstance());
  } else {
    tmp_14 = false;
  }
  if (tmp_14) {
    yield* $this.ce0($receiver, OnboardingHint_AfterTheRewardsHunterItemsAndBeastly_getInstance(), $completion);
  }
  var tmp_17;
  var tmp_18;
  var tmp_19;
  if (event instanceof RestoreStuffEvent) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_19 = !get_charactersInOrder($context_GameState_t6qee5).n1();
  } else {
    tmp_19 = false;
  }
  if (tmp_19) {
    tmp_18 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_18 = false;
  }
  if (tmp_18) {
    tmp_17 = equals(get_phase($context_GameState_t6qee5), NightPhase_getInstance());
  } else {
    tmp_17 = false;
  }
  if (tmp_17) {
    yield* $this.ce0($receiver, OnboardingHint_NextAllActionCardsFromHandsUnused_getInstance(), $completion);
  }
  yield* $this.de0($receiver, VOID, $completion);
  return Unit_instance;
}
function *afterNotificationAppliedInt($this, $context_GameState_t6qee5, $receiver, event, $completion) {
  var tmp;
  if (event instanceof InitGameStateEvent) {
    tmp = equals(event.a54_1.d38_1, NonePhase_getInstance());
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* $this.be0($receiver, OnboardingSequence_Introduction_getInstance(), $completion);
  }
  if (refreshesArsenal($this, event) && get_charactersInOrder($context_GameState_t6qee5).n1()) {
    yield* $this.ce0($receiver, OnboardingHint_AtTheBeginningOfTheGameReveal_getInstance(), $completion);
  }
  var tmp_0;
  var tmp_1 = get_phase($context_GameState_t6qee5);
  if (tmp_1 instanceof InitialPhase) {
    var tmp_2 = $receiver.t6h();
    tmp_0 = withStateRuntime($receiver, tmp_2, OnboardingScript$afterNotificationAppliedInt$lambda(event));
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    yield* $this.ce0($receiver, OnboardingHint_ToSimplifyTheTrackingOfBeastThis_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_TrailsTrailIsAnImportantConceptIn_getInstance(), $completion);
  }
  var tmp_3;
  var tmp_4;
  var tmp_5;
  if (event instanceof ApplyDamageEvent) {
    tmp_5 = $receiver.t6h().e38_1 === 1;
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = $receiver.t6h().f38_1 === 1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    // Inline function 'kotlin.with' call
    var $this$with = $receiver.t6h();
    tmp_3 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    yield* $this.ce0($receiver, OnboardingHint_SheepTypeHasJust1HPSoBolgin_getInstance(), $completion);
    yield* $this.de0($receiver, VOID, $completion);
  }
  var tmp_6;
  if (event instanceof NewSimpleObjectEvent) {
    // Inline function 'kotlin.with' call
    var $this$with_0 = $receiver.t6h();
    tmp_6 = ($this$with_0.e38_1 === 1 && $this$with_0.f38_1 === 1);
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    yield* $this.ce0($receiver, OnboardingHint_WhenASummonIsActivatedItPerforms_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LikeHuntersAndBeastsSummonsHave1_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_WhileSummonsAreQuiteDeadlyTheyHave_getInstance(), $completion);
  }
  if (event instanceof StartPhaseEvent) {
    var phase = event.i5a_1;
    // Inline function 'kotlin.with' call
    var $this$with_1 = $receiver.t6h();
    var tmp_7;
    var tmp_8;
    if ($this$with_1.e38_1 === 1 && $this$with_1.f38_1 === 1) {
      tmp_8 = phase instanceof PlayerTurnPhase;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      var tmp_9 = get_objectType($this$with_1, phase.x4g_1);
      tmp_7 = tmp_9 instanceof Bolgin;
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      yield* $this.ce0($receiver, OnboardingHint_DuringTheDayPhaseAllPlayersTake_getInstance(), $completion);
      yield* $this.ce0($receiver, OnboardingHint_PassingIsNotFinalAPlayerMay_getInstance(), $completion);
    }
  }
  var tmp_10;
  if (event instanceof StartResolveCardEvent) {
    var tmp_11 = event.p5a_1;
    tmp_10 = tmp_11 instanceof EngorgeCard;
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    yield* $this.ce0($receiver, OnboardingHint_WhenYouPlayACardYouShould_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_TechnicallyYouCanSkipAllStatementsOn_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SoInThisCaseBolginPerformsAn_getInstance(), $completion);
  }
  var gainedCards_0 = gainedCards($this, $receiver, event);
  var tmp_12;
  if (get_currentDayNumber($context_GameState_t6qee5) === 1 && get_currentTurnNumber($context_GameState_t6qee5) === 1) {
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_13;
      if (isInterface(gainedCards_0, Collection)) {
        tmp_13 = gainedCards_0.n1();
      } else {
        tmp_13 = false;
      }
      if (tmp_13) {
        tmp$ret$6 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = gainedCards_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof SmokeBombCard) {
          tmp$ret$6 = true;
          break $l$block_0;
        }
      }
      tmp$ret$6 = false;
    }
    tmp_12 = tmp$ret$6;
  } else {
    tmp_12 = false;
  }
  if (tmp_12) {
    yield* $this.be0($receiver, OnboardingSequence_SmokeBomb_getInstance(), $completion);
  }
  var tmp_14;
  if (event instanceof RevealLastMovementsEvent) {
    tmp_14 = $receiver.t6h().e38_1 === 1;
  } else {
    tmp_14 = false;
  }
  if (tmp_14) {
    yield* $this.ce0($receiver, OnboardingHint_NowTheHuntersKnowForSureWhere_getInstance(), $completion);
    yield* $this.de0($receiver, VOID, $completion);
  }
  var tmp_15;
  var tmp_16;
  if (event instanceof TrailsRevealedEvent) {
    tmp_16 = $receiver.t6h().e38_1 === 1;
  } else {
    tmp_16 = false;
  }
  if (tmp_16) {
    tmp_15 = $receiver.t6h().f38_1 === 2;
  } else {
    tmp_15 = false;
  }
  if (tmp_15) {
    yield* $this.ce0($receiver, OnboardingHint_EvenThoughTheHuntersAlreadyKnowWhere_getInstance(), $completion);
    yield* $this.de0($receiver, VOID, $completion);
  }
  var tmp_17;
  if (get_currentDayNumber($context_GameState_t6qee5) === 1 && get_currentTurnNumber($context_GameState_t6qee5) === 4) {
    var tmp$ret$8;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_18;
      if (isInterface(gainedCards_0, Collection)) {
        tmp_18 = gainedCards_0.n1();
      } else {
        tmp_18 = false;
      }
      if (tmp_18) {
        tmp$ret$8 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_0 = gainedCards_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        if (element_0 instanceof FlareCard) {
          tmp$ret$8 = true;
          break $l$block_2;
        }
      }
      tmp$ret$8 = false;
    }
    tmp_17 = tmp$ret$8;
  } else {
    tmp_17 = false;
  }
  if (tmp_17) {
    yield* $this.be0($receiver, OnboardingSequence_Flare_getInstance(), $completion);
  }
  var tmp_19;
  if (get_currentDayNumber($context_GameState_t6qee5) === 1 && get_currentTurnNumber($context_GameState_t6qee5) === 5) {
    var tmp$ret$10;
    $l$block_4: {
      // Inline function 'kotlin.collections.any' call
      var tmp_20;
      if (isInterface(gainedCards_0, Collection)) {
        tmp_20 = gainedCards_0.n1();
      } else {
        tmp_20 = false;
      }
      if (tmp_20) {
        tmp$ret$10 = false;
        break $l$block_4;
      }
      var _iterator__ex2g4s_1 = gainedCards_0.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        var tmp_21;
        if (element_1 instanceof OutpostCard) {
          tmp_21 = true;
        } else {
          tmp_21 = equals(element_1, BladeOfValhCard_getInstance());
        }
        if (tmp_21) {
          tmp$ret$10 = true;
          break $l$block_4;
        }
      }
      tmp$ret$10 = false;
    }
    tmp_19 = tmp$ret$10;
  } else {
    tmp_19 = false;
  }
  if (tmp_19) {
    var tmp$ret$12;
    $l$block_6: {
      // Inline function 'kotlin.collections.any' call
      var tmp_22;
      if (isInterface(gainedCards_0, Collection)) {
        tmp_22 = gainedCards_0.n1();
      } else {
        tmp_22 = false;
      }
      if (tmp_22) {
        tmp$ret$12 = false;
        break $l$block_6;
      }
      var _iterator__ex2g4s_2 = gainedCards_0.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_2 = _iterator__ex2g4s_2.r1();
        if (element_2 instanceof OutpostCard) {
          tmp$ret$12 = true;
          break $l$block_6;
        }
      }
      tmp$ret$12 = false;
    }
    var isOutpost = tmp$ret$12;
    yield* $this.be0($receiver, isOutpost ? OnboardingSequence_Outpost_getInstance() : OnboardingSequence_BladeOfValh_getInstance(), $completion);
  }
  var tmp_23;
  var tmp_24;
  var tmp_25;
  if (event instanceof DamageResolvedEvent) {
    tmp_25 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_25 = false;
  }
  if (tmp_25) {
    tmp_24 = get_currentTurnNumber($context_GameState_t6qee5) === 4;
  } else {
    tmp_24 = false;
  }
  if (tmp_24) {
    tmp_23 = equals(get_phase($context_GameState_t6qee5), new PlayerTurnPhase(get_bolginBeast($context_GameState_t6qee5)));
  } else {
    tmp_23 = false;
  }
  if (tmp_23) {
    yield* $this.ce0($receiver, OnboardingHint_SoTheHuntersSavedTheSettlerThe_getInstance(), $completion);
  }
  var tmp_26;
  var tmp_27;
  var tmp_28;
  if (event instanceof TrailsRevealedEvent) {
    tmp_28 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_28 = false;
  }
  if (tmp_28) {
    tmp_27 = get_currentTurnNumber($context_GameState_t6qee5) === 9;
  } else {
    tmp_27 = false;
  }
  if (tmp_27) {
    tmp_26 = equals(get_phase($context_GameState_t6qee5), new PlayerTurnPhase(get_helgaHunter($context_GameState_t6qee5)));
  } else {
    tmp_26 = false;
  }
  if (tmp_26) {
    yield* $this.ce0($receiver, OnboardingHint_WatchtowerTypeRevealsNearbyTrailOnlyOnlyWhile_getInstance(), $completion);
  }
  var tmp_29;
  if (event instanceof CheckForDestroyEvent) {
    var tmp_30 = get_phase($context_GameState_t6qee5);
    tmp_29 = tmp_30 instanceof NightPhase;
  } else {
    tmp_29 = false;
  }
  if (tmp_29) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatTheFarmerTypeWasKilledBy_getInstance(), $completion);
  }
  var tmp_31;
  var tmp_32;
  if (event instanceof StartPhaseEvent) {
    tmp_32 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_32 = false;
  }
  if (tmp_32) {
    var tmp_33 = event.i5a_1;
    tmp_31 = tmp_33 instanceof NightPhase;
  } else {
    tmp_31 = false;
  }
  if (tmp_31) {
    yield* $this.ce0($receiver, OnboardingHint_TheDayIsOverSinceAllCharacters_getInstance(), $completion);
  }
  var tmp_34;
  var tmp_35;
  if (event instanceof RestoreStuffEvent) {
    var tmp_36 = get_phase($context_GameState_t6qee5);
    tmp_35 = tmp_36 instanceof NightPhase;
  } else {
    tmp_35 = false;
  }
  if (tmp_35) {
    tmp_34 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_34 = false;
  }
  if (tmp_34) {
    yield* $this.ce0($receiver, OnboardingHint_FinallyRemoveAllOneDamageFromSettlersFarmerType_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_InMostContractsTheDeathOfThe_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_TheRewardSubphaseIsResolvedBeforeThe_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_IfAHunterDiesByABeast_getInstance(), $completion);
  }
  var tmp_37;
  var tmp_38;
  if (event instanceof TransformSimpleObjectChangeEvent) {
    tmp_38 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_38 = false;
  }
  if (tmp_38) {
    var tmp_39 = get_phase($context_GameState_t6qee5);
    tmp_37 = tmp_39 instanceof NightPhase;
  } else {
    tmp_37 = false;
  }
  if (tmp_37) {
    yield* $this.ce0($receiver, OnboardingHint_NowTheHuntersWillHaveSomeTime_getInstance(), $completion);
  }
  var tmp_40;
  var tmp_41;
  if (event instanceof StartPhaseEvent) {
    tmp_41 = get_currentDayNumber($context_GameState_t6qee5) === 2;
  } else {
    tmp_41 = false;
  }
  if (tmp_41) {
    var tmp_42 = event.i5a_1;
    tmp_40 = tmp_42 instanceof DawnPhase;
  } else {
    tmp_40 = false;
  }
  if (tmp_40) {
    yield* $this.ce0($receiver, OnboardingHint_TheNextDayNowBeginsWithThe_getInstance(), $completion);
  }
  yield* $this.de0($receiver, VOID, $completion);
  return Unit_instance;
}
function *beforeAnswerInt($this, $context_GameState_t6qee5, $receiver, gameQuestion, $completion) {
  var tmp;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp = gameQuestion.r48_1.w2(Helga_getInstance());
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* $this.be0($receiver, OnboardingSequence_BolginBoard_getInstance(), $completion);
  }
  var tmp_0;
  var tmp_1;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp_1 = gameQuestion.r48_1.w2(Varja_getInstance());
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = !gameQuestion.r48_1.w2(Helga_getInstance());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    yield* $this.be0($receiver, OnboardingSequence_HelgaBoard_getInstance(), $completion);
  }
  var tmp_2;
  var tmp_3;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp_3 = gameQuestion.r48_1.w2(Iona_getInstance());
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = !gameQuestion.r48_1.w2(Varja_getInstance());
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    yield* $this.be0($receiver, OnboardingSequence_VarjaCards_getInstance(), $completion);
  }
  var tmp_4;
  var tmp_5;
  var tmp_6;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp_7 = get_phase($context_GameState_t6qee5);
    tmp_6 = tmp_7 instanceof InitialPhase;
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    var tmp0_safe_receiver = gameQuestion.y48_1;
    var tmp_8 = tmp0_safe_receiver == null ? null : get_objectType($context_GameState_t6qee5, tmp0_safe_receiver);
    tmp_5 = !(tmp_8 == null) ? isInterface(tmp_8, BeastCharacter) : false;
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = gameQuestion.z48_1.s2() === 1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    $this.ee0(-317, -95, 0.2608);
    yield* $this.ce0($receiver, OnboardingHint_TheBeastStartsTheGameInThe_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_YouMayAlsoNoticeWhiteLinesSplitting_getInstance(), $completion);
  }
  var tmp_9;
  var tmp_10;
  var tmp_11;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_11 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_11 = false;
  }
  if (tmp_11) {
    tmp_10 = get_currentTurnNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    tmp_9 = gameQuestion.y4a_1.w2(new PlayCardVariant(EnsnareCard_getInstance()));
  } else {
    tmp_9 = false;
  }
  if (tmp_9) {
    yield* $this.ce0($receiver, OnboardingHint_BolginHasPlayedTwoCardsAndIt_getInstance(), $completion);
  }
  var tmp_12;
  var tmp_13;
  var tmp_14;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_14 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_14 = false;
  }
  if (tmp_14) {
    tmp_13 = gameQuestion.m4a_1.s2() === 3;
  } else {
    tmp_13 = false;
  }
  if (tmp_13) {
    var tmp_15 = get_phase($context_GameState_t6qee5);
    tmp_12 = tmp_15 instanceof NightPhase;
  } else {
    tmp_12 = false;
  }
  if (tmp_12) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatTheHuntersKnowBolginS_getInstance(), $completion);
  }
  var tmp_16;
  var tmp_17;
  var tmp_18;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_18 = get_currentDayNumber($context_GameState_t6qee5) === 1;
  } else {
    tmp_18 = false;
  }
  if (tmp_18) {
    tmp_17 = gameQuestion.s4b_1.w2(HeroicSpeechUpgrade_getInstance());
  } else {
    tmp_17 = false;
  }
  if (tmp_17) {
    var tmp_19 = get_phase($context_GameState_t6qee5);
    tmp_16 = tmp_19 instanceof NightPhase;
  } else {
    tmp_16 = false;
  }
  if (tmp_16) {
    yield* $this.ce0($receiver, OnboardingHint_AfterTheRefreshPlayersMayUpgradeAs_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_TheHuntersNowKnowThatBolginIs_getInstance(), $completion);
  }
  yield* $this.de0($receiver, VOID, $completion);
  return Unit_instance;
}
function *whenChoiceUiWasInstalledImpl($this, $receiver, gameQuestion, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $receiver.t6h();
  var tmp0_safe_receiver = gameQuestion instanceof ChooseCardOnDraftQuestion ? gameQuestion : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp$ret$3;
    $l$block: {
      var tmp0_elvis_lhs = $this$with.p38_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$3 = null;
        break $l$block;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var draft = tmp_0;
      var tmp0 = sorted(draft.r4m_1);
      var tmp$ret$4;
      $l$block_2: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var availableCards = draft.s4m_1 ? draft.p4m_1.u2(element) : draft.o4m_1.u2(element);
          var tmp$ret$6;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_1;
            if (isInterface(availableCards, Collection)) {
              tmp_1 = availableCards.n1();
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp$ret$6 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_0 = availableCards.p1();
            while (_iterator__ex2g4s_0.q1()) {
              var element_0 = _iterator__ex2g4s_0.r1();
              if (tmp0_safe_receiver.g48_1.w2(element_0)) {
                tmp$ret$6 = true;
                break $l$block_1;
              }
            }
            tmp$ret$6 = false;
          }
          if (tmp$ret$6) {
            tmp$ret$4 = element;
            break $l$block_2;
          }
        }
        tmp$ret$4 = null;
      }
      var tmp1_safe_receiver = tmp$ret$4;
      var tmp_2;
      if (tmp1_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = $this$with.i38_1.u2(tmp1_safe_receiver);
      }
      tmp$ret$3 = tmp_2;
    }
    tmp = tmp$ret$3;
  }
  var draftQuestionCharacter = tmp;
  var tmp_3;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    var tmp0_0 = gameQuestion.r48_1;
    var tmp$ret$10;
    $l$block_4: {
      // Inline function 'kotlin.collections.all' call
      var tmp_4;
      if (isInterface(tmp0_0, Collection)) {
        tmp_4 = tmp0_0.n1();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$10 = true;
        break $l$block_4;
      }
      var _iterator__ex2g4s_1 = tmp0_0.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (!isInterface(element_1, BeastCharacter)) {
          tmp$ret$10 = false;
          break $l$block_4;
        }
      }
      tmp$ret$10 = true;
    }
    tmp_3 = tmp$ret$10;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    yield* $this.ce0($receiver, OnboardingHint_ThenPlayersChooseTheirCharactersTheBeast_getInstance(), $completion);
  }
  var tmp_5;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp_5 = gameQuestion.r48_1.w2(Helga_getInstance());
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    yield* $this.ce0($receiver, OnboardingHint_TheBeastHasBeenChosenSoThe_getInstance(), $completion);
  }
  var tmp_6;
  var tmp_7;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp_7 = gameQuestion.r48_1.w2(Varja_getInstance());
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    tmp_6 = !gameQuestion.r48_1.w2(Helga_getInstance());
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickVarjaAsTheSecond_getInstance(), $completion);
  }
  var tmp_8;
  var tmp_9;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp_9 = gameQuestion.r48_1.w2(Iona_getInstance());
  } else {
    tmp_9 = false;
  }
  if (tmp_9) {
    tmp_8 = !gameQuestion.r48_1.w2(Varja_getInstance());
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    yield* $this.ce0($receiver, OnboardingHint_ForTheLastPositionLetSPick_getInstance(), $completion);
  }
  var tmp_10;
  var tmp_11;
  var tmp_12;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp_13 = $this$with.d38_1;
    tmp_12 = tmp_13 instanceof InitialPhase;
  } else {
    tmp_12 = false;
  }
  if (tmp_12) {
    var tmp1_safe_receiver_0 = gameQuestion.y48_1;
    var tmp_14 = tmp1_safe_receiver_0 == null ? null : get_objectType($this$with, tmp1_safe_receiver_0);
    tmp_11 = !(tmp_14 == null) ? isInterface(tmp_14, BeastCharacter) : false;
  } else {
    tmp_11 = false;
  }
  if (tmp_11) {
    tmp_10 = gameQuestion.z48_1.s2() === 1;
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    $this.ee0(-603, -453, 0.3516);
    yield* $this.ce0($receiver, OnboardingHint_AtTheBeginningOfTheGameThe_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_ToReceiveTheFirstNightRewardBolgin_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_TheMapHas3ConvenientSwampLocations_getInstance(), $completion);
  }
  var tmp_15;
  var tmp_16;
  var tmp_17;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp2_safe_receiver = gameQuestion.y48_1;
    var tmp_18 = tmp2_safe_receiver == null ? null : get_objectType($this$with, tmp2_safe_receiver);
    tmp_17 = !(tmp_18 == null) ? isInterface(tmp_18, BeastCharacter) : false;
  } else {
    tmp_17 = false;
  }
  if (tmp_17) {
    var tmp_19 = $this$with.d38_1;
    tmp_16 = tmp_19 instanceof InitialPhase;
  } else {
    tmp_16 = false;
  }
  if (tmp_16) {
    tmp_15 = gameQuestion.z48_1.s2() === 2;
  } else {
    tmp_15 = false;
  }
  if (tmp_15) {
    $this.ee0(-603, -453, 0.3516);
    try {
      yield* $this.ce0($receiver, OnboardingHint_AndTheNextStepToTheLeft_getInstance(), $completion);
    }finally {
      $this.fe0();
    }
  }
  var tmp_20;
  var tmp_21;
  var tmp_22;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp_23 = $this$with.d38_1;
    tmp_22 = tmp_23 instanceof InitialPhase;
  } else {
    tmp_22 = false;
  }
  if (tmp_22) {
    var tmp3_safe_receiver = gameQuestion.y48_1;
    var tmp_24 = tmp3_safe_receiver == null ? null : get_objectType($this$with, tmp3_safe_receiver);
    tmp_21 = tmp_24 instanceof Helga;
  } else {
    tmp_21 = false;
  }
  if (tmp_21) {
    tmp_20 = gameQuestion.z48_1.s2() === 1;
  } else {
    tmp_20 = false;
  }
  if (tmp_20) {
    yield* $this.ce0($receiver, OnboardingHint_LetSSwitchToTheHuntersPerspective_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_HuntersDonTSeeTheBeastS_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_ActuallyTheBeastCanBeInTwo_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_NowItIsTheHunterSPart_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_HuntersGainManyBonusesWhenTheyStay_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SoLetSPlaceHelgaInTiveden_getInstance(), $completion);
  }
  var tmp_25;
  var tmp_26;
  var tmp_27;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp_28 = $this$with.d38_1;
    tmp_27 = tmp_28 instanceof InitialPhase;
  } else {
    tmp_27 = false;
  }
  if (tmp_27) {
    var tmp4_safe_receiver = gameQuestion.y48_1;
    var tmp_29 = tmp4_safe_receiver == null ? null : get_objectType($this$with, tmp4_safe_receiver);
    tmp_26 = tmp_29 instanceof Varja;
  } else {
    tmp_26 = false;
  }
  if (tmp_26) {
    tmp_25 = gameQuestion.z48_1.s2() === 1;
  } else {
    tmp_25 = false;
  }
  if (tmp_25) {
    yield* $this.ce0($receiver, OnboardingHint_NowLetSPlaceVarjaInGhastvik_getInstance(), $completion);
  }
  var tmp_30;
  var tmp_31;
  var tmp_32;
  if (gameQuestion instanceof DestinationQuestion) {
    var tmp_33 = $this$with.d38_1;
    tmp_32 = tmp_33 instanceof InitialPhase;
  } else {
    tmp_32 = false;
  }
  if (tmp_32) {
    var tmp5_safe_receiver = gameQuestion.y48_1;
    var tmp_34 = tmp5_safe_receiver == null ? null : get_objectType($this$with, tmp5_safe_receiver);
    tmp_31 = tmp_34 instanceof Iona;
  } else {
    tmp_31 = false;
  }
  if (tmp_31) {
    tmp_30 = gameQuestion.z48_1.s2() === 1;
  } else {
    tmp_30 = false;
  }
  if (tmp_30) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSPlaceIonaInGhastvik_getInstance(), $completion);
  }
  var tmp_35;
  var tmp_36;
  var tmp_37;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_37 = $this$with.e38_1 === 1;
  } else {
    tmp_37 = false;
  }
  if (tmp_37) {
    var tmp6_safe_receiver = $this$with.p38_1;
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.p4m_1;
    var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, 0);
    tmp_36 = (tmp8_safe_receiver == null ? null : tmp8_safe_receiver.s2()) === 1;
  } else {
    tmp_36 = false;
  }
  if (tmp_36) {
    var tmp_38 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_35 = tmp_38 instanceof Bolgin;
  } else {
    tmp_35 = false;
  }
  if (tmp_35) {
    yield* $this.ce0($receiver, OnboardingHint_BeforeTheDraftBeginsTheBeastReceives_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayALittleBitGreedy_getInstance(), $completion);
  }
  var tmp_39;
  var tmp_40;
  var tmp_41;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_41 = $this$with.e38_1 === 1;
  } else {
    tmp_41 = false;
  }
  if (tmp_41) {
    var tmp10_safe_receiver = $this$with.p38_1;
    var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.p4m_1;
    var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : getOrNull(tmp11_safe_receiver, 1);
    tmp_40 = (tmp12_safe_receiver == null ? null : tmp12_safe_receiver.s2()) === 0;
  } else {
    tmp_40 = false;
  }
  if (tmp_40) {
    var tmp_42 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_39 = tmp_42 instanceof Helga;
  } else {
    tmp_39 = false;
  }
  if (tmp_39) {
    yield* $this.ce0($receiver, OnboardingHint_TheBeastGameIsDesignedSoThat_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPickEnsnareActionCardFor_getInstance(), $completion);
  }
  var tmp_43;
  var tmp_44;
  var tmp_45;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_45 = $this$with.e38_1 === 1;
  } else {
    tmp_45 = false;
  }
  if (tmp_45) {
    var tmp14_safe_receiver = $this$with.p38_1;
    var tmp15_safe_receiver = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.p4m_1;
    var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : getOrNull(tmp15_safe_receiver, 2);
    tmp_44 = (tmp16_safe_receiver == null ? null : tmp16_safe_receiver.s2()) === 0;
  } else {
    tmp_44 = false;
  }
  if (tmp_44) {
    var tmp_46 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_43 = tmp_46 instanceof Varja;
  } else {
    tmp_43 = false;
  }
  if (tmp_43) {
    yield* $this.ce0($receiver, OnboardingHint_ForVarjaLetSPickTheCharge_getInstance(), $completion);
  }
  var tmp_47;
  var tmp_48;
  var tmp_49;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_49 = $this$with.e38_1 === 1;
  } else {
    tmp_49 = false;
  }
  if (tmp_49) {
    var tmp18_safe_receiver = $this$with.p38_1;
    var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.p4m_1;
    var tmp20_safe_receiver = tmp19_safe_receiver == null ? null : getOrNull(tmp19_safe_receiver, 3);
    tmp_48 = (tmp20_safe_receiver == null ? null : tmp20_safe_receiver.s2()) === 0;
  } else {
    tmp_48 = false;
  }
  if (tmp_48) {
    var tmp_50 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_47 = tmp_50 instanceof Iona;
  } else {
    tmp_47 = false;
  }
  if (tmp_47) {
    yield* $this.ce0($receiver, OnboardingHint_AndAtLastLetSChooseHidden_getInstance(), $completion);
  }
  var tmp_51;
  var tmp_52;
  var tmp_53;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_53 = $this$with.e38_1 === 1;
  } else {
    tmp_53 = false;
  }
  if (tmp_53) {
    var tmp22_safe_receiver = $this$with.p38_1;
    var tmp23_safe_receiver = tmp22_safe_receiver == null ? null : tmp22_safe_receiver.p4m_1;
    var tmp24_safe_receiver = tmp23_safe_receiver == null ? null : getOrNull(tmp23_safe_receiver, 0);
    tmp_52 = (tmp24_safe_receiver == null ? null : tmp24_safe_receiver.s2()) === 2;
  } else {
    tmp_52 = false;
  }
  if (tmp_52) {
    var tmp_54 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_51 = tmp_54 instanceof Bolgin;
  } else {
    tmp_51 = false;
  }
  if (tmp_51) {
    yield* $this.ce0($receiver, OnboardingHint_WhenAllPlayersHavePickedACard_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheAnimateCard_getInstance(), $completion);
  }
  var tmp_55;
  var tmp_56;
  var tmp_57;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_57 = $this$with.e38_1 === 1;
  } else {
    tmp_57 = false;
  }
  if (tmp_57) {
    var tmp26_safe_receiver = $this$with.p38_1;
    var tmp27_safe_receiver = tmp26_safe_receiver == null ? null : tmp26_safe_receiver.p4m_1;
    var tmp28_safe_receiver = tmp27_safe_receiver == null ? null : getOrNull(tmp27_safe_receiver, 1);
    tmp_56 = (tmp28_safe_receiver == null ? null : tmp28_safe_receiver.s2()) === 1;
  } else {
    tmp_56 = false;
  }
  if (tmp_56) {
    var tmp_58 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_55 = tmp_58 instanceof Helga;
  } else {
    tmp_55 = false;
  }
  if (tmp_55) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheAdaptCardFor_getInstance(), $completion);
  }
  var tmp_59;
  var tmp_60;
  var tmp_61;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_61 = $this$with.e38_1 === 1;
  } else {
    tmp_61 = false;
  }
  if (tmp_61) {
    var tmp30_safe_receiver = $this$with.p38_1;
    var tmp31_safe_receiver = tmp30_safe_receiver == null ? null : tmp30_safe_receiver.p4m_1;
    var tmp32_safe_receiver = tmp31_safe_receiver == null ? null : getOrNull(tmp31_safe_receiver, 2);
    tmp_60 = (tmp32_safe_receiver == null ? null : tmp32_safe_receiver.s2()) === 1;
  } else {
    tmp_60 = false;
  }
  if (tmp_60) {
    var tmp_62 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_59 = tmp_62 instanceof Varja;
  } else {
    tmp_59 = false;
  }
  if (tmp_59) {
    yield* $this.ce0($receiver, OnboardingHint_ForVarijaLetSPickTheDark_getInstance(), $completion);
  }
  var tmp_63;
  var tmp_64;
  var tmp_65;
  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
    tmp_65 = $this$with.e38_1 === 1;
  } else {
    tmp_65 = false;
  }
  if (tmp_65) {
    var tmp34_safe_receiver = $this$with.p38_1;
    var tmp35_safe_receiver = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.p4m_1;
    var tmp36_safe_receiver = tmp35_safe_receiver == null ? null : getOrNull(tmp35_safe_receiver, 3);
    tmp_64 = (tmp36_safe_receiver == null ? null : tmp36_safe_receiver.s2()) === 1;
  } else {
    tmp_64 = false;
  }
  if (tmp_64) {
    var tmp_66 = draftQuestionCharacter == null ? null : get_objectType($this$with, draftQuestionCharacter);
    tmp_63 = tmp_66 instanceof Iona;
  } else {
    tmp_63 = false;
  }
  if (tmp_63) {
    yield* $this.ce0($receiver, OnboardingHint_AndForIonaLetSPickThe_getInstance(), $completion);
  }
  var tmp_67;
  var tmp_68;
  var tmp_69;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_69 = $this$with.e38_1 === 1;
  } else {
    tmp_69 = false;
  }
  if (tmp_69) {
    tmp_68 = $this$with.f38_1 === 1;
  } else {
    tmp_68 = false;
  }
  if (tmp_68) {
    tmp_67 = gameQuestion.y4a_1.w2(new PlayCardVariant(EngorgeCard_getInstance()));
  } else {
    tmp_67 = false;
  }
  if (tmp_67) {
    yield* $this.ce0($receiver, OnboardingHint_APlayerMayPassOnlyIfNo_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_RightNowBolginHas4AbilityCards_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_DuringATurnAPlayerCanEither_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SometimesYouMayWantToMoveBut_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_NowLetSPlayTheEngorgeCard_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_JustClickOnTheEngorgeCard_getInstance(), $completion);
  }
  var tmp_70;
  var tmp_71;
  var tmp_72;
  var tmp_73;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_73 = $this$with.e38_1 === 1;
  } else {
    tmp_73 = false;
  }
  if (tmp_73) {
    tmp_72 = $this$with.f38_1 === 1;
  } else {
    tmp_72 = false;
  }
  if (tmp_72) {
    tmp_71 = $this$with.c39_1 === 1;
  } else {
    tmp_71 = false;
  }
  if (tmp_71) {
    tmp_70 = gameQuestion.y4a_1.w2(new PlayCardVariant(SummonPolypCard_getInstance()));
  } else {
    tmp_70 = false;
  }
  if (tmp_70) {
    yield* $this.ce0($receiver, OnboardingHint_BolginPlayedTheFirstCardAndIt_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheSummonPolypCard_getInstance(), $completion);
  }
  var tmp_74;
  var tmp_75;
  var tmp_76;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_76 = $this$with.e38_1 === 1;
  } else {
    tmp_76 = false;
  }
  if (tmp_76) {
    tmp_75 = $this$with.f38_1 === 1;
  } else {
    tmp_75 = false;
  }
  if (tmp_75) {
    var tmp0_1 = gameQuestion.d4b_1;
    var tmp$ret$12;
    $l$block_6: {
      // Inline function 'kotlin.collections.any' call
      var tmp_77;
      if (isInterface(tmp0_1, Collection)) {
        tmp_77 = tmp0_1.n1();
      } else {
        tmp_77 = false;
      }
      if (tmp_77) {
        tmp$ret$12 = false;
        break $l$block_6;
      }
      var _iterator__ex2g4s_2 = tmp0_1.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_2 = _iterator__ex2g4s_2.r1();
        if (element_2 instanceof SummonSignStatement) {
          tmp$ret$12 = true;
          break $l$block_6;
        }
      }
      tmp$ret$12 = false;
    }
    tmp_74 = tmp$ret$12;
  } else {
    tmp_74 = false;
  }
  if (tmp_74) {
    yield* $this.ce0($receiver, OnboardingHint_ThisCardContainsTwoStatementsThatCan_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSStartWithTheSummonActivationAction_getInstance(), $completion);
  }
  var tmp_78;
  var tmp_79;
  if (gameQuestion instanceof PlaceNewObjectQuestion) {
    tmp_79 = $this$with.e38_1 === 1;
  } else {
    tmp_79 = false;
  }
  if (tmp_79) {
    tmp_78 = $this$with.f38_1 === 1;
  } else {
    tmp_78 = false;
  }
  if (tmp_78) {
    yield* $this.ce0($receiver, OnboardingHint_WhenYouPlayASummonActivationActionYou_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SinceThereIsNoPolypOnThe_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_EveryBeastHasItsOwnSummonLimit_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_EveryBeastCanPlaceASummonOnly_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlaceAPolypJustAbove_getInstance(), $completion);
  }
  var tmp_80;
  var tmp_81;
  var tmp_82;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_82 = $this$with.e38_1 === 1;
  } else {
    tmp_82 = false;
  }
  if (tmp_82) {
    tmp_81 = $this$with.f38_1 === 1;
  } else {
    tmp_81 = false;
  }
  if (tmp_81) {
    var tmp38_safe_receiver = gameQuestion.y48_1;
    var tmp_83 = tmp38_safe_receiver == null ? null : get_objectType($this$with, tmp38_safe_receiver);
    tmp_80 = tmp_83 instanceof Bolgin;
  } else {
    tmp_80 = false;
  }
  if (tmp_80) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSMoveBolginOne_getInstance(), $completion);
  }
  var tmp_84;
  var tmp_85;
  var tmp_86;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_86 = $this$with.e38_1 === 1;
  } else {
    tmp_86 = false;
  }
  if (tmp_86) {
    tmp_85 = $this$with.f38_1 === 1;
  } else {
    tmp_85 = false;
  }
  if (tmp_85) {
    tmp_84 = gameQuestion.y4a_1.w2(new PlayCardVariant(EnsnareCard_getInstance()));
  } else {
    tmp_84 = false;
  }
  if (tmp_84) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatHelgaCanPassNowIt_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheEnsnareCard_getInstance(), $completion);
  }
  var tmp_87;
  var tmp_88;
  var tmp_89;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_89 = $this$with.e38_1 === 1;
  } else {
    tmp_89 = false;
  }
  if (tmp_89) {
    tmp_88 = $this$with.f38_1 === 1;
  } else {
    tmp_88 = false;
  }
  if (tmp_88) {
    tmp_87 = gameQuestion.l48_1.w2(BeastlyTongueCard_getInstance());
  } else {
    tmp_87 = false;
  }
  if (tmp_87) {
    yield* $this.ce0($receiver, OnboardingHint_TheEnsnareCardAllowsYouToSee_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSDiscardTheBeastlyTongueCard_getInstance(), $completion);
  }
  var tmp_90;
  var tmp_91;
  var tmp_92;
  var tmp_93;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_93 = $this$with.e38_1 === 1;
  } else {
    tmp_93 = false;
  }
  if (tmp_93) {
    tmp_92 = $this$with.f38_1 === 1;
  } else {
    tmp_92 = false;
  }
  if (tmp_92) {
    tmp_91 = !gameQuestion.y4a_1.w2(new PlayCardVariant(EnsnareCard_getInstance()));
  } else {
    tmp_91 = false;
  }
  if (tmp_91) {
    tmp_90 = gameQuestion.y4a_1.w2(new PlayCardVariant(SeerCard_getInstance()));
  } else {
    tmp_90 = false;
  }
  if (tmp_90) {
    yield* $this.ce0($receiver, OnboardingHint_LetSKeepTheCardsAndEnd_getInstance(), $completion);
  }
  var tmp_94;
  var tmp_95;
  var tmp_96;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_96 = $this$with.e38_1 === 1;
  } else {
    tmp_96 = false;
  }
  if (tmp_96) {
    tmp_95 = $this$with.f38_1 === 1;
  } else {
    tmp_95 = false;
  }
  if (tmp_95) {
    tmp_94 = gameQuestion.y4a_1.w2(new PlayCardVariant(InciteCard_getInstance()));
  } else {
    tmp_94 = false;
  }
  if (tmp_94) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveCloseToBeastPlay_getInstance(), $completion);
  }
  var tmp_97;
  var tmp_98;
  var tmp_99;
  var tmp_100;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_100 = $this$with.e38_1 === 1;
  } else {
    tmp_100 = false;
  }
  if (tmp_100) {
    tmp_99 = $this$with.f38_1 === 1;
  } else {
    tmp_99 = false;
  }
  if (tmp_99) {
    tmp_98 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_98 = false;
  }
  if (tmp_98) {
    var tmp0_2 = gameQuestion.m4a_1;
    var tmp$ret$14;
    $l$block_8: {
      // Inline function 'kotlin.collections.any' call
      var tmp_101;
      if (isInterface(tmp0_2, Collection)) {
        tmp_101 = tmp0_2.n1();
      } else {
        tmp_101 = false;
      }
      if (tmp_101) {
        tmp$ret$14 = false;
        break $l$block_8;
      }
      var _iterator__ex2g4s_3 = tmp0_2.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var element_3 = _iterator__ex2g4s_3.r1();
        var tmp_102 = get_objectType($this$with, element_3);
        if (tmp_102 instanceof Varja) {
          tmp$ret$14 = true;
          break $l$block_8;
        }
      }
      tmp$ret$14 = false;
    }
    tmp_97 = tmp$ret$14;
  } else {
    tmp_97 = false;
  }
  if (tmp_97) {
    yield* $this.ce0($receiver, OnboardingHint_TheInciteCardAllowsYouToMove_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_HuntersPerformMovementStepByStepAnd_getInstance(), $completion);
  }
  var tmp_103;
  var tmp_104;
  var tmp_105;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_105 = $this$with.e38_1 === 1;
  } else {
    tmp_105 = false;
  }
  if (tmp_105) {
    tmp_104 = $this$with.f38_1 === 1;
  } else {
    tmp_104 = false;
  }
  if (tmp_104) {
    var tmp39_safe_receiver = gameQuestion.y48_1;
    var tmp_106 = tmp39_safe_receiver == null ? null : get_objectType($this$with, tmp39_safe_receiver);
    tmp_103 = tmp_106 instanceof Varja;
  } else {
    tmp_103 = false;
  }
  if (tmp_103) {
    yield* $this.ce0($receiver, OnboardingHint_MoveVarjaOneStepLower_getInstance(), $completion);
  }
  var tmp_107;
  var tmp_108;
  var tmp_109;
  var tmp_110;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_110 = $this$with.e38_1 === 1;
  } else {
    tmp_110 = false;
  }
  if (tmp_110) {
    tmp_109 = $this$with.f38_1 === 1;
  } else {
    tmp_109 = false;
  }
  if (tmp_109) {
    tmp_108 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_108 = false;
  }
  if (tmp_108) {
    var tmp40_safe_receiver = gameQuestion.y48_1;
    var tmp_111 = tmp40_safe_receiver == null ? null : get_objectType($this$with, tmp40_safe_receiver);
    tmp_107 = tmp_111 instanceof Iona;
  } else {
    tmp_107 = false;
  }
  if (tmp_107) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatAllHunterMovementsAsWell_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_NowLetSMoveIonaOneStep_getInstance(), $completion);
  }
  var tmp_112;
  var tmp_113;
  var tmp_114;
  var tmp_115;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_115 = $this$with.e38_1 === 1;
  } else {
    tmp_115 = false;
  }
  if (tmp_115) {
    tmp_114 = $this$with.f38_1 === 1;
  } else {
    tmp_114 = false;
  }
  if (tmp_114) {
    tmp_113 = $this$with.c39_1 === 1;
  } else {
    tmp_113 = false;
  }
  if (tmp_113) {
    tmp_112 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_112 = false;
  }
  if (tmp_112) {
    yield* $this.ce0($receiver, OnboardingHint_LetSNowFinishVarjsSTurn_getInstance(), $completion);
  }
  var tmp_116;
  var tmp_117;
  var tmp_118;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_118 = $this$with.e38_1 === 1;
  } else {
    tmp_118 = false;
  }
  if (tmp_118) {
    tmp_117 = $this$with.f38_1 === 1;
  } else {
    tmp_117 = false;
  }
  if (tmp_117) {
    tmp_116 = gameQuestion.y4a_1.w2(new PlayCardVariant(BolsterCard_getInstance()));
  } else {
    tmp_116 = false;
  }
  if (tmp_116) {
    yield* $this.ce0($receiver, OnboardingHint_WhileTheTwoHuntersAreTogetherLet_getInstance(), $completion);
  }
  var tmp_119;
  var tmp_120;
  var tmp_121;
  var tmp_122;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_122 = $this$with.e38_1 === 1;
  } else {
    tmp_122 = false;
  }
  if (tmp_122) {
    tmp_121 = $this$with.f38_1 === 1;
  } else {
    tmp_121 = false;
  }
  if (tmp_121) {
    tmp_120 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_120 = false;
  }
  if (tmp_120) {
    var tmp0_3 = gameQuestion.m4a_1;
    var tmp$ret$16;
    $l$block_10: {
      // Inline function 'kotlin.collections.any' call
      var tmp_123;
      if (isInterface(tmp0_3, Collection)) {
        tmp_123 = tmp0_3.n1();
      } else {
        tmp_123 = false;
      }
      if (tmp_123) {
        tmp$ret$16 = false;
        break $l$block_10;
      }
      var _iterator__ex2g4s_4 = tmp0_3.p1();
      while (_iterator__ex2g4s_4.q1()) {
        var element_4 = _iterator__ex2g4s_4.r1();
        var tmp_124 = get_objectType($this$with, element_4);
        if (tmp_124 instanceof Iona) {
          tmp$ret$16 = true;
          break $l$block_10;
        }
      }
      tmp$ret$16 = false;
    }
    tmp_119 = tmp$ret$16;
  } else {
    tmp_119 = false;
  }
  if (tmp_119) {
    yield* $this.ce0($receiver, OnboardingHint_SoNowBothVarjaAndIonaCan_getInstance(), $completion);
  }
  var tmp_125;
  var tmp_126;
  var tmp_127;
  var tmp_128;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_128 = $this$with.e38_1 === 1;
  } else {
    tmp_128 = false;
  }
  if (tmp_128) {
    tmp_127 = $this$with.f38_1 === 1;
  } else {
    tmp_127 = false;
  }
  if (tmp_127) {
    tmp_126 = !gameQuestion.l48_1.w2(LeapCard_getInstance());
  } else {
    tmp_126 = false;
  }
  if (tmp_126) {
    var tmp0_4 = get_hand($this$with, get_ionaHunter($this$with));
    var tmp$ret$18;
    $l$block_12: {
      // Inline function 'kotlin.collections.none' call
      var tmp_129;
      if (isInterface(tmp0_4, Collection)) {
        tmp_129 = tmp0_4.n1();
      } else {
        tmp_129 = false;
      }
      if (tmp_129) {
        tmp$ret$18 = true;
        break $l$block_12;
      }
      var _iterator__ex2g4s_5 = tmp0_4.p1();
      while (_iterator__ex2g4s_5.q1()) {
        var element_5 = _iterator__ex2g4s_5.r1();
        if (isInterface(element_5, HunterItemCard)) {
          tmp$ret$18 = false;
          break $l$block_12;
        }
      }
      tmp$ret$18 = true;
    }
    tmp_125 = tmp$ret$18;
  } else {
    tmp_125 = false;
  }
  if (tmp_125) {
    yield* $this.ce0($receiver, OnboardingHint_ThereAre3OpenHunterItemsAnd_getInstance(), $completion);
  }
  var tmp_130;
  var tmp_131;
  var tmp_132;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_132 = $this$with.e38_1 === 1;
  } else {
    tmp_132 = false;
  }
  if (tmp_132) {
    tmp_131 = $this$with.f38_1 === 1;
  } else {
    tmp_131 = false;
  }
  if (tmp_131) {
    var tmp0_5 = get_hand($this$with, get_ionaHunter($this$with));
    var tmp$ret$20;
    $l$block_14: {
      // Inline function 'kotlin.collections.any' call
      var tmp_133;
      if (isInterface(tmp0_5, Collection)) {
        tmp_133 = tmp0_5.n1();
      } else {
        tmp_133 = false;
      }
      if (tmp_133) {
        tmp$ret$20 = false;
        break $l$block_14;
      }
      var _iterator__ex2g4s_6 = tmp0_5.p1();
      while (_iterator__ex2g4s_6.q1()) {
        var element_6 = _iterator__ex2g4s_6.r1();
        if (isInterface(element_6, HunterItemCard)) {
          tmp$ret$20 = true;
          break $l$block_14;
        }
      }
      tmp$ret$20 = false;
    }
    tmp_130 = tmp$ret$20;
  } else {
    tmp_130 = false;
  }
  if (tmp_130) {
    yield* $this.ce0($receiver, OnboardingHint_NowItIsTimeToPickAn_getInstance(), $completion);
  }
  var tmp_134;
  var tmp_135;
  var tmp_136;
  var tmp_137;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_137 = $this$with.e38_1 === 1;
  } else {
    tmp_137 = false;
  }
  if (tmp_137) {
    tmp_136 = $this$with.f38_1 === 1;
  } else {
    tmp_136 = false;
  }
  if (tmp_136) {
    tmp_135 = $this$with.c39_1 === 1;
  } else {
    tmp_135 = false;
  }
  if (tmp_135) {
    tmp_134 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_134 = false;
  }
  if (tmp_134) {
    yield* $this.ce0($receiver, OnboardingHint_NowLetSKillThatPolypPlay_getInstance(), $completion);
  }
  var tmp_138;
  var tmp_139;
  var tmp_140;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_140 = $this$with.e38_1 === 1;
  } else {
    tmp_140 = false;
  }
  if (tmp_140) {
    tmp_139 = $this$with.f38_1 === 1;
  } else {
    tmp_139 = false;
  }
  if (tmp_139) {
    var tmp0_6 = gameQuestion.d4b_1;
    var tmp$ret$22;
    $l$block_16: {
      // Inline function 'kotlin.collections.any' call
      var tmp_141;
      if (isInterface(tmp0_6, Collection)) {
        tmp_141 = tmp0_6.n1();
      } else {
        tmp_141 = false;
      }
      if (tmp_141) {
        tmp$ret$22 = false;
        break $l$block_16;
      }
      var _iterator__ex2g4s_7 = tmp0_6.p1();
      while (_iterator__ex2g4s_7.q1()) {
        var element_7 = _iterator__ex2g4s_7.r1();
        if (element_7 instanceof AttackStatement) {
          tmp$ret$22 = true;
          break $l$block_16;
        }
      }
      tmp$ret$22 = false;
    }
    tmp_138 = tmp$ret$22;
  } else {
    tmp_138 = false;
  }
  if (tmp_138) {
    yield* $this.ce0($receiver, OnboardingHint_TheAttackInTheSilverArrowCard_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_NearbyLocationsAreLocationsThatAre1_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SoLetSPlayTheAttackAnd_getInstance(), $completion);
  }
  var tmp_142;
  var tmp_143;
  var tmp_144;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_144 = $this$with.e38_1 === 1;
  } else {
    tmp_144 = false;
  }
  if (tmp_144) {
    tmp_143 = $this$with.f38_1 === 1;
  } else {
    tmp_143 = false;
  }
  if (tmp_143) {
    tmp_142 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_142 = false;
  }
  if (tmp_142) {
    yield* $this.ce0($receiver, OnboardingHint_ThisIsWhyTheSilverArrowIs_getInstance(), $completion);
  }
  var tmp_145;
  var tmp_146;
  var tmp_147;
  var tmp_148;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_148 = $this$with.e38_1 === 1;
  } else {
    tmp_148 = false;
  }
  if (tmp_148) {
    tmp_147 = $this$with.f38_1 === 2;
  } else {
    tmp_147 = false;
  }
  if (tmp_147) {
    tmp_146 = $this$with.c39_1 === 0;
  } else {
    tmp_146 = false;
  }
  if (tmp_146) {
    tmp_145 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_145 = false;
  }
  if (tmp_145) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatBolginIsNowInA_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheUnearthCardTo_getInstance(), $completion);
  }
  var tmp_149;
  var tmp_150;
  var tmp_151;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_151 = $this$with.e38_1 === 1;
  } else {
    tmp_151 = false;
  }
  if (tmp_151) {
    tmp_150 = $this$with.f38_1 === 2;
  } else {
    tmp_150 = false;
  }
  if (tmp_150) {
    tmp_149 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_149 = false;
  }
  if (tmp_149) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheBrutalityCard_getInstance(), $completion);
  }
  var tmp_152;
  var tmp_153;
  var tmp_154;
  var tmp_155;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_155 = $this$with.e38_1 === 1;
  } else {
    tmp_155 = false;
  }
  if (tmp_155) {
    tmp_154 = $this$with.f38_1 === 2;
  } else {
    tmp_154 = false;
  }
  if (tmp_154) {
    tmp_153 = $this$with.c39_1 === 1;
  } else {
    tmp_153 = false;
  }
  if (tmp_153) {
    tmp_152 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_152 = false;
  }
  if (tmp_152) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSJustFinishTheTurn_getInstance(), $completion);
  }
  var tmp_156;
  var tmp_157;
  var tmp_158;
  var tmp_159;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_159 = $this$with.e38_1 === 1;
  } else {
    tmp_159 = false;
  }
  if (tmp_159) {
    tmp_158 = $this$with.f38_1 === 2;
  } else {
    tmp_158 = false;
  }
  if (tmp_158) {
    tmp_157 = $this$with.c39_1 === 0;
  } else {
    tmp_157 = false;
  }
  if (tmp_157) {
    tmp_156 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_156 = false;
  }
  if (tmp_156) {
    yield* $this.ce0($receiver, OnboardingHint_BolginPlayedQuiteGreedilyLetSPunish_getInstance(), $completion);
  }
  var tmp_160;
  var tmp_161;
  var tmp_162;
  var tmp_163;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_163 = $this$with.e38_1 === 1;
  } else {
    tmp_163 = false;
  }
  if (tmp_163) {
    tmp_162 = $this$with.f38_1 === 2;
  } else {
    tmp_162 = false;
  }
  if (tmp_162) {
    tmp_161 = $this$with.c39_1 === 1;
  } else {
    tmp_161 = false;
  }
  if (tmp_161) {
    tmp_160 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_160 = false;
  }
  if (tmp_160) {
    yield* $this.ce0($receiver, OnboardingHint_LetSFinishHelgaSTurnNow_getInstance(), $completion);
  }
  var tmp_164;
  var tmp_165;
  var tmp_166;
  var tmp_167;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_167 = $this$with.e38_1 === 1;
  } else {
    tmp_167 = false;
  }
  if (tmp_167) {
    tmp_166 = $this$with.f38_1 === 2;
  } else {
    tmp_166 = false;
  }
  if (tmp_166) {
    tmp_165 = $this$with.c39_1 === 0;
  } else {
    tmp_165 = false;
  }
  if (tmp_165) {
    tmp_164 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_164 = false;
  }
  if (tmp_164) {
    yield* $this.ce0($receiver, OnboardingHint_NowLetSMoveVarjaOntoBolgin_getInstance(), $completion);
  }
  var tmp_168;
  var tmp_169;
  var tmp_170;
  var tmp_171;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_171 = $this$with.e38_1 === 1;
  } else {
    tmp_171 = false;
  }
  if (tmp_171) {
    tmp_170 = $this$with.f38_1 === 2;
  } else {
    tmp_170 = false;
  }
  if (tmp_170) {
    tmp_169 = $this$with.c39_1 === 0;
  } else {
    tmp_169 = false;
  }
  if (tmp_169) {
    var tmp41_safe_receiver = gameQuestion.y48_1;
    var tmp_172 = tmp41_safe_receiver == null ? null : get_objectType($this$with, tmp41_safe_receiver);
    tmp_168 = tmp_172 instanceof Varja;
  } else {
    tmp_168 = false;
  }
  if (tmp_168) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveVarjaOneStepTo_getInstance(), $completion);
  }
  var tmp_173;
  var tmp_174;
  var tmp_175;
  var tmp_176;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_176 = $this$with.e38_1 === 1;
  } else {
    tmp_176 = false;
  }
  if (tmp_176) {
    tmp_175 = $this$with.f38_1 === 2;
  } else {
    tmp_175 = false;
  }
  if (tmp_175) {
    tmp_174 = $this$with.c39_1 === 1;
  } else {
    tmp_174 = false;
  }
  if (tmp_174) {
    tmp_173 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_173 = false;
  }
  if (tmp_173) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSPlayTheTrack_getInstance(), $completion);
  }
  var tmp_177;
  var tmp_178;
  var tmp_179;
  var tmp_180;
  var tmp_181;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_181 = $this$with.e38_1 === 1;
  } else {
    tmp_181 = false;
  }
  if (tmp_181) {
    tmp_180 = $this$with.f38_1 === 2;
  } else {
    tmp_180 = false;
  }
  if (tmp_180) {
    tmp_179 = $this$with.c39_1 === 1;
  } else {
    tmp_179 = false;
  }
  if (tmp_179) {
    var tmp42_safe_receiver = gameQuestion.y48_1;
    var tmp_182 = tmp42_safe_receiver == null ? null : get_objectType($this$with, tmp42_safe_receiver);
    tmp_178 = tmp_182 instanceof Varja;
  } else {
    tmp_178 = false;
  }
  if (tmp_178) {
    tmp_177 = get_varjaHunter($this$with).s2w($this$with) === _BoardPosition___init__impl__1nizgq(-2, 1);
  } else {
    tmp_177 = false;
  }
  if (tmp_177) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveOneMoreStepRight_getInstance(), $completion);
  }
  var tmp_183;
  var tmp_184;
  var tmp_185;
  var tmp_186;
  var tmp_187;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_187 = $this$with.e38_1 === 1;
  } else {
    tmp_187 = false;
  }
  if (tmp_187) {
    tmp_186 = $this$with.f38_1 === 2;
  } else {
    tmp_186 = false;
  }
  if (tmp_186) {
    tmp_185 = $this$with.c39_1 === 1;
  } else {
    tmp_185 = false;
  }
  if (tmp_185) {
    var tmp43_safe_receiver = gameQuestion.y48_1;
    var tmp_188 = tmp43_safe_receiver == null ? null : get_objectType($this$with, tmp43_safe_receiver);
    tmp_184 = tmp_188 instanceof Varja;
  } else {
    tmp_184 = false;
  }
  if (tmp_184) {
    tmp_183 = get_varjaHunter($this$with).s2w($this$with) === _BoardPosition___init__impl__1nizgq(-1, 1);
  } else {
    tmp_183 = false;
  }
  if (tmp_183) {
    yield* $this.ce0($receiver, OnboardingHint_WhenTheBeastIsHiddenTheStandee_getInstance(), $completion);
  }
  var tmp_189;
  var tmp_190;
  var tmp_191;
  var tmp_192;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_192 = $this$with.e38_1 === 1;
  } else {
    tmp_192 = false;
  }
  if (tmp_192) {
    tmp_191 = $this$with.f38_1 === 2;
  } else {
    tmp_191 = false;
  }
  if (tmp_191) {
    tmp_190 = $this$with.c39_1 === 0;
  } else {
    tmp_190 = false;
  }
  if (tmp_190) {
    tmp_189 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_189 = false;
  }
  if (tmp_189) {
    yield* $this.ce0($receiver, OnboardingHint_NowItSTimeToRelocateIona_getInstance(), $completion);
  }
  var tmp_193;
  var tmp_194;
  var tmp_195;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_195 = $this$with.e38_1 === 1;
  } else {
    tmp_195 = false;
  }
  if (tmp_195) {
    tmp_194 = $this$with.f38_1 === 2;
  } else {
    tmp_194 = false;
  }
  if (tmp_194) {
    tmp_193 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_193 = false;
  }
  if (tmp_193) {
    yield* $this.ce0($receiver, OnboardingHint_LetSChooseIona_getInstance(), $completion);
  }
  var tmp_196;
  var tmp_197;
  var tmp_198;
  var tmp_199;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_199 = $this$with.e38_1 === 1;
  } else {
    tmp_199 = false;
  }
  if (tmp_199) {
    tmp_198 = $this$with.f38_1 === 2;
  } else {
    tmp_198 = false;
  }
  if (tmp_198) {
    tmp_197 = $this$with.c39_1 === 0;
  } else {
    tmp_197 = false;
  }
  if (tmp_197) {
    var tmp44_safe_receiver = gameQuestion.y48_1;
    var tmp_200 = tmp44_safe_receiver == null ? null : get_objectType($this$with, tmp44_safe_receiver);
    tmp_196 = tmp_200 instanceof Iona;
  } else {
    tmp_196 = false;
  }
  if (tmp_196) {
    yield* $this.ce0($receiver, OnboardingHint_AsTheDestinationLetSChooseVarja_getInstance(), $completion);
  }
  var tmp_201;
  var tmp_202;
  var tmp_203;
  var tmp_204;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_204 = $this$with.e38_1 === 1;
  } else {
    tmp_204 = false;
  }
  if (tmp_204) {
    tmp_203 = $this$with.f38_1 === 2;
  } else {
    tmp_203 = false;
  }
  if (tmp_203) {
    tmp_202 = $this$with.c39_1 === 1;
  } else {
    tmp_202 = false;
  }
  if (tmp_202) {
    tmp_201 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_201 = false;
  }
  if (tmp_201) {
    yield* $this.ce0($receiver, OnboardingHint_AtLastPlayTheHuntCard_getInstance(), $completion);
  }
  var tmp_205;
  var tmp_206;
  var tmp_207;
  var tmp_208;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_208 = $this$with.e38_1 === 1;
  } else {
    tmp_208 = false;
  }
  if (tmp_208) {
    tmp_207 = $this$with.f38_1 === 3;
  } else {
    tmp_207 = false;
  }
  if (tmp_207) {
    tmp_206 = $this$with.c39_1 === 0;
  } else {
    tmp_206 = false;
  }
  if (tmp_206) {
    tmp_205 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_205 = false;
  }
  if (tmp_205) {
    yield* $this.ce0($receiver, OnboardingHint_SoBolginPaidForTheirGreedyPlay_getInstance(), $completion);
  }
  var tmp_209;
  var tmp_210;
  var tmp_211;
  var tmp_212;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_212 = $this$with.e38_1 === 1;
  } else {
    tmp_212 = false;
  }
  if (tmp_212) {
    tmp_211 = $this$with.f38_1 === 3;
  } else {
    tmp_211 = false;
  }
  if (tmp_211) {
    tmp_210 = $this$with.c39_1 === 0;
  } else {
    tmp_210 = false;
  }
  if (tmp_210) {
    tmp_209 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_209 = false;
  }
  if (tmp_209) {
    yield* $this.ce0($receiver, OnboardingHint_LetSChooseTheSheepType_getInstance(), $completion);
  }
  var tmp_213;
  var tmp_214;
  if (gameQuestion instanceof AncientPowerNumberQuestion) {
    tmp_214 = $this$with.e38_1 === 1;
  } else {
    tmp_214 = false;
  }
  if (tmp_214) {
    tmp_213 = $this$with.f38_1 === 3;
  } else {
    tmp_213 = false;
  }
  if (tmp_213) {
    yield* $this.ce0($receiver, OnboardingHint_PlayersCanIncreaseTheDamageByUsing_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_WhenYouSpendAnAncientPowerReturnIt_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSSaveAncientPowerForNowJust_getInstance(), $completion);
  }
  var tmp_215;
  var tmp_216;
  if (gameQuestion instanceof TriggersQuestion) {
    tmp_216 = $this$with.e38_1 === 1;
  } else {
    tmp_216 = false;
  }
  if (tmp_216) {
    tmp_215 = $this$with.f38_1 === 3;
  } else {
    tmp_215 = false;
  }
  if (tmp_215) {
    yield* $this.ce0($receiver, OnboardingHint_NowIonaCanPlayHerSmokebombCard_getInstance(), $completion);
  }
  var tmp_217;
  var tmp_218;
  var tmp_219;
  var tmp_220;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_220 = $this$with.e38_1 === 1;
  } else {
    tmp_220 = false;
  }
  if (tmp_220) {
    tmp_219 = $this$with.f38_1 === 3;
  } else {
    tmp_219 = false;
  }
  if (tmp_219) {
    tmp_218 = $this$with.c39_1 === 0;
  } else {
    tmp_218 = false;
  }
  if (tmp_218) {
    var tmp45_safe_receiver = gameQuestion.y48_1;
    var tmp_221 = tmp45_safe_receiver == null ? null : get_objectType($this$with, tmp45_safe_receiver);
    tmp_217 = tmp_221 instanceof Bolgin;
  } else {
    tmp_217 = false;
  }
  if (tmp_217) {
    yield* $this.ce0($receiver, OnboardingHint_BolginNeedsToMoveAwayFromThe_getInstance(), $completion);
  }
  var tmp_222;
  var tmp_223;
  var tmp_224;
  var tmp_225;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_225 = $this$with.e38_1 === 1;
  } else {
    tmp_225 = false;
  }
  if (tmp_225) {
    tmp_224 = $this$with.f38_1 === 3;
  } else {
    tmp_224 = false;
  }
  if (tmp_224) {
    tmp_223 = $this$with.c39_1 === 1;
  } else {
    tmp_223 = false;
  }
  if (tmp_223) {
    tmp_222 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_222 = false;
  }
  if (tmp_222) {
    yield* $this.ce0($receiver, OnboardingHint_NowItIsConvenientTimeToPlay_getInstance(), $completion);
  }
  var tmp_226;
  var tmp_227;
  var tmp_228;
  var tmp_229;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_229 = $this$with.e38_1 === 1;
  } else {
    tmp_229 = false;
  }
  if (tmp_229) {
    tmp_228 = $this$with.f38_1 === 3;
  } else {
    tmp_228 = false;
  }
  if (tmp_228) {
    tmp_227 = $this$with.c39_1 === 1;
  } else {
    tmp_227 = false;
  }
  if (tmp_227) {
    var tmp46_safe_receiver = gameQuestion.y48_1;
    var tmp_230 = tmp46_safe_receiver == null ? null : get_objectType($this$with, tmp46_safe_receiver);
    tmp_226 = tmp_230 instanceof Bolgin;
  } else {
    tmp_226 = false;
  }
  if (tmp_226) {
    if (gameQuestion.z48_1.s2() === 1) {
      yield* $this.ce0($receiver, OnboardingHint_NoteThatMovingBolginToTheRight_getInstance(), $completion);
      yield* $this.ce0($receiver, OnboardingHint_LetSMoveBolginOneMoreStep_getInstance(), $completion);
    }
    if (gameQuestion.z48_1.s2() === 2) {
      yield* $this.ce0($receiver, OnboardingHint_AndNowLetSTrickTheHunters_getInstance(), $completion);
    }
  }
  var tmp_231;
  var tmp_232;
  var tmp_233;
  var tmp_234;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_234 = $this$with.e38_1 === 1;
  } else {
    tmp_234 = false;
  }
  if (tmp_234) {
    tmp_233 = $this$with.f38_1 === 3;
  } else {
    tmp_233 = false;
  }
  if (tmp_233) {
    tmp_232 = $this$with.c39_1 === 0;
  } else {
    tmp_232 = false;
  }
  if (tmp_232) {
    tmp_231 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_231 = false;
  }
  if (tmp_231) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheDarkDealingsCard_getInstance(), $completion);
  }
  var tmp_235;
  var tmp_236;
  var tmp_237;
  var tmp_238;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_238 = $this$with.e38_1 === 1;
  } else {
    tmp_238 = false;
  }
  if (tmp_238) {
    tmp_237 = $this$with.f38_1 === 3;
  } else {
    tmp_237 = false;
  }
  if (tmp_237) {
    tmp_236 = $this$with.c39_1 === 0;
  } else {
    tmp_236 = false;
  }
  if (tmp_236) {
    tmp_235 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_235 = false;
  }
  if (tmp_235) {
    yield* $this.ce0($receiver, OnboardingHint_TheDarkDealingsCardAllowsToReturn_getInstance(), $completion);
  }
  var tmp_239;
  var tmp_240;
  var tmp_241;
  var tmp_242;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_242 = $this$with.e38_1 === 1;
  } else {
    tmp_242 = false;
  }
  if (tmp_242) {
    tmp_241 = $this$with.f38_1 === 3;
  } else {
    tmp_241 = false;
  }
  if (tmp_241) {
    tmp_240 = $this$with.c39_1 === 1;
  } else {
    tmp_240 = false;
  }
  if (tmp_240) {
    tmp_239 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_239 = false;
  }
  if (tmp_239) {
    yield* $this.ce0($receiver, OnboardingHint_LetSEndHelgaSTurn_getInstance(), $completion);
  }
  var tmp_243;
  var tmp_244;
  var tmp_245;
  var tmp_246;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_246 = $this$with.e38_1 === 1;
  } else {
    tmp_246 = false;
  }
  if (tmp_246) {
    tmp_245 = $this$with.f38_1 === 3;
  } else {
    tmp_245 = false;
  }
  if (tmp_245) {
    tmp_244 = $this$with.c39_1 === 0;
  } else {
    tmp_244 = false;
  }
  if (tmp_244) {
    tmp_243 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_243 = false;
  }
  if (tmp_243) {
    yield* $this.ce0($receiver, OnboardingHint_TheHuntersCanTryToCheckBolgin_getInstance(), $completion);
  }
  var tmp_247;
  var tmp_248;
  var tmp_249;
  var tmp_250;
  var tmp_251;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_251 = $this$with.e38_1 === 1;
  } else {
    tmp_251 = false;
  }
  if (tmp_251) {
    tmp_250 = $this$with.f38_1 === 3;
  } else {
    tmp_250 = false;
  }
  if (tmp_250) {
    tmp_249 = $this$with.c39_1 === 0;
  } else {
    tmp_249 = false;
  }
  if (tmp_249) {
    var tmp0_7 = gameQuestion.m4a_1;
    var tmp$ret$24;
    $l$block_18: {
      // Inline function 'kotlin.collections.any' call
      var tmp_252;
      if (isInterface(tmp0_7, Collection)) {
        tmp_252 = tmp0_7.n1();
      } else {
        tmp_252 = false;
      }
      if (tmp_252) {
        tmp$ret$24 = false;
        break $l$block_18;
      }
      var _iterator__ex2g4s_8 = tmp0_7.p1();
      while (_iterator__ex2g4s_8.q1()) {
        var element_8 = _iterator__ex2g4s_8.r1();
        var tmp_253 = get_objectType($this$with, element_8);
        if (isInterface(tmp_253, SettlerType)) {
          tmp$ret$24 = true;
          break $l$block_18;
        }
      }
      tmp$ret$24 = false;
    }
    tmp_248 = tmp$ret$24;
  } else {
    tmp_248 = false;
  }
  if (tmp_248) {
    tmp_247 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_247 = false;
  }
  if (tmp_247) {
    yield* $this.ce0($receiver, OnboardingHint_HuntersDonTKnowWhereBolginMoved_getInstance(), $completion);
  }
  var tmp_254;
  var tmp_255;
  var tmp_256;
  var tmp_257;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_257 = $this$with.e38_1 === 1;
  } else {
    tmp_257 = false;
  }
  if (tmp_257) {
    tmp_256 = $this$with.f38_1 === 3;
  } else {
    tmp_256 = false;
  }
  if (tmp_256) {
    var tmp47_safe_receiver = gameQuestion.y48_1;
    var tmp_258 = tmp47_safe_receiver == null ? null : get_objectType($this$with, tmp47_safe_receiver);
    tmp_255 = tmp_258 instanceof FarmerType;
  } else {
    tmp_255 = false;
  }
  if (tmp_255) {
    tmp_254 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_254 = false;
  }
  if (tmp_254) {
    yield* $this.ce0($receiver, OnboardingHint_MoveTheFarmerTypeOneStepUp_getInstance(), $completion);
  }
  var tmp_259;
  var tmp_260;
  var tmp_261;
  var tmp_262;
  var tmp_263;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_263 = $this$with.e38_1 === 1;
  } else {
    tmp_263 = false;
  }
  if (tmp_263) {
    tmp_262 = $this$with.f38_1 === 3;
  } else {
    tmp_262 = false;
  }
  if (tmp_262) {
    tmp_261 = $this$with.c39_1 === 0;
  } else {
    tmp_261 = false;
  }
  if (tmp_261) {
    var tmp0_8 = gameQuestion.m4a_1;
    var tmp$ret$26;
    $l$block_20: {
      // Inline function 'kotlin.collections.none' call
      var tmp_264;
      if (isInterface(tmp0_8, Collection)) {
        tmp_264 = tmp0_8.n1();
      } else {
        tmp_264 = false;
      }
      if (tmp_264) {
        tmp$ret$26 = true;
        break $l$block_20;
      }
      var _iterator__ex2g4s_9 = tmp0_8.p1();
      while (_iterator__ex2g4s_9.q1()) {
        var element_9 = _iterator__ex2g4s_9.r1();
        var tmp_265 = get_objectType($this$with, element_9);
        if (isInterface(tmp_265, SettlerType)) {
          tmp$ret$26 = false;
          break $l$block_20;
        }
      }
      tmp$ret$26 = true;
    }
    tmp_260 = tmp$ret$26;
  } else {
    tmp_260 = false;
  }
  if (tmp_260) {
    tmp_259 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_259 = false;
  }
  if (tmp_259) {
    yield* $this.ce0($receiver, OnboardingHint_TheTrailIsFoundSoLetS_getInstance(), $completion);
  }
  var tmp_266;
  var tmp_267;
  var tmp_268;
  var tmp_269;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_269 = $this$with.e38_1 === 1;
  } else {
    tmp_269 = false;
  }
  if (tmp_269) {
    tmp_268 = $this$with.f38_1 === 3;
  } else {
    tmp_268 = false;
  }
  if (tmp_268) {
    var tmp48_safe_receiver = gameQuestion.y48_1;
    var tmp_270 = tmp48_safe_receiver == null ? null : get_objectType($this$with, tmp48_safe_receiver);
    tmp_267 = tmp_270 instanceof Iona;
  } else {
    tmp_267 = false;
  }
  if (tmp_267) {
    tmp_266 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_266 = false;
  }
  if (tmp_266) {
    yield* $this.ce0($receiver, OnboardingHint_MoveIonaOneStepRight_getInstance(), $completion);
  }
  var tmp_271;
  var tmp_272;
  var tmp_273;
  var tmp_274;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_274 = $this$with.e38_1 === 1;
  } else {
    tmp_274 = false;
  }
  if (tmp_274) {
    tmp_273 = $this$with.f38_1 === 3;
  } else {
    tmp_273 = false;
  }
  if (tmp_273) {
    tmp_272 = $this$with.c39_1 === 1;
  } else {
    tmp_272 = false;
  }
  if (tmp_272) {
    tmp_271 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_271 = false;
  }
  if (tmp_271) {
    yield* $this.ce0($receiver, OnboardingHint_NowItIsAGoodTimeTo_getInstance(), $completion);
  }
  var tmp_275;
  var tmp_276;
  var tmp_277;
  var tmp_278;
  var tmp_279;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_279 = $this$with.e38_1 === 1;
  } else {
    tmp_279 = false;
  }
  if (tmp_279) {
    tmp_278 = $this$with.f38_1 === 3;
  } else {
    tmp_278 = false;
  }
  if (tmp_278) {
    tmp_277 = $this$with.c39_1 === 1;
  } else {
    tmp_277 = false;
  }
  if (tmp_277) {
    var tmp0_9 = gameQuestion.m4a_1;
    var tmp$ret$28;
    $l$block_22: {
      // Inline function 'kotlin.collections.any' call
      var tmp_280;
      if (isInterface(tmp0_9, Collection)) {
        tmp_280 = tmp0_9.n1();
      } else {
        tmp_280 = false;
      }
      if (tmp_280) {
        tmp$ret$28 = false;
        break $l$block_22;
      }
      var _iterator__ex2g4s_10 = tmp0_9.p1();
      while (_iterator__ex2g4s_10.q1()) {
        var element_10 = _iterator__ex2g4s_10.r1();
        var tmp_281 = get_objectType($this$with, element_10);
        if (tmp_281 instanceof Iona) {
          tmp$ret$28 = true;
          break $l$block_22;
        }
      }
      tmp$ret$28 = false;
    }
    tmp_276 = tmp$ret$28;
  } else {
    tmp_276 = false;
  }
  if (tmp_276) {
    tmp_275 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_275 = false;
  }
  if (tmp_275) {
    yield* $this.ce0($receiver, OnboardingHint_NoteThatDarkRitualsCardAlsoDeals_getInstance(), $completion);
  }
  var tmp_282;
  var tmp_283;
  var tmp_284;
  var tmp_285;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_285 = $this$with.e38_1 === 1;
  } else {
    tmp_285 = false;
  }
  if (tmp_285) {
    tmp_284 = $this$with.f38_1 === 3;
  } else {
    tmp_284 = false;
  }
  if (tmp_284) {
    tmp_283 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_283 = false;
  }
  if (tmp_283) {
    var tmp0_10 = get_hand($this$with, get_ionaHunter($this$with));
    var tmp$ret$30;
    $l$block_23: {
      // Inline function 'kotlin.collections.count' call
      var tmp_286;
      if (isInterface(tmp0_10, Collection)) {
        tmp_286 = tmp0_10.n1();
      } else {
        tmp_286 = false;
      }
      if (tmp_286) {
        tmp$ret$30 = 0;
        break $l$block_23;
      }
      var count = 0;
      var _iterator__ex2g4s_11 = tmp0_10.p1();
      while (_iterator__ex2g4s_11.q1()) {
        var element_11 = _iterator__ex2g4s_11.r1();
        if (isInterface(element_11, AbilityCard)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$30 = count;
    }
    tmp_282 = tmp$ret$30 === 1;
  } else {
    tmp_282 = false;
  }
  if (tmp_282) {
    yield* $this.ce0($receiver, OnboardingHint_TheSaferPlayWouldBeToReturn_getInstance(), $completion);
  }
  var tmp_287;
  var tmp_288;
  var tmp_289;
  var tmp_290;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_290 = $this$with.e38_1 === 1;
  } else {
    tmp_290 = false;
  }
  if (tmp_290) {
    tmp_289 = $this$with.f38_1 === 3;
  } else {
    tmp_289 = false;
  }
  if (tmp_289) {
    tmp_288 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_288 = false;
  }
  if (tmp_288) {
    var tmp0_11 = get_hand($this$with, get_ionaHunter($this$with));
    var tmp$ret$32;
    $l$block_24: {
      // Inline function 'kotlin.collections.count' call
      var tmp_291;
      if (isInterface(tmp0_11, Collection)) {
        tmp_291 = tmp0_11.n1();
      } else {
        tmp_291 = false;
      }
      if (tmp_291) {
        tmp$ret$32 = 0;
        break $l$block_24;
      }
      var count_0 = 0;
      var _iterator__ex2g4s_12 = tmp0_11.p1();
      while (_iterator__ex2g4s_12.q1()) {
        var element_12 = _iterator__ex2g4s_12.r1();
        if (isInterface(element_12, AbilityCard)) {
          count_0 = count_0 + 1 | 0;
          checkCountOverflow(count_0);
        }
      }
      tmp$ret$32 = count_0;
    }
    tmp_287 = tmp$ret$32 === 2;
  } else {
    tmp_287 = false;
  }
  if (tmp_287) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSReturnTheCommandCard_getInstance(), $completion);
  }
  var tmp_292;
  var tmp_293;
  var tmp_294;
  var tmp_295;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_295 = $this$with.e38_1 === 1;
  } else {
    tmp_295 = false;
  }
  if (tmp_295) {
    tmp_294 = $this$with.f38_1 === 3;
  } else {
    tmp_294 = false;
  }
  if (tmp_294) {
    tmp_293 = $this$with.c39_1 === 0;
  } else {
    tmp_293 = false;
  }
  if (tmp_293) {
    tmp_292 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_292 = false;
  }
  if (tmp_292) {
    yield* $this.ce0($receiver, OnboardingHint_NowTheHuntersNeedToProtectBoth_getInstance(), $completion);
  }
  var tmp_296;
  var tmp_297;
  var tmp_298;
  var tmp_299;
  var tmp_300;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_300 = $this$with.e38_1 === 1;
  } else {
    tmp_300 = false;
  }
  if (tmp_300) {
    tmp_299 = $this$with.f38_1 === 3;
  } else {
    tmp_299 = false;
  }
  if (tmp_299) {
    var tmp49_safe_receiver = gameQuestion.y48_1;
    var tmp_301 = tmp49_safe_receiver == null ? null : get_objectType($this$with, tmp49_safe_receiver);
    tmp_298 = tmp_301 instanceof Iona;
  } else {
    tmp_298 = false;
  }
  if (tmp_298) {
    tmp_297 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_297 = false;
  }
  if (tmp_297) {
    tmp_296 = !(get_ionaHunter($this$with).s2w($this$with) === get_bolginBeast($this$with).s2w($this$with));
  } else {
    tmp_296 = false;
  }
  if (tmp_296) {
    yield* $this.ce0($receiver, OnboardingHint_MoveIonaOneStepLeft_getInstance(), $completion);
  }
  var tmp_302;
  var tmp_303;
  var tmp_304;
  var tmp_305;
  var tmp_306;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_306 = $this$with.e38_1 === 1;
  } else {
    tmp_306 = false;
  }
  if (tmp_306) {
    tmp_305 = $this$with.f38_1 === 3;
  } else {
    tmp_305 = false;
  }
  if (tmp_305) {
    var tmp50_safe_receiver = gameQuestion.y48_1;
    var tmp_307 = tmp50_safe_receiver == null ? null : get_objectType($this$with, tmp50_safe_receiver);
    tmp_304 = tmp_307 instanceof Iona;
  } else {
    tmp_304 = false;
  }
  if (tmp_304) {
    tmp_303 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_303 = false;
  }
  if (tmp_303) {
    tmp_302 = get_ionaHunter($this$with).s2w($this$with) === get_bolginBeast($this$with).s2w($this$with);
  } else {
    tmp_302 = false;
  }
  if (tmp_302) {
    yield* $this.ce0($receiver, OnboardingHint_AndOneMoreStepLeft_getInstance(), $completion);
  }
  var tmp_308;
  var tmp_309;
  var tmp_310;
  var tmp_311;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_311 = $this$with.e38_1 === 1;
  } else {
    tmp_311 = false;
  }
  if (tmp_311) {
    tmp_310 = $this$with.f38_1 === 3;
  } else {
    tmp_310 = false;
  }
  if (tmp_310) {
    tmp_309 = $this$with.c39_1 === 1;
  } else {
    tmp_309 = false;
  }
  if (tmp_309) {
    tmp_308 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_308 = false;
  }
  if (tmp_308) {
    yield* $this.ce0($receiver, OnboardingHint_OkTheHuntersDiscoverThatBolginDid_getInstance(), $completion);
  }
  var tmp_312;
  var tmp_313;
  var tmp_314;
  var tmp_315;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_315 = $this$with.e38_1 === 1;
  } else {
    tmp_315 = false;
  }
  if (tmp_315) {
    tmp_314 = $this$with.f38_1 === 4;
  } else {
    tmp_314 = false;
  }
  if (tmp_314) {
    tmp_313 = $this$with.c39_1 === 0;
  } else {
    tmp_313 = false;
  }
  if (tmp_313) {
    tmp_312 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_312 = false;
  }
  if (tmp_312) {
    yield* $this.ce0($receiver, OnboardingHint_OkLetSTryToKillThe_getInstance(), $completion);
  }
  var tmp_316;
  var tmp_317;
  var tmp_318;
  var tmp_319;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_319 = $this$with.e38_1 === 1;
  } else {
    tmp_319 = false;
  }
  if (tmp_319) {
    tmp_318 = $this$with.f38_1 === 4;
  } else {
    tmp_318 = false;
  }
  if (tmp_318) {
    tmp_317 = $this$with.c39_1 === 0;
  } else {
    tmp_317 = false;
  }
  if (tmp_317) {
    tmp_316 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_316 = false;
  }
  if (tmp_316) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPerformTheAttackFirst_getInstance(), $completion);
  }
  var tmp_320;
  var tmp_321;
  var tmp_322;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_322 = $this$with.e38_1 === 1;
  } else {
    tmp_322 = false;
  }
  if (tmp_322) {
    tmp_321 = $this$with.f38_1 === 4;
  } else {
    tmp_321 = false;
  }
  if (tmp_321) {
    tmp_320 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_320 = false;
  }
  if (tmp_320) {
    yield* $this.ce0($receiver, OnboardingHint_AttackFarmerType_getInstance(), $completion);
  }
  var tmp_323;
  var tmp_324;
  var tmp_325;
  if (gameQuestion instanceof AncientPowerNumberQuestion) {
    tmp_325 = $this$with.e38_1 === 1;
  } else {
    tmp_325 = false;
  }
  if (tmp_325) {
    tmp_324 = $this$with.f38_1 === 4;
  } else {
    tmp_324 = false;
  }
  if (tmp_324) {
    tmp_323 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_323 = false;
  }
  if (tmp_323) {
    yield* $this.ce0($receiver, OnboardingHint_LetSKillTheFarmerTypeInOne_getInstance(), $completion);
  }
  var tmp_326;
  var tmp_327;
  var tmp_328;
  if (gameQuestion instanceof TriggersQuestion) {
    tmp_328 = $this$with.e38_1 === 1;
  } else {
    tmp_328 = false;
  }
  if (tmp_328) {
    tmp_327 = $this$with.f38_1 === 4;
  } else {
    tmp_327 = false;
  }
  if (tmp_327) {
    tmp_326 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_326 = false;
  }
  if (tmp_326) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowItIsAGoodTime_getInstance(), $completion);
  }
  var tmp_329;
  var tmp_330;
  var tmp_331;
  var tmp_332;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_332 = $this$with.e38_1 === 1;
  } else {
    tmp_332 = false;
  }
  if (tmp_332) {
    tmp_331 = $this$with.f38_1 === 4;
  } else {
    tmp_331 = false;
  }
  if (tmp_331) {
    tmp_330 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_330 = false;
  }
  if (tmp_330) {
    tmp_329 = equals(gameQuestion.m48_1, ArsenalCardToGainQuestionContext_getInstance());
  } else {
    tmp_329 = false;
  }
  if (tmp_329) {
    yield* $this.ce0($receiver, OnboardingHint_OkBolginFailedToKillTheFarmerType_getInstance(), $completion);
  }
  var tmp_333;
  var tmp_334;
  var tmp_335;
  var tmp_336;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_336 = $this$with.e38_1 === 1;
  } else {
    tmp_336 = false;
  }
  if (tmp_336) {
    tmp_335 = $this$with.f38_1 === 4;
  } else {
    tmp_335 = false;
  }
  if (tmp_335) {
    tmp_334 = $this$with.c39_1 === 1;
  } else {
    tmp_334 = false;
  }
  if (tmp_334) {
    tmp_333 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_333 = false;
  }
  if (tmp_333) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheEvolveCardTo_getInstance(), $completion);
  }
  var tmp_337;
  var tmp_338;
  var tmp_339;
  var tmp_340;
  var tmp_341;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_341 = $this$with.e38_1 === 1;
  } else {
    tmp_341 = false;
  }
  if (tmp_341) {
    tmp_340 = $this$with.f38_1 === 4;
  } else {
    tmp_340 = false;
  }
  if (tmp_340) {
    tmp_339 = $this$with.c39_1 === 1;
  } else {
    tmp_339 = false;
  }
  if (tmp_339) {
    tmp_338 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_338 = false;
  }
  if (tmp_338) {
    tmp_337 = get_isRevealed($this$with, get_bolginBeast($this$with));
  } else {
    tmp_337 = false;
  }
  if (tmp_337) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveFirst_getInstance(), $completion);
  }
  var tmp_342;
  var tmp_343;
  var tmp_344;
  var tmp_345;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_345 = $this$with.e38_1 === 1;
  } else {
    tmp_345 = false;
  }
  if (tmp_345) {
    tmp_344 = $this$with.f38_1 === 4;
  } else {
    tmp_344 = false;
  }
  if (tmp_344) {
    tmp_343 = $this$with.c39_1 === 1;
  } else {
    tmp_343 = false;
  }
  if (tmp_343) {
    tmp_342 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_342 = false;
  }
  if (tmp_342) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveOneStepToThe_getInstance(), $completion);
  }
  var tmp_346;
  var tmp_347;
  var tmp_348;
  var tmp_349;
  var tmp_350;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_350 = $this$with.e38_1 === 1;
  } else {
    tmp_350 = false;
  }
  if (tmp_350) {
    tmp_349 = $this$with.f38_1 === 4;
  } else {
    tmp_349 = false;
  }
  if (tmp_349) {
    tmp_348 = $this$with.c39_1 === 1;
  } else {
    tmp_348 = false;
  }
  if (tmp_348) {
    tmp_347 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_347 = false;
  }
  if (tmp_347) {
    tmp_346 = get_isHidden($this$with, get_bolginBeast($this$with));
  } else {
    tmp_346 = false;
  }
  if (tmp_346) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSUpgradeBolgin_getInstance(), $completion);
  }
  var tmp_351;
  var tmp_352;
  var tmp_353;
  var tmp_354;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_354 = $this$with.e38_1 === 1;
  } else {
    tmp_354 = false;
  }
  if (tmp_354) {
    tmp_353 = $this$with.f38_1 === 4;
  } else {
    tmp_353 = false;
  }
  if (tmp_353) {
    tmp_352 = $this$with.c39_1 === 1;
  } else {
    tmp_352 = false;
  }
  if (tmp_352) {
    tmp_351 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_351 = false;
  }
  if (tmp_351) {
    yield* $this.ce0($receiver, OnboardingHint_SoLetSIncreaseBolginSMobility_getInstance(), $completion);
  }
  var tmp_355;
  var tmp_356;
  var tmp_357;
  var tmp_358;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_358 = $this$with.e38_1 === 1;
  } else {
    tmp_358 = false;
  }
  if (tmp_358) {
    tmp_357 = $this$with.f38_1 === 4;
  } else {
    tmp_357 = false;
  }
  if (tmp_357) {
    tmp_356 = $this$with.c39_1 === 0;
  } else {
    tmp_356 = false;
  }
  if (tmp_356) {
    tmp_355 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_355 = false;
  }
  if (tmp_355) {
    yield* $this.ce0($receiver, OnboardingHint_FinallyLetSRelocateHelgaCloserTo_getInstance(), $completion);
  }
  var tmp_359;
  var tmp_360;
  var tmp_361;
  var tmp_362;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_362 = $this$with.e38_1 === 1;
  } else {
    tmp_362 = false;
  }
  if (tmp_362) {
    tmp_361 = $this$with.f38_1 === 4;
  } else {
    tmp_361 = false;
  }
  if (tmp_361) {
    tmp_360 = $this$with.c39_1 === 0;
  } else {
    tmp_360 = false;
  }
  if (tmp_360) {
    tmp_359 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_359 = false;
  }
  if (tmp_359) {
    yield* $this.ce0($receiver, OnboardingHint_LetSRelocateHelgaFirstAndCheck_getInstance(), $completion);
  }
  var tmp_363;
  var tmp_364;
  var tmp_365;
  var tmp_366;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_366 = $this$with.e38_1 === 1;
  } else {
    tmp_366 = false;
  }
  if (tmp_366) {
    tmp_365 = $this$with.f38_1 === 4;
  } else {
    tmp_365 = false;
  }
  if (tmp_365) {
    tmp_364 = $this$with.c39_1 === 0;
  } else {
    tmp_364 = false;
  }
  if (tmp_364) {
    tmp_363 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_363 = false;
  }
  if (tmp_363) {
    yield* $this.ce0($receiver, OnboardingHint_ChooseNewArksteadAsTheDestination_getInstance(), $completion);
  }
  var tmp_367;
  var tmp_368;
  var tmp_369;
  var tmp_370;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_370 = $this$with.e38_1 === 1;
  } else {
    tmp_370 = false;
  }
  if (tmp_370) {
    tmp_369 = $this$with.f38_1 === 4;
  } else {
    tmp_369 = false;
  }
  if (tmp_369) {
    tmp_368 = $this$with.c39_1 === 0;
  } else {
    tmp_368 = false;
  }
  if (tmp_368) {
    tmp_367 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_367 = false;
  }
  if (tmp_367) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickAnUnknownCard_getInstance(), $completion);
  }
  var tmp_371;
  var tmp_372;
  var tmp_373;
  var tmp_374;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_374 = $this$with.e38_1 === 1;
  } else {
    tmp_374 = false;
  }
  if (tmp_374) {
    tmp_373 = $this$with.f38_1 === 4;
  } else {
    tmp_373 = false;
  }
  if (tmp_373) {
    tmp_372 = $this$with.c39_1 === 0;
  } else {
    tmp_372 = false;
  }
  if (tmp_372) {
    tmp_371 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_371 = false;
  }
  if (tmp_371) {
    yield* $this.ce0($receiver, OnboardingHint_TheHuntersKnowWhereBolginIsRight_getInstance(), $completion);
  }
  var tmp_375;
  var tmp_376;
  var tmp_377;
  var tmp_378;
  var tmp_379;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_379 = $this$with.e38_1 === 1;
  } else {
    tmp_379 = false;
  }
  if (tmp_379) {
    tmp_378 = $this$with.f38_1 === 4;
  } else {
    tmp_378 = false;
  }
  if (tmp_378) {
    tmp_377 = $this$with.c39_1 === 0;
  } else {
    tmp_377 = false;
  }
  if (tmp_377) {
    var tmp0_12 = gameQuestion.m4a_1;
    var tmp$ret$34;
    $l$block_26: {
      // Inline function 'kotlin.collections.any' call
      var tmp_380;
      if (isInterface(tmp0_12, Collection)) {
        tmp_380 = tmp0_12.n1();
      } else {
        tmp_380 = false;
      }
      if (tmp_380) {
        tmp$ret$34 = false;
        break $l$block_26;
      }
      var _iterator__ex2g4s_13 = tmp0_12.p1();
      while (_iterator__ex2g4s_13.q1()) {
        var element_13 = _iterator__ex2g4s_13.r1();
        var tmp_381 = get_objectType($this$with, element_13);
        if (isInterface(tmp_381, HunterCharacter)) {
          tmp$ret$34 = true;
          break $l$block_26;
        }
      }
      tmp$ret$34 = false;
    }
    tmp_376 = tmp$ret$34;
  } else {
    tmp_376 = false;
  }
  if (tmp_376) {
    tmp_375 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_375 = false;
  }
  if (tmp_375) {
    yield* $this.ce0($receiver, OnboardingHint_LetSStartByMovingIona_getInstance(), $completion);
  }
  var tmp_382;
  var tmp_383;
  var tmp_384;
  var tmp_385;
  var tmp_386;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_386 = $this$with.e38_1 === 1;
  } else {
    tmp_386 = false;
  }
  if (tmp_386) {
    tmp_385 = $this$with.f38_1 === 4;
  } else {
    tmp_385 = false;
  }
  if (tmp_385) {
    tmp_384 = $this$with.c39_1 === 0;
  } else {
    tmp_384 = false;
  }
  if (tmp_384) {
    var tmp51_safe_receiver = gameQuestion.y48_1;
    var tmp_387 = tmp51_safe_receiver == null ? null : get_objectType($this$with, tmp51_safe_receiver);
    tmp_383 = tmp_387 instanceof Iona;
  } else {
    tmp_383 = false;
  }
  if (tmp_383) {
    tmp_382 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_382 = false;
  }
  if (tmp_382) {
    yield* $this.ce0($receiver, OnboardingHint_MoveIonaOneStepSouth_getInstance(), $completion);
  }
  var tmp_388;
  var tmp_389;
  var tmp_390;
  var tmp_391;
  var tmp_392;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_392 = $this$with.e38_1 === 1;
  } else {
    tmp_392 = false;
  }
  if (tmp_392) {
    tmp_391 = $this$with.f38_1 === 4;
  } else {
    tmp_391 = false;
  }
  if (tmp_391) {
    tmp_390 = $this$with.c39_1 === 0;
  } else {
    tmp_390 = false;
  }
  if (tmp_390) {
    var tmp0_13 = gameQuestion.m4a_1;
    var tmp$ret$36;
    $l$block_28: {
      // Inline function 'kotlin.collections.any' call
      var tmp_393;
      if (isInterface(tmp0_13, Collection)) {
        tmp_393 = tmp0_13.n1();
      } else {
        tmp_393 = false;
      }
      if (tmp_393) {
        tmp$ret$36 = false;
        break $l$block_28;
      }
      var _iterator__ex2g4s_14 = tmp0_13.p1();
      while (_iterator__ex2g4s_14.q1()) {
        var element_14 = _iterator__ex2g4s_14.r1();
        var tmp_394 = get_objectType($this$with, element_14);
        if (isInterface(tmp_394, HunterCharacter)) {
          tmp$ret$36 = true;
          break $l$block_28;
        }
      }
      tmp$ret$36 = false;
    }
    tmp_389 = !tmp$ret$36;
  } else {
    tmp_389 = false;
  }
  if (tmp_389) {
    tmp_388 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_388 = false;
  }
  if (tmp_388) {
    yield* $this.ce0($receiver, OnboardingHint_ThenLetSMoveTheWoundedFarmerType_getInstance(), $completion);
  }
  var tmp_395;
  var tmp_396;
  var tmp_397;
  var tmp_398;
  var tmp_399;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_399 = $this$with.e38_1 === 1;
  } else {
    tmp_399 = false;
  }
  if (tmp_399) {
    tmp_398 = $this$with.f38_1 === 4;
  } else {
    tmp_398 = false;
  }
  if (tmp_398) {
    tmp_397 = $this$with.c39_1 === 0;
  } else {
    tmp_397 = false;
  }
  if (tmp_397) {
    var tmp52_safe_receiver = gameQuestion.y48_1;
    var tmp_400 = tmp52_safe_receiver == null ? null : get_objectType($this$with, tmp52_safe_receiver);
    tmp_396 = tmp_400 instanceof FarmerType;
  } else {
    tmp_396 = false;
  }
  if (tmp_396) {
    tmp_395 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_395 = false;
  }
  if (tmp_395) {
    yield* $this.ce0($receiver, OnboardingHint_MoveTheFarmerTypeToTheRight_getInstance(), $completion);
  }
  var tmp_401;
  var tmp_402;
  var tmp_403;
  var tmp_404;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_404 = $this$with.e38_1 === 1;
  } else {
    tmp_404 = false;
  }
  if (tmp_404) {
    tmp_403 = $this$with.f38_1 === 4;
  } else {
    tmp_403 = false;
  }
  if (tmp_403) {
    tmp_402 = $this$with.c39_1 === 1;
  } else {
    tmp_402 = false;
  }
  if (tmp_402) {
    tmp_401 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_401 = false;
  }
  if (tmp_401) {
    yield* $this.ce0($receiver, OnboardingHint_LetSTalkNowAboutTrapSignTraps_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SoLetSPlayTheFireTrap_getInstance(), $completion);
  }
  var tmp_405;
  var tmp_406;
  var tmp_407;
  if (gameQuestion instanceof ZoneQuestion) {
    tmp_407 = $this$with.e38_1 === 1;
  } else {
    tmp_407 = false;
  }
  if (tmp_407) {
    tmp_406 = $this$with.f38_1 === 4;
  } else {
    tmp_406 = false;
  }
  if (tmp_406) {
    tmp_405 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_405 = false;
  }
  if (tmp_405) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlaceItInTheNew_getInstance(), $completion);
  }
  var tmp_408;
  var tmp_409;
  var tmp_410;
  if (gameQuestion instanceof LocationTypeQuestion) {
    tmp_410 = $this$with.e38_1 === 1;
  } else {
    tmp_410 = false;
  }
  if (tmp_410) {
    tmp_409 = $this$with.f38_1 === 4;
  } else {
    tmp_409 = false;
  }
  if (tmp_409) {
    tmp_408 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_408 = false;
  }
  if (tmp_408) {
    yield* $this.ce0($receiver, OnboardingHint_TheHuntersHaveNowPreparedIonaTo_getInstance(), $completion);
  }
  var tmp_411;
  var tmp_412;
  var tmp_413;
  var tmp_414;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_414 = $this$with.e38_1 === 1;
  } else {
    tmp_414 = false;
  }
  if (tmp_414) {
    tmp_413 = $this$with.f38_1 === 4;
  } else {
    tmp_413 = false;
  }
  if (tmp_413) {
    tmp_412 = $this$with.c39_1 === 0;
  } else {
    tmp_412 = false;
  }
  if (tmp_412) {
    tmp_411 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_411 = false;
  }
  if (tmp_411) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheAvariceCardTo_getInstance(), $completion);
  }
  var tmp_415;
  var tmp_416;
  var tmp_417;
  var tmp_418;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_418 = $this$with.e38_1 === 1;
  } else {
    tmp_418 = false;
  }
  if (tmp_418) {
    tmp_417 = $this$with.f38_1 === 4;
  } else {
    tmp_417 = false;
  }
  if (tmp_417) {
    tmp_416 = $this$with.c39_1 === 0;
  } else {
    tmp_416 = false;
  }
  if (tmp_416) {
    tmp_415 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_415 = false;
  }
  if (tmp_415) {
    yield* $this.ce0($receiver, OnboardingHint_TheAvariceCardGivesAnActionTo_getInstance(), $completion);
  }
  var tmp_419;
  var tmp_420;
  var tmp_421;
  var tmp_422;
  var tmp_423;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_423 = $this$with.e38_1 === 1;
  } else {
    tmp_423 = false;
  }
  if (tmp_423) {
    tmp_422 = $this$with.f38_1 === 4;
  } else {
    tmp_422 = false;
  }
  if (tmp_422) {
    tmp_421 = $this$with.c39_1 === 0;
  } else {
    tmp_421 = false;
  }
  if (tmp_421) {
    var tmp53_safe_receiver = gameQuestion.y48_1;
    var tmp_424 = tmp53_safe_receiver == null ? null : get_objectType($this$with, tmp53_safe_receiver);
    tmp_420 = tmp_424 instanceof Iona;
  } else {
    tmp_420 = false;
  }
  if (tmp_420) {
    tmp_419 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_419 = false;
  }
  if (tmp_419) {
    yield* $this.ce0($receiver, OnboardingHint_MoveIonaToTheRight_getInstance(), $completion);
  }
  var tmp_425;
  var tmp_426;
  var tmp_427;
  var tmp_428;
  var tmp_429;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_429 = $this$with.e38_1 === 1;
  } else {
    tmp_429 = false;
  }
  if (tmp_429) {
    tmp_428 = $this$with.f38_1 === 4;
  } else {
    tmp_428 = false;
  }
  if (tmp_428) {
    tmp_427 = $this$with.c39_1 === 0;
  } else {
    tmp_427 = false;
  }
  if (tmp_427) {
    var tmp54_safe_receiver = gameQuestion.y48_1;
    var tmp_430 = tmp54_safe_receiver == null ? null : get_objectType($this$with, tmp54_safe_receiver);
    tmp_426 = tmp_430 instanceof Helga;
  } else {
    tmp_426 = false;
  }
  if (tmp_426) {
    tmp_425 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_425 = false;
  }
  if (tmp_425) {
    yield* $this.ce0($receiver, OnboardingHint_TheAvariceCardAllowsAttacksOnlyAgainst_getInstance(), $completion);
  }
  var tmp_431;
  var tmp_432;
  var tmp_433;
  var tmp_434;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_434 = $this$with.e38_1 === 1;
  } else {
    tmp_434 = false;
  }
  if (tmp_434) {
    tmp_433 = $this$with.f38_1 === 4;
  } else {
    tmp_433 = false;
  }
  if (tmp_433) {
    tmp_432 = $this$with.c39_1 === 1;
  } else {
    tmp_432 = false;
  }
  if (tmp_432) {
    tmp_431 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_431 = false;
  }
  if (tmp_431) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSPlayTheHunt_getInstance(), $completion);
  }
  var tmp_435;
  var tmp_436;
  var tmp_437;
  if (gameQuestion instanceof TriggersQuestion) {
    tmp_437 = $this$with.e38_1 === 1;
  } else {
    tmp_437 = false;
  }
  if (tmp_437) {
    tmp_436 = $this$with.f38_1 === 4;
  } else {
    tmp_436 = false;
  }
  if (tmp_436) {
    tmp_435 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_435 = false;
  }
  if (tmp_435) {
    yield* $this.ce0($receiver, OnboardingHint_SoBeforeTheAttackIonaSearchedAnd_getInstance(), $completion);
  }
  var tmp_438;
  var tmp_439;
  var tmp_440;
  var tmp_441;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_441 = $this$with.e38_1 === 1;
  } else {
    tmp_441 = false;
  }
  if (tmp_441) {
    tmp_440 = $this$with.f38_1 === 5;
  } else {
    tmp_440 = false;
  }
  if (tmp_440) {
    tmp_439 = $this$with.c39_1 === 0;
  } else {
    tmp_439 = false;
  }
  if (tmp_439) {
    tmp_438 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_438 = false;
  }
  if (tmp_438) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheHasteCard_getInstance(), $completion);
  }
  var tmp_442;
  var tmp_443;
  var tmp_444;
  var tmp_445;
  var tmp_446;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_446 = $this$with.e38_1 === 1;
  } else {
    tmp_446 = false;
  }
  if (tmp_446) {
    tmp_445 = $this$with.f38_1 === 5;
  } else {
    tmp_445 = false;
  }
  if (tmp_445) {
    tmp_444 = $this$with.c39_1 === 0;
  } else {
    tmp_444 = false;
  }
  if (tmp_444) {
    var tmp0_14 = gameQuestion.d4b_1;
    var tmp$ret$38;
    $l$block_30: {
      // Inline function 'kotlin.collections.any' call
      var tmp_447;
      if (isInterface(tmp0_14, Collection)) {
        tmp_447 = tmp0_14.n1();
      } else {
        tmp_447 = false;
      }
      if (tmp_447) {
        tmp$ret$38 = false;
        break $l$block_30;
      }
      var _iterator__ex2g4s_15 = tmp0_14.p1();
      while (_iterator__ex2g4s_15.q1()) {
        var element_15 = _iterator__ex2g4s_15.r1();
        if (element_15 instanceof SimpleBeastMovementStatement) {
          tmp$ret$38 = true;
          break $l$block_30;
        }
      }
      tmp$ret$38 = false;
    }
    tmp_443 = tmp$ret$38;
  } else {
    tmp_443 = false;
  }
  if (tmp_443) {
    tmp_442 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_442 = false;
  }
  if (tmp_442) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveBolginFirst_getInstance(), $completion);
  }
  var tmp_448;
  var tmp_449;
  var tmp_450;
  var tmp_451;
  var tmp_452;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_452 = $this$with.e38_1 === 1;
  } else {
    tmp_452 = false;
  }
  if (tmp_452) {
    tmp_451 = $this$with.f38_1 === 5;
  } else {
    tmp_451 = false;
  }
  if (tmp_451) {
    tmp_450 = $this$with.c39_1 === 0;
  } else {
    tmp_450 = false;
  }
  if (tmp_450) {
    var tmp55_safe_receiver = gameQuestion.y48_1;
    var tmp_453 = tmp55_safe_receiver == null ? null : get_objectType($this$with, tmp55_safe_receiver);
    tmp_449 = tmp_453 instanceof Bolgin;
  } else {
    tmp_449 = false;
  }
  if (tmp_449) {
    tmp_448 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_448 = false;
  }
  if (tmp_448) {
    if (gameQuestion.z48_1.s2() === 1) {
      yield* $this.ce0($receiver, OnboardingHint_LetSMoveBolginOneMoreStep2_getInstance(), $completion);
    }
    if (gameQuestion.z48_1.s2() === 2) {
      yield* $this.ce0($receiver, OnboardingHint_AndNowLetSMoveBolginInto_getInstance(), $completion);
    }
  }
  var tmp_454;
  var tmp_455;
  var tmp_456;
  var tmp_457;
  if (gameQuestion instanceof TriggersQuestion) {
    tmp_457 = $this$with.e38_1 === 1;
  } else {
    tmp_457 = false;
  }
  if (tmp_457) {
    tmp_456 = $this$with.f38_1 === 5;
  } else {
    tmp_456 = false;
  }
  if (tmp_456) {
    tmp_455 = $this$with.c39_1 === 0;
  } else {
    tmp_455 = false;
  }
  if (tmp_455) {
    tmp_454 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_454 = false;
  }
  if (tmp_454) {
    yield* $this.ce0($receiver, OnboardingHint_BolginDecidesToFinishTheWoundedFarmerType_getInstance(), $completion);
  }
  var tmp_458;
  var tmp_459;
  var tmp_460;
  var tmp_461;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_461 = $this$with.e38_1 === 1;
  } else {
    tmp_461 = false;
  }
  if (tmp_461) {
    tmp_460 = $this$with.f38_1 === 5;
  } else {
    tmp_460 = false;
  }
  if (tmp_460) {
    tmp_459 = $this$with.c39_1 === 0;
  } else {
    tmp_459 = false;
  }
  if (tmp_459) {
    tmp_458 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_458 = false;
  }
  if (tmp_458) {
    yield* $this.ce0($receiver, OnboardingHint_InMostCasesYouWantToMove_getInstance(), $completion);
  }
  var tmp_462;
  var tmp_463;
  var tmp_464;
  var tmp_465;
  var tmp_466;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_466 = $this$with.e38_1 === 1;
  } else {
    tmp_466 = false;
  }
  if (tmp_466) {
    tmp_465 = $this$with.f38_1 === 5;
  } else {
    tmp_465 = false;
  }
  if (tmp_465) {
    tmp_464 = $this$with.c39_1 === 0;
  } else {
    tmp_464 = false;
  }
  if (tmp_464) {
    var tmp56_safe_receiver = gameQuestion.y48_1;
    var tmp_467 = tmp56_safe_receiver == null ? null : get_objectType($this$with, tmp56_safe_receiver);
    tmp_463 = tmp_467 instanceof FarmerType;
  } else {
    tmp_463 = false;
  }
  if (tmp_463) {
    tmp_462 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_462 = false;
  }
  if (tmp_462) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveTheFarmerTypeOneStep_getInstance(), $completion);
  }
  var tmp_468;
  var tmp_469;
  var tmp_470;
  var tmp_471;
  var tmp_472;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_472 = $this$with.e38_1 === 1;
  } else {
    tmp_472 = false;
  }
  if (tmp_472) {
    tmp_471 = $this$with.f38_1 === 5;
  } else {
    tmp_471 = false;
  }
  if (tmp_471) {
    tmp_470 = $this$with.c39_1 === 0;
  } else {
    tmp_470 = false;
  }
  if (tmp_470) {
    var tmp0_15 = gameQuestion.d4b_1;
    var tmp$ret$40;
    $l$block_32: {
      // Inline function 'kotlin.collections.none' call
      var tmp_473;
      if (isInterface(tmp0_15, Collection)) {
        tmp_473 = tmp0_15.n1();
      } else {
        tmp_473 = false;
      }
      if (tmp_473) {
        tmp$ret$40 = true;
        break $l$block_32;
      }
      var _iterator__ex2g4s_16 = tmp0_15.p1();
      while (_iterator__ex2g4s_16.q1()) {
        var element_16 = _iterator__ex2g4s_16.r1();
        if (element_16 instanceof SimpleBeastMovementStatement) {
          tmp$ret$40 = false;
          break $l$block_32;
        }
      }
      tmp$ret$40 = true;
    }
    tmp_469 = tmp$ret$40;
  } else {
    tmp_469 = false;
  }
  if (tmp_469) {
    tmp_468 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_468 = false;
  }
  if (tmp_468) {
    yield* $this.ce0($receiver, OnboardingHint_MovementAndReactionsHaveFinishedSoBolgin_getInstance(), $completion);
  }
  var tmp_474;
  var tmp_475;
  var tmp_476;
  var tmp_477;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_477 = $this$with.e38_1 === 1;
  } else {
    tmp_477 = false;
  }
  if (tmp_477) {
    tmp_476 = $this$with.f38_1 === 5;
  } else {
    tmp_476 = false;
  }
  if (tmp_476) {
    tmp_475 = $this$with.c39_1 === 1;
  } else {
    tmp_475 = false;
  }
  if (tmp_475) {
    tmp_474 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_474 = false;
  }
  if (tmp_474) {
    yield* $this.ce0($receiver, OnboardingHint_AsTheSecondCardLetSPlay_getInstance(), $completion);
  }
  var tmp_478;
  var tmp_479;
  var tmp_480;
  var tmp_481;
  if (gameQuestion instanceof PlaceNewObjectQuestion) {
    tmp_481 = $this$with.e38_1 === 1;
  } else {
    tmp_481 = false;
  }
  if (tmp_481) {
    tmp_480 = $this$with.f38_1 === 5;
  } else {
    tmp_480 = false;
  }
  if (tmp_480) {
    tmp_479 = $this$with.c39_1 === 1;
  } else {
    tmp_479 = false;
  }
  if (tmp_479) {
    tmp_478 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_478 = false;
  }
  if (tmp_478) {
    yield* $this.ce0($receiver, OnboardingHint_TheAnimateCardHasTheThenKeyword_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_SoFirstYouMustPerformSummonActivationBecause_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlaceItNearFarmerTypeFrom_getInstance(), $completion);
  }
  var tmp_482;
  var tmp_483;
  var tmp_484;
  var tmp_485;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_485 = $this$with.e38_1 === 1;
  } else {
    tmp_485 = false;
  }
  if (tmp_485) {
    tmp_484 = $this$with.f38_1 === 5;
  } else {
    tmp_484 = false;
  }
  if (tmp_484) {
    tmp_483 = $this$with.c39_1 === 1;
  } else {
    tmp_483 = false;
  }
  if (tmp_483) {
    tmp_482 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_482 = false;
  }
  if (tmp_482) {
    yield* $this.ce0($receiver, OnboardingHint_ThirteenActionCardsWereDealtDuringThe_getInstance(), $completion);
  }
  var tmp_486;
  var tmp_487;
  var tmp_488;
  var tmp_489;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_489 = $this$with.e38_1 === 1;
  } else {
    tmp_489 = false;
  }
  if (tmp_489) {
    tmp_488 = $this$with.f38_1 === 5;
  } else {
    tmp_488 = false;
  }
  if (tmp_488) {
    tmp_487 = $this$with.c39_1 === 0;
  } else {
    tmp_487 = false;
  }
  if (tmp_487) {
    tmp_486 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_486 = false;
  }
  if (tmp_486) {
    yield* $this.ce0($receiver, OnboardingHint_HelgaAndIonaInTheSameLocation_getInstance(), $completion);
  }
  var tmp_490;
  var tmp_491;
  var tmp_492;
  var tmp_493;
  var tmp_494;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_494 = $this$with.e38_1 === 1;
  } else {
    tmp_494 = false;
  }
  if (tmp_494) {
    tmp_493 = $this$with.f38_1 === 5;
  } else {
    tmp_493 = false;
  }
  if (tmp_493) {
    tmp_492 = $this$with.c39_1 === 0;
  } else {
    tmp_492 = false;
  }
  if (tmp_492) {
    tmp_491 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_491 = false;
  }
  if (tmp_491) {
    var tmp0_16 = gameQuestion.m4a_1;
    var tmp$ret$42;
    $l$block_34: {
      // Inline function 'kotlin.collections.any' call
      var tmp_495;
      if (isInterface(tmp0_16, Collection)) {
        tmp_495 = tmp0_16.n1();
      } else {
        tmp_495 = false;
      }
      if (tmp_495) {
        tmp$ret$42 = false;
        break $l$block_34;
      }
      var _iterator__ex2g4s_17 = tmp0_16.p1();
      while (_iterator__ex2g4s_17.q1()) {
        var element_17 = _iterator__ex2g4s_17.r1();
        var tmp_496 = get_objectType($this$with, element_17);
        if (tmp_496 instanceof Helga) {
          tmp$ret$42 = true;
          break $l$block_34;
        }
      }
      tmp$ret$42 = false;
    }
    tmp_490 = tmp$ret$42;
  } else {
    tmp_490 = false;
  }
  if (tmp_490) {
    yield* $this.ce0($receiver, OnboardingHint_LetSStartWithHelga_getInstance(), $completion);
  }
  var tmp_497;
  var tmp_498;
  var tmp_499;
  var tmp_500;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_500 = $this$with.e38_1 === 1;
  } else {
    tmp_500 = false;
  }
  if (tmp_500) {
    tmp_499 = $this$with.f38_1 === 5;
  } else {
    tmp_499 = false;
  }
  if (tmp_499) {
    tmp_498 = $this$with.c39_1 === 0;
  } else {
    tmp_498 = false;
  }
  if (tmp_498) {
    var tmp0_17 = get_hand($this$with, get_helgaHunter($this$with));
    var tmp$ret$44;
    $l$block_36: {
      // Inline function 'kotlin.collections.none' call
      var tmp_501;
      if (isInterface(tmp0_17, Collection)) {
        tmp_501 = tmp0_17.n1();
      } else {
        tmp_501 = false;
      }
      if (tmp_501) {
        tmp$ret$44 = true;
        break $l$block_36;
      }
      var _iterator__ex2g4s_18 = tmp0_17.p1();
      while (_iterator__ex2g4s_18.q1()) {
        var element_18 = _iterator__ex2g4s_18.r1();
        if (isInterface(element_18, HunterItemCard)) {
          tmp$ret$44 = false;
          break $l$block_36;
        }
      }
      tmp$ret$44 = true;
    }
    tmp_497 = tmp$ret$44;
  } else {
    tmp_497 = false;
  }
  if (tmp_497) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheUnknownHunterItem_getInstance(), $completion);
  }
  var tmp_502;
  var tmp_503;
  var tmp_504;
  var tmp_505;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_505 = $this$with.e38_1 === 1;
  } else {
    tmp_505 = false;
  }
  if (tmp_505) {
    tmp_504 = $this$with.f38_1 === 5;
  } else {
    tmp_504 = false;
  }
  if (tmp_504) {
    tmp_503 = $this$with.c39_1 === 0;
  } else {
    tmp_503 = false;
  }
  if (tmp_503) {
    var tmp0_18 = get_hand($this$with, get_helgaHunter($this$with));
    var tmp$ret$46;
    $l$block_38: {
      // Inline function 'kotlin.collections.any' call
      var tmp_506;
      if (isInterface(tmp0_18, Collection)) {
        tmp_506 = tmp0_18.n1();
      } else {
        tmp_506 = false;
      }
      if (tmp_506) {
        tmp$ret$46 = false;
        break $l$block_38;
      }
      var _iterator__ex2g4s_19 = tmp0_18.p1();
      while (_iterator__ex2g4s_19.q1()) {
        var element_19 = _iterator__ex2g4s_19.r1();
        if (isInterface(element_19, HunterItemCard)) {
          tmp$ret$46 = true;
          break $l$block_38;
        }
      }
      tmp$ret$46 = false;
    }
    tmp_502 = tmp$ret$46;
  } else {
    tmp_502 = false;
  }
  if (tmp_502) {
    yield* $this.ce0($receiver, OnboardingHint_LetSAlsoPickTheUnknownHunter_getInstance(), $completion);
  }
  var tmp_507;
  var tmp_508;
  var tmp_509;
  var tmp_510;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_510 = $this$with.e38_1 === 1;
  } else {
    tmp_510 = false;
  }
  if (tmp_510) {
    tmp_509 = $this$with.f38_1 === 5;
  } else {
    tmp_509 = false;
  }
  if (tmp_509) {
    tmp_508 = $this$with.c39_1 === 1;
  } else {
    tmp_508 = false;
  }
  if (tmp_508) {
    tmp_507 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_507 = false;
  }
  if (tmp_507) {
    yield* $this.ce0($receiver, OnboardingHint_LetSFinishHelgaSTurnFor_getInstance(), $completion);
  }
  var tmp_511;
  var tmp_512;
  var tmp_513;
  var tmp_514;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_514 = $this$with.e38_1 === 1;
  } else {
    tmp_514 = false;
  }
  if (tmp_514) {
    tmp_513 = $this$with.f38_1 === 5;
  } else {
    tmp_513 = false;
  }
  if (tmp_513) {
    tmp_512 = $this$with.c39_1 === 0;
  } else {
    tmp_512 = false;
  }
  if (tmp_512) {
    tmp_511 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_511 = false;
  }
  if (tmp_511) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPassForVarja_getInstance(), $completion);
  }
  var tmp_515;
  var tmp_516;
  var tmp_517;
  var tmp_518;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_518 = $this$with.e38_1 === 1;
  } else {
    tmp_518 = false;
  }
  if (tmp_518) {
    tmp_517 = $this$with.f38_1 === 5;
  } else {
    tmp_517 = false;
  }
  if (tmp_517) {
    tmp_516 = $this$with.c39_1 === 0;
  } else {
    tmp_516 = false;
  }
  if (tmp_516) {
    tmp_515 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_515 = false;
  }
  if (tmp_515) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSPassForIonaAs_getInstance(), $completion);
  }
  var tmp_519;
  var tmp_520;
  var tmp_521;
  var tmp_522;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_522 = $this$with.e38_1 === 1;
  } else {
    tmp_522 = false;
  }
  if (tmp_522) {
    tmp_521 = $this$with.f38_1 === 6;
  } else {
    tmp_521 = false;
  }
  if (tmp_521) {
    tmp_520 = $this$with.c39_1 === 0;
  } else {
    tmp_520 = false;
  }
  if (tmp_520) {
    tmp_519 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_519 = false;
  }
  if (tmp_519) {
    yield* $this.ce0($receiver, OnboardingHint_TheHuntersHaveMostlyRunOutOf_getInstance(), $completion);
  }
  var tmp_523;
  var tmp_524;
  var tmp_525;
  var tmp_526;
  var tmp_527;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_527 = $this$with.e38_1 === 1;
  } else {
    tmp_527 = false;
  }
  if (tmp_527) {
    tmp_526 = $this$with.f38_1 === 6;
  } else {
    tmp_526 = false;
  }
  if (tmp_526) {
    tmp_525 = $this$with.c39_1 === 0;
  } else {
    tmp_525 = false;
  }
  if (tmp_525) {
    var tmp0_19 = gameQuestion.d4b_1;
    var tmp$ret$48;
    $l$block_40: {
      // Inline function 'kotlin.collections.any' call
      var tmp_528;
      if (isInterface(tmp0_19, Collection)) {
        tmp_528 = tmp0_19.n1();
      } else {
        tmp_528 = false;
      }
      if (tmp_528) {
        tmp$ret$48 = false;
        break $l$block_40;
      }
      var _iterator__ex2g4s_20 = tmp0_19.p1();
      while (_iterator__ex2g4s_20.q1()) {
        var element_20 = _iterator__ex2g4s_20.r1();
        if (element_20 instanceof GainBeastlyTalentStatement) {
          tmp$ret$48 = true;
          break $l$block_40;
        }
      }
      tmp$ret$48 = false;
    }
    tmp_524 = tmp$ret$48;
  } else {
    tmp_524 = false;
  }
  if (tmp_524) {
    tmp_523 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_523 = false;
  }
  if (tmp_523) {
    yield* $this.ce0($receiver, OnboardingHint_LetSFirstPickABeastlyTalent_getInstance(), $completion);
  }
  var tmp_529;
  var tmp_530;
  var tmp_531;
  var tmp_532;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_532 = $this$with.e38_1 === 1;
  } else {
    tmp_532 = false;
  }
  if (tmp_532) {
    tmp_531 = $this$with.f38_1 === 6;
  } else {
    tmp_531 = false;
  }
  if (tmp_531) {
    tmp_530 = $this$with.c39_1 === 0;
  } else {
    tmp_530 = false;
  }
  if (tmp_530) {
    tmp_529 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_529 = false;
  }
  if (tmp_529) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheUnbendingWill_getInstance(), $completion);
  }
  var tmp_533;
  var tmp_534;
  var tmp_535;
  var tmp_536;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_536 = $this$with.e38_1 === 1;
  } else {
    tmp_536 = false;
  }
  if (tmp_536) {
    tmp_535 = $this$with.f38_1 === 6;
  } else {
    tmp_535 = false;
  }
  if (tmp_535) {
    tmp_534 = $this$with.c39_1 === 0;
  } else {
    tmp_534 = false;
  }
  if (tmp_534) {
    tmp_533 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_533 = false;
  }
  if (tmp_533) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSMoveBolginOneStep_getInstance(), $completion);
  }
  var tmp_537;
  var tmp_538;
  var tmp_539;
  var tmp_540;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_540 = $this$with.e38_1 === 1;
  } else {
    tmp_540 = false;
  }
  if (tmp_540) {
    tmp_539 = $this$with.f38_1 === 6;
  } else {
    tmp_539 = false;
  }
  if (tmp_539) {
    tmp_538 = $this$with.c39_1 === 0;
  } else {
    tmp_538 = false;
  }
  if (tmp_538) {
    tmp_537 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_537 = false;
  }
  if (tmp_537) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPassForHelga_getInstance(), $completion);
  }
  var tmp_541;
  var tmp_542;
  var tmp_543;
  var tmp_544;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_544 = $this$with.e38_1 === 1;
  } else {
    tmp_544 = false;
  }
  if (tmp_544) {
    tmp_543 = $this$with.f38_1 === 6;
  } else {
    tmp_543 = false;
  }
  if (tmp_543) {
    tmp_542 = $this$with.c39_1 === 0;
  } else {
    tmp_542 = false;
  }
  if (tmp_542) {
    tmp_541 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_541 = false;
  }
  if (tmp_541) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSPassForVarjaAs_getInstance(), $completion);
  }
  var tmp_545;
  var tmp_546;
  var tmp_547;
  var tmp_548;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_548 = $this$with.e38_1 === 1;
  } else {
    tmp_548 = false;
  }
  if (tmp_548) {
    tmp_547 = $this$with.f38_1 === 6;
  } else {
    tmp_547 = false;
  }
  if (tmp_547) {
    tmp_546 = $this$with.c39_1 === 0;
  } else {
    tmp_546 = false;
  }
  if (tmp_546) {
    tmp_545 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_545 = false;
  }
  if (tmp_545) {
    yield* $this.ce0($receiver, OnboardingHint_LetSActuallyPlayTheBladeOf_getInstance(), $completion);
  }
  var tmp_549;
  var tmp_550;
  var tmp_551;
  var tmp_552;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_552 = $this$with.e38_1 === 1;
  } else {
    tmp_552 = false;
  }
  if (tmp_552) {
    tmp_551 = $this$with.f38_1 === 6;
  } else {
    tmp_551 = false;
  }
  if (tmp_551) {
    tmp_550 = $this$with.c39_1 === 0;
  } else {
    tmp_550 = false;
  }
  if (tmp_550) {
    tmp_549 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_549 = false;
  }
  if (tmp_549) {
    yield* $this.ce0($receiver, OnboardingHint_SometimesYouMayWantToPlayThe_getInstance(), $completion);
  }
  var tmp_553;
  var tmp_554;
  var tmp_555;
  var tmp_556;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_556 = $this$with.e38_1 === 1;
  } else {
    tmp_556 = false;
  }
  if (tmp_556) {
    tmp_555 = $this$with.f38_1 === 6;
  } else {
    tmp_555 = false;
  }
  if (tmp_555) {
    tmp_554 = $this$with.c39_1 === 0;
  } else {
    tmp_554 = false;
  }
  if (tmp_554) {
    tmp_553 = equals($this$with.d38_1, new PlayerTurnPhase(get_ionaHunter($this$with)));
  } else {
    tmp_553 = false;
  }
  if (tmp_553) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPickTheMostPracticalUpgrade_getInstance(), $completion);
  }
  var tmp_557;
  var tmp_558;
  var tmp_559;
  var tmp_560;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_560 = $this$with.e38_1 === 1;
  } else {
    tmp_560 = false;
  }
  if (tmp_560) {
    tmp_559 = $this$with.f38_1 === 7;
  } else {
    tmp_559 = false;
  }
  if (tmp_559) {
    tmp_558 = $this$with.c39_1 === 0;
  } else {
    tmp_558 = false;
  }
  if (tmp_558) {
    tmp_557 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_557 = false;
  }
  if (tmp_557) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheUnbendingWillCard_getInstance(), $completion);
  }
  var tmp_561;
  var tmp_562;
  var tmp_563;
  var tmp_564;
  if (gameQuestion instanceof ChooseCardsQuestion) {
    tmp_564 = $this$with.e38_1 === 1;
  } else {
    tmp_564 = false;
  }
  if (tmp_564) {
    tmp_563 = $this$with.f38_1 === 7;
  } else {
    tmp_563 = false;
  }
  if (tmp_563) {
    tmp_562 = $this$with.c39_1 === 0;
  } else {
    tmp_562 = false;
  }
  if (tmp_562) {
    tmp_561 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_561 = false;
  }
  if (tmp_561) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSReturnTheSummonPolyp_getInstance(), $completion);
  }
  var tmp_565;
  var tmp_566;
  var tmp_567;
  var tmp_568;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_568 = $this$with.e38_1 === 1;
  } else {
    tmp_568 = false;
  }
  if (tmp_568) {
    tmp_567 = $this$with.f38_1 === 7;
  } else {
    tmp_567 = false;
  }
  if (tmp_567) {
    tmp_566 = $this$with.c39_1 === 1;
  } else {
    tmp_566 = false;
  }
  if (tmp_566) {
    tmp_565 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_565 = false;
  }
  if (tmp_565) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSFinishTheTurn_getInstance(), $completion);
  }
  var tmp_569;
  var tmp_570;
  var tmp_571;
  var tmp_572;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_572 = $this$with.e38_1 === 1;
  } else {
    tmp_572 = false;
  }
  if (tmp_572) {
    tmp_571 = $this$with.f38_1 === 7;
  } else {
    tmp_571 = false;
  }
  if (tmp_571) {
    tmp_570 = $this$with.c39_1 === 0;
  } else {
    tmp_570 = false;
  }
  if (tmp_570) {
    tmp_569 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_569 = false;
  }
  if (tmp_569) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheTrackCard_getInstance(), $completion);
  }
  var tmp_573;
  var tmp_574;
  var tmp_575;
  var tmp_576;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_576 = $this$with.e38_1 === 1;
  } else {
    tmp_576 = false;
  }
  if (tmp_576) {
    tmp_575 = $this$with.f38_1 === 7;
  } else {
    tmp_575 = false;
  }
  if (tmp_575) {
    tmp_574 = $this$with.c39_1 === 0;
  } else {
    tmp_574 = false;
  }
  if (tmp_574) {
    tmp_573 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_573 = false;
  }
  if (tmp_573) {
    var tmp57_safe_receiver = gameQuestion.y48_1;
    var tmp_577 = tmp57_safe_receiver == null ? null : get_objectType($this$with, tmp57_safe_receiver);
    if (tmp_577 instanceof Helga) {
      if (get_helgaHunter($this$with).s2w($this$with) === get_ionaHunter($this$with).s2w($this$with)) {
        yield* $this.ce0($receiver, OnboardingHint_LetSSupposeTheHuntersGuessBolgin_getInstance(), $completion);
      } else {
        yield* $this.ce0($receiver, OnboardingHint_ThereIsATrailSoTrackNow_getInstance(), $completion);
      }
    } else {
      yield* $this.ce0($receiver, OnboardingHint_HelgaFinishesTrackInTheSameZone_getInstance(), $completion);
    }
  }
  var tmp_578;
  var tmp_579;
  var tmp_580;
  var tmp_581;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_581 = $this$with.e38_1 === 1;
  } else {
    tmp_581 = false;
  }
  if (tmp_581) {
    tmp_580 = $this$with.f38_1 === 7;
  } else {
    tmp_580 = false;
  }
  if (tmp_580) {
    tmp_579 = $this$with.c39_1 === 1;
  } else {
    tmp_579 = false;
  }
  if (tmp_579) {
    tmp_578 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_578 = false;
  }
  if (tmp_578) {
    yield* $this.ce0($receiver, OnboardingHint_LetSFinishHelgaSTurn_getInstance(), $completion);
  }
  var tmp_582;
  var tmp_583;
  var tmp_584;
  var tmp_585;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_585 = $this$with.e38_1 === 1;
  } else {
    tmp_585 = false;
  }
  if (tmp_585) {
    tmp_584 = $this$with.f38_1 === 7;
  } else {
    tmp_584 = false;
  }
  if (tmp_584) {
    tmp_583 = $this$with.c39_1 === 0;
  } else {
    tmp_583 = false;
  }
  if (tmp_583) {
    tmp_582 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_582 = false;
  }
  if (tmp_582) {
    yield* $this.ce0($receiver, OnboardingHint_VarjaCannotDoMuchEitherLetS_getInstance(), $completion);
  }
  var tmp_586;
  var tmp_587;
  var tmp_588;
  var tmp_589;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_589 = $this$with.e38_1 === 1;
  } else {
    tmp_589 = false;
  }
  if (tmp_589) {
    tmp_588 = $this$with.f38_1 === 8;
  } else {
    tmp_588 = false;
  }
  if (tmp_588) {
    tmp_587 = $this$with.c39_1 === 0;
  } else {
    tmp_587 = false;
  }
  if (tmp_587) {
    tmp_586 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_586 = false;
  }
  if (tmp_586) {
    yield* $this.ce0($receiver, OnboardingHint_IonaHasNoCardsSoSheWill_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheSummonPolypCard2_getInstance(), $completion);
  }
  var tmp_590;
  var tmp_591;
  var tmp_592;
  var tmp_593;
  var tmp_594;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_594 = $this$with.e38_1 === 1;
  } else {
    tmp_594 = false;
  }
  if (tmp_594) {
    tmp_593 = $this$with.f38_1 === 8;
  } else {
    tmp_593 = false;
  }
  if (tmp_593) {
    tmp_592 = $this$with.c39_1 === 0;
  } else {
    tmp_592 = false;
  }
  if (tmp_592) {
    var tmp0_20 = gameQuestion.d4b_1;
    var tmp$ret$50;
    $l$block_42: {
      // Inline function 'kotlin.collections.any' call
      var tmp_595;
      if (isInterface(tmp0_20, Collection)) {
        tmp_595 = tmp0_20.n1();
      } else {
        tmp_595 = false;
      }
      if (tmp_595) {
        tmp$ret$50 = false;
        break $l$block_42;
      }
      var _iterator__ex2g4s_21 = tmp0_20.p1();
      while (_iterator__ex2g4s_21.q1()) {
        var element_21 = _iterator__ex2g4s_21.r1();
        if (element_21 instanceof SimpleBeastMovementStatement) {
          tmp$ret$50 = true;
          break $l$block_42;
        }
      }
      tmp$ret$50 = false;
    }
    tmp_591 = tmp$ret$50;
  } else {
    tmp_591 = false;
  }
  if (tmp_591) {
    tmp_590 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_590 = false;
  }
  if (tmp_590) {
    yield* $this.ce0($receiver, OnboardingHint_LetSStartWithMovement_getInstance(), $completion);
  }
  var tmp_596;
  var tmp_597;
  var tmp_598;
  var tmp_599;
  var tmp_600;
  var tmp_601;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_601 = $this$with.e38_1 === 1;
  } else {
    tmp_601 = false;
  }
  if (tmp_601) {
    tmp_600 = $this$with.f38_1 === 8;
  } else {
    tmp_600 = false;
  }
  if (tmp_600) {
    tmp_599 = $this$with.c39_1 === 0;
  } else {
    tmp_599 = false;
  }
  if (tmp_599) {
    tmp_598 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_598 = false;
  }
  if (tmp_598) {
    var tmp58_safe_receiver = gameQuestion.y48_1;
    var tmp_602 = tmp58_safe_receiver == null ? null : get_objectType($this$with, tmp58_safe_receiver);
    tmp_597 = tmp_602 instanceof Bolgin;
  } else {
    tmp_597 = false;
  }
  if (tmp_597) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_596 = !summonsOnMap($this$with, get_bolginBeast($this$with)).n1();
  } else {
    tmp_596 = false;
  }
  if (tmp_596) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveBolginWest_getInstance(), $completion);
  }
  var tmp_603;
  var tmp_604;
  var tmp_605;
  var tmp_606;
  var tmp_607;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_607 = $this$with.e38_1 === 1;
  } else {
    tmp_607 = false;
  }
  if (tmp_607) {
    tmp_606 = $this$with.f38_1 === 8;
  } else {
    tmp_606 = false;
  }
  if (tmp_606) {
    tmp_605 = $this$with.c39_1 === 0;
  } else {
    tmp_605 = false;
  }
  if (tmp_605) {
    var tmp0_21 = gameQuestion.d4b_1;
    var tmp$ret$53;
    $l$block_44: {
      // Inline function 'kotlin.collections.none' call
      var tmp_608;
      if (isInterface(tmp0_21, Collection)) {
        tmp_608 = tmp0_21.n1();
      } else {
        tmp_608 = false;
      }
      if (tmp_608) {
        tmp$ret$53 = true;
        break $l$block_44;
      }
      var _iterator__ex2g4s_22 = tmp0_21.p1();
      while (_iterator__ex2g4s_22.q1()) {
        var element_22 = _iterator__ex2g4s_22.r1();
        if (element_22 instanceof SimpleBeastMovementStatement) {
          tmp$ret$53 = false;
          break $l$block_44;
        }
      }
      tmp$ret$53 = true;
    }
    tmp_604 = tmp$ret$53;
  } else {
    tmp_604 = false;
  }
  if (tmp_604) {
    tmp_603 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_603 = false;
  }
  if (tmp_603) {
    var tmp0_22 = gameQuestion.d4b_1;
    var tmp$ret$55;
    $l$block_46: {
      // Inline function 'kotlin.collections.any' call
      var tmp_609;
      if (isInterface(tmp0_22, Collection)) {
        tmp_609 = tmp0_22.n1();
      } else {
        tmp_609 = false;
      }
      if (tmp_609) {
        tmp$ret$55 = false;
        break $l$block_46;
      }
      var _iterator__ex2g4s_23 = tmp0_22.p1();
      while (_iterator__ex2g4s_23.q1()) {
        var element_23 = _iterator__ex2g4s_23.r1();
        if (element_23 instanceof SummonSignStatement) {
          tmp$ret$55 = true;
          break $l$block_46;
        }
      }
      tmp$ret$55 = false;
    }
    if (tmp$ret$55) {
      yield* $this.ce0($receiver, OnboardingHint_AndNowLetSPlaySummonActivation_getInstance(), $completion);
    }
    var tmp0_23 = gameQuestion.d4b_1;
    var tmp$ret$57;
    $l$block_48: {
      // Inline function 'kotlin.collections.any' call
      var tmp_610;
      if (isInterface(tmp0_23, Collection)) {
        tmp_610 = tmp0_23.n1();
      } else {
        tmp_610 = false;
      }
      if (tmp_610) {
        tmp$ret$57 = false;
        break $l$block_48;
      }
      var _iterator__ex2g4s_24 = tmp0_23.p1();
      while (_iterator__ex2g4s_24.q1()) {
        var element_24 = _iterator__ex2g4s_24.r1();
        if (element_24 instanceof ActivateSummonsStatement) {
          tmp$ret$57 = true;
          break $l$block_48;
        }
      }
      tmp$ret$57 = false;
    }
    if (tmp$ret$57) {
      yield* $this.ce0($receiver, OnboardingHint_LetSActivateAllSummonsOnThe_getInstance(), $completion);
    }
    var tmp0_24 = gameQuestion.d4b_1;
    var tmp$ret$59;
    $l$block_50: {
      // Inline function 'kotlin.collections.any' call
      var tmp_611;
      if (isInterface(tmp0_24, Collection)) {
        tmp_611 = tmp0_24.n1();
      } else {
        tmp_611 = false;
      }
      if (tmp_611) {
        tmp$ret$59 = false;
        break $l$block_50;
      }
      var _iterator__ex2g4s_25 = tmp0_24.p1();
      while (_iterator__ex2g4s_25.q1()) {
        var element_25 = _iterator__ex2g4s_25.r1();
        if (element_25 instanceof BurstStatement) {
          tmp$ret$59 = true;
          break $l$block_50;
        }
      }
      tmp$ret$59 = false;
    }
    if (tmp$ret$59) {
      yield* $this.ce0($receiver, OnboardingHint_AndLetSUsePolypSUnique_getInstance(), $completion);
    }
  }
  var tmp_612;
  var tmp_613;
  var tmp_614;
  var tmp_615;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_615 = $this$with.e38_1 === 1;
  } else {
    tmp_615 = false;
  }
  if (tmp_615) {
    tmp_614 = $this$with.f38_1 === 8;
  } else {
    tmp_614 = false;
  }
  if (tmp_614) {
    tmp_613 = $this$with.c39_1 === 0;
  } else {
    tmp_613 = false;
  }
  if (tmp_613) {
    tmp_612 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_612 = false;
  }
  if (tmp_612) {
    var tmp59_safe_receiver = gameQuestion.y48_1;
    var tmp_616 = tmp59_safe_receiver == null ? null : get_objectType($this$with, tmp59_safe_receiver);
    if (tmp_616 instanceof PolypType) {
      yield* $this.ce0($receiver, OnboardingHint_SoBurstThePolypInGhastvikFjord_getInstance(), $completion);
    }
    var tmp_617;
    var tmp60_safe_receiver = gameQuestion.y48_1;
    var tmp_618 = tmp60_safe_receiver == null ? null : get_objectType($this$with, tmp60_safe_receiver);
    if (tmp_618 instanceof Bolgin) {
      tmp_617 = summonsOnMap($this$with, get_bolginBeast($this$with)).n1();
    } else {
      tmp_617 = false;
    }
    if (tmp_617) {
      yield* $this.ce0($receiver, OnboardingHint_ThePolypBurstsDestroyingItselfWoundingThe_getInstance(), $completion);
    }
  }
  var tmp_619;
  var tmp_620;
  var tmp_621;
  var tmp_622;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_622 = $this$with.e38_1 === 1;
  } else {
    tmp_622 = false;
  }
  if (tmp_622) {
    tmp_621 = $this$with.f38_1 === 8;
  } else {
    tmp_621 = false;
  }
  if (tmp_621) {
    tmp_620 = $this$with.c39_1 === 1;
  } else {
    tmp_620 = false;
  }
  if (tmp_620) {
    tmp_619 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_619 = false;
  }
  if (tmp_619) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSPlayTheRage_getInstance(), $completion);
  }
  var tmp_623;
  var tmp_624;
  var tmp_625;
  var tmp_626;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_626 = $this$with.e38_1 === 1;
  } else {
    tmp_626 = false;
  }
  if (tmp_626) {
    tmp_625 = $this$with.f38_1 === 8;
  } else {
    tmp_625 = false;
  }
  if (tmp_625) {
    tmp_624 = $this$with.c39_1 === 0;
  } else {
    tmp_624 = false;
  }
  if (tmp_624) {
    tmp_623 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_623 = false;
  }
  if (tmp_623) {
    yield* $this.ce0($receiver, OnboardingHint_NowItIsUnlikelyThatHelgaCan_getInstance(), $completion);
  }
  var tmp_627;
  var tmp_628;
  var tmp_629;
  var tmp_630;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_630 = $this$with.e38_1 === 1;
  } else {
    tmp_630 = false;
  }
  if (tmp_630) {
    tmp_629 = $this$with.f38_1 === 8;
  } else {
    tmp_629 = false;
  }
  if (tmp_629) {
    tmp_628 = $this$with.c39_1 === 0;
  } else {
    tmp_628 = false;
  }
  if (tmp_628) {
    tmp_627 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_627 = false;
  }
  if (tmp_627) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveHelgaNorth_getInstance(), $completion);
  }
  var tmp_631;
  var tmp_632;
  var tmp_633;
  var tmp_634;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_634 = $this$with.e38_1 === 1;
  } else {
    tmp_634 = false;
  }
  if (tmp_634) {
    tmp_633 = $this$with.f38_1 === 8;
  } else {
    tmp_633 = false;
  }
  if (tmp_633) {
    tmp_632 = $this$with.c39_1 === 0;
  } else {
    tmp_632 = false;
  }
  if (tmp_632) {
    tmp_631 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_631 = false;
  }
  if (tmp_631) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPassForVarja2_getInstance(), $completion);
  }
  var tmp_635;
  var tmp_636;
  var tmp_637;
  var tmp_638;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_638 = $this$with.e38_1 === 1;
  } else {
    tmp_638 = false;
  }
  if (tmp_638) {
    tmp_637 = $this$with.f38_1 === 9;
  } else {
    tmp_637 = false;
  }
  if (tmp_637) {
    tmp_636 = $this$with.c39_1 === 0;
  } else {
    tmp_636 = false;
  }
  if (tmp_636) {
    tmp_635 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_635 = false;
  }
  if (tmp_635) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowBolginHasOneGrudgeToPlay_getInstance(), $completion);
  }
  var tmp_639;
  var tmp_640;
  var tmp_641;
  var tmp_642;
  var tmp_643;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_643 = $this$with.e38_1 === 1;
  } else {
    tmp_643 = false;
  }
  if (tmp_643) {
    tmp_642 = $this$with.f38_1 === 9;
  } else {
    tmp_642 = false;
  }
  if (tmp_642) {
    tmp_641 = $this$with.c39_1 === 0;
  } else {
    tmp_641 = false;
  }
  if (tmp_641) {
    var tmp0_25 = gameQuestion.d4b_1;
    var tmp$ret$61;
    $l$block_52: {
      // Inline function 'kotlin.collections.any' call
      var tmp_644;
      if (isInterface(tmp0_25, Collection)) {
        tmp_644 = tmp0_25.n1();
      } else {
        tmp_644 = false;
      }
      if (tmp_644) {
        tmp$ret$61 = false;
        break $l$block_52;
      }
      var _iterator__ex2g4s_26 = tmp0_25.p1();
      while (_iterator__ex2g4s_26.q1()) {
        var element_26 = _iterator__ex2g4s_26.r1();
        if (element_26 instanceof SimpleBeastMovementStatement) {
          tmp$ret$61 = true;
          break $l$block_52;
        }
      }
      tmp$ret$61 = false;
    }
    tmp_640 = tmp$ret$61;
  } else {
    tmp_640 = false;
  }
  if (tmp_640) {
    tmp_639 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_639 = false;
  }
  if (tmp_639) {
    yield* $this.ce0($receiver, OnboardingHint_LetSStartWithMovement2_getInstance(), $completion);
  }
  var tmp_645;
  var tmp_646;
  var tmp_647;
  var tmp_648;
  var tmp_649;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_649 = $this$with.e38_1 === 1;
  } else {
    tmp_649 = false;
  }
  if (tmp_649) {
    tmp_648 = $this$with.f38_1 === 9;
  } else {
    tmp_648 = false;
  }
  if (tmp_648) {
    tmp_647 = $this$with.c39_1 === 0;
  } else {
    tmp_647 = false;
  }
  if (tmp_647) {
    tmp_646 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_646 = false;
  }
  if (tmp_646) {
    var tmp61_safe_receiver = gameQuestion.y48_1;
    var tmp_650 = tmp61_safe_receiver == null ? null : get_objectType($this$with, tmp61_safe_receiver);
    tmp_645 = tmp_650 instanceof Bolgin;
  } else {
    tmp_645 = false;
  }
  if (tmp_645) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveBolginEast_getInstance(), $completion);
  }
  var tmp_651;
  var tmp_652;
  var tmp_653;
  var tmp_654;
  var tmp_655;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_655 = $this$with.e38_1 === 1;
  } else {
    tmp_655 = false;
  }
  if (tmp_655) {
    tmp_654 = $this$with.f38_1 === 9;
  } else {
    tmp_654 = false;
  }
  if (tmp_654) {
    tmp_653 = $this$with.c39_1 === 0;
  } else {
    tmp_653 = false;
  }
  if (tmp_653) {
    var tmp0_26 = gameQuestion.d4b_1;
    var tmp$ret$63;
    $l$block_54: {
      // Inline function 'kotlin.collections.none' call
      var tmp_656;
      if (isInterface(tmp0_26, Collection)) {
        tmp_656 = tmp0_26.n1();
      } else {
        tmp_656 = false;
      }
      if (tmp_656) {
        tmp$ret$63 = true;
        break $l$block_54;
      }
      var _iterator__ex2g4s_27 = tmp0_26.p1();
      while (_iterator__ex2g4s_27.q1()) {
        var element_27 = _iterator__ex2g4s_27.r1();
        if (element_27 instanceof SimpleBeastMovementStatement) {
          tmp$ret$63 = false;
          break $l$block_54;
        }
      }
      tmp$ret$63 = true;
    }
    tmp_652 = tmp$ret$63;
  } else {
    tmp_652 = false;
  }
  if (tmp_652) {
    tmp_651 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_651 = false;
  }
  if (tmp_651) {
    yield* $this.ce0($receiver, OnboardingHint_AndNowLetSPlaySummonActivation2_getInstance(), $completion);
  }
  var tmp_657;
  var tmp_658;
  var tmp_659;
  var tmp_660;
  if (gameQuestion instanceof PlaceNewObjectQuestion) {
    tmp_660 = $this$with.e38_1 === 1;
  } else {
    tmp_660 = false;
  }
  if (tmp_660) {
    tmp_659 = $this$with.f38_1 === 9;
  } else {
    tmp_659 = false;
  }
  if (tmp_659) {
    tmp_658 = $this$with.c39_1 === 0;
  } else {
    tmp_658 = false;
  }
  if (tmp_658) {
    tmp_657 = equals($this$with.d38_1, new PlayerTurnPhase(get_bolginBeast($this$with)));
  } else {
    tmp_657 = false;
  }
  if (tmp_657) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlaceTheNewPolypIn_getInstance(), $completion);
  }
  var tmp_661;
  var tmp_662;
  var tmp_663;
  var tmp_664;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_664 = $this$with.e38_1 === 1;
  } else {
    tmp_664 = false;
  }
  if (tmp_664) {
    tmp_663 = $this$with.f38_1 === 9;
  } else {
    tmp_663 = false;
  }
  if (tmp_663) {
    tmp_662 = $this$with.c39_1 === 0;
  } else {
    tmp_662 = false;
  }
  if (tmp_662) {
    tmp_661 = equals($this$with.d38_1, new PlayerTurnPhase(get_helgaHunter($this$with)));
  } else {
    tmp_661 = false;
  }
  if (tmp_661) {
    yield* $this.ce0($receiver, OnboardingHint_LetSPlayTheOutpostCard_getInstance(), $completion);
  }
  var tmp_665;
  var tmp_666;
  var tmp_667;
  var tmp_668;
  if (gameQuestion instanceof PlayCardInTurnQuestion) {
    tmp_668 = $this$with.e38_1 === 1;
  } else {
    tmp_668 = false;
  }
  if (tmp_668) {
    tmp_667 = $this$with.f38_1 === 9;
  } else {
    tmp_667 = false;
  }
  if (tmp_667) {
    tmp_666 = $this$with.c39_1 === 0;
  } else {
    tmp_666 = false;
  }
  if (tmp_666) {
    tmp_665 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_665 = false;
  }
  if (tmp_665) {
    yield* $this.ce0($receiver, OnboardingHint_ThatPolypCanBurstHittingBothVarja_getInstance(), $completion);
  }
  var tmp_669;
  var tmp_670;
  var tmp_671;
  var tmp_672;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_672 = $this$with.e38_1 === 1;
  } else {
    tmp_672 = false;
  }
  if (tmp_672) {
    tmp_671 = $this$with.f38_1 === 9;
  } else {
    tmp_671 = false;
  }
  if (tmp_671) {
    tmp_670 = $this$with.c39_1 === 0;
  } else {
    tmp_670 = false;
  }
  if (tmp_670) {
    tmp_669 = equals($this$with.d38_1, new PlayerTurnPhase(get_varjaHunter($this$with)));
  } else {
    tmp_669 = false;
  }
  if (tmp_669) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveVarjaWestCloseTo_getInstance(), $completion);
  }
  var tmp_673;
  var tmp_674;
  if (gameQuestion instanceof StatementQuestion) {
    tmp_674 = $this$with.e38_1 === 1;
  } else {
    tmp_674 = false;
  }
  if (tmp_674) {
    tmp_673 = equals($this$with.d38_1, NightPhase_getInstance());
  } else {
    tmp_673 = false;
  }
  if (tmp_673) {
    var tmp0_27 = gameQuestion.d4b_1;
    var tmp$ret$65;
    $l$block_56: {
      // Inline function 'kotlin.collections.any' call
      var tmp_675;
      if (isInterface(tmp0_27, Collection)) {
        tmp_675 = tmp0_27.n1();
      } else {
        tmp_675 = false;
      }
      if (tmp_675) {
        tmp$ret$65 = false;
        break $l$block_56;
      }
      var _iterator__ex2g4s_28 = tmp0_27.p1();
      while (_iterator__ex2g4s_28.q1()) {
        var element_28 = _iterator__ex2g4s_28.r1();
        if (element_28 instanceof ActivateSummonsStatement) {
          tmp$ret$65 = true;
          break $l$block_56;
        }
      }
      tmp$ret$65 = false;
    }
    if (tmp$ret$65) {
      yield* $this.ce0($receiver, OnboardingHint_BolginReceivesAncientPowerAndMayNowPerform_getInstance(), $completion);
    } else {
      yield* $this.ce0($receiver, OnboardingHint_LetSUseTheBurstAgain_getInstance(), $completion);
    }
  }
  var tmp_676;
  var tmp_677;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_677 = $this$with.e38_1 === 1;
  } else {
    tmp_677 = false;
  }
  if (tmp_677) {
    tmp_676 = equals($this$with.d38_1, NightPhase_getInstance());
  } else {
    tmp_676 = false;
  }
  if (tmp_676) {
    var tmp62_safe_receiver = gameQuestion.y48_1;
    var tmp_678 = tmp62_safe_receiver == null ? null : get_objectType($this$with, tmp62_safe_receiver);
    if (tmp_678 instanceof PolypType) {
      yield* $this.ce0($receiver, OnboardingHint_LetSBurstTheWoundedFarmerTypeBelow_getInstance(), $completion);
    }
    var tmp_679;
    var tmp63_safe_receiver = gameQuestion.y48_1;
    var tmp_680 = tmp63_safe_receiver == null ? null : get_objectType($this$with, tmp63_safe_receiver);
    if (tmp_680 instanceof Bolgin) {
      tmp_679 = summonsOnMap($this$with, get_bolginBeast($this$with)).n1();
    } else {
      tmp_679 = false;
    }
    if (tmp_679) {
      yield* $this.ce0($receiver, OnboardingHint_TheCascadeUpgradeAllowsBolginToMove_getInstance(), $completion);
    }
  }
  var tmp_681;
  var tmp_682;
  var tmp_683;
  var tmp_684;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_684 = $this$with.e38_1 === 1;
  } else {
    tmp_684 = false;
  }
  if (tmp_684) {
    tmp_683 = gameQuestion.m4a_1.s2() === 3;
  } else {
    tmp_683 = false;
  }
  if (tmp_683) {
    var tmp0_28 = gameQuestion.m4a_1;
    var tmp$ret$67;
    $l$block_58: {
      // Inline function 'kotlin.collections.all' call
      var tmp_685;
      if (isInterface(tmp0_28, Collection)) {
        tmp_685 = tmp0_28.n1();
      } else {
        tmp_685 = false;
      }
      if (tmp_685) {
        tmp$ret$67 = true;
        break $l$block_58;
      }
      var _iterator__ex2g4s_29 = tmp0_28.p1();
      while (_iterator__ex2g4s_29.q1()) {
        var element_29 = _iterator__ex2g4s_29.r1();
        var tmp_686 = get_objectType($this$with, element_29);
        if (!isInterface(tmp_686, HunterCharacter)) {
          tmp$ret$67 = false;
          break $l$block_58;
        }
      }
      tmp$ret$67 = true;
    }
    tmp_682 = tmp$ret$67;
  } else {
    tmp_682 = false;
  }
  if (tmp_682) {
    var tmp_687 = $this$with.d38_1;
    tmp_681 = tmp_687 instanceof NightPhase;
  } else {
    tmp_681 = false;
  }
  if (tmp_681) {
    yield* $this.ce0($receiver, OnboardingHint_AllHuntersGainOneGrudgeAsAReward_getInstance(), $completion);
  }
  var tmp_688;
  var tmp_689;
  var tmp_690;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_690 = $this$with.e38_1 === 1;
  } else {
    tmp_690 = false;
  }
  if (tmp_690) {
    tmp_689 = equals($this$with.d38_1, NightPhase_getInstance());
  } else {
    tmp_689 = false;
  }
  if (tmp_689) {
    var tmp64_safe_receiver = gameQuestion.y48_1;
    var tmp_691 = tmp64_safe_receiver == null ? null : get_objectType($this$with, tmp64_safe_receiver);
    tmp_688 = tmp_691 instanceof Helga;
  } else {
    tmp_688 = false;
  }
  if (tmp_688) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveHelgaOneStepRight_getInstance(), $completion);
  }
  var tmp_692;
  var tmp_693;
  var tmp_694;
  var tmp_695;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_695 = $this$with.e38_1 === 1;
  } else {
    tmp_695 = false;
  }
  if (tmp_695) {
    tmp_694 = gameQuestion.m4a_1.s2() === 2;
  } else {
    tmp_694 = false;
  }
  if (tmp_694) {
    var tmp0_29 = gameQuestion.m4a_1;
    var tmp$ret$69;
    $l$block_60: {
      // Inline function 'kotlin.collections.all' call
      var tmp_696;
      if (isInterface(tmp0_29, Collection)) {
        tmp_696 = tmp0_29.n1();
      } else {
        tmp_696 = false;
      }
      if (tmp_696) {
        tmp$ret$69 = true;
        break $l$block_60;
      }
      var _iterator__ex2g4s_30 = tmp0_29.p1();
      while (_iterator__ex2g4s_30.q1()) {
        var element_30 = _iterator__ex2g4s_30.r1();
        var tmp_697 = get_objectType($this$with, element_30);
        if (!isInterface(tmp_697, HunterCharacter)) {
          tmp$ret$69 = false;
          break $l$block_60;
        }
      }
      tmp$ret$69 = true;
    }
    tmp_693 = tmp$ret$69;
  } else {
    tmp_693 = false;
  }
  if (tmp_693) {
    var tmp_698 = $this$with.d38_1;
    tmp_692 = tmp_698 instanceof NightPhase;
  } else {
    tmp_692 = false;
  }
  if (tmp_692) {
    yield* $this.ce0($receiver, OnboardingHint_NextLetSMoveVarja_getInstance(), $completion);
  }
  var tmp_699;
  var tmp_700;
  var tmp_701;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_701 = $this$with.e38_1 === 1;
  } else {
    tmp_701 = false;
  }
  if (tmp_701) {
    tmp_700 = equals($this$with.d38_1, NightPhase_getInstance());
  } else {
    tmp_700 = false;
  }
  if (tmp_700) {
    var tmp65_safe_receiver = gameQuestion.y48_1;
    var tmp_702 = tmp65_safe_receiver == null ? null : get_objectType($this$with, tmp65_safe_receiver);
    tmp_699 = tmp_702 instanceof Varja;
  } else {
    tmp_699 = false;
  }
  if (tmp_699) {
    yield* $this.ce0($receiver, OnboardingHint_LetSMoveVarjaNorth_getInstance(), $completion);
  }
  var tmp_703;
  var tmp_704;
  var tmp_705;
  if (gameQuestion instanceof DestinationQuestion) {
    tmp_705 = $this$with.e38_1 === 1;
  } else {
    tmp_705 = false;
  }
  if (tmp_705) {
    tmp_704 = equals($this$with.d38_1, NightPhase_getInstance());
  } else {
    tmp_704 = false;
  }
  if (tmp_704) {
    var tmp66_safe_receiver = gameQuestion.y48_1;
    var tmp_706 = tmp66_safe_receiver == null ? null : get_objectType($this$with, tmp66_safe_receiver);
    tmp_703 = tmp_706 instanceof Iona;
  } else {
    tmp_703 = false;
  }
  if (tmp_703) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSMoveIonaEastClose_getInstance(), $completion);
  }
  var tmp_707;
  var tmp_708;
  var tmp_709;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_709 = $this$with.e38_1 === 1;
  } else {
    tmp_709 = false;
  }
  if (tmp_709) {
    tmp_708 = gameQuestion.s4b_1.w2(HeroicSpeechUpgrade_getInstance());
  } else {
    tmp_708 = false;
  }
  if (tmp_708) {
    var tmp_710 = $this$with.d38_1;
    tmp_707 = tmp_710 instanceof NightPhase;
  } else {
    tmp_707 = false;
  }
  if (tmp_707) {
    yield* $this.ce0($receiver, OnboardingHint_LetSStartWithVarjaAndUpgrade_getInstance(), $completion);
  }
  var tmp_711;
  var tmp_712;
  var tmp_713;
  if (gameQuestion instanceof ObjectsGameQuestion) {
    tmp_713 = $this$with.e38_1 === 1;
  } else {
    tmp_713 = false;
  }
  if (tmp_713) {
    var tmp0_30 = gameQuestion.m4a_1;
    var tmp$ret$71;
    $l$block_62: {
      // Inline function 'kotlin.collections.all' call
      var tmp_714;
      if (isInterface(tmp0_30, Collection)) {
        tmp_714 = tmp0_30.n1();
      } else {
        tmp_714 = false;
      }
      if (tmp_714) {
        tmp$ret$71 = true;
        break $l$block_62;
      }
      var _iterator__ex2g4s_31 = tmp0_30.p1();
      while (_iterator__ex2g4s_31.q1()) {
        var element_31 = _iterator__ex2g4s_31.r1();
        var tmp_715 = get_objectType($this$with, element_31);
        if (!(tmp_715 instanceof FarmerType)) {
          tmp$ret$71 = false;
          break $l$block_62;
        }
      }
      tmp$ret$71 = true;
    }
    tmp_712 = tmp$ret$71;
  } else {
    tmp_712 = false;
  }
  if (tmp_712) {
    var tmp_716 = $this$with.d38_1;
    tmp_711 = tmp_716 instanceof NightPhase;
  } else {
    tmp_711 = false;
  }
  if (tmp_711) {
    yield* $this.ce0($receiver, OnboardingHint_LetSChooseTheFarmerTypeInVintervik_getInstance(), $completion);
  }
  var tmp_717;
  var tmp_718;
  var tmp_719;
  var tmp_720;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_720 = $this$with.e38_1 === 1;
  } else {
    tmp_720 = false;
  }
  if (tmp_720) {
    tmp_719 = !gameQuestion.s4b_1.w2(HeroicSpeechUpgrade_getInstance());
  } else {
    tmp_719 = false;
  }
  if (tmp_719) {
    tmp_718 = gameQuestion.s4b_1.w2(AncientCallingUpgrade_getInstance());
  } else {
    tmp_718 = false;
  }
  if (tmp_718) {
    var tmp_721 = $this$with.d38_1;
    tmp_717 = tmp_721 instanceof NightPhase;
  } else {
    tmp_717 = false;
  }
  if (tmp_717) {
    yield* $this.ce0($receiver, OnboardingHint_BolginNowNeedsOnlyOneDamageOneDamageTo_getInstance(), $completion);
  }
  var tmp_722;
  var tmp_723;
  var tmp_724;
  var tmp_725;
  if (gameQuestion instanceof UpgradeQuestion) {
    tmp_725 = $this$with.e38_1 === 1;
  } else {
    tmp_725 = false;
  }
  if (tmp_725) {
    tmp_724 = !gameQuestion.s4b_1.w2(HeroicSpeechUpgrade_getInstance());
  } else {
    tmp_724 = false;
  }
  if (tmp_724) {
    tmp_723 = !gameQuestion.s4b_1.w2(AncientCallingUpgrade_getInstance());
  } else {
    tmp_723 = false;
  }
  if (tmp_723) {
    var tmp_726 = $this$with.d38_1;
    tmp_722 = tmp_726 instanceof NightPhase;
  } else {
    tmp_722 = false;
  }
  if (tmp_722) {
    yield* $this.ce0($receiver, OnboardingHint_AndLetSSaveOneGrudgeForHelga_getInstance(), $completion);
  }
  yield* $this.ge0($receiver, false, $completion);
  return Unit_instance;
}
function *answerWasGivenInt($this, $receiver, gameQuestion, mayNothing, answer, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $receiver.t6h();
  var tmp;
  if (gameQuestion instanceof ChooseCharacterQuestion) {
    tmp = equals(answer, Iona_getInstance());
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* $this.be0($receiver, OnboardingSequence_IonaCards_getInstance(), $completion);
  }
  var tmp_0;
  var tmp_1;
  if ($this$with.e38_1 === 1 && $this$with.f38_1 === 1) {
    tmp_1 = gameQuestion instanceof ObjectsGameQuestion;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    var tmp0_safe_receiver = singleOrNull(gameQuestion.m4a_1);
    tmp_0 = equals(tmp0_safe_receiver == null ? null : get_objectType($this$with, tmp0_safe_receiver), SheepType_getInstance());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    yield* $this.ce0($receiver, OnboardingHint_WhenTheBeastRevealsHuntersCanPlay_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_WhenAttackingTheBeastMustDeclareA_getInstance(), $completion);
    yield* $this.ce0($receiver, OnboardingHint_ByDefaultEveryBeastDealsOneDamage_getInstance(), $completion);
  }
  yield* $this.de0($receiver, VOID, $completion);
  return Unit_instance;
}
function OnboardingScript$_init_$slambda_qyeczq() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function OnboardingScript$gainedCards$lambda($event) {
  return ($this$withStateRuntime) => setOf(last($this$withStateRuntime.m4l($event.o51_1).d36()));
}
function OnboardingScript$beforeNotificationApplied$slambda($stateHolder, this$0, $event) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.with' call
    var $this$with = $stateHolder.t6h();
    yield* /*#__NOINLINE__*/beforeNotificationAppliedInt(this$0, $this$with, $stateHolder, $event, $completion);
    return Unit_instance;
  }, 0);
}
function OnboardingScript$beforeNotificationAppliedInt$lambda($event) {
  return ($this$withStateRuntime) => {
    var tmp0 = $event.o37($this$withStateRuntime);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof BeastMovementInfoChange) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function OnboardingScript$afterNotificationApplied$slambda($stateHolder, this$0, $event) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.with' call
    var $this$with = $stateHolder.t6h();
    yield* /*#__NOINLINE__*/afterNotificationAppliedInt(this$0, $this$with, $stateHolder, $event, $completion);
    return Unit_instance;
  }, 0);
}
function OnboardingScript$afterNotificationAppliedInt$lambda($event) {
  return ($this$withStateRuntime) => {
    var tmp0 = $event.o37($this$withStateRuntime);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof BeastMovementInfoChange) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function OnboardingScript$beforeAnswer$slambda($stateHolder, this$0, $gameQuestion) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.with' call
    var $this$with = $stateHolder.t6h();
    yield* /*#__NOINLINE__*/beforeAnswerInt(this$0, $this$with, $stateHolder, $gameQuestion, $completion);
    return Unit_instance;
  }, 0);
}
function OnboardingScript$whenChoiceUiWasInstalled$slambda(this$0, $stateHolder, $gameQuestion) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/whenChoiceUiWasInstalledImpl(this$0, $stateHolder, $gameQuestion, $completion);
    return Unit_instance;
  }, 0);
}
function OnboardingScript$answerWasGiven$slambda(this$0, $stateHolder, $gameQuestion, $mayNothing, $answer) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/answerWasGivenInt(this$0, $stateHolder, $gameQuestion, $mayNothing, $answer, $completion);
    return Unit_instance;
  }, 0);
}
function *peekAnswerAndAnimations($context_GameStateRuntime_604ce3, _this__u8e3s4, question, mayNothing, $completion) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var animations = ArrayList.p2();
  while (true) {
    var answer = yield* _this__u8e3s4.f6y($context_GameStateRuntime_604ce3, question, mayNothing, $completion);
    if (!(!(answer == null) ? isInterface(answer, AnimationInsertion) : false))
      return to(answer, animations);
    animations.d2(answer);
    _this__u8e3s4.g6y();
  }
}
function visibleServerMessages(messages, dismissedMessageIds) {
  return combine(messages, dismissedMessageIds, visibleServerMessages$slambda());
}
var ReplayVisibility_Hunters_instance;
var ReplayVisibility_Beasts_instance;
var ReplayVisibility_CurrentTeam_instance;
var ReplayVisibility_FullVisibility_instance;
function values() {
  return [ReplayVisibility_Hunters_getInstance(), ReplayVisibility_Beasts_getInstance(), ReplayVisibility_CurrentTeam_getInstance(), ReplayVisibility_FullVisibility_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var ReplayVisibility_entriesInitialized;
function ReplayVisibility_initEntries() {
  if (ReplayVisibility_entriesInitialized)
    return Unit_instance;
  ReplayVisibility_entriesInitialized = true;
  ReplayVisibility_Hunters_instance = new ReplayVisibility('Hunters', 0, 'Hunters');
  ReplayVisibility_Beasts_instance = new ReplayVisibility('Beasts', 1, 'Beasts');
  ReplayVisibility_CurrentTeam_instance = new ReplayVisibility('CurrentTeam', 2, 'Current team');
  ReplayVisibility_FullVisibility_instance = new ReplayVisibility('FullVisibility', 3, 'Full visibility');
}
var $ENTRIES;
function SwitchingGameTeamProvider$_init_$slambda_1fvhxe() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function SwitchingGameTeamProvider$_init_$slambda_1fvhxe_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function SwitchingGameTeamProvider$_init_$lambda_o57uil(it) {
  return Unit_instance;
}
function replayStartShowAnswerFrom(startFromAnswer, infoStep) {
  return !(infoStep == null) ? coerceAtLeast(startFromAnswer - 1 | 0, 0) : startFromAnswer;
}
function get_fixedVisibilityTeam(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 0:
      tmp = get_huntersGameTeam();
      break;
    case 1:
      tmp = get_beastsGameTeam();
      break;
    case 2:
    case 3:
      tmp = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function visibleServerMessages$slambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.j6u();
  var tmp$ret$2 = b.j6u();
  return compareValues(tmp, tmp$ret$2);
}
function visibleServerMessages$slambda() {
  return constructCallableReference(function *(current, dismissedIds, $completion) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = current.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!dismissedIds.w2(element.j6u())) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = visibleServerMessages$slambda$lambda;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    return sortedWith(destination, tmp$ret$4);
  }, 2);
}
function ReplayVisibility_Hunters_getInstance() {
  ReplayVisibility_initEntries();
  return ReplayVisibility_Hunters_instance;
}
function ReplayVisibility_Beasts_getInstance() {
  ReplayVisibility_initEntries();
  return ReplayVisibility_Beasts_instance;
}
function ReplayVisibility_CurrentTeam_getInstance() {
  ReplayVisibility_initEntries();
  return ReplayVisibility_CurrentTeam_instance;
}
function ReplayVisibility_FullVisibility_getInstance() {
  ReplayVisibility_initEntries();
  return ReplayVisibility_FullVisibility_instance;
}
var RevertMode_ReapplyJustCurrent_instance;
var RevertMode_RevertFirstForSure_instance;
var RevertMode_DefaultRevert_instance;
var RevertMode_entriesInitialized;
function RevertMode_initEntries() {
  if (RevertMode_entriesInitialized)
    return Unit_instance;
  RevertMode_entriesInitialized = true;
  RevertMode_ReapplyJustCurrent_instance = new RevertMode('ReapplyJustCurrent', 0);
  RevertMode_RevertFirstForSure_instance = new RevertMode('RevertFirstForSure', 1);
  RevertMode_DefaultRevert_instance = new RevertMode('DefaultRevert', 2);
}
function *clearPendingQuestion($this, $completion) {
  $this.ee1_1.cdx();
  yield* $this.fe1_1($completion);
  return Unit_instance;
}
function *performRewind($this, revertMode, revert, onboarding, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.de1_1;
  yield* revert(ReplayRevertFlow$performRewind$slambda($this, $this$with, revertMode, onboarding), $completion);
  return Unit_instance;
}
function ReplayRevertFlow$_init_$slambda_mc16wj($agent) {
  return constructCallableReference(function *($completion) {
    $agent.le1();
    return Unit_instance;
  }, 0);
}
function ReplayRevertFlow$_init_$lambda_tblrhq() {
  return EmptyListener_instance;
}
function ReplayRevertFlow$_init_$lambda_tblrhq_0() {
  return new ReplayRevertConfiguration();
}
function *performRewind$restoreAnswer($onboarding, $this_with, data, $completion) {
  return yield* $onboarding.jdz($this_with, data.q6p_1, data.r6p_1, data.s6p_1, $completion);
}
function ReplayRevertFlow$performRewind$slambda$lambda($revertedToQuestion, $revertOutcome) {
  return ($this$withStateRuntime) => {
    var tmp;
    if ($revertOutcome._v == null) {
      throwUninitializedPropertyAccessException('revertOutcome');
    } else {
      tmp = $revertOutcome._v;
    }
    return defaultAnswer($this$withStateRuntime, $revertedToQuestion, tmp.h6i_1);
  };
}
function ReplayRevertFlow$performRewind$slambda(this$0, $$this$with, $revertMode, $onboarding) {
  return constructCallableReference(function *(revertOneElement, $completion) {
    var isFirstRevert = true;
    var revertOutcome = {_v: null};
    var shouldRevertToQuestionStrictly = !this$0.he1_1().me1_1 && (this$0.he1_1().ne1_1 || !(this$0.ee1_1.xdv_1 == null) || this$0.ee1_1.ydv_1);
    $l$loop_5: while (true) {
      revertOutcome._v = yield* revertOneElement($completion);
      var tmp;
      if (revertOutcome._v == null) {
        throwUninitializedPropertyAccessException('revertOutcome');
      } else {
        tmp = revertOutcome._v;
      }
      if (tmp.e6i_1.equals(WhatWillBeReapply_InitialStateNotification_getInstance())) {
        break $l$loop_5;
      }
      var tmp_0;
      if (this$0.ie1_1) {
        var tmp_1;
        if (revertOutcome._v == null) {
          throwUninitializedPropertyAccessException('revertOutcome');
        } else {
          tmp_1 = revertOutcome._v;
        }
        tmp_0 = tmp_1.e6i_1.equals(WhatWillBeReapply_GameNotification_getInstance());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        this$0.ee1_1.wdv_1 = emptyList();
        yield* /*#__NOINLINE__*/clearPendingQuestion(this$0, $completion);
        var tmp_2;
        if (revertOutcome._v == null) {
          throwUninitializedPropertyAccessException('revertOutcome');
        } else {
          tmp_2 = revertOutcome._v;
        }
        yield* $$this$with.a6i(tmp_2, $completion);
        yield* $$this$with.oe1($completion);
      }
      this$0.ie1_1 = true;
      if (this$0.he1_1().me1_1)
        this$0.ee1_1.xdv_1 = null;
      else {
        this$0.ee1_1.bdx();
      }
      if ($revertMode.equals(RevertMode_ReapplyJustCurrent_getInstance()))
        break $l$loop_5;
      var tmp_3;
      if (revertOutcome._v == null) {
        throwUninitializedPropertyAccessException('revertOutcome');
      } else {
        tmp_3 = revertOutcome._v;
      }
      var revertedToQuestion = tmp_3.g6i_1;
      if (!isFirstRevert && !this$0.he1_1().me1_1 && !(revertedToQuestion == null)) {
        if (shouldRevertToQuestionStrictly) {
          break $l$loop_5;
        }
        // Inline function 'kotlin.with' call
        var $this$with = $$this$with.t6h();
        var defaultAnswer = withStateRuntime($$this$with, $this$with, ReplayRevertFlow$performRewind$slambda$lambda(revertedToQuestion, revertOutcome));
        if (defaultAnswer == null) {
          break $l$loop_5;
        }
      }
      if (!($onboarding == null) && this$0.he1_1().me1_1) {
        var map = $onboarding.wdy_1.w4(to($onboarding.tdy_1, $$this$with.t6h().g38_1));
        if (!(map == null)) {
          if (!(isFirstRevert && $revertMode.equals(RevertMode_RevertFirstForSure_getInstance()))) {
            var tmp_4;
            var tmp_5;
            if (revertOutcome._v == null) {
              throwUninitializedPropertyAccessException('revertOutcome');
            } else {
              tmp_5 = revertOutcome._v;
            }
            if (tmp_5.e6i_1.equals(WhatWillBeReapply_GameQuestion_getInstance())) {
              var tmp0_safe_receiver = map.w4(GameFlowNotificationType_WhenChoiceUiWasInstalled_getInstance());
              var tmp_6;
              if (tmp0_safe_receiver == null) {
                tmp_6 = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp0_safe_receiver_0 = map.w4(GameFlowNotificationType_BeforeAnswer_getInstance());
                var tmp_7;
                if (tmp0_safe_receiver_0 == null) {
                  tmp_7 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  tmp_7 = to(tmp0_safe_receiver_0.pm_1, tmp0_safe_receiver.qm_1);
                }
                var tmp1_elvis_lhs = tmp_7;
                tmp_6 = tmp1_elvis_lhs == null ? tmp0_safe_receiver : tmp1_elvis_lhs;
              }
              var tmp1_elvis_lhs_0 = tmp_6;
              tmp_4 = tmp1_elvis_lhs_0 == null ? map.w4(GameFlowNotificationType_BeforeAnswer_getInstance()) : tmp1_elvis_lhs_0;
            } else {
              tmp_4 = map.w4(GameFlowNotificationType_BeforeNotificationApplied_getInstance());
            }
            var stepInfo = tmp_4;
            if (!(stepInfo == null)) {
              $onboarding.sdy_1 = stepInfo.pm_1;
              $onboarding.rdy_1 = stepInfo.qm_1;
              var tmp_8;
              if (revertOutcome._v == null) {
                throwUninitializedPropertyAccessException('revertOutcome');
              } else {
                tmp_8 = revertOutcome._v;
              }
              if (tmp_8.e6i_1.equals(WhatWillBeReapply_GameQuestion_getInstance())) {
                $onboarding.udy_1 = $onboarding.tdy_1;
              }
              break $l$loop_5;
            }
          }
          var afterNotificationResult = map.w4(GameFlowNotificationType_AfterNotificationApplied_getInstance());
          var answerWasGivenResult = map.w4(GameFlowNotificationType_AnswerWasGiven_getInstance());
          if (!(afterNotificationResult == null)) {
            var tmp_9;
            if (revertOutcome._v == null) {
              throwUninitializedPropertyAccessException('revertOutcome');
            } else {
              tmp_9 = revertOutcome._v;
            }
            var tmp2_elvis_lhs = tmp_9.j6i_1;
            var tmp_10;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.error' call
              var message = 'The previous game state event is null';
              throw IllegalStateException.o(toString(message));
            } else {
              tmp_10 = tmp2_elvis_lhs;
            }
            var previousEvent = tmp_10;
            try {
              $onboarding.sdy_1 = afterNotificationResult.pm_1;
              $onboarding.rdy_1 = afterNotificationResult.qm_1;
              yield* $onboarding.idz($$this$with, previousEvent, $completion);
              break $l$loop_5;
            } catch ($p) {
              if ($p instanceof PressedBackException) {
                var _unused_var__etf5q3 = $p;
              } else {
                throw $p;
              }
            }
          } else if (!(answerWasGivenResult == null)) {
            $onboarding.sdy_1 = answerWasGivenResult.pm_1;
            $onboarding.rdy_1 = answerWasGivenResult.qm_1;
            var tmp_11;
            if (revertOutcome._v == null) {
              throwUninitializedPropertyAccessException('revertOutcome');
            } else {
              tmp_11 = revertOutcome._v;
            }
            var data = tmp_11.i6i_1;
            if (!(data == null)) {
              try {
                yield* /*#__NOINLINE__*/performRewind$restoreAnswer($onboarding, $$this$with, data, $completion);
                break $l$loop_5;
              } catch ($p_0) {
                if ($p_0 instanceof PressedBackException) {
                  var _unused_var__etf5q3_0 = $p_0;
                  yield* /*#__NOINLINE__*/clearPendingQuestion(this$0, $completion);
                } else {
                  throw $p_0;
                }
              }
            }
          }
        }
      }
      var tmp_12;
      var tmp_13;
      if (revertOutcome._v == null) {
        throwUninitializedPropertyAccessException('revertOutcome');
      } else {
        tmp_13 = revertOutcome._v;
      }
      if (tmp_13.e6i_1.equals(WhatWillBeReapply_GameQuestion_getInstance())) {
        tmp_12 = !($onboarding == null);
      } else {
        tmp_12 = false;
      }
      if (tmp_12) {
        var _receiver__tnumb7 = $onboarding;
        _receiver__tnumb7.tdy_1 = _receiver__tnumb7.tdy_1 - 1 | 0;
      }
      isFirstRevert = false;
    }
    var tmp_14;
    var tmp_15;
    var tmp_16;
    if (revertOutcome._v == null) {
      throwUninitializedPropertyAccessException('revertOutcome');
    } else {
      tmp_16 = revertOutcome._v;
    }
    if (tmp_16.e6i_1.equals(WhatWillBeReapply_GameQuestion_getInstance())) {
      tmp_15 = !($onboarding == null);
    } else {
      tmp_15 = false;
    }
    if (tmp_15) {
      var _receiver__tnumb7_0 = $onboarding;
      _receiver__tnumb7_0.tdy_1 = _receiver__tnumb7_0.tdy_1 - 1 | 0;
      tmp_14 = Unit_instance;
    }
    var tmp_17 = this$0.ee1_1;
    var tmp_18;
    if (shouldRevertToQuestionStrictly) {
      var tmp_19;
      if (revertOutcome._v == null) {
        throwUninitializedPropertyAccessException('revertOutcome');
      } else {
        tmp_19 = revertOutcome._v;
      }
      tmp_18 = tmp_19.e6i_1.equals(WhatWillBeReapply_GameQuestion_getInstance());
    } else {
      tmp_18 = false;
    }
    tmp_17.ydv_1 = tmp_18;
    return Unit_instance;
  }, 1);
}
function RevertMode_ReapplyJustCurrent_getInstance() {
  RevertMode_initEntries();
  return RevertMode_ReapplyJustCurrent_instance;
}
function RevertMode_RevertFirstForSure_getInstance() {
  RevertMode_initEntries();
  return RevertMode_RevertFirstForSure_instance;
}
function RevertMode_DefaultRevert_getInstance() {
  RevertMode_initEntries();
  return RevertMode_DefaultRevert_instance;
}
function *showAndGetControlAgent($this, $completion) {
  return yield* $this.se1_1.ze1($completion);
}
function *chooseAnswer($this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled, $completion) {
  while (true) {
    try {
      return yield* coroutineScope(SameScreenFlowAgent$chooseAnswer$slambda($this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled), $completion);
    } catch ($p) {
      if ($p instanceof ReplayQuestionReinstallException) {
        var _unused_var__etf5q3 = $p;
      } else {
        throw $p;
      }
    }
  }
}
function *chooseAttempt($this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled, $completion) {
  if (!($this.ve1_1 == null)) {
    if (shouldFastForwardReplay($this.o6t().z6x(), $this.re1_1.re0_1)) {
      var answer = yield* $this.o6t().q6t($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion);
      // Inline function 'kotlin.with' call
      var $this$with = ensureNotNull($this.re1_1.we0_1);
      yield* $this.te1_1().be2_1.cdz($this$with, gameQuestion, mayNothing, $completion);
      var defaultAnswer_0 = defaultAnswer($context_GameStateRuntime_604ce3, gameQuestion, mayNothing);
      if (defaultAnswer_0 == null || !equals(defaultAnswer_0.j71_1, answer)) {
        yield* $this.te1_1().be2_1.edw($this$with, gameQuestion, mayNothing, $completion);
      }
      yield* $this.te1_1().be2_1.jdz($this$with, gameQuestion, mayNothing, answer, $completion);
      yield* $this.re1_1.se0_1($this.o6t().z6x(), $completion);
      return answer;
    } else if (shouldStartDisplayingReplay($this.o6t().z6x(), $this.re1_1.re0_1)) {
      var holder = ensureNotNull($this.re1_1.we0_1);
      yield* $this.te1_1().be2_1.gdz(holder, gameQuestion, mayNothing, $completion);
      $this.re1_1.we0_1 = null;
      var tmp = $this.re1_1;
      var tmp0_elvis_lhs = $this.re1_1.ae1();
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
        tmp_0 = $this.qe1_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp.qe0_1 = tmp_0;
      yield* $this.re1_1.te0_1($completion);
      yield* notifyAboutGameEventImpl($this, new GameNotification(new InitGameStateEvent(holder.t6h()), null), true, $completion);
      $this.re1_1.re0_1 = 0;
    }
    var controlAgent = yield* /*#__NOINLINE__*/showAndGetControlAgent($this, $completion);
    yield* $this.se1_1.fe2(SameScreenFlowAgent$chooseAttempt$slambda($this, controlAgent), $completion);
    var tmp_2 = $this.re1_1.ae1();
    // Inline function 'kotlin.let' call
    var tmp_3 = tmp_2 == null ? null : new GameTeam(tmp_2);
    var it = tmp_3 == null ? null : tmp_3.r3p_1;
    var tmp_4;
    var tmp_5 = it;
    if (!((tmp_5 == null ? null : new GameTeam(tmp_5)) == null)) {
      var tmp_6 = it;
      tmp_4 = !equals(tmp_6 == null ? null : new GameTeam(tmp_6), new GameTeam($this.qe1_1));
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      if (!controlAgent.gdw() && !($this.xe1_1 === get_revision($context_GameStateRuntime_604ce3))) {
        yield* controlAgent.rdw().n22($completion);
      }
      var tmp_7 = $this.re1_1.ae1();
      // Inline function 'kotlin.let' call
      var tmp_8 = tmp_7 == null ? null : new GameTeam(tmp_7);
      var it_0 = tmp_8 == null ? null : tmp_8.r3p_1;
      var tmp_9;
      var tmp_10 = it_0;
      if (!((tmp_10 == null ? null : new GameTeam(tmp_10)) == null)) {
        var tmp_11 = it_0;
        tmp_9 = !equals(tmp_11 == null ? null : new GameTeam(tmp_11), new GameTeam($this.qe1_1));
      } else {
        tmp_9 = false;
      }
      if (tmp_9) {
        var savedAnswer = yield* $this.o6t().f6y($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion);
        $l$loop: while (!(savedAnswer == null) ? isInterface(savedAnswer, AnimationInsertion) : false) {
          $this.o6t().g6y();
          savedAnswer = yield* $this.o6t().f6y($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, $completion);
        }
        $this.xe1_1 = get_revision($context_GameStateRuntime_604ce3);
        var tmp_12;
        if (!(savedAnswer == null) ? isInterface(savedAnswer, AdjustedSavedAnswer) : false) {
          tmp_12 = savedAnswer.h6y();
        } else {
          tmp_12 = savedAnswer;
        }
        var answer_0 = tmp_12;
        $this.o6t().g6y();
        controlAgent.wdw();
        $this.re1_1.ue0_1($this.o6t().z6x());
        return answer_0;
      }
    }
  }
  var controlAgent_0 = yield* /*#__NOINLINE__*/showAndGetControlAgent($this, $completion);
  yield* $this.re1_1.te0_1($completion);
  var answer_1 = yield* $this.se1_1.fe2(SameScreenFlowAgent$chooseAttempt$slambda_0($this, $context_GameStateRuntime_604ce3, controlAgent_0, gameQuestion, mayNothing, onInstalled), $completion);
  advanceSavedAnswerIfNeeded($this, controlAgent_0);
  if (!($this.ve1_1 == null)) {
    $this.re1_1.ue0_1($this.o6t().z6x());
  }
  return answer_1;
}
function advanceSavedAnswerIfNeeded($this, controlAgent) {
  if (!($this.ve1_1 == null) && controlAgent.ge2()) {
    $this.o6t().g6y();
    controlAgent.wdw();
  }
}
function *chooseInternal($this, $context_GameStateRuntime_604ce3, controlAgent, gameQuestion, mayNothing, onInstalled, $completion) {
  yield* prepareQuestionVisibility($this, controlAgent, VOID, $completion);
  $this.ye1_1 = false;
  setSavedAnswersIfNeeded($this, controlAgent);
  var answer = yield* controlAgent.he2($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled, $completion);
  $this.te1_1().ee2_1($context_GameStateRuntime_604ce3, gameQuestion, answer);
  return answer;
}
function *prepareQuestionVisibility($this, controlAgent, initialHandover, $completion) {
  initialHandover = initialHandover === VOID ? false : initialHandover;
  var tmp0_elvis_lhs = $this.re1_1.ae1();
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new GameTeam(tmp_0)) == null) {
    tmp = $this.qe1_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var displayedTeam = tmp;
  var tmp_1 = $this.se1_1.ie2();
  var teamChanged = !equals(tmp_1 == null ? null : new GameTeam(tmp_1), new GameTeam(displayedTeam));
  if (teamChanged || initialHandover) {
    controlAgent.le1();
    var updatePerspective = SameScreenFlowAgent$prepareQuestionVisibility$slambda($this, displayedTeam, controlAgent);
    if ($this.ue1_1) {
      yield* $this.se1_1.je2(displayedTeam, $this.te1_1().ce2_1 && $this.ye1_1 && displayedTeam === get_beastsGameTeam(), updatePerspective, $completion);
    } else {
      if ($this.te1_1().de2_1 && teamChanged) {
        yield* controlAgent.rdw().n22($completion);
      }
      yield* updatePerspective($completion);
    }
  }
  return Unit_instance;
}
function setSavedAnswersIfNeeded($this, controlAgent) {
  if (!($this.ve1_1 == null) && !$this.we1_1) {
    controlAgent.qdw($this.o6t());
    $this.we1_1 = true;
  }
}
function *notifyAboutGameEventImpl($this, notification, forceFixedVisibilityProcessing, $completion) {
  forceFixedVisibilityProcessing = forceFixedVisibilityProcessing === VOID ? false : forceFixedVisibilityProcessing;
  var fixedVisibilityTeam = $this.re1_1.ae1();
  var tmp;
  var tmp_0 = fixedVisibilityTeam;
  if ((tmp_0 == null ? null : new GameTeam(tmp_0)) == null) {
    tmp = $this.qe1_1;
  } else {
    tmp = fixedVisibilityTeam;
  }
  var displayedTeam = tmp;
  var tmp_1 = fixedVisibilityTeam;
  if (!((tmp_1 == null ? null : new GameTeam(tmp_1)) == null)) {
    var tmp_2;
    if (!forceFixedVisibilityProcessing) {
      var tmp_3 = fixedVisibilityTeam;
      tmp_2 = !equals(new GameTeam($this.qe1_1), tmp_3 == null ? null : new GameTeam(tmp_3));
    } else {
      tmp_2 = false;
    }
    if (tmp_2)
      return Unit_instance;
    $this.se1_1.ke2(fixedVisibilityTeam);
    $this.re1_1.qe0_1 = fixedVisibilityTeam;
  }
  var isFirstTime = {_v: false};
  var tmp_4 = $this.se1_1.ie2();
  if ((tmp_4 == null ? null : new GameTeam(tmp_4)) == null) {
    $this.se1_1.ke2(displayedTeam);
    isFirstTime._v = true;
  }
  var tmp_5 = $this.se1_1.ie2();
  if (!equals(tmp_5 == null ? null : new GameTeam(tmp_5), new GameTeam(displayedTeam))) {
    return Unit_instance;
  }
  yield* $this.se1_1.fe2(SameScreenFlowAgent$notifyAboutGameEventImpl$slambda($this, isFirstTime, notification), $completion);
  return Unit_instance;
}
function SameScreenFlowAgent$_init_$lambda_hk2r4q() {
  return new UiFlowConfiguration();
}
function SameScreenFlowAgent$chooseDeferred$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing) {
  return constructCallableReference(function *(onInstalled, $completion) {
    return yield* /*#__NOINLINE__*/chooseAnswer(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, onInstalled, $completion);
  }, 1);
}
function SameScreenFlowAgent$chooseAnswer$slambda$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* /*#__NOINLINE__*/chooseAttempt(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled, $completion);
  }, 1);
}
function SameScreenFlowAgent$chooseAnswer$slambda$lambda($attempt) {
  return () => {
    $attempt.n1n(ReplayQuestionReinstallException.qe2());
    return Unit_instance;
  };
}
function SameScreenFlowAgent$chooseAnswer$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp = CoroutineStart_LAZY_getInstance();
    var attempt = async($this$coroutineScope, VOID, tmp, SameScreenFlowAgent$chooseAnswer$slambda$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled));
    var requestReinstall = SameScreenFlowAgent$chooseAnswer$slambda$lambda(attempt);
    this$0.re1_1.xe0_1 = requestReinstall;
    this$0.re1_1.ye0_1 = this$0.qe1_1;
    var tmp_0;
    try {
      tmp_0 = yield* boundAwait(attempt, $completion);
    }finally {
      if (this$0.re1_1.xe0_1 === requestReinstall) {
        this$0.re1_1.xe0_1 = null;
        this$0.re1_1.ye0_1 = null;
      }
    }
    return tmp_0;
  }, 1);
}
function SameScreenFlowAgent$chooseAttempt$slambda(this$0, $controlAgent) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/prepareQuestionVisibility(this$0, $controlAgent, VOID, $completion);
    return Unit_instance;
  }, 0);
}
function SameScreenFlowAgent$chooseAttempt$slambda_0(this$0, $$context_GameStateRuntime_ogzdp3, $controlAgent, $gameQuestion, $mayNothing, $onInstalled) {
  return constructCallableReference(function *($completion) {
    return yield* /*#__NOINLINE__*/chooseInternal(this$0, $$context_GameStateRuntime_ogzdp3, $controlAgent, $gameQuestion, $mayNothing, $onInstalled, $completion);
  }, 0);
}
function SameScreenFlowAgent$prepareQuestionVisibility$slambda(this$0, $displayedTeam, $controlAgent) {
  return constructCallableReference(function *($completion) {
    this$0.se1_1.ke2($displayedTeam);
    this$0.re1_1.qe0_1 = $displayedTeam;
    if ($controlAgent.y6h())
      yield* $controlAgent.oe1($completion);
    return Unit_instance;
  }, 0);
}
function SameScreenFlowAgent$approveMasterFixing$slambda(this$0, $requestingTeam) {
  return constructCallableReference(function *($completion) {
    return yield* (yield* /*#__NOINLINE__*/showAndGetControlAgent(this$0, $completion)).v6q($requestingTeam, $completion);
  }, 0);
}
function SameScreenFlowAgent$approveRevert$slambda(this$0, $requestingTeam) {
  return constructCallableReference(function *($completion) {
    return yield* (yield* /*#__NOINLINE__*/showAndGetControlAgent(this$0, $completion)).t6q($requestingTeam, $completion);
  }, 0);
}
function SameScreenFlowAgent$revertEvent$slambda(this$0, $checkInfo, $event, $revertingChanges) {
  return constructCallableReference(function *($completion) {
    var controlAgent = yield* /*#__NOINLINE__*/showAndGetControlAgent(this$0, $completion);
    var tmp;
    if (!(controlAgent.t6h().g38_1 === $checkInfo.e3q_1)) {
      tmp = yield* controlAgent.u6q($event, $revertingChanges, $checkInfo, $completion);
    }
    return Unit_instance;
  }, 0);
}
function SameScreenFlowAgent$useMasterFixingEvents$slambda($masterFixingEventsConsumer, this$0) {
  return constructCallableReference(function *($completion) {
    var agent = $masterFixingEventsConsumer == null ? this$0.se1_1.re2() : (yield* /*#__NOINLINE__*/showAndGetControlAgent(this$0, $completion));
    yield* agent.w6q($masterFixingEventsConsumer, $completion);
    return Unit_instance;
  }, 0);
}
function SameScreenFlowAgent$notifyAboutGameEventImpl$slambda(this$0, $isFirstTime, $notification) {
  return constructCallableReference(function *($completion) {
    var controlAgent = yield* /*#__NOINLINE__*/showAndGetControlAgent(this$0, $completion);
    setSavedAnswersIfNeeded(this$0, controlAgent);
    var tmp;
    if ($isFirstTime._v && this$0.ue1_1) {
      tmp = yield* /*#__NOINLINE__*/prepareQuestionVisibility(this$0, controlAgent, true, $completion);
    } else if ($isFirstTime._v && this$0.te1_1().de2_1) {
      tmp = yield* controlAgent.rdw().n22($completion);
    }
    yield* controlAgent.r6t($notification, $completion);
    return Unit_instance;
  }, 0);
}
function shouldFastForwardReplay(currentAnswerIndex, startFromAnswer) {
  return currentAnswerIndex < startFromAnswer;
}
function shouldStartDisplayingReplay(currentAnswerIndex, startFromAnswer) {
  return startFromAnswer > 0 && currentAnswerIndex === startFromAnswer;
}
function shouldBufferReplayNotification(currentAnswerIndex, startFromAnswer) {
  return startFromAnswer > 0 && currentAnswerIndex <= startFromAnswer;
}
function SandboxSetupFlow$_init_$slambda_5c7gnc($agent) {
  return constructCallableReference(function *(it, $completion) {
    yield* $agent.r6t(it, $completion);
    return Unit_instance;
  }, 1);
}
function SandboxSetupFlow$prepare$slambda$slambda($queue, this$0, $gameCode) {
  return constructCallableReference(function *($this$launch, $completion) {
    var _iterator__ex2g4s = $queue.p1();
    while (yield* _iterator__ex2g4s.x21($completion)) {
      var submission = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.requireNotNull' call
      var tmp0 = $gameCode;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalArgumentException.h2(toString(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var tmp$ret$0 = tmp$ret$1;
      var result = yield* this$0.ee3_1(tmp$ret$0, submission.ye2_1, submission.ze2_1, submission.be3_1, $completion);
      // Inline function 'kotlin.check' call
      if (!(result instanceof SandboxInitApplyEventSuccessResult)) {
        var message_0 = 'Unexpected result of event application: ' + toString(result);
        throw IllegalStateException.o(toString(message_0));
      }
      // Inline function 'kotlin.require' call
      if (!result.c6x_1.equals(submission.ae3_1)) {
        var message_1 = 'Check code is not the same after event application: ' + result.c6x_1.toString() + ' != ' + submission.ae3_1.toString();
        throw IllegalArgumentException.h2(toString(message_1));
      }
    }
    return Unit_instance;
  }, 1);
}
function SandboxSetupFlow$prepare$slambda$slambda_0(this$0, $sender) {
  return constructCallableReference(function *($this$withContext, $completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.ge3_1;
    yield* this_0.y2a(null, $completion);
    try {
      this$0.ie3_1 = null;
      this$0.je3_1 = null;
    }finally {
      this_0.k2a(null);
    }
    var tmp0_safe_receiver = $sender._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* cancelAndJoin(tmp0_safe_receiver, $completion);
    this$0.he3_1.o1n();
    var tmp;
    if (this$0.de3_1.se3()) {
      this$0.de3_1.re3();
      tmp = Unit_instance;
    }
    this$0.ke3_1 = false;
    return Unit_instance;
  }, 1);
}
function SandboxSetupFlow$prepare$slambda(this$0, $numberOfAppliedEvents, $gameCode, $initialState, $restoreArsenal) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var scope = $this$coroutineScope;
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.ge3_1;
    yield* this_0.y2a(null, $completion);
    try {
      // Inline function 'kotlin.check' call
      if (!!this$0.ke3_1) {
        var message = 'Sandbox preparation is already active';
        throw IllegalStateException.o(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!($numberOfAppliedEvents >= 0)) {
        var message_0 = 'Sandbox event number cannot be negative';
        throw IllegalArgumentException.h2(toString(message_0));
      }
      this$0.me3_1 = $numberOfAppliedEvents;
      this$0.he3_1 = CompletableDeferred();
      var tmp = this$0;
      var tmp_0;
      if ($gameCode == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Channel(100);
      }
      tmp.ie3_1 = tmp_0;
      this$0.je3_1 = scope;
      this$0.ke3_1 = true;
      this$0.le3_1 = true;
    }finally {
      this_0.k2a(null);
    }
    var queue = this$0.ie3_1;
    var sender = {_v: null};
    var tmp_1;
    try {
      this$0.de3_1.te3($initialState);
      if (!(queue == null)) {
        sender._v = launch($this$coroutineScope, VOID, VOID, SandboxSetupFlow$prepare$slambda$slambda(queue, this$0, $gameCode));
      }
      yield* this$0.fe3_1(new GameNotification(new InitGameStateEvent($initialState, true), null), $completion);
      if ($restoreArsenal)
        yield* this$0.ue3(RestoreArsenalEvent_getInstance(), $completion);
      var params = yield* this$0.he3_1.m1q($completion);
      if (queue == null)
        null;
      else
        queue.y22();
      var tmp1_safe_receiver = sender._v;
      if (tmp1_safe_receiver == null)
        null;
      else
        yield* tmp1_safe_receiver.k1n($completion);
      yield* this$0.de3_1.ve3($completion);
      tmp_1 = new PreparedSandbox(this$0.ce3_1.t6h(), params, $gameCode, this$0.me3_1);
    }finally {
      this$0.le3_1 = false;
      if (queue == null)
        null;
      else {
        queue.a23();
      }
      cancelChildren(scope.d1m());
      var tmp_2 = NonCancellable_getInstance();
      yield* withContext(tmp_2, SandboxSetupFlow$prepare$slambda$slambda_0(this$0, sender), $completion);
    }
    return tmp_1;
  }, 1);
}
function SandboxSetupFlow$submitEvent$slambda(this$0, $event) {
  return constructCallableReference(function *($this$async, $completion) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      var this_0 = this$0.ge3_1;
      yield* this_0.y2a(null, $completion);
      try {
        // Inline function 'kotlin.check' call
        if (!(this$0.ke3_1 && this$0.le3_1)) {
          var message = 'Sandbox setup is not accepting events';
          throw IllegalStateException.o(toString(message));
        }
        var tmp0_safe_receiver = this$0.ie3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var before = calculateCheckCode(this$0.ce3_1.t6h());
          var expected = this$0.ce3_1.t6h().y4l();
          // Inline function 'kotlin.with' call
          var $this$with = this$0.ce3_1;
          // Inline function 'kotlin.with' call
          applyAllChanges(expected, $this$with, $event);
          yield* tmp0_safe_receiver.j22(new Submission(this$0.me3_1, before, calculateCheckCode(expected), $event), $completion);
        }
        var _unary__edvuaz = this$0.me3_1;
        this$0.me3_1 = _unary__edvuaz + 1 | 0;
        yield* this$0.fe3_1(new GameNotification($event, null), $completion);
      }finally {
        this_0.k2a(null);
      }
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp$ret$0 = tmp;
    return new Result(tmp$ret$0);
  }, 1);
}
function activate($this, gameState, mode) {
  $this.ne3_1.v6h(gameState);
  $this.ne3_1.x6h(gameState);
  $this.qe3_1 = mode;
}
function SpecialSetupFlow$_init_$slambda_lybk6() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function SpecialSetupFlow$_init_$slambda_lybk6_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
var SandboxInit_instance;
function SandboxInit_getInstance() {
  return SandboxInit_instance;
}
var EmptyListener_instance;
function EmptyListener_getInstance() {
  return EmptyListener_instance;
}
function UiFlowConfiguration$_init_$lambda_zls2f($context_GameState_t6qee5, _unused_var__etf5q3, _unused_var__etf5q3_0) {
  return Unit_instance;
}
function *answerFlow(holder, _this__u8e3s4, question, mayNothing, choose, cancel, finish, $completion) {
  var tmp;
  if (cancel === VOID) {
    tmp = answerFlow$slambda();
  } else {
    tmp = cancel;
  }
  cancel = tmp;
  var tmp_0;
  if (finish === VOID) {
    tmp_0 = answerFlow$slambda_0();
  } else {
    tmp_0 = finish;
  }
  finish = tmp_0;
  yield* _this__u8e3s4.cdz(holder, question, mayNothing, $completion);
  var tmp_1;
  try {
    tmp_1 = yield* choose($completion);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof CancellationException) {
      var e = $p;
      yield* cancel($completion);
      throw e;
    } else {
      throw $p;
    }
  }
  var answer = tmp_1;
  yield* finish($completion);
  yield* _this__u8e3s4.jdz(holder, question, mayNothing, answer, $completion);
  return answer;
}
function answerFlow$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function answerFlow$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
//region block: post-declaration
initMetadataForClass(ChoiceFlow, 'ChoiceFlow', VOID, VOID, VOID, [4, 1, 5]);
initMetadataForInterface(ChoicePresentation, 'ChoicePresentation', VOID, VOID, VOID, [0, 4, 2, 1]);
initMetadataForClass(InstalledChoice, 'InstalledChoice');
initMetadataForClass(ChoiceFlowConfiguration, 'ChoiceFlowConfiguration', ChoiceFlowConfiguration);
initMetadataForClass(UiSessionState, 'UiSessionState', UiSessionState);
initMetadataForClass(OfflineRecordedGameSetup, 'OfflineRecordedGameSetup');
initMetadataForInterface(MenuManagement, 'MenuManagement', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(ServerDuelSetup, 'ServerDuelSetup');
initMetadataForObject(NewGameSetup, 'NewGameSetup');
initMetadataForClass(SandboxSetup, 'SandboxSetup');
initMetadataForClass(ReconnectSandboxSetup, 'ReconnectSandboxSetup');
initMetadataForObject(LoadGameSetup, 'LoadGameSetup');
initMetadataForClass(ContentVersionSelectionState, 'ContentVersionSelectionState');
initMetadataForClass(PressedBackException, 'PressedBackException', PressedBackException.pdy);
initMetadataForClass(GameFlowNotificationType, 'GameFlowNotificationType');
initMetadataForInterface(GameFlowListener, 'GameFlowListener', VOID, VOID, VOID, [3, 2, 4]);
protoOf(OnboardingGameFlowListener).hdz = beforeNotificationApplied;
protoOf(OnboardingGameFlowListener).idz = afterNotificationApplied;
protoOf(OnboardingGameFlowListener).edw = whenChoiceUiWasInstalled;
protoOf(OnboardingGameFlowListener).jdz = answerWasGiven;
initMetadataForClass(OnboardingGameFlowListener, 'OnboardingGameFlowListener', OnboardingGameFlowListener, VOID, [GameFlowListener], [3, 2, 4]);
initMetadataForClass(OnboardingHint, 'OnboardingHint');
initMetadataForClass(OnboardingSequence, 'OnboardingSequence');
initMetadataForClass(OnboardingScript, 'OnboardingScript', OnboardingScript, VOID, VOID, [2, 3, 4]);
initMetadataForInterface(GameTeamProvider, 'GameTeamProvider');
protoOf(JustGameTeamProvider).me0 = get_hasFullVisibility;
initMetadataForClass(JustGameTeamProvider, 'JustGameTeamProvider', VOID, VOID, [GameTeamProvider]);
initMetadataForClass(ReplayVisibility, 'ReplayVisibility');
initMetadataForClass(SwitchingGameTeamProvider, 'SwitchingGameTeamProvider', VOID, VOID, [GameTeamProvider]);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(RevertMode, 'RevertMode');
initMetadataForClass(ReplayRevertFlow, 'ReplayRevertFlow', VOID, VOID, VOID, [1, 0, 3]);
initMetadataForClass(ReplayRevertConfiguration, 'ReplayRevertConfiguration', ReplayRevertConfiguration);
initMetadataForClass(SameScreenFlowAgent, 'SameScreenFlowAgent', VOID, VOID, [MasterFixingSupportingAgent, RevertSupportingAgent, PingingSupport], [0, 3, 4, 5, 2, 1]);
initMetadataForClass(ReplayQuestionReinstallException, 'ReplayQuestionReinstallException', ReplayQuestionReinstallException.qe2);
initMetadataForClass(PreparedSandbox, 'PreparedSandbox');
initMetadataForClass(Submission, 'Submission');
initMetadataForClass(SandboxSetupFlow, 'SandboxSetupFlow', VOID, VOID, VOID, [4, 1]);
protoOf(SpecialSetupFlow).v6q = approveMasterFixing;
initMetadataForClass(SpecialSetupFlow, 'SpecialSetupFlow', VOID, VOID, [MasterFixingSupportingAgent], [0, 1, 2]);
initMetadataForObject(SandboxInit, 'SandboxInit');
initMetadataForClass(MasterFixing, 'MasterFixing');
protoOf(EmptyListener).gdx = flushPendingTexts;
protoOf(EmptyListener).jdx = skipReplayQuestionPresentation;
protoOf(EmptyListener).gdz = prepareReplayBoundary;
protoOf(EmptyListener).hdz = beforeNotificationApplied;
protoOf(EmptyListener).idz = afterNotificationApplied;
protoOf(EmptyListener).cdz = beforeAnswer;
protoOf(EmptyListener).edw = whenChoiceUiWasInstalled;
protoOf(EmptyListener).jdz = answerWasGiven;
initMetadataForObject(EmptyListener, 'EmptyListener', VOID, VOID, [GameFlowListener], [3, 2, 4]);
initMetadataForClass(UiFlowConfiguration, 'UiFlowConfiguration', UiFlowConfiguration);
//endregion
//region block: init
NewGameSetup_instance = new NewGameSetup();
LoadGameSetup_instance = new LoadGameSetup();
SandboxInit_instance = new SandboxInit();
EmptyListener_instance = new EmptyListener();
//endregion
//region block: exports
export {
  EmptyListener_instance as EmptyListener_instancelj0tdcdfktrc,
  LoadGameSetup_instance as LoadGameSetup_instancedynmdw5l1ibx,
  NewGameSetup_instance as NewGameSetup_instance21xugcdjajd1l,
  SandboxInit_instance as SandboxInit_instance2eyebb5m3b2w3,
  OnboardingSequence_Outpost_getInstance as OnboardingSequence_Outpost_getInstance1oyyrqk0uw5zh,
  ReplayVisibility_CurrentTeam_getInstance as ReplayVisibility_CurrentTeam_getInstance31k9ithqooozn,
  RevertMode_RevertFirstForSure_getInstance as RevertMode_RevertFirstForSure_getInstance15jk7v54dl2u1,
  shareReplay as shareReplay1hga7jj1zwgtn,
  answerFlow as answerFlow2bhqnoa9tb0qv,
  processDuelSession as processDuelSession329ouhvf1a0wt,
  reconnectClientAfterReload as reconnectClientAfterReload3me0qgkvquf5r,
  ChoiceFlowConfiguration as ChoiceFlowConfiguration2jqt6nz2oewh2,
  ChoiceFlow as ChoiceFlow3r341chgmsw27,
  ChoicePresentation as ChoicePresentation1vh53566cmej6,
  ContentVersionSelectionState as ContentVersionSelectionState30lx6a5rvrcza,
  canSeePrivateInfoOf as canSeePrivateInfoOf9e2d27g7wzcs,
  GameTeamProvider as GameTeamProvider2tka980cqn2bv,
  InstalledChoice as InstalledChoice2nyv8x5v495wn,
  JustGameTeamProvider as JustGameTeamProvider1igg1wo0xc3wh,
  LoadGameSetup as LoadGameSetup1k9f8hcugoyuv,
  get_canShareReplay as get_canShareReplay2i20c2ebxo8sw,
  get_isNetworkGame as get_isNetworkGame3j47mql0se16c,
  reloadGameCallback as reloadGameCallback272ilqsw0e9x8,
  get_replayTimeline as get_replayTimeline1zceyqjy38q6d,
  MenuManagement as MenuManagementp52wobde9q5e,
  NewGameSetup as NewGameSetup1lcqmn970xsp6,
  OfflineRecordedGameSetup as OfflineRecordedGameSetup3bgixk2i1vcnw,
  OnboardingScript as OnboardingScript1xddc1rg7qnob,
  PressedBackException as PressedBackException22atp96o0y92v,
  ReconnectSandboxSetup as ReconnectSandboxSetup2nwh12h6ozq2w,
  ReplayRevertConfiguration as ReplayRevertConfiguration114bh0uw7avj5,
  ReplayRevertFlow as ReplayRevertFlow3p2tqo0e2v4x0,
  get_entries as get_entries34vldtkch6t8x,
  SameScreenFlowAgent as SameScreenFlowAgent16e8wth7lkmsa,
  SandboxSetupFlow as SandboxSetupFlowh4qs7yy80fds,
  SandboxSetup as SandboxSetup1s0c85bn4b5d7,
  ServerDuelSetup as ServerDuelSetuph7xwhhxe2xfz,
  SpecialSetupFlow as SpecialSetupFlow1wg19nhji0s66,
  MasterFixing as MasterFixing225222srs8psi,
  SandboxInit as SandboxInit2yt0sj0f9nsmu,
  SwitchingGameTeamProvider as SwitchingGameTeamProvider3nw4zylvxdxlr,
  UiFlowConfiguration as UiFlowConfiguration1h4ikmn9s7ox6,
  UiSessionState as UiSessionState152j89nvae1zt,
  replayStartShowAnswerFrom as replayStartShowAnswerFromjqt988fml6oc,
  visibleServerMessages as visibleServerMessages1gk72m0zmjr4m,
};
//endregion
